import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigInt: { input: any; output: any; }
  CamelizedJson: { input: any; output: any; }
  ISO8601Date: { input: any; output: any; }
  ISO8601DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

/** Access entity */
export type Access = {
  __typename?: 'Access';
  /** Component name (Access control component) */
  component: AccessComponentEnum;
  /** Related items IDs */
  itemIds: Array<Scalars['ID']['output']>;
  /** Level of access */
  level: Maybe<AccessLevelEnum>;
  /** Policy type */
  policy: Maybe<AccessPolicyEnum>;
  /** Scope level */
  scopeLevel: Maybe<AccessScopeLevelEnum>;
};

/** Available components */
export enum AccessComponentEnum {
  /** AI assistance */
  AiAssistance = 'AI_ASSISTANCE',
  /** Assets counter reading (index adding) */
  AssetsCounterReading = 'ASSETS_COUNTER_READING',
  /** Assets management */
  AssetsManagement = 'ASSETS_MANAGEMENT',
  /** Assets management in asset categories only */
  AssetsManagementCategoriesScope = 'ASSETS_MANAGEMENT_CATEGORIES_SCOPE',
  /** Asset categories management */
  AssetCategoriesManagement = 'ASSET_CATEGORIES_MANAGEMENT',
  /** Departments management */
  DepartmentsManagement = 'DEPARTMENTS_MANAGEMENT',
  /** Documentation analytics */
  DocumentationAnalytics = 'DOCUMENTATION_ANALYTICS',
  /** Documentation categories management */
  DocumentationCategoriesManagement = 'DOCUMENTATION_CATEGORIES_MANAGEMENT',
  /** Documentation management */
  DocumentationManagement = 'DOCUMENTATION_MANAGEMENT',
  /** Documentation categories scope */
  DocumentationManagementCategoriesScope = 'DOCUMENTATION_MANAGEMENT_CATEGORIES_SCOPE',
  /** Form categories management */
  FormCategoriesManagement = 'FORM_CATEGORIES_MANAGEMENT',
  /** Home page management */
  HomePageManagement = 'HOME_PAGE_MANAGEMENT',
  /** Interventions management */
  InterventionsManagement = 'INTERVENTIONS_MANAGEMENT',
  /** Interventions management in intervention categories only */
  InterventionsManagementCategoriesScope = 'INTERVENTIONS_MANAGEMENT_CATEGORIES_SCOPE',
  /** Intervention categories management */
  InterventionCategoriesManagement = 'INTERVENTION_CATEGORIES_MANAGEMENT',
  /** Sites management */
  SitesManagement = 'SITES_MANAGEMENT',
  /** Tasks management */
  TasksManagement = 'TASKS_MANAGEMENT',
  /** Tasks performing */
  TasksPerforming = 'TASKS_PERFORMING',
  /** Users and teams management */
  UsersManagement = 'USERS_MANAGEMENT'
}

/** Access attributes */
export type AccessCuInputObject = {
  /** Destroy access */
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Component name (Access control component) */
  component: AccessComponentEnum;
  /** Scope items attributes array */
  items?: InputMaybe<Array<LinkingInputObject>>;
  /** Level of access (for non-scope access) */
  level?: InputMaybe<AccessLevelEnum>;
  /** Scope level of access (for scope access) */
  scopeLevel?: InputMaybe<AccessScopeLevelEnum>;
};

/** Available levels of access */
export enum AccessLevelEnum {
  LimitedRead = 'LIMITED_READ',
  Read = 'READ',
  Write = 'WRITE'
}

/** Available policies of accesses based on every possible setup */
export enum AccessPolicyEnum {
  CompanyPlan = 'COMPANY_PLAN',
  Default = 'DEFAULT',
  Team = 'TEAM',
  User = 'USER'
}

/** Available scope levels of access */
export enum AccessScopeLevelEnum {
  All = 'ALL',
  Selected = 'SELECTED'
}

/** Whether a document's file can be attached to an AI chat, or the reason it cannot */
export enum AiAttachabilityStatusEnum {
  /** The file can be attached and read by the assistant */
  Attachable = 'ATTACHABLE',
  /** The file exceeds the attachment size limit */
  TooLarge = 'TOO_LARGE',
  /** The video exceeds the attachment duration limit */
  TooLong = 'TOO_LONG',
  /** The file type cannot be read by the assistant */
  UnsupportedType = 'UNSUPPORTED_TYPE'
}

/** Why AI spend is currently refused */
export enum AiBudgetBlockedReasonEnum {
  /** The current period's budget has been used up; spend resumes next cycle */
  BudgetExhausted = 'BUDGET_EXHAUSTED',
  /** No budget cap is configured for the company, so no spend is admitted until an administrator sets one */
  BudgetNotConfigured = 'BUDGET_NOT_CONFIGURED'
}

/** A point-in-time view of a company's AI budget for the current billing period, in both authoritative micros and the credits the UI renders. */
export type AiBudgetStatus = {
  __typename?: 'AiBudgetStatus';
  /** Why AI spend is refused right now; null when it is admitted. The signal to disable AI controls — a request made anyway fails with the matching error code. Not derivable from the credit fields, which round up; an unconfigured cap also blocks spend while reading enforced false. */
  blockedReason: Maybe<AiBudgetBlockedReasonEnum>;
  /**
   * The last day of the current billing period; null when no cap is configured.
   * ATTENTION: Access allowed for system admins.
   */
  cycleEndsAt: Maybe<Scalars['ISO8601Date']['output']>;
  /**
   * The day the current billing period started; null when no cap is configured.
   * ATTENTION: Access allowed for system admins.
   */
  cycleStartedAt: Maybe<Scalars['ISO8601Date']['output']>;
  /** Whether a budget cap is configured. When false, the cap fields below are null — render the meter as unlimited, but read blocked_reason before allowing AI usage. */
  enforced: Scalars['Boolean']['output'];
  /** Spend so far this period as a percentage of the cap (0–100, can read above 100 if a charge overran the remainder); null when no cap is configured. */
  percentage: Maybe<Scalars['Float']['output']>;
  /** Remaining display credits, clamped at zero; null when no cap is configured. */
  remainingCredits: Maybe<Scalars['Int']['output']>;
  /**
   * Cap minus usage, in micros; null when no cap is configured. May go negative if a single allowed charge exceeded the remainder.
   * ATTENTION: Access allowed for system admins.
   */
  remainingMicros: Maybe<Scalars['BigInt']['output']>;
  /** The share of the cap consumed by automated background work with no acting user (document indexing, etc.), as a percentage; null when no cap is configured. */
  systemPercentage: Maybe<Scalars['Float']['output']>;
  /** The cap in display credits (1000 credits = 1 euro, EUR); null when no cap is configured. */
  totalCredits: Maybe<Scalars['Int']['output']>;
  /**
   * The current-period spending cap in micros (millionths of a euro, EUR); null when no cap is configured.
   * ATTENTION: Access allowed for system admins.
   */
  totalMicros: Maybe<Scalars['BigInt']['output']>;
  /** When this snapshot was computed. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Spend so far this period in display credits, rounded up. */
  usedCredits: Scalars['Int']['output'];
  /**
   * Spend so far this period, in micros.
   * ATTENTION: Access allowed for system admins.
   */
  usedMicros: Scalars['BigInt']['output'];
  /** The share of the cap consumed by real users (credits users spent), as a percentage; null when no cap is configured. */
  userPercentage: Maybe<Scalars['Float']['output']>;
};

/** A single content block in an AI message; provide exactly one variant. */
export type AiContentBlockInputObject = {
  /** A reference to an existing entity. */
  entityRef?: InputMaybe<AiEntityRefBlockInputObject>;
  /** A run of message text. */
  text?: InputMaybe<Scalars['String']['input']>;
};

/** An AI assistant conversation owned by a user. */
export type AiConversation = TimestampInterface & {
  __typename?: 'AiConversation';
  /** Whether an assistant reply is currently being generated; clients use this on load to decide whether to wait before sending. */
  busy: Maybe<Scalars['Boolean']['output']>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The AI feature (assistant) this conversation belongs to. */
  feature: AiConversationFeatureEnum;
  /** The conversation ID. */
  id: Scalars['ID']['output'];
  /** Who initiated the conversation (user or system). */
  initiator: AiConversationInitiatorEnum;
  /** Number of visible (non-system) messages in the conversation. */
  messagesCount: Scalars['Int']['output'];
  /** The conversation status (active or closed). */
  status: AiConversationStatusEnum;
  /** The conversation's current reasoning level — sticky across sends; restore the client's level picker from it on load. */
  thinkingLevel: AiThinkingLevelEnum;
  /** The conversation title; null until generated or set. */
  title: Maybe<Scalars['String']['output']>;
  /** Whether the title was generated automatically. */
  titleAutoGenerated: Scalars['Boolean']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** AiConversationCollection type */
export type AiConversationCollection = {
  __typename?: 'AiConversationCollection';
  /** A collection of paginated AiConversationCollection */
  collection: Array<AiConversation>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type AiConversationDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The conversation ID. */
  id: Scalars['ID']['input'];
};

/** AI feature (assistant) a conversation belongs to */
export enum AiConversationFeatureEnum {
  /** Documentation assistant */
  Documentation = 'DOCUMENTATION'
}

/** Filters for the AI conversations collection. */
export type AiConversationFilterInputObject = {
  /** Filter by conversation status (ACTIVE / CLOSED). */
  status?: InputMaybe<FilterIntInputObject>;
  /** Filter by conversation title. */
  title?: InputMaybe<FilterInputObject>;
};

/** Who initiated an AI conversation */
export enum AiConversationInitiatorEnum {
  /** Started by an automated workflow */
  System = 'SYSTEM',
  /** Started by a human user */
  User = 'USER'
}

/** Sort options for the AI conversations collection. */
export type AiConversationSortInputObject = {
  /** Sort by creation time. */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Sort by last update time. */
  updatedAt?: InputMaybe<SortDirectionEnum>;
};

/** Lifecycle status of an AI conversation */
export enum AiConversationStatusEnum {
  /** Open and accepting messages */
  Active = 'ACTIVE',
  /** Closed; no further messages accepted */
  Closed = 'CLOSED'
}

/** A single frame on the AI conversation stream, discriminated by eventType; fields not applicable to the frame kind are null. */
export type AiConversationStreamEvent = {
  __typename?: 'AiConversationStreamEvent';
  /** The auto-generated conversation title; only on title frames. */
  conversationTitle: Maybe<Scalars['String']['output']>;
  /** The newly generated text fragment for this frame; null outside streaming message frames. */
  delta: Maybe<Scalars['String']['output']>;
  /** Machine-readable failure reason on terminal failure frames; null otherwise. */
  errorCode: Maybe<Scalars['String']['output']>;
  /** Discriminator for the frame kind. */
  eventType: AiStreamEventTypeEnum;
  /** The assistant message the frame belongs to — on tool frames, the message that carries the tool invocation (the same message toolCalls are grouped under in the transcript). Null on title frames. */
  messageId: Maybe<Scalars['ID']['output']>;
  /** A monotonic per-turn frame number on message frames; clients order deltas by this, since delivery order is not guaranteed. Null on suggestions and title frames. */
  sequence: Maybe<Scalars['Int']['output']>;
  /** The assistant message status (streaming while generating, then complete, failed, or truncated_budget). Null outside message frames. */
  status: Maybe<AiMessageStatusEnum>;
  /** Follow-up question suggestions for the completed assistant message; only on suggestions frames. */
  suggestedFollowups: Maybe<Array<Scalars['String']['output']>>;
  /** Identifier of the individual tool invocation; pairs the running and completed frames of one call. Only on tool frames. */
  toolCallId: Maybe<Scalars['ID']['output']>;
  /** Machine name of the tool being invoked; only on tool frames. */
  toolName: Maybe<Scalars['String']['output']>;
  /** Whether the tool is running or has completed; only on tool frames. */
  toolStatus: Maybe<AiToolStatusEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type AiConversationUpdateInput = {
  /** The fields to update. */
  attributes: AiConversationUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The conversation ID. */
  id: Scalars['ID']['input'];
};

/** Input for renaming an AI conversation. */
export type AiConversationUpdateInputObject = {
  /** The new conversation title. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type AiDismissDocumentationDetectionInput = {
  /** Which detection annotation to dismiss. */
  attributes: AiDismissDocumentationDetectionInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The document ID. */
  id: Scalars['ID']['input'];
};

/** Input for dismissing a document's AI-detection annotations. */
export type AiDismissDocumentationDetectionInputObject = {
  /** Which field's annotation to dismiss; omit to dismiss every annotation on the document. */
  field?: InputMaybe<AiDocumentationFieldEnum>;
};

/** A documentation field that AI can generate. */
export enum AiDocumentationFieldEnum {
  /** The best-matching category for the document, chosen from the categories the requester can assign. */
  Category = 'CATEGORY',
  /** The document's reference code. */
  Code = 'CODE',
  /** The document's description. */
  Description = 'DESCRIPTION',
  /** The document's name (title). */
  Name = 'NAME',
  /** The version's notes. */
  Notes = 'NOTES',
  /** Suggested tags (short labels) for the document. */
  Tags = 'TAGS'
}

/** A reference to an existing entity by id. */
export type AiEntityRefBlockInputObject = {
  /** The referenced entity type. */
  entityType: AiEntityRefTypeEnum;
  /** The referenced entity ID. */
  id: Scalars['ID']['input'];
};

/** Type of entity a content block can reference */
export enum AiEntityRefTypeEnum {
  /** A specific version of a document */
  DocumentationVersion = 'DOCUMENTATION_VERSION'
}

/** One indexable media kind and the model that extracts its text in a region. */
export type AiExtractionMedia = {
  __typename?: 'AiExtractionMedia';
  /** The media kind — DOCUMENT, IMAGE, or VIDEO. */
  mediaKind: AiMediaKindEnum;
  /** The model that extracts this kind's text — an OCR model with its page pricing, or null when the region's assistant model does it via vision (token-priced; render the region's selected chat model there). */
  model: Maybe<AiModelInfo>;
};

/** The status of AI detection for one field of a document. */
export enum AiFieldDetectionStatusEnum {
  /** Detection was stopped before it reached this field. */
  Cancelled = 'CANCELLED',
  /** A value was written (or tags linked). */
  Detected = 'DETECTED',
  /** AI is generating this field now. */
  Detecting = 'DETECTING',
  /** The user reviewed and settled this annotation (acknowledged a failure or ignored the suggestions). */
  Dismissed = 'DISMISSED',
  /** Detection failed for this field. */
  Failed = 'FAILED',
  /** AI found nothing to fill for this field. */
  NotFound = 'NOT_FOUND',
  /** Detection is scheduled but has not started for this field. */
  Queued = 'QUEUED',
  /** Left untouched because the field was already filled by hand. */
  SkippedExisting = 'SKIPPED_EXISTING',
  /** The document's file cannot be read by AI (e.g. a spreadsheet). */
  UnsupportedFile = 'UNSUPPORTED_FILE'
}

/** The result of an asynchronous documentation field generation, delivered on the subscription. */
export type AiFieldGeneration = {
  __typename?: 'AiFieldGeneration';
  /** The detected category id for the category field; null on failure, for other fields, or when the model found nothing (see not_found). Resolve it via documentationCategory to prefill the selector. */
  categoryId: Maybe<Scalars['ID']['output']>;
  /** The failure code when generation failed; null on success. */
  errorCode: Maybe<Scalars['String']['output']>;
  /** Which field was generated. */
  field: AiDocumentationFieldEnum;
  /** True when the model ran but produced nothing to fill for this field; the value fields are null and there is no error code. */
  notFound: Scalars['Boolean']['output'];
  /** The generated scalar value; null on failure, for list fields, or when the model found nothing (see not_found). */
  text: Maybe<Scalars['String']['output']>;
  /** The generated list values (e.g. suggested tags); null on failure, for scalar fields, or when the model found nothing (see not_found). */
  values: Maybe<Array<Scalars['String']['output']>>;
};

/** Acknowledges that a field generation was validated and enqueued. */
export type AiFieldGenerationRequest = {
  __typename?: 'AiFieldGenerationRequest';
  /** The client's correlation id, echoed; the value arrives on the subscription. */
  generationId: Scalars['ID']['output'];
};

/** The result of a one-click "detect all" — every requested documentation field generated in one combined model call, delivered on the subscription. */
export type AiFieldsGeneration = {
  __typename?: 'AiFieldsGeneration';
  /** The failure code when the whole combined generation failed; null on success. */
  errorCode: Maybe<Scalars['String']['output']>;
  /** The client's correlation id for this generation. */
  generationId: Scalars['ID']['output'];
  /** One entry per requested field with its detected value or not_found; empty when the whole call failed (see error_code). */
  results: Array<AiFieldGeneration>;
};

/** Description from base input object. Please set your description for child object. */
export type AiGenerateDocumentationFieldsInput = {
  /** The fields to generate and their source. */
  attributes: AiGenerateDocumentationFieldsInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Input for generating a document's own fields — one, a subset, or all — in one job. */
export type AiGenerateDocumentationFieldsInputObject = {
  /** Optional free-text hint applied only when generating CODE (ignored for other fields); a hint, never an override. */
  codePrompt?: InputMaybe<Scalars['String']['input']>;
  /** A saved documentation version to generate from. Provide exactly one of file or documentationVersionId. */
  documentationVersionId?: InputMaybe<Scalars['ID']['input']>;
  /** Which fields to generate (NAME, DESCRIPTION, CODE, TAGS, CATEGORY); deduped. */
  fields: Array<AiDocumentationFieldEnum>;
  /** A freshly uploaded file (cache descriptor) to generate from, for create or a new version. Provide exactly one of file or documentationVersionId. */
  file?: InputMaybe<AttachmentFileInputObject>;
  /** Client-generated id, unique per request, correlating this generation with the aiDocumentationFieldsGenerated subscription. */
  generationId: Scalars['ID']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type AiGenerateDocumentationVersionFieldsInput = {
  /** The fields to generate and their source. */
  attributes: AiGenerateDocumentationVersionFieldsInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Input for generating a documentation version's own fields (currently notes) — one, a subset, or all — in one job. */
export type AiGenerateDocumentationVersionFieldsInputObject = {
  /** A saved documentation version to generate from. Provide exactly one of file or documentationVersionId. */
  documentationVersionId?: InputMaybe<Scalars['ID']['input']>;
  /** Which version fields to generate (currently NOTES); deduped. */
  fields: Array<AiDocumentationFieldEnum>;
  /** A freshly uploaded file (cache descriptor) to generate from, for a new version. Provide exactly one of file or documentationVersionId. */
  file?: InputMaybe<AttachmentFileInputObject>;
  /** Client-generated id, unique per request, correlating this generation with the aiDocumentationVersionFieldsGenerated subscription. */
  generationId: Scalars['ID']['input'];
};

/** Documentation indexing coverage for one company, on two axes: the five buckets say whether each document is searchable, the retry counts and `indexingState` say whether anything is still working on the ones that are not. */
export type AiIndexingCoverage = {
  __typename?: 'AiIndexingCoverage';
  /** The company. */
  companyId: Scalars['ID']['output'];
  /** The company's name. */
  companyName: Maybe<Scalars['String']['output']>;
  /** Rough processing time for the documents the next automatic pass will actually take (`retryingSoon`), from a crude per-document average — a display hint ("~N min"), not a promise. `0` when nothing is due imminently, including when the whole backlog is waiting for the daily pass or is parked; `indexingState` says which. */
  estimatedReindexSeconds: Scalars['Int']['output'];
  /** Documentations whose indexing exhausted its retries. Still retried once a day for a while — `parked` counts the ones nothing will retry again. */
  failed: Scalars['Int']['output'];
  /** Documentations whose current version is indexed with the active embedding model and has searchable content. */
  indexed: Scalars['Int']['output'];
  /** Documentations whose content extraction is riding a provider batch that has not come back yet. Their processing is genuinely under way even though no count moves for minutes; `0` does not mean idle (ordinary indexing shows up as a moving `lastIndexingAttemptAt`). */
  indexingInFlight: Scalars['Int']['output'];
  /** What is happening to the backlog right now — the verdict to render as the card's status line, instead of guessing from how long updates have been quiet. */
  indexingState: AiIndexingStateEnum;
  /** When indexing last completed on any of the company's current document versions. A historical fact — unaffected by the region argument and by staleness after a model change. Null when nothing was ever indexed. */
  lastIndexedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When indexing was last attempted on any of the company's current document versions, whether it succeeded or failed — the sign of life `lastIndexedAt` cannot give, since a backlog that keeps failing never completes. Null when nothing was ever attempted. */
  lastIndexingAttemptAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Documentations no automatic retry will touch again — they stay unsearchable until someone re-indexes them. The one count that means "a human has to act". */
  parked: Scalars['Int']['output'];
  /** Why the parked documentations gave up, commonest first, always summing to `parked` — so the card can say "2 unreadable files, 1 file missing" instead of a bare number. Empty when nothing is parked. */
  parkedReasons: Array<AiIndexingFailureReason>;
  /** Documentations whose current version is awaiting indexing. */
  pending: Scalars['Int']['output'];
  /** Processed share of documentations (indexed + skipped), as a percentage (0–100) — reaches 100 even when some files are unindexable; `skipped` names the gap between processed and searchable. */
  progress: Scalars['Float']['output'];
  /** Documentations only the once-a-day pass will retry — the next attempt can be up to a day away. Nothing is wrong; the frequent pass has given up on them for now. */
  retryingDaily: Scalars['Int']['output'];
  /** Documentations awaiting the frequent (roughly quarter-hourly) indexing pass. With `retryingDaily` and `parked` this splits the not-yet-searchable documents (stale + pending + failed) by what happens to them NEXT, and the three always sum to that total. Under the `region` argument every document that the switch would re-index counts here, because a region switch re-drives all of them at once. */
  retryingSoon: Scalars['Int']['output'];
  /** Documentations terminally processed with the active model but yielding NO searchable content — the file type is unsupported for the region (e.g. video under Mistral) or the file has no extractable text. Not searchable, and never will be until the file or region changes. */
  skipped: Scalars['Int']['output'];
  /** Documentations still indexed with a PREVIOUS embedding model — being re-embedded to the current one after a region/model change (the "Re-indexing" state). Distinct from `pending` (never indexed); not searchable until re-indexed. A region switch turns the whole corpus stale at once, then drains it toward `indexed`. */
  stale: Scalars['Int']['output'];
  /** Total documentations. */
  total: Scalars['Int']['output'];
};

/** One reason documentations stopped being indexed, with how many carry it. */
export type AiIndexingFailureReason = {
  __typename?: 'AiIndexingFailureReason';
  /** How many documentations carry this reason. */
  count: Scalars['Int']['output'];
  /** Why indexing gave up, as a stable code — `file_missing` (the document's file is gone from storage; re-upload it), `unreadable_file` (the file could not be parsed; replace it), `unknown` (recorded before reasons were kept), or one of the shared AI error codes listed in the error-code table. Render a label per code; never show it raw. */
  reason: Scalars['String']['output'];
};

/** Which automatic pass will next revisit a document that still needs indexing — the per-document counterpart of the coverage card's retry-lane counts. Orthogonal to the status: it answers "will this fix itself?", not "is it searchable?". */
export enum AiIndexingRetryLaneEnum {
  /** Every automatic retry is exhausted — nothing will revisit it until someone acts. */
  Parked = 'PARKED',
  /** Frequent retries exhausted; retried once a day for a while yet. */
  RetryingDaily = 'RETRYING_DAILY',
  /** Picked up by the frequent pass; expected to resolve on its own shortly. */
  RetryingSoon = 'RETRYING_SOON'
}

/** Description from base input object. Please set your description for child object. */
export type AiIndexingRetryParkedForCompanyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The company whose indexing to re-drive. */
  companyId: Scalars['ID']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type AiIndexingRetryParkedInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** What is happening to a company's document-indexing backlog right now — the single verdict behind the indexing card's status line, so no client has to infer progress from the absence of updates. */
export enum AiIndexingStateEnum {
  /** Only documents no automatic retry will touch again remain — they need a manual re-index. */
  Blocked = 'BLOCKED',
  /** What remains is only retried by the once-a-day pass. */
  Deferred = 'DEFERRED',
  /** Background indexing is held back by the company's AI spending limit. */
  PausedBudget = 'PAUSED_BUDGET',
  /** The company's AI plan is off, so nothing is indexed. */
  PausedPlan = 'PAUSED_PLAN',
  /** The AI provider is unavailable and indexing has backed off until it recovers. */
  PausedProvider = 'PAUSED_PROVIDER',
  /** The documents have only just arrived and the next processing pass is still due — nothing has been attempted yet, and nothing is wrong. */
  Scheduled = 'SCHEDULED',
  /** There is work the frequent pass should have picked up, nothing is known to be holding it back, and nothing has been attempted for far longer than expected — worth investigating. */
  Stalled = 'STALLED',
  /** Every document is processed; there is no backlog. */
  UpToDate = 'UP_TO_DATE',
  /** Indexing is progressing — a provider batch is open, or a document was attempted moments ago. */
  Working = 'WORKING'
}

/** Where one document stands in AI processing — the per-document counterpart of the company-wide indexing coverage counts, judged against the company's current system model. */
export enum AiIndexingStatusEnum {
  /** Processing could not complete (see aiIndexingError). */
  Failed = 'FAILED',
  /** Processed and searchable by the assistant. */
  Indexed = 'INDEXED',
  /** Not processed yet; being picked up automatically. */
  Pending = 'PENDING',
  /** Processed, but yielded no searchable text — an unsupported file type, or nothing extractable. */
  Skipped = 'SKIPPED',
  /** Indexed under a previous system model; re-processed automatically. */
  Stale = 'STALE'
}

/** The AI validation rules for one processable file type — its size cap and, where applicable, its duration cap. */
export type AiMediaConstraint = {
  __typename?: 'AiMediaConstraint';
  /** The maximum file size in bytes for this type. */
  maxBytes: Scalars['Int']['output'];
  /** The maximum duration in seconds; null when the type has no duration limit. */
  maxDurationSeconds: Maybe<Scalars['Int']['output']>;
  /** The MIME type these rules apply to. */
  mimeType: Scalars['String']['output'];
};

/** A category of file the AI can process — grouped the way the indexing pipeline groups uploads. */
export enum AiMediaKindEnum {
  /** PDF and other document files. */
  Document = 'DOCUMENT',
  /** Image files (JPEG, PNG, WebP). */
  Image = 'IMAGE',
  /** Video files. */
  Video = 'VIDEO'
}

/** A single message within an AI conversation. */
export type AiMessage = TimestampInterface & {
  __typename?: 'AiMessage';
  /** The message text; null until generated. */
  content: Maybe<Scalars['String']['output']>;
  /** Structured content blocks (text and entity references) for the message. */
  contentBlocks: Maybe<Scalars['CamelizedJson']['output']>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Machine-readable failure reason when the message failed. */
  errorCode: Maybe<Scalars['String']['output']>;
  /** The requester's rating of this assistant message (POSITIVE or NEGATIVE); null when not rated. */
  feedback: Maybe<AiMessageFeedbackEnum>;
  /** When the current feedback was recorded; null when not rated. */
  feedbackAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Optional free-text detail the requester left with a NEGATIVE rating. */
  feedbackComment: Maybe<Scalars['String']['output']>;
  /** Why the message was rated NEGATIVE; null otherwise. */
  feedbackReason: Maybe<AiMessageFeedbackReasonEnum>;
  /** The message ID. */
  id: Scalars['ID']['output'];
  /** The message role (user, assistant, or tool). */
  role: AiMessageRoleEnum;
  /** The message lifecycle status. */
  status: AiMessageStatusEnum;
  /** Follow-up questions suggested after this assistant message; empty when none were generated. */
  suggestedFollowups: Array<Scalars['String']['output']>;
  /** The assistant's extended-thinking (reasoning) text for this message; null in regular mode or when the model returned none. */
  thinking: Maybe<Scalars['String']['output']>;
  /** Tool invocations this assistant message requested, in invocation order; empty for messages without tool use. */
  toolCalls: Array<AiToolCall>;
  /** Whether the assistant reply stopped at the model's output-token limit instead of finishing naturally (distinct from the TRUNCATED_BUDGET status, which is the company budget guard); always false for user messages and for history predating this field. */
  truncated: Scalars['Boolean']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** AiMessageCollection type */
export type AiMessageCollection = {
  __typename?: 'AiMessageCollection';
  /** A collection of paginated AiMessageCollection */
  collection: Array<AiMessage>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type AiMessageFeedbackCreateInput = {
  /** The feedback to record. */
  attributes: AiMessageFeedbackInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The message ID. */
  id: Scalars['ID']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type AiMessageFeedbackDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The message ID. */
  id: Scalars['ID']['input'];
};

/** A requester's rating of an AI assistant message */
export enum AiMessageFeedbackEnum {
  /** The message was not helpful */
  Negative = 'NEGATIVE',
  /** The message was helpful */
  Positive = 'POSITIVE'
}

/** Input for rating an AI assistant message. */
export type AiMessageFeedbackInputObject = {
  /** Optional free-text detail about the rating. */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Whether the message was helpful (POSITIVE) or not (NEGATIVE). */
  feedback: AiMessageFeedbackEnum;
  /** Why the message was unhelpful; required when feedback is NEGATIVE. */
  reason?: InputMaybe<AiMessageFeedbackReasonEnum>;
};

/** Why an AI assistant message was rated not helpful */
export enum AiMessageFeedbackReasonEnum {
  /** The answer was wrong */
  Incorrect = 'INCORRECT',
  /** The answer did not address the request */
  NotRelevant = 'NOT_RELEVANT',
  /** Another reason, given in the comment */
  Other = 'OTHER',
  /** The answer was based on outdated information */
  Outdated = 'OUTDATED'
}

/** Author role of an AI message */
export enum AiMessageRoleEnum {
  /** Generated by the assistant */
  Assistant = 'ASSISTANT',
  /** Produced by a tool invocation */
  Tool = 'TOOL',
  /** Sent by the user */
  User = 'USER'
}

/** Sort options for the AI messages collection. */
export type AiMessageSortInputObject = {
  /** Sort by creation time. */
  createdAt?: InputMaybe<SortDirectionEnum>;
};

/** Lifecycle status of an AI assistant message */
export enum AiMessageStatusEnum {
  /** Generation was cancelled */
  Cancelled = 'CANCELLED',
  /** Generation finished successfully */
  Complete = 'COMPLETE',
  /** Generation failed; see errorCode */
  Failed = 'FAILED',
  /** Queued; generation has not started yet */
  Pending = 'PENDING',
  /** Generation in progress; text deltas are being streamed */
  Streaming = 'STREAMING',
  /** Stopped because the conversation exceeded the model context window; the conversation is closed */
  TruncatedBudget = 'TRUNCATED_BUDGET'
}

/** One hosting region's AI model offer. */
export type AiModelCatalogRegion = {
  __typename?: 'AiModelCatalogRegion';
  /** Whether the region can serve traffic (its provider credential is configured). An unavailable region cannot be assigned to a company. */
  available: Scalars['Boolean']['output'];
  /** The selectable assistant models. */
  chatModels: Array<AiModelOption>;
  /** Stable persona key for the region's one-line description; clients map it to their own localized copy. Null — or a key the client does not recognize — means no description. */
  copyKey: Maybe<Scalars['String']['output']>;
  /** Human-readable region name. */
  displayName: Scalars['String']['output'];
  /** The region-derived embedding model powering document search. Not selectable. */
  embeddingModel: AiModelInfo;
  /** What extracts each indexable media kind in this region — one entry per kind, each with the extracting model, or a null model when the region's assistant model does it via vision. Documents, images, and video may use different engines per region; render this instead of hardcoding a per-region label. */
  extractionMedia: Array<AiExtractionMedia>;
  /** The region-derived document-extraction (OCR) model. Null when extraction rides the chat model's vision. */
  extractionModel: Maybe<AiModelInfo>;
  /** The media kinds this region's indexing pipeline can turn into searchable text. A kind absent here (e.g. VIDEO under a region whose model cannot read video) is stored but never searchable — derive any "not indexed" note from what is missing, never hardcode it per region. */
  indexableMediaKinds: Array<AiMediaKindEnum>;
  /** Whether this region is the recommended choice. */
  recommended: Scalars['Boolean']['output'];
  /** The hosting and data region. */
  region: CompanyPlanAiRegionEnum;
};

/** A region-derived AI model with its pricing. Display data only — no input accepts its id. */
export type AiModelInfo = {
  __typename?: 'AiModelInfo';
  /** Human-readable model name. */
  displayName: Scalars['String']['output'];
  /** The model's id. */
  modelId: Scalars['String']['output'];
  /** The model's price. */
  pricing: AiModelPricing;
};

/** A selectable AI chat model with its pricing. */
export type AiModelOption = {
  __typename?: 'AiModelOption';
  /** Stable persona key for the option's one-line description; clients map it to their own localized copy. Null — or a key the client does not recognize — means no description. */
  copyKey: Maybe<Scalars['String']['output']>;
  /** Whether this model applies when no selection is stored. */
  default: Scalars['Boolean']['output'];
  /** Human-readable model name. */
  displayName: Scalars['String']['output'];
  /** Whether this model is the newest/premium tier. */
  latest: Scalars['Boolean']['output'];
  /** The id to store via companyCreate/companyUpdate plan.aiModelConfig.chatModelId. */
  modelId: Scalars['String']['output'];
  /** The model's price. */
  pricing: AiModelPricing;
  /** Whether this model is the recommended choice. */
  recommended: Scalars['Boolean']['output'];
};

/** A provider discount currently applied to a model's price, and the price it reverts to when the discount lapses. */
export type AiModelPriceDiscount = {
  __typename?: 'AiModelPriceDiscount';
  /** The last day the discounted price applies. Null for a discount published without an end date. */
  endsOn: Maybe<Scalars['ISO8601Date']['output']>;
  /** listInputPrice converted to EUR at the current exchange rate. Null when no rate is available. */
  listEurInputPrice: Maybe<Scalars['Float']['output']>;
  /** listOutputPrice converted to EUR at the current exchange rate. Null when listOutputPrice is null or no rate is available. */
  listEurOutputPrice: Maybe<Scalars['Float']['output']>;
  /** Price per `per` input units once the discount lapses, in `currency`. */
  listInputPrice: Maybe<Scalars['Float']['output']>;
  /** Price per `per` output tokens once the discount lapses, in `currency`. Null for embedding and extraction models. */
  listOutputPrice: Maybe<Scalars['Float']['output']>;
  /** How far below the list price the model is charged today, rounded to whole percent. */
  percentage: Maybe<Scalars['Int']['output']>;
};

/** An AI model's price in its provider's billing currency, with EUR equivalents. */
export type AiModelPricing = {
  __typename?: 'AiModelPricing';
  /** Approximate words corresponding to `per` units (~0.75 words per token, ~500 words per page) — an English-centric display hint (real ratios vary by language, tokenizer and layout), never a billing basis. */
  approxWordsPer: Maybe<Scalars['Int']['output']>;
  /** ISO code of the currency the provider bills in. */
  currency: Scalars['String']['output'];
  /** The provider discount currently applied to this model, and the list price it reverts to. Null when the model is charged at list price, and once a discount has lapsed. */
  discount: Maybe<AiModelPriceDiscount>;
  /** inputPrice converted to EUR at the current exchange rate (equals inputPrice when the currency is EUR). Null when no rate is available. */
  eurInputPrice: Maybe<Scalars['Float']['output']>;
  /** outputPrice converted to EUR at the current exchange rate (equals outputPrice when the currency is EUR). Null when outputPrice is null or no rate is available. */
  eurOutputPrice: Maybe<Scalars['Float']['output']>;
  /** Price per `per` input units, in `currency`. */
  inputPrice: Scalars['Float']['output'];
  /** Price per `per` output tokens, in `currency`. Null for embedding and extraction models. */
  outputPrice: Maybe<Scalars['Float']['output']>;
  /** The denominator the prices refer to (1,000,000 tokens or 1,000 pages). */
  per: Scalars['Int']['output'];
  /** Whether prices are per tokens or per document pages. */
  unit: AiPricingUnitEnum;
};

/** Everything the AI price calculator screen needs — the form to render, the rate cards, the costed workload and the caveats that apply to it. */
export type AiPriceCalculator = {
  __typename?: 'AiPriceCalculator';
  /** The panel's own wording, so the client holds no copy of its own. */
  copy: AiPriceCopy;
  /** The same workload costed at the price a discounted model reverts to, and the date it does. Null when nothing this quote prices is discounted. */
  discount: Maybe<AiPriceDiscount>;
  /** The submitted workload costed out. */
  estimate: AiPriceEstimate;
  /** The form controls to render, with their labels, bounds, defaults and options. */
  fields: Array<AiPriceFormField>;
  /** Caveats that apply to this particular quote. */
  notices: Array<AiPriceNotice>;
  /** Per-unit prices for every region and assistant model on offer, priced for the same workload. */
  rateCards: Array<AiPriceRateCard>;
};

/** The workload to cost and how to calibrate it. Every argument is optional — omit them all to get the form, its defaults, and the estimate they produce. */
export type AiPriceCalculatorInput = {
  /** Which assistant model to cost. Defaults to the region's own default. */
  chatModelId?: InputMaybe<Scalars['String']['input']>;
  /** Offers this company's own size as a starting point. Does not narrow the calibration, which stays platform-wide. */
  companyId?: InputMaybe<Scalars['ID']['input']>;
  /** Average document size, used for storage and transfer, and to infer pages when pages are not given. */
  documentSizeMb?: InputMaybe<Scalars['Float']['input']>;
  /** How many documents will be indexed. */
  documents?: InputMaybe<Scalars['Int']['input']>;
  /** How many documents arrive each month after go-live. Indexing recurs, so this is what makes the monthly figure real. */
  documentsPerMonth?: InputMaybe<Scalars['Int']['input']>;
  /** Average image size. Affects storage and transfer only. */
  imageSizeMb?: InputMaybe<Scalars['Float']['input']>;
  /** How many images will be indexed. Billed per image rather than per megabyte. */
  images?: InputMaybe<Scalars['Int']['input']>;
  /** Images uploaded every month after go-live, indexed as they land. */
  imagesPerMonth?: InputMaybe<Scalars['Int']['input']>;
  /** Messages each user sends per month. Model round-trips per message are already accounted for. */
  messagesPerUser?: InputMaybe<Scalars['Int']['input']>;
  /** Average pages per document. The main cost driver — extraction is billed per page. */
  pagesPerDocument?: InputMaybe<Scalars['Int']['input']>;
  /** Which hosting region to cost. Defaults to the recommended one. */
  region?: InputMaybe<CompanyPlanAiRegionEnum>;
  /** How many people will use the assistant. */
  users?: InputMaybe<Scalars['Int']['input']>;
  /** Average video size. Video cost scales with size — the whole file is sent to the model. */
  videoSizeMb?: InputMaybe<Scalars['Float']['input']>;
  /** How many videos will be indexed. Not supported in every region. */
  videos?: InputMaybe<Scalars['Int']['input']>;
  /** Videos uploaded every month after go-live, indexed as they land. */
  videosPerMonth?: InputMaybe<Scalars['Int']['input']>;
  /** How far back to measure real usage when calibrating the platform-wide averages. */
  windowDays?: InputMaybe<Scalars['String']['input']>;
};

/** Where one figure behind the estimate came from — real traffic or a committed default. */
export type AiPriceCalibrationEntry = {
  __typename?: 'AiPriceCalibrationEntry';
  /** Which figure this describes. */
  key: Scalars['String']['output'];
  /** How many observations it rests on; null for a default. */
  sampleSize: Maybe<Scalars['Int']['output']>;
  /** Whether it was measured or defaulted. */
  source: AiPriceCalibrationSourceEnum;
  /** The figure itself. */
  value: Maybe<Scalars['JSON']['output']>;
};

/** Whether a figure behind a price estimate was measured from real traffic or fell back to a committed default. */
export enum AiPriceCalibrationSourceEnum {
  /** A committed fallback, used when there was not enough real usage to trust. */
  Default = 'DEFAULT',
  /** Learned from the platform's own usage over the calibration window. */
  Measured = 'MEASURED'
}

/** One priced ingredient of a unit of work. A single unit can span two providers on different commercial terms, only one of which may charge a commission. */
export type AiPriceComponent = {
  __typename?: 'AiPriceComponent';
  /** What the provider's platform adds on top. */
  commission: Scalars['Float']['output'];
  /** Net plus commission — what we actually pay. */
  gross: Scalars['Float']['output'];
  /** What this ingredient is — extraction, embedding, chat, storage, egress or database. */
  key: Scalars['String']['output'];
  /** Provider list price, in the estimate's currency. */
  net: Scalars['Float']['output'];
  /** The provider billing it, or null for infrastructure. */
  provider: Maybe<Scalars['String']['output']>;
};

/** The calculator panel's own wording — captions, column headings and section names, so the client holds none of its own. */
export type AiPriceCopy = {
  __typename?: 'AiPriceCopy';
  /** Name of the section holding fields a quote rarely touches. */
  advancedSection: Scalars['String']['output'];
  /** Caption for the same total costed at list price, shown beside each figure while a model in the quote is discounted. */
  afterDiscount: Scalars['String']['output'];
  /** How a cost relates to the monthly AI budget it can be applied to. */
  budgetHint: Scalars['String']['output'];
  /** Name of the assistant-usage block. */
  conversationsSection: Scalars['String']['output'];
  /** Names the figure as our spend rather than a price to charge. */
  costLabel: Scalars['String']['output'];
  /** What the estimate is and how far it can be trusted. */
  description: Scalars['String']['output'];
  /** Name of the section holding the rate card and the remaining caveats. */
  detailsSection: Scalars['String']['output'];
  /** Name of the corpus block. */
  documentsSection: Scalars['String']['output'];
  /** Name of the images-and-video section. */
  mediaSection: Scalars['String']['output'];
  /** Shown as the media section's summary when it asks for none. */
  mediaSectionEmpty: Scalars['String']['output'];
  /** Caption for the first month, which carries the migration. */
  monthOne: Scalars['String']['output'];
  /** Caption for every month after the migration. */
  monthly: Scalars['String']['output'];
  /** Shown in place of a price for a medium the region cannot index. */
  notSupported: Scalars['String']['output'];
  /** Heading for the rate card's unit column. */
  unitColumn: Scalars['String']['output'];
};

/** The same workload costed at the price a discounted model reverts to, beside the date it does. */
export type AiPriceDiscount = {
  __typename?: 'AiPriceDiscount';
  /** The last day the discounted prices apply — the earliest end date among the models this quote is priced with. Null when every discount on them was published without one. */
  endsOn: Maybe<Scalars['ISO8601Date']['output']>;
  /** The workload costed at the providers' list prices, for comparison with the estimate charged today. */
  estimate: AiPriceEstimate;
};

/** A workload costed out, with one-off and recurring costs kept apart. */
export type AiPriceEstimate = {
  __typename?: 'AiPriceEstimate';
  /** The named parts each total was built from, for a cost-breakdown chart. */
  breakdown: Scalars['JSON']['output'];
  /** Quantities inferred from the workload, such as page counts implied by file sizes. */
  derived: Scalars['JSON']['output'];
  /** The one-off and the first month together. */
  monthOne: AiPriceTotals;
  /** Charged every month — conversations, storage and database. */
  monthly: AiPriceTotals;
  /** Charged once, when the corpus is first indexed. */
  oneOff: AiPriceTotals;
};

/** How prominent a price-calculator field is — the handful that decide the price, versus details a quote rarely touches. */
export enum AiPriceFieldGroupEnum {
  /** Tuning a quote rarely needs. */
  Advanced = 'ADVANCED',
  /** Rendered by the page this panel sits under, not by the panel itself. */
  Configuration = 'CONFIGURATION',
  /** How much the assistant is used; always shown. */
  Conversations = 'CONVERSATIONS',
  /** The corpus and its shape; always shown. */
  Documents = 'DOCUMENTS',
  /** Images and video, which most corpora have none of. */
  Media = 'MEDIA'
}

/** Which control renders a price-calculator field. */
export enum AiPriceFieldKindEnum {
  /** A numeric input. */
  Number = 'NUMBER',
  /** A small set of mutually exclusive choices shown side by side. */
  Segmented = 'SEGMENTED',
  /** A single-choice dropdown. */
  Select = 'SELECT'
}

/** One control on the calculator form, described by the backend so the client renders the same form the estimate was computed from. */
export type AiPriceFormField = {
  __typename?: 'AiPriceFormField';
  /** The value to start from. */
  defaultValue: Maybe<Scalars['JSON']['output']>;
  /** Why this control cannot be used with the current selection; null when it can. */
  disabledReason: Maybe<Scalars['String']['output']>;
  /** How prominent the field is, so a client can fold the details away. */
  group: AiPriceFieldGroupEnum;
  /** One line explaining what the value affects. */
  help: Maybe<Scalars['String']['output']>;
  /** The workload attribute this control sets. */
  key: Scalars['String']['output'];
  /** Which control to render. */
  kind: AiPriceFieldKindEnum;
  /** The control's label. */
  label: Scalars['String']['output'];
  /** Whether the value is a fact read from the record rather than an input; the reason is in disabled_reason. */
  locked: Scalars['Boolean']['output'];
  /** Highest accepted value. */
  max: Maybe<Scalars['Float']['output']>;
  /** Lowest accepted value. */
  min: Maybe<Scalars['Float']['output']>;
  /** The available choices, for controls that have a fixed set. */
  options: Array<AiPriceFormOption>;
  /** Increment between accepted values. */
  step: Maybe<Scalars['Float']['output']>;
  /** The unit the value is expressed in, when it has one. */
  unit: Maybe<Scalars['String']['output']>;
};

/** One choice available on a calculator control. */
export type AiPriceFormOption = {
  __typename?: 'AiPriceFormOption';
  /** A figure worth showing beside the label, such as what this model costs per message. */
  detail: Maybe<Scalars['Float']['output']>;
  /** The choice's label. */
  label: Scalars['String']['output'];
  /** The value submitted when this choice is picked. */
  value: Scalars['String']['output'];
};

/** The exchange rate every non-EUR price in this quote was converted at. */
export type AiPriceFx = {
  __typename?: 'AiPriceFx';
  /** Whether a rate was on record. When false, money fields are null rather than zero. */
  available: Scalars['Boolean']['output'];
  /** When that rate was published. */
  observedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The rate used. */
  rate: Maybe<Scalars['Float']['output']>;
};

/** The price of one unit — a page, a megabyte, a message, a gigabyte-month. Money fields are null, never zero, when the figure could not be produced. */
export type AiPriceLine = {
  __typename?: 'AiPriceLine';
  /** What the provider's platform adds on top. */
  commission: Maybe<Scalars['Float']['output']>;
  /** The priced ingredients this line is the sum of. */
  components: Array<AiPriceComponent>;
  /** Net plus commission — what we actually pay. */
  gross: Maybe<Scalars['Float']['output']>;
  /** Which unit this prices. */
  key: Scalars['String']['output'];
  /** The unit's name, for display. */
  label: Scalars['String']['output'];
  /** The kind of file this applies to, when it applies to one. */
  mediaKind: Maybe<AiMediaKindEnum>;
  /** Provider list price. */
  net: Maybe<Scalars['Float']['output']>;
  /** Why it could not be priced — the medium is not indexable, the model has no price, or no exchange rate was available. */
  reason: Maybe<Scalars['String']['output']>;
  /** Whether this unit could be priced at all. */
  supported: Scalars['Boolean']['output'];
  /** What one unit is. */
  unit: Scalars['String']['output'];
};

/** A caveat that applies to this quote, emitted only when it applies. */
export type AiPriceNotice = {
  __typename?: 'AiPriceNotice';
  /** Which caveat this is, for clients that want to style or suppress specific ones. */
  key: Scalars['String']['output'];
  /** The caveat, already translated. */
  message: Scalars['String']['output'];
  /** How much attention it deserves. */
  severity: AiPriceNoticeSeverityEnum;
};

/** How much attention a price-calculator caveat deserves. */
export enum AiPriceNoticeSeverityEnum {
  /** The estimate could not be produced in full. */
  Error = 'ERROR',
  /** Context worth knowing; nothing is wrong. */
  Info = 'INFO',
  /** Confirmation that the figures rest on real measurements. */
  Success = 'SUCCESS',
  /** Something that materially affects the price or its reliability. */
  Warning = 'WARNING'
}

/** Per-unit prices for one region and one assistant model, independent of any workload. */
export type AiPriceRateCard = {
  __typename?: 'AiPriceRateCard';
  /** Whether bulk-import pricing was applied. */
  batch: Scalars['Boolean']['output'];
  /** Where each figure behind these prices came from. */
  calibration: Array<AiPriceCalibrationEntry>;
  /** The assistant model priced. */
  chatModelId: Scalars['String']['output'];
  /** The currency every figure is expressed in. */
  currency: Scalars['String']['output'];
  /** The exchange rate the non-EUR prices were converted at. */
  fx: AiPriceFx;
  /** Whether files reach the model as inlined bytes rather than links, which changes what transfer costs. */
  inlineAttachments: Scalars['Boolean']['output'];
  /** The per-unit prices. */
  lines: Array<AiPriceLine>;
  /** The hosting region priced. */
  region: CompanyPlanAiRegionEnum;
  /** Whether this region is configured on this environment and can serve traffic today. */
  regionAvailable: Scalars['Boolean']['output'];
};

/** A costed total. Null rather than zero when part of the workload could not be priced. */
export type AiPriceTotals = {
  __typename?: 'AiPriceTotals';
  /** What provider platforms add on top. */
  commission: Maybe<Scalars['Float']['output']>;
  /** Net plus commission — what we actually pay. */
  gross: Maybe<Scalars['Float']['output']>;
  /** Provider list prices. */
  net: Maybe<Scalars['Float']['output']>;
};

/** Unit an AI model's price is denominated in */
export enum AiPricingUnitEnum {
  /** Priced per processed document pages */
  Pages = 'PAGES',
  /** Priced per processed tokens */
  Tokens = 'TOKENS'
}

/** Description from base input object. Please set your description for child object. */
export type AiSendMessageInput = {
  /** The message to send. */
  attributes: AiSendMessageInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Input for sending a message to an AI conversation. */
export type AiSendMessageInputObject = {
  /** The message as ordered content blocks (text and entity references). */
  contentBlocks: Array<AiContentBlockInputObject>;
  /** Existing conversation to continue; omit to start a new one. */
  conversationId?: InputMaybe<Scalars['ID']['input']>;
  /** The AI feature (assistant) to use. */
  feature: AiConversationFeatureEnum;
  /** Sets the conversation's reasoning level from this message on (sticky until changed); omit to keep the current level. Levels come from aiThinkingCapability; a level the model does not support is safely ignored at send time. */
  thinkingLevel?: InputMaybe<AiThinkingLevelEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type AiSendMessageStopInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The conversation ID. */
  id: Scalars['ID']['input'];
};

/** Kind of event delivered on the AI conversation stream */
export enum AiStreamEventTypeEnum {
  /** An assistant message frame (text delta or status change) */
  Message = 'MESSAGE',
  /** Follow-up question suggestions generated for a completed assistant message */
  Suggestions = 'SUGGESTIONS',
  /** A reasoning frame — an extended-thinking text delta streamed before the answer when thinking mode is on */
  Thinking = 'THINKING',
  /** The conversation's auto-generated title */
  Title = 'TITLE',
  /** A tool-activity frame emitted when a tool starts or finishes running during the turn */
  Tool = 'TOOL'
}

/** The thinking levels the current AI model offers — the choices a client may present and send as thinkingLevel. Per model; cache it, it changes only when the model does. */
export type AiThinkingCapability = {
  __typename?: 'AiThinkingCapability';
  /** The thinking levels available on the current model; a single-element list means there is nothing to pick. */
  levels: Array<AiThinkingLevelEnum>;
  /** Whether reasoning is UNSUPPORTED, OPTIONAL (reasons on demand), or ALWAYS_ON. */
  mode: AiThinkingModeEnum;
  /** Whether the thinking level is user-selectable — false when a single level is offered. */
  selectable: Scalars['Boolean']['output'];
};

/** The reasoning level of an AI conversation — one vocabulary for every model, mapped to the model's own reasoning control at send time */
export enum AiThinkingLevelEnum {
  /** The model reasons before answering — deeper analysis at higher cost and latency */
  Extended = 'EXTENDED',
  /** Regular answers without extended reasoning */
  Standard = 'STANDARD'
}

/** Whether the current AI model supports extended thinking (reasoning) */
export enum AiThinkingModeEnum {
  /** The model always reasons; EXTENDED is the only level */
  AlwaysOn = 'ALWAYS_ON',
  /** The model reasons on demand */
  Optional = 'OPTIONAL',
  /** The model cannot reason; STANDARD is the only level */
  Unsupported = 'UNSUPPORTED'
}

/** A tool invocation requested by an assistant message. */
export type AiToolCall = TimestampInterface & {
  __typename?: 'AiToolCall';
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The tool call ID. */
  id: Scalars['ID']['output'];
  /** Provider-issued identifier of the invocation; matches toolCallId on AI conversation stream tool frames. */
  toolCallId: Scalars['ID']['output'];
  /** Machine name of the invoked tool. */
  toolName: Scalars['String']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Phase of a tool invocation reported on the AI conversation stream */
export enum AiToolStatusEnum {
  /** The tool has finished and returned its result */
  Completed = 'COMPLETED',
  /** The tool has started executing */
  Running = 'RUNNING'
}

/** One row of the AI-usage-by-user table — an AI-enabled user's AI credit spend this period and its share of the total user spend (zero for a user who hasn't used AI). */
export type AiUsageByUser = {
  __typename?: 'AiUsageByUser';
  /** Credits this user spent this period, rounded up (0 if none). */
  creditsUsed: Scalars['Int']['output'];
  /** This row's share of the total user spend this period, as a percentage (0–100). */
  sharePercentage: Scalars['Float']['output'];
  /** The AI-enabled user this row is for. */
  user: User;
};

/** AiUsageByUserCollection type */
export type AiUsageByUserCollection = {
  __typename?: 'AiUsageByUserCollection';
  /** A collection of paginated AiUsageByUserCollection */
  collection: Array<AiUsageByUser>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Filters for the AI usage-by-user table. */
export type AiUsageByUserFilterInputObject = {
  /** Filter by user name. */
  fullName?: InputMaybe<FilterInputObject>;
};

/** Sort options for the AI usage-by-user table. */
export type AiUsageByUserSortInputObject = {
  /** Sort by credits used. */
  creditsUsed?: InputMaybe<SortDirectionEnum>;
  /** Sort by user name. */
  name?: InputMaybe<SortDirectionEnum>;
  /** Sort by share of usage. */
  sharePercentage?: InputMaybe<SortDirectionEnum>;
};

/** API Token */
export type ApiToken = TimestampInterface & {
  __typename?: 'ApiToken';
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** ApiToken ID */
  id: Scalars['ID']['output'];
  /** Label */
  label: Maybe<Scalars['String']['output']>;
  /** Last activity time */
  lastActivityAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Status */
  status: Maybe<ApiTokenStatusEnum>;
  /** Token (can be accessed once only after creation) */
  token: Maybe<Scalars['String']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** ApiTokenCollection type */
export type ApiTokenCollection = {
  __typename?: 'ApiTokenCollection';
  /** A collection of paginated ApiTokenCollection */
  collection: Array<ApiToken>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type ApiTokenCreateInput = {
  /** Create attributes */
  attributes: ApiTokenCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** ApiToken attributes */
export type ApiTokenCreateInputObject = {
  /** Label */
  label?: InputMaybe<Scalars['String']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type ApiTokenDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ApiToken ID */
  id: Scalars['ID']['input'];
};

/** Available statuses */
export enum ApiTokenStatusEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/** Description from base input object. Please set your description for child object. */
export type ApiTokenUpdateInput = {
  /** Update attributes */
  attributes: ApiTokenUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ApiToken ID */
  id: Scalars['ID']['input'];
};

/** ApiToken attributes */
export type ApiTokenUpdateInputObject = {
  /** Label */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Status */
  status?: InputMaybe<ApiTokenStatusEnum>;
};

/** Asset entity */
export type Asset = TimestampInterface & {
  __typename?: 'Asset';
  canDestroy: AuthorizationResult;
  /**
   * Asset Category entity
   * NOTE: if you only need an Object ID, please use the categoryId field to reduce the load on the database.
   */
  category: Maybe<AssetCategory>;
  /** Asset Category ID */
  categoryId: Maybe<Scalars['ID']['output']>;
  /** Code */
  code: Scalars['String']['output'];
  /** Counter count */
  countersCount: Maybe<Scalars['Int']['output']>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Full code (As on the QR code) */
  fullCode: Scalars['String']['output'];
  /** Asset icon */
  iconAttached: Maybe<Attachment>;
  /** Asset ID */
  id: Scalars['ID']['output'];
  /** Manufacturer */
  manufacturer: Maybe<Scalars['String']['output']>;
  /** Model */
  model: Maybe<Scalars['String']['output']>;
  /** Name */
  name: Scalars['String']['output'];
  /** Indicates if asset location has poor wifi or does not have wifi */
  poorWifi: Scalars['Boolean']['output'];
  /** QR code prefix */
  qrPrefix: Maybe<Scalars['String']['output']>;
  /** Serial number */
  serialNumber: Maybe<Scalars['String']['output']>;
  /** Service date */
  serviceDate: Maybe<Scalars['ISO8601Date']['output']>;
  /**
   * Site entity
   * NOTE: if you only need an Object ID, please use the siteId field to reduce the load on the database.
   */
  site: Maybe<Site>;
  /**
   * Site Area entity
   * NOTE: if you only need an Object ID, please use the siteAreaId field to reduce the load on the database.
   */
  siteArea: Maybe<SiteArea>;
  /** Site Area ID */
  siteAreaId: Maybe<Scalars['ID']['output']>;
  /** Site ID */
  siteId: Maybe<Scalars['ID']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Indicates number of nomenclatures where is used */
  usesAsNomenclatureCount: Scalars['Int']['output'];
};

/** Description from base input object. Please set your description for child object. */
export type AssetBulkDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type AssetBulkQrCodeCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Create params */
  params: QrCodesCreateInputObject;
};

/** Asset Category entity */
export type AssetCategory = TimestampInterface & {
  __typename?: 'AssetCategory';
  /** Assets collection */
  assets: AssetCollection;
  canDestroy: AuthorizationResult;
  /** Color */
  color: ColorEnum;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Asset Category ID */
  id: Scalars['ID']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Prefix */
  prefix: Maybe<Scalars['String']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Number of visible Assets */
  visibleAssetsCount: Scalars['Int']['output'];
};


/** Asset Category entity */
export type AssetCategoryAssetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** AssetCategoryCollection type */
export type AssetCategoryCollection = {
  __typename?: 'AssetCategoryCollection';
  /** A collection of paginated AssetCategoryCollection */
  collection: Array<AssetCategory>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type AssetCategoryCreateInput = {
  /** Create attributes */
  attributes: AssetCategoryCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Asset Category attributes */
export type AssetCategoryCreateInputObject = {
  /** Color */
  color: ColorEnum;
  /** Name */
  name: Scalars['String']['input'];
  /** Prefix */
  prefix?: InputMaybe<Scalars['String']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type AssetCategoryDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Asset Category ID */
  id: Scalars['ID']['input'];
};

/** Asset Category filters */
export type AssetCategoryFilterInputObject = {
  /** Asset Category ID */
  id?: InputMaybe<FilterIdInputObject>;
  /** Asset Category name */
  name?: InputMaybe<FilterInputObject>;
};

/** Asset Category sorts */
export type AssetCategorySortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Number of visible Assets in this category */
  visibleAssetsCount?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type AssetCategoryUpdateInput = {
  /** Update attributes */
  attributes: AssetCategoryUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Asset Category ID */
  id: Scalars['ID']['input'];
  /** Refresh QR prefix for related assets */
  refreshQrPrefixForAssets?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Asset Category attributes */
export type AssetCategoryUpdateInputObject = {
  /** Color */
  color?: InputMaybe<ColorEnum>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Prefix */
  prefix?: InputMaybe<Scalars['String']['input']>;
};

/** AssetCollection type */
export type AssetCollection = {
  __typename?: 'AssetCollection';
  /** A collection of paginated AssetCollection */
  collection: Array<Asset>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type AssetCreateInput = {
  /** Create attributes */
  attributes: AssetCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Asset attributes */
export type AssetCreateInputObject = {
  /** Asset Category ID */
  categoryId: Scalars['ID']['input'];
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Documentations to link to / unlink from the asset. On the free plan, exactly one entry
   * is accepted and unlinking is not supported; on paid plans any combination of link and
   * unlink entries is allowed. On free-plan update, the provided link replaces any existing
   * documentation link(s) on the asset.
   *
   */
  documentationLinks?: InputMaybe<Array<DocumentationLinkInputObject>>;
  /** Icon */
  iconAttached?: InputMaybe<AttachmentCuInputObject>;
  /** Manufacturer */
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  /** Model */
  model?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name: Scalars['String']['input'];
  /** Indicates if asset location has poor wifi or does not have wifi */
  poorWifi?: InputMaybe<Scalars['Boolean']['input']>;
  /** Serial number */
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  /** Service date */
  serviceDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Site Area ID */
  siteAreaId?: InputMaybe<Scalars['ID']['input']>;
  /** Site ID */
  siteId: Scalars['ID']['input'];
};

/** Asset filters */
export type AssetFilterInputObject = {
  /** Asset Category ID */
  categoryId?: InputMaybe<FilterIdInputObject>;
  /** Asset Category name */
  categoryName?: InputMaybe<FilterInputObject>;
  /** Asset code */
  code?: InputMaybe<FilterInputObject>;
  /** Counter count */
  countersCount?: InputMaybe<FilterIntInputObject>;
  /** Documentation ID */
  documentationsId?: InputMaybe<FilterIdInputObject>;
  /** Asset ID */
  id?: InputMaybe<FilterIdInputObject>;
  /** Asset manufacturer */
  manufacturer?: InputMaybe<FilterInputObject>;
  /** Asset name */
  name?: InputMaybe<FilterInputObject>;
  /** QR prefix */
  qrPrefix?: InputMaybe<FilterInputObject>;
  /** Asset serial number */
  serialNumber?: InputMaybe<FilterInputObject>;
  /** Site Area code */
  siteAreaCode?: InputMaybe<FilterInputObject>;
  /** Site Area ID */
  siteAreaId?: InputMaybe<FilterIdInputObject>;
  /** Site Area name */
  siteAreaName?: InputMaybe<FilterInputObject>;
  /** Site code */
  siteCode?: InputMaybe<FilterInputObject>;
  /** Site ID */
  siteId?: InputMaybe<FilterIdInputObject>;
  /** Site name */
  siteName?: InputMaybe<FilterInputObject>;
  /** Site Sector ID */
  siteSectorId?: InputMaybe<FilterIdInputObject>;
};

/** Asset attributes */
export type AssetFindByInputObject = {
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** ID */
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Asset sorts */
export type AssetSortInputObject = {
  /** Asset Category name */
  categoryName?: InputMaybe<SortDirectionEnum>;
  /** Code */
  code?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Asset manufacturer */
  manufacturer?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Asset serial number */
  serialNumber?: InputMaybe<SortDirectionEnum>;
  /** Site Area code */
  siteAreaCode?: InputMaybe<SortDirectionEnum>;
  /** Site Area name */
  siteAreaName?: InputMaybe<SortDirectionEnum>;
  /** Site code */
  siteCode?: InputMaybe<SortDirectionEnum>;
  /** Site name */
  siteName?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type AssetUpdateInput = {
  /** Update attributes */
  attributes: AssetUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Asset ID */
  id: Scalars['ID']['input'];
};

/** Asset attributes */
export type AssetUpdateInputObject = {
  /** Asset Category ID */
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Documentations to link to / unlink from the asset. On the free plan, exactly one entry
   * is accepted and unlinking is not supported; on paid plans any combination of link and
   * unlink entries is allowed. On free-plan update, the provided link replaces any existing
   * documentation link(s) on the asset.
   *
   */
  documentationLinks?: InputMaybe<Array<DocumentationLinkInputObject>>;
  /** Icon */
  iconAttached?: InputMaybe<AttachmentCuInputObject>;
  /** Manufacturer */
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  /** Model */
  model?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if asset location has poor wifi or does not have wifi */
  poorWifi?: InputMaybe<Scalars['Boolean']['input']>;
  /** Serial number */
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  /** Service date */
  serviceDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Site Area ID */
  siteAreaId?: InputMaybe<Scalars['ID']['input']>;
  /** Update QR prefix (if true, QR prefix will be used from asset category prefix) */
  updateQrPrefix?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Attachment */
export type Attachment = {
  __typename?: 'Attachment';
  /** Raw file data JSON (to copy attached files from one object to another without reprocessing) */
  fileData: Maybe<Scalars['JSON']['output']>;
  /** Any string to identify file in CDN (content delivery network) (e.g. some default icon or image or whatever) */
  fileTag: Maybe<Scalars['String']['output']>;
  /** Filename */
  filename: Maybe<Scalars['String']['output']>;
  /** Attachment ID */
  id: Scalars['ID']['output'];
  /** {description: "Metadata", fields: {intended_use: "Intended use"}} */
  metadata: Maybe<AttachmentMetadata>;
  /** MIME type */
  mimeType: Maybe<Scalars['String']['output']>;
  /** Position */
  position: Maybe<Scalars['Int']['output']>;
  /** Indicates if attachment is processed */
  processed: Scalars['Boolean']['output'];
  /** URLs */
  urls: Maybe<AttachmentUrl>;
};

/** Attachment attributes */
export type AttachmentCuInputObject = {
  /** Destroy attachment */
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  /** File just uploaded to cache storage. Mutually exclusive with source_attachment_id */
  file?: InputMaybe<AttachmentFileInputObject>;
  /** Any string to identify file in CDN (content delivery network) (e.g. some default icon or image or whatever) */
  fileTag?: InputMaybe<Scalars['String']['input']>;
  /** Filename */
  filename?: InputMaybe<Scalars['String']['input']>;
  /** Attachment ID (to update existing attachment pass ID. To create new attachment do not pass ID) */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Metadata */
  metadata?: InputMaybe<AttachmentMetadataInputObject>;
  /** Position */
  position?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the attachment whose file to copy, instead of uploading it again. Only accepted by mutations that support copying, and only for an attachment you can already read */
  sourceAttachmentId?: InputMaybe<Scalars['ID']['input']>;
};

/** File attributes */
export type AttachmentFileInputObject = {
  /** File ID */
  id: Scalars['String']['input'];
  /** Metadata */
  metadata: AttachmentFileMetadataInputObject;
  /** Storage */
  storage: AttachmentStorageEnum;
};

/** File attributes */
export type AttachmentFileMetadataInputObject = {
  /** Filename */
  filename: Scalars['String']['input'];
  /** Height */
  height?: InputMaybe<Scalars['Int']['input']>;
  /** Mime type */
  mimeType: Scalars['String']['input'];
  /** Size of file */
  size: Scalars['Int']['input'];
  /** Width */
  width?: InputMaybe<Scalars['Int']['input']>;
};

/** Metadata */
export type AttachmentMetadata = {
  __typename?: 'AttachmentMetadata';
  /** Intended use */
  intendedUse: Maybe<Scalars['String']['output']>;
};

/** Metadata attributes */
export type AttachmentMetadataInputObject = {
  /** Intended use */
  intendedUse?: InputMaybe<Scalars['String']['input']>;
};

/** Available storages */
export enum AttachmentStorageEnum {
  Cache = 'cache'
}

/** Attachment URLs */
export type AttachmentUrl = {
  __typename?: 'AttachmentUrl';
  /** Image preview URL */
  imagePreview: Maybe<Scalars['String']['output']>;
  /** Large URL */
  large: Maybe<Scalars['String']['output']>;
  /** Medium URL */
  medium: Maybe<Scalars['String']['output']>;
  /** Original URL */
  original: Maybe<Scalars['String']['output']>;
  /** Original direct download URL (without preview in browser even for known formats) */
  originalDirectDownload: Maybe<Scalars['String']['output']>;
  /** Small URL */
  small: Maybe<Scalars['String']['output']>;
  /** Video 480p URL */
  video480p: Maybe<Scalars['String']['output']>;
  /** Video 720p URL */
  video720p: Maybe<Scalars['String']['output']>;
  /** Video 1080p URL */
  video1080p: Maybe<Scalars['String']['output']>;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationConfirmationsEmailConfirmationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Scope */
  scope: AuthenticationScopeEnum;
  /** Token */
  token: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationConfirmationsRegistrationConfirmationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Scope */
  scope: AuthenticationScopeEnum;
  /** Token */
  token: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationConfirmationsResendEmailConfirmationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Resource ID */
  id: Scalars['String']['input'];
  /** Url to confirm new email */
  redirectUrl: Scalars['String']['input'];
  /** Scope */
  scope: AuthenticationScopeEnum;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationConfirmationsResendRegistrationConfirmationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Resource ID */
  id: Scalars['String']['input'];
  /** Url to confirm registration */
  redirectUrl: Scalars['String']['input'];
  /** Scope */
  scope: AuthenticationScopeEnum;
};

/** Show entrypoint */
export type AuthenticationEntrypointUnion = ApiToken | Session;

/** Description from base input object. Please set your description for child object. */
export type AuthenticationPasswordSetupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** New password */
  password: Scalars['String']['input'];
  /** New password confirmation */
  passwordConfirmation: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationPasswordsForgotInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Email */
  email: Scalars['String']['input'];
  /** Url to change password */
  redirectUrl: Scalars['String']['input'];
  /** Scope */
  scope: AuthenticationScopeEnum;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationPasswordsResetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** New password */
  password: Scalars['String']['input'];
  /** New password confirmation */
  passwordConfirmation: Scalars['String']['input'];
  /** Scope */
  scope: AuthenticationScopeEnum;
  /** Token */
  token: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationPasswordsUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** New password */
  password: Scalars['String']['input'];
  /** Current password. Required only if user already has a password set (check hasPassword field). */
  passwordChallenge?: InputMaybe<Scalars['String']['input']>;
  /** New password confirmation */
  passwordConfirmation: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationResendAccountLockedEmailForAdminInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** URL to include in the email for account restoration */
  restoreRedirectUrl: Scalars['String']['input'];
  /** ID of the locked admin to send the email to */
  targetAdminId: Scalars['ID']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationResendAccountLockedEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Email address of the locked account */
  email: Scalars['String']['input'];
  /** URL for account restore link in email */
  restoreRedirectUrl: Scalars['String']['input'];
  /** Account type (USER or SYSTEM_ADMIN) */
  scope: AuthenticationScopeEnum;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationRestoreAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** New password */
  password: Scalars['String']['input'];
  /** New password confirmation */
  passwordConfirmation: Scalars['String']['input'];
  /** Scope */
  scope: AuthenticationScopeEnum;
  /** Account restore token from email */
  token: Scalars['String']['input'];
};

/** Available resource scopes */
export enum AuthenticationScopeEnum {
  SystemAdmin = 'SYSTEM_ADMIN',
  User = 'USER'
}

/** Description from base input object. Please set your description for child object. */
export type AuthenticationSessionCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Password */
  password: Scalars['String']['input'];
  /** Scope */
  scope: AuthenticationScopeEnum;
  /** Email or username */
  uid: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationSessionEndAllInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether to exclude current session (default true) */
  excludeCurrent?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationSessionEndInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationSessionEndSpecificInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Session ID */
  sessionId: Scalars['ID']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationSessionReportSuspiciousByTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** URL to redirect to for account restoration */
  restoreRedirectUrl: Scalars['String']['input'];
  /** Token from email */
  token: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationSessionReportSuspiciousInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** URL to redirect to for account restoration */
  restoreRedirectUrl: Scalars['String']['input'];
  /** Session ID to report */
  sessionId: Scalars['ID']['input'];
};

/** Two-factor authentication code types */
export enum AuthenticationTwoFactorCodeTypeEnum {
  /** Backup code */
  Backup = 'BACKUP',
  /** Email One-Time Password */
  Email = 'EMAIL',
  /** Time-based One-Time Password */
  Totp = 'TOTP'
}

/** Description from base input object. Please set your description for child object. */
export type AuthenticationTwoFactorDisableEmailOtpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationTwoFactorDisableTotpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationTwoFactorEnableEmailOtpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 6-digit code from email */
  code: Scalars['String']['input'];
  /** Generate backup codes after enabling email OTP */
  generateBackupCodes?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationTwoFactorEnableTotpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 6-digit code from authenticator app */
  code: Scalars['String']['input'];
  /** Generate backup codes after enabling TOTP */
  generateBackupCodes?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationTwoFactorGenerateBackupCodesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 2FA code for verification */
  code: Scalars['String']['input'];
  /** Type of code (totp, email, backup) */
  codeType: AuthenticationTwoFactorCodeTypeEnum;
};

/** Two-factor authentication methods */
export enum AuthenticationTwoFactorOtpMethodEnum {
  /** Email One-Time Password */
  Email = 'EMAIL',
  /** Time-based One-Time Password (authenticator app) */
  Totp = 'TOTP'
}

/** Description from base input object. Please set your description for child object. */
export type AuthenticationTwoFactorResendEmailOtpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationTwoFactorResetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Current admin's 2FA code for verification */
  code: Scalars['String']['input'];
  /** Type of code (totp, email, backup) */
  codeType: AuthenticationTwoFactorCodeTypeEnum;
  /** Target SystemAdmin ID */
  targetAdminId: Scalars['ID']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationTwoFactorSetupEmailOtpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 2FA verification code (required when adding second method) */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Type of verification code (required when adding second method) */
  codeType?: InputMaybe<AuthenticationTwoFactorCodeTypeEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationTwoFactorSetupTotpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 2FA verification code (required when adding second method) */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Type of verification code (required when adding second method) */
  codeType?: InputMaybe<AuthenticationTwoFactorCodeTypeEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationTwoFactorVerifyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 6-digit code from authenticator app or email */
  code: Scalars['String']['input'];
  /** Type of code (totp, email, backup) */
  codeType: AuthenticationTwoFactorCodeTypeEnum;
};

/** Show current user */
export type AuthenticationWhoamiUnion = SystemAdmin | User;

export type AuthorizationResult = {
  __typename?: 'AuthorizationResult';
  /** Human-readable error message */
  message: Maybe<Scalars['String']['output']>;
  /** Reasons of check failure */
  reasons: Maybe<FailureReasons>;
  /** Result of applying a policy rule */
  value: Scalars['Boolean']['output'];
};

/** A tracked background job — a node in a (possibly hierarchical) job tree */
export type BackgroundJob = TimestampInterface & {
  __typename?: 'BackgroundJob';
  canCancel: AuthorizationResult;
  canDismiss: AuthorizationResult;
  canRequestDelivery: AuthorizationResult;
  canRequeue: AuthorizationResult;
  /** When cancellation was requested (drives the "Cancelling…" state); null otherwise */
  cancelRequestedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Child nodes (e.g. phases) of this job */
  children: Array<BackgroundJob>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** When the owner asked to be emailed the result; null otherwise */
  deliveryRequestedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Whether the owner has closed this job from their list */
  dismissed: Scalars['Boolean']['output'];
  /** User-facing status — like status but never shows retrying (a retrying job is presented as working/in progress) */
  displayStatus: BackgroundJobStatusEnum;
  /** Units completed */
  done: Scalars['Int']['output'];
  /** Stable reason this job failed, for the client to key off; null unless it failed with a classified cause. Shares its vocabulary with the AI stream's errorCode (e.g. budget_exhausted), so one copy map serves both. */
  errorCode: Maybe<Scalars['String']['output']>;
  /** Absolute estimated finish time (null when not estimable); count down to it */
  estimatedFinishAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Units that failed */
  failed: Scalars['Int']['output'];
  /** When the job reached a terminal status */
  finishedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Background job ID */
  id: Scalars['ID']['output'];
  /** The Sidekiq job ID (null for an aggregate phase) */
  jid: Maybe<Scalars['String']['output']>;
  /** What kind of work this job performs */
  kind: BackgroundJobKindEnum;
  /** Current progress message; cleared when the job finishes, so it is only ever set on a live node */
  message: Maybe<Scalars['String']['output']>;
  /** Parent node ID (null for a root) */
  parentId: Maybe<Scalars['ID']['output']>;
  /** Percentage complete (0–100) */
  pctComplete: Scalars['Int']['output'];
  /** The job's durable result payload, when it produces one */
  result: Maybe<Scalars['JSON']['output']>;
  /** Root node ID of this job's tree (the subscription topic) */
  rootId: Scalars['ID']['output'];
  /** When the job started running */
  startedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Current status (raw lifecycle state, incl. retrying) */
  status: BackgroundJobStatusEnum;
  /** Total units of work */
  total: Scalars['Int']['output'];
  /** Rolled-up status for this job's whole tree — working while any node is live, otherwise the worst terminal outcome (so a failed child is not hidden behind a complete parent) */
  treeStatus: BackgroundJobStatusEnum;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Description from base input object. Please set your description for child object. */
export type BackgroundJobCancelInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Background job ID */
  id: Scalars['ID']['input'];
};

/** BackgroundJobCollection type */
export type BackgroundJobCollection = {
  __typename?: 'BackgroundJobCollection';
  /** A collection of paginated BackgroundJobCollection */
  collection: Array<BackgroundJob>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type BackgroundJobDismissInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Background job ID */
  id: Scalars['ID']['input'];
};

/** Background job filters */
export type BackgroundJobFilterInputObject = {
  /** Filter by creation time */
  createdAt?: InputMaybe<FilterDateInputObject>;
  /** Filter by the dismissed (closed-from-list) flag */
  dismissed?: InputMaybe<FilterBooleanInputObject>;
  /** Filter by finish time */
  finishedAt?: InputMaybe<FilterDateInputObject>;
  /** Filter by ID */
  id?: InputMaybe<FilterIdInputObject>;
  /** Filter by kind */
  kind?: InputMaybe<FilterIntInputObject>;
  /** Filter by status */
  status?: InputMaybe<FilterIntInputObject>;
};

/** Background-job kinds */
export enum BackgroundJobKindEnum {
  /** Data import */
  DataImport = 'DATA_IMPORT',
  /** AI field detection for an imported document */
  DocumentationFieldDetection = 'DOCUMENTATION_FIELD_DETECTION',
  /** Documentation import */
  DocumentationImport = 'DOCUMENTATION_IMPORT',
  /** QR code generation */
  QrCodeGeneration = 'QR_CODE_GENERATION',
  /** Timeline report generation */
  TimelineReport = 'TIMELINE_REPORT'
}

/** A pushed change to a background job tree — apply the node delta by id */
export type BackgroundJobProgressEvent = {
  __typename?: 'BackgroundJobProgressEvent';
  /** The changed node */
  node: Maybe<BackgroundJob>;
  /** Root node ID of the affected tree */
  rootId: Scalars['ID']['output'];
};

/** Description from base input object. Please set your description for child object. */
export type BackgroundJobRequestDeliveryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Background job ID */
  id: Scalars['ID']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type BackgroundJobRequeueInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Background job ID */
  id: Scalars['ID']['input'];
};

/** Coarse status-group presets for listing background jobs */
export enum BackgroundJobScopeEnum {
  /** All jobs */
  All = 'ALL',
  /** Completed */
  Completed = 'COMPLETED',
  /** Failed or interrupted */
  Failed = 'FAILED',
  /** Queued */
  Queued = 'QUEUED',
  /** Finished within the last 30 minutes (any outcome) */
  Recent = 'RECENT',
  /** Retrying */
  Retrying = 'RETRYING',
  /** Stopped */
  Stopped = 'STOPPED',
  /** Working */
  Working = 'WORKING'
}

/** Background job sorts */
export type BackgroundJobSortInputObject = {
  /** Sort by creation time */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Sort by finish time */
  finishedAt?: InputMaybe<SortDirectionEnum>;
};

/** Background-job statuses */
export enum BackgroundJobStatusEnum {
  /** Completed successfully */
  Complete = 'COMPLETE',
  /** Failed (after all retries) */
  Failed = 'FAILED',
  /** Interrupted (process ended before finishing) */
  Interrupted = 'INTERRUPTED',
  /** Queued (waiting to be processed) */
  Queued = 'QUEUED',
  /** Still in progress: an attempt failed and another is scheduled. Not an outcome — use display_status, which presents it as working */
  Retrying = 'RETRYING',
  /** Stopped (cancelled) */
  Stopped = 'STOPPED',
  /** Work in progress */
  Working = 'WORKING'
}

/** Type for CollectionMetadataType */
export type CollectionMetadata = {
  __typename?: 'CollectionMetadata';
  /** Current Page of loaded data */
  currentPage: Scalars['Int']['output'];
  /** The number of items per page */
  limitValue: Scalars['Int']['output'];
  /** The total number of items to be paginated */
  totalCount: Scalars['Int']['output'];
  /** The total number of pages in the pagination */
  totalPages: Scalars['Int']['output'];
};

/** Available colors */
export enum ColorEnum {
  Aquamarine = 'AQUAMARINE',
  Black = 'BLACK',
  Blue = 'BLUE',
  Brown = 'BROWN',
  Coral = 'CORAL',
  Gray = 'GRAY',
  Green = 'GREEN',
  Lime = 'LIME',
  Orange = 'ORANGE',
  Pink = 'PINK',
  Red = 'RED',
  Violet = 'VIOLET',
  White = 'WHITE',
  Yellow = 'YELLOW'
}

/** Company entity */
export type Company = TimestampInterface & {
  __typename?: 'Company';
  /** Active users count in the company */
  activeUsersCount: Scalars['Int']['output'];
  /**
   * Share of the AI budget consumed this cycle, as a percentage (0–100); null when no budget is enforced.
   * ATTENTION: Access allowed for system admins.
   */
  aiAssistancePercentage: Maybe<Scalars['Float']['output']>;
  /**
   * The company's AI budget for the current cycle — AI credits + Total/User/System usage percentages (plus the raw euro ledger and cycle dates, system-admin only).
   * ATTENTION: Access allowed for system admins.
   */
  aiBudgetStatus: AiBudgetStatus;
  /**
   * Estimated AI cost for the current budget cycle, in EUR micros (millionths of a euro); null when no budget is enforced.
   * ATTENTION: Access allowed for system admins.
   */
  aiEstimatedPriceMicros: Maybe<Scalars['BigInt']['output']>;
  /**
   * Document indexing coverage counts for this company.
   * ATTENTION: Access allowed for system admins.
   */
  aiIndexingCoverage: AiIndexingCoverage;
  /** Country */
  country: CountryEnum;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Indicates if company is deactivated */
  deactivated: Scalars['Boolean']['output'];
  /** Description */
  description: Scalars['String']['output'];
  /** Company ID */
  id: Scalars['ID']['output'];
  /** Industry */
  industry: Maybe<Industry>;
  /** Name */
  name: Scalars['String']['output'];
  /** Company full admin owner entity */
  owner: Maybe<User>;
  /** Plan entity */
  plan: CompanyPlan;
  /** Timezone name */
  timezone: Scalars['String']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Active users as a percentage (0–100) of the plan's user limit; null when no limit is set. */
  usersLimitPercentage: Maybe<Scalars['Float']['output']>;
  /** Website */
  website: Maybe<Scalars['String']['output']>;
};


/** Company entity */
export type CompanyAiIndexingCoverageArgs = {
  region?: InputMaybe<CompanyPlanAiRegionEnum>;
};

/** CompanyCollection type */
export type CompanyCollection = {
  __typename?: 'CompanyCollection';
  /** A collection of paginated CompanyCollection */
  collection: Array<Company>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type CompanyCreateInput = {
  /** Create attributes */
  attributes: CompanyCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Url to confirm registration */
  redirectUrl: Scalars['String']['input'];
};

/** Company attributes */
export type CompanyCreateInputObject = {
  /** Admin attributes */
  admin: UserCreateOwnerInputObject;
  /** Country */
  country: CountryEnum;
  /** Description */
  description: Scalars['String']['input'];
  /** Industry ID */
  industryId?: InputMaybe<Scalars['ID']['input']>;
  /** Name */
  name: Scalars['String']['input'];
  /** Plan attributes */
  plan: CompanyPlanCuInputObject;
  /** Website */
  website?: InputMaybe<Scalars['String']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type CompanyDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 2FA code for verification */
  code: Scalars['String']['input'];
  /** Type of code (totp, email, backup) */
  codeType: AuthenticationTwoFactorCodeTypeEnum;
  /** Company ID */
  id: Scalars['ID']['input'];
};

/** Company Domain entity */
export type CompanyDomain = TimestampInterface & {
  __typename?: 'CompanyDomain';
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Full DNS TXT record for domain verification */
  dnsTxtRecord: Scalars['String']['output'];
  /** Domain name */
  domain: Scalars['String']['output'];
  /** Company Domain ID */
  id: Scalars['ID']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** DNS verification token */
  verificationToken: Scalars['String']['output'];
  /** Indicates if domain is verified */
  verified: Scalars['Boolean']['output'];
  /** Verification timestamp */
  verifiedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** CompanyDomainCollection type */
export type CompanyDomainCollection = {
  __typename?: 'CompanyDomainCollection';
  /** A collection of paginated CompanyDomainCollection */
  collection: Array<CompanyDomain>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type CompanyDomainCreateInput = {
  /** Create attributes */
  attributes: CompanyDomainCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Company Domain attributes */
export type CompanyDomainCreateInputObject = {
  /** Domain name (e.g., example.com) */
  domain: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type CompanyDomainDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Company Domain ID */
  id: Scalars['ID']['input'];
};

/** Company Domain filters */
export type CompanyDomainFilterInputObject = {
  /** Created at */
  createdAt?: InputMaybe<FilterDateInputObject>;
  /** Domain name */
  domain?: InputMaybe<FilterInputObject>;
  /** Company Domain ID */
  id?: InputMaybe<FilterIdInputObject>;
  /** Verification timestamp */
  verifiedAt?: InputMaybe<FilterDateInputObject>;
};

/** Company Domain sorts */
export type CompanyDomainSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Domain name */
  domain?: InputMaybe<SortDirectionEnum>;
  /** Verification timestamp */
  verifiedAt?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type CompanyDomainVerifyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Company Domain ID */
  id: Scalars['ID']['input'];
};

/** Company filters */
export type CompanyFilterInputObject = {
  /** Country name */
  country?: InputMaybe<FilterInputObject>;
  /** Industry ID */
  industryId?: InputMaybe<FilterIdInputObject>;
  /** Industry name */
  industryName?: InputMaybe<FilterInputObject>;
  /** Company name */
  name?: InputMaybe<FilterInputObject>;
  /** Owner full name */
  ownerFullName?: InputMaybe<FilterInputObject>;
  /**
   * Plan kind
   * ATTENTION: Access allowed for system admins.
   */
  planKind?: InputMaybe<FilterIntInputObject>;
};

/** Company plan entity */
export type CompanyPlan = TimestampInterface & {
  __typename?: 'CompanyPlan';
  /** Accesses */
  accesses: Array<Access>;
  /**
   * AI budget cap for the current cycle, in EUR micros (millionths of a euro); null when no budget is set.
   * ATTENTION: Access allowed for system admins.
   */
  aiBudgetLimitMicros: Maybe<Scalars['BigInt']['output']>;
  /**
   * The media kinds the company's AI indexing pipeline turns into searchable text, derived from the plan's hosting region; an absent kind is not indexed.
   * ATTENTION: Requires plan upgrade for feature: AI_ASSISTANCE.
   */
  aiIndexableMediaKinds: Array<AiMediaKindEnum>;
  /**
   * The plan's AI hosting region and model configuration.
   * ATTENTION: Access allowed for system admins.
   */
  aiModelConfig: CompanyPlanAiModelConfig;
  /** Shows a list of available access components to create or edit for company users */
  allowedUsersAccessComponents: Array<AccessComponentEnum>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Currency
   * ATTENTION: Access allowed for system admins.
   */
  currency: Maybe<CompanyPlanCurrencyEnum>;
  /** Company plan ID */
  id: Scalars['ID']['output'];
  /**
   * Kind
   * ATTENTION: Access allowed for system admins.
   */
  kind: Maybe<CompanyPlanKindEnum>;
  /**
   * Payment period
   * ATTENTION: Access allowed for system admins.
   */
  paymentPeriod: Maybe<CompanyPlanPaymentPeriodEnum>;
  /**
   * Price
   * ATTENTION: Access allowed for system admins.
   */
  price: Maybe<Scalars['Float']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Shows a list of features that require a plan upgrade for the company */
  upgradeFeatures: Array<AccessComponentEnum>;
  /** Maximum active users */
  usersLimit: Maybe<Scalars['Int']['output']>;
};

/** AI spending cap for the current billing period and the billing cycle anchor date. */
export type CompanyPlanAiBudgetInputObject = {
  /** Cap amount for the current billing period in euros (EUR). Provider-billed AI usage is converted to EUR at the exchange rate in effect when it occurred. */
  currentPeriod: Scalars['Float']['input'];
  /** Date the current billing cycle starts. Subsequent cycles roll over on the same day-of-month. Must be today or in the past. */
  cycleStartedAt: Scalars['ISO8601Date']['input'];
  /** When true, zeroes the counted spend now, making the full cap available for the rest of the current cycle. Billing cycle dates are unchanged, and a new cycle always starts counting from zero regardless of past resets. One-shot action, not a stored setting. */
  resetUsage?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A company plan's AI hosting region and model configuration. The region-derived embedding/extraction models are not repeated here — read them from aiModelCatalog by region. */
export type CompanyPlanAiModelConfig = {
  __typename?: 'CompanyPlanAiModelConfig';
  /** The stored chat model selection; null when the region default applies. */
  chatModelId: Maybe<Scalars['String']['output']>;
  /** The chat model actually in effect — the stored selection, or the region default when none (or a delisted one) is stored. */
  effectiveChatModelId: Scalars['String']['output'];
  /** The display name of the effective chat model. */
  effectiveChatModelName: Scalars['String']['output'];
  /** The hosting and data region. */
  region: CompanyPlanAiRegionEnum;
};

/** AI hosting region and chat model selection. The embedding and extraction models are derived from the region and cannot be set. */
export type CompanyPlanAiModelConfigInputObject = {
  /** Chat model id from the chosen region's catalog (see aiModelCatalog). Omitted or null selects the region's default. */
  chatModelId?: InputMaybe<Scalars['String']['input']>;
  /** Hosting and data region. It derives the embedding and extraction models; changing it re-indexes every document with the new region's embedding model. */
  region: CompanyPlanAiRegionEnum;
};

/** AI hosting and data regions */
export enum CompanyPlanAiRegionEnum {
  /** Mistral models via their direct EU API (data stays in the EU) */
  EuSovereign = 'EU_SOVEREIGN',
  /** Google + OpenAI models via OpenRouter (US-hosted, zero data retention) */
  Standard = 'STANDARD'
}

/** Description from base input object. Please set your description for child object. */
export type CompanyPlanChangeRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Params */
  params: CompanyPlanChangeRequestInputObject;
};

/** Company Plan change params */
export type CompanyPlanChangeRequestInputObject = {
  /**  Link to open the company profile page for system admins. Supported variables: `companyId`. Example: `https://system.datizy.com/dashboard/accounts/:companyId/view`  */
  companyProfileLink: Scalars['String']['input'];
  /** Email to contact */
  contactEmail: Scalars['String']['input'];
  /** Topics the request is about */
  features?: InputMaybe<Array<CompanyPlanUpgradeFeatureEnum>>;
  /** Message */
  message: Scalars['String']['input'];
};

/** Company Plan attributes */
export type CompanyPlanCuInputObject = {
  /** Accesses */
  accesses: Array<AccessCuInputObject>;
  /** AI spending cap for the current billing period (in euros) and billing cycle anchor. Null removes the budget — all AI features stay blocked until a budget is configured. */
  aiBudget?: InputMaybe<CompanyPlanAiBudgetInputObject>;
  /** AI hosting region and chat model powering the company's assistant. Null resets to the standard-region defaults. A region change switches the embedding model and automatically re-indexes the company's documents. */
  aiModelConfig?: InputMaybe<CompanyPlanAiModelConfigInputObject>;
  /** Currency */
  currency: CompanyPlanCurrencyEnum;
  /** Kind */
  kind: CompanyPlanKindEnum;
  /** Payment period */
  paymentPeriod: CompanyPlanPaymentPeriodEnum;
  /** Price */
  price: Scalars['Float']['input'];
  /** Limit of users */
  usersLimit?: InputMaybe<Scalars['Int']['input']>;
};

/** Available currencies */
export enum CompanyPlanCurrencyEnum {
  Eur = 'EUR'
}

/** Available plans */
export enum CompanyPlanKindEnum {
  Custom = 'CUSTOM',
  Gold = 'GOLD',
  Silver = 'SILVER',
  Starter = 'STARTER'
}

/** Available payment periods */
export enum CompanyPlanPaymentPeriodEnum {
  Month = 'MONTH'
}

/** Topics a plan change request can be about */
export enum CompanyPlanUpgradeFeatureEnum {
  /** AI assistance */
  AiAssistance = 'AI_ASSISTANCE',
  /** Billing or contract */
  BillingOrContract = 'BILLING_OR_CONTRACT',
  /** Documentation */
  Documentation = 'DOCUMENTATION',
  /** Feature question */
  FeatureQuestion = 'FEATURE_QUESTION',
  /** Interventions */
  Interventions = 'INTERVENTIONS',
  /** Other */
  Other = 'OTHER',
  /** Plan change */
  PlanChange = 'PLAN_CHANGE',
  /** User limit */
  UserLimit = 'USER_LIMIT',
  /** User limit change */
  UserLimitChange = 'USER_LIMIT_CHANGE'
}

/** Company sorts */
export type CompanySortInputObject = {
  /** Active users count */
  activeUsersCount?: InputMaybe<SortDirectionEnum>;
  /**
   * Share of the AI budget consumed this cycle
   * ATTENTION: Access allowed for system admins.
   */
  aiAssistancePercentage?: InputMaybe<SortDirectionEnum>;
  /**
   * Estimated AI cost for the current budget cycle
   * ATTENTION: Access allowed for system admins.
   */
  aiEstimatedPriceMicros?: InputMaybe<SortDirectionEnum>;
  /** Country name */
  country?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Industry name */
  industryName?: InputMaybe<SortDirectionEnum>;
  /** Company name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Owner full name */
  ownerFullName?: InputMaybe<SortDirectionEnum>;
  /**
   * Plan kind
   * ATTENTION: Access allowed for system admins.
   */
  planKind?: InputMaybe<SortDirectionEnum>;
  /** Maximum users allowed by the plan */
  planUsersLimit?: InputMaybe<SortDirectionEnum>;
  /** Active users as a percentage of the plan's user limit */
  usersLimitPercentage?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type CompanyUpdateInput = {
  /** Update attributes */
  attributes: CompanyUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Company ID */
  id: Scalars['ID']['input'];
};

/** Company attributes */
export type CompanyUpdateInputObject = {
  /** Admin ID */
  adminId?: InputMaybe<Scalars['ID']['input']>;
  /** Country */
  country?: InputMaybe<CountryEnum>;
  /** Deactivate company */
  deactivated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Industry ID */
  industryId?: InputMaybe<Scalars['ID']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Plan attributes */
  plan?: InputMaybe<CompanyPlanCuInputObject>;
  /** Website */
  website?: InputMaybe<Scalars['String']['input']>;
};

/** Counter entity */
export type Counter = TimestampInterface & {
  __typename?: 'Counter';
  /**
   * Asset entity
   * NOTE: if you only need an Object ID, please use the assetId field to reduce the load on the database.
   */
  asset: Asset;
  /** Asset ID */
  assetId: Scalars['ID']['output'];
  /** Code */
  code: Scalars['String']['output'];
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Full code (As on the QR code) */
  fullCode: Scalars['String']['output'];
  /** Counter ID */
  id: Scalars['ID']['output'];
  /** Last check at */
  lastCheckAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Latest index value */
  latestIndex: Maybe<Scalars['Float']['output']>;
  /** Measure type */
  measureType: CounterMeasureTypeEnum;
  /** Measure unit */
  measureUnit: CounterMeasureUnitEnum;
  /** Name */
  name: Scalars['String']['output'];
  /** Prohibit lower index. The next index must be higher than the previous one. The cumulative usage is calculated by adding the gap to the last cumulative total that is stored after the counter is reset. Allow lower index. The next index can be lower than the previous one. The cumulative usage is calculated by adding the index to the last cumulative total that is stored after the counter is reset. */
  prohibitLowerIndexThanPrevious: Scalars['Boolean']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Description from base input object. Please set your description for child object. */
export type CounterBulkDestroyInput = {
  /** Asset ID */
  assetId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Counter IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type CounterBulkQrCodeCreateInput = {
  /** Asset ID */
  assetId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Create params */
  params: QrCodesCreateInputObject;
};

/** CounterCollection type */
export type CounterCollection = {
  __typename?: 'CounterCollection';
  /** A collection of paginated CounterCollection */
  collection: Array<Counter>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type CounterCreateInput = {
  /** Create attributes */
  attributes: CounterCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Counter attributes */
export type CounterCreateInputObject = {
  /** Asset ID */
  assetId: Scalars['ID']['input'];
  /** Code */
  code: Scalars['String']['input'];
  /** Measure type */
  measureType: CounterMeasureTypeEnum;
  /** Measure unit */
  measureUnit: CounterMeasureUnitEnum;
  /** Name */
  name: Scalars['String']['input'];
  /** Prohibit lower index. The next index must be higher than the previous one. The cumulative usage is calculated by adding the gap to the last cumulative total that is stored after the counter is reset. Allow lower index. The next index can be lower than the previous one. The cumulative usage is calculated by adding the index to the last cumulative total that is stored after the counter is reset. */
  prohibitLowerIndexThanPrevious: Scalars['Boolean']['input'];
};

/** Counter filters */
export type CounterFilterInputObject = {
  /** Code */
  code?: InputMaybe<FilterInputObject>;
};

/** Counter attributes */
export type CounterFindByInputObject = {
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** ID */
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Counter Measure entity */
export type CounterMeasure = TimestampInterface & {
  __typename?: 'CounterMeasure';
  /**
   * Counter entity
   * NOTE: if you only need an Object ID, please use the counterId field to reduce the load on the database.
   */
  counter: Counter;
  /** Counter ID */
  counterId: Scalars['ID']['output'];
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** (Total Consumption) - Previous cumulative value + the gap (to get the total usage over time) */
  cumulativeUsage: Scalars['Float']['output'];
  /** (Consumption) - The difference between the current index and the previous check index. If a new meter is installed, calculate the difference accordingly */
  gap: Scalars['Float']['output'];
  /** Counter ID */
  id: Scalars['ID']['output'];
  /** Manually entered the reading value */
  index: Scalars['Float']['output'];
  /** Indicates if the measure was reset to zero */
  resetToZero: Scalars['Boolean']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** CounterMeasureCollection type */
export type CounterMeasureCollection = {
  __typename?: 'CounterMeasureCollection';
  /** A collection of paginated CounterMeasureCollection */
  collection: Array<CounterMeasure>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type CounterMeasureCreateInput = {
  /** Asset ID */
  assetId: Scalars['ID']['input'];
  /** Create attributes */
  attributes: CounterMeasureCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Counter Measure attributes */
export type CounterMeasureCreateInputObject = {
  /** Counter ID */
  counterId: Scalars['ID']['input'];
  /** Manually entered the reading value */
  index: Scalars['Float']['input'];
};

/** Counter Measure filters */
export type CounterMeasureFilterInputObject = {
  /** Created at */
  createdAt?: InputMaybe<FilterDateInputObject>;
};

/** Counter Measure graph data */
export type CounterMeasureGraphData = {
  __typename?: 'CounterMeasureGraphData';
  /** Created at */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** (Total Consumption) - Previous cumulative value + the gap (to get the total usage over time) */
  cumulativeUsage: Scalars['Float']['output'];
  /** (Consumption) - The difference between the current index and the previous check index. If a new meter is installed, calculate the difference accordingly */
  gap: Scalars['Float']['output'];
};

/** Counter Measure sorts */
export type CounterMeasureSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
};

/** All available measure types */
export enum CounterMeasureTypeEnum {
  Distance = 'DISTANCE',
  Energy = 'ENERGY',
  Mass = 'MASS',
  Quantity = 'QUANTITY',
  Time = 'TIME'
}

/** All available measure units */
export enum CounterMeasureUnitEnum {
  Centimeter = 'CENTIMETER',
  CubicMeter = 'CUBIC_METER',
  Foot = 'FOOT',
  Gram = 'GRAM',
  Hour = 'HOUR',
  Kilogram = 'KILOGRAM',
  Kilometer = 'KILOMETER',
  KilowattHour = 'KILOWATT_HOUR',
  Meter = 'METER',
  Mile = 'MILE',
  Minute = 'MINUTE',
  Piece = 'PIECE',
  Second = 'SECOND',
  Ton = 'TON',
  Yard = 'YARD'
}

/** Description from base input object. Please set your description for child object. */
export type CounterResetToZeroInput = {
  /** Asset ID */
  assetId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Counter ID */
  id: Scalars['ID']['input'];
};

/** Counter sorts */
export type CounterSortInputObject = {
  /** Code */
  code?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Last check at */
  lastCheckAt?: InputMaybe<SortDirectionEnum>;
  /** Latest index value */
  latestIndex?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Updated at */
  updatedAt?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type CounterUpdateInput = {
  /** Counter ID */
  assetId: Scalars['ID']['input'];
  /** Update attributes */
  attributes: CounterUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Counter ID */
  id: Scalars['ID']['input'];
};

/** Counter attributes */
export type CounterUpdateInputObject = {
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Prohibit lower index. The next index must be higher than the previous one. The cumulative usage is calculated by adding the gap to the last cumulative total that is stored after the counter is reset. Allow lower index. The next index can be lower than the previous one. The cumulative usage is calculated by adding the index to the last cumulative total that is stored after the counter is reset. */
  prohibitLowerIndexThanPrevious?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Available countries */
export enum CountryEnum {
  /** Andorra */
  Ad = 'AD',
  /** Albania */
  Al = 'AL',
  /** Austria */
  At = 'AT',
  /** Bosnia and Herzegovina */
  Ba = 'BA',
  /** Belgium */
  Be = 'BE',
  /** Bulgaria */
  Bg = 'BG',
  /** Canada */
  Ca = 'CA',
  /** Switzerland */
  Ch = 'CH',
  /** Cyprus */
  Cy = 'CY',
  /** Czech Republic */
  Cz = 'CZ',
  /** Germany */
  De = 'DE',
  /** Denmark */
  Dk = 'DK',
  /** Estonia */
  Ee = 'EE',
  /** Spain */
  Es = 'ES',
  /** Finland */
  Fi = 'FI',
  /** France */
  Fr = 'FR',
  /** United Kingdom */
  Gb = 'GB',
  /** Greenland */
  Gl = 'GL',
  /** Greece */
  Gr = 'GR',
  /** Croatia */
  Hr = 'HR',
  /** Hungary */
  Hu = 'HU',
  /** Ireland */
  Ie = 'IE',
  /** Iceland */
  Is = 'IS',
  /** Italy */
  It = 'IT',
  /** Lithuania */
  Lt = 'LT',
  /** Luxembourg */
  Lu = 'LU',
  /** Latvia */
  Lv = 'LV',
  /** Monaco */
  Mc = 'MC',
  /** Moldova */
  Md = 'MD',
  /** Montenegro */
  Me = 'ME',
  /** North Macedonia */
  Mk = 'MK',
  /** Malta */
  Mt = 'MT',
  /** Mexico */
  Mx = 'MX',
  /** Netherlands */
  Nl = 'NL',
  /** Norway */
  No = 'NO',
  /** Poland */
  Pl = 'PL',
  /** Saint Pierre and Miquelon */
  Pm = 'PM',
  /** Portugal */
  Pt = 'PT',
  /** Romania */
  Ro = 'RO',
  /** Serbia */
  Rs = 'RS',
  /** Sweden */
  Se = 'SE',
  /** Slovenia */
  Si = 'SI',
  /** Slovakia */
  Sk = 'SK',
  /** San Marino */
  Sm = 'SM',
  /** Ukraine */
  Ua = 'UA',
  /** United States of America */
  Us = 'US',
  /** Vatican City */
  Va = 'VA'
}

/** Data Import entity */
export type DataImport = TimestampInterface & {
  __typename?: 'DataImport';
  /** Attachment to import */
  attachmentAttached: Maybe<Attachment>;
  /** Background job tracking this import (status, progress, result) */
  backgroundJob: Maybe<BackgroundJob>;
  canDestroy: AuthorizationResult;
  canUpdate: AuthorizationResult;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Failure error details */
  failureDetails: Maybe<Scalars['CamelizedJson']['output']>;
  /** File exception (use when failureDetails is empty and there is a file exception) */
  fileException: Maybe<Array<Scalars['String']['output']>>;
  /** Data Import ID */
  id: Scalars['ID']['output'];
  /** Indicator to ignore rows with errors and import only valid rows */
  ignoreRowsWithErrors: Scalars['Boolean']['output'];
  /** Imported rows */
  importedRows: Maybe<Scalars['Int']['output']>;
  /** Kind of import */
  kind: DataImportKindEnum;
  /** Current status */
  status: DataImportStatusEnum;
  /** Total rows to import */
  totalRows: Maybe<Scalars['Int']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Created by User
   * NOTE: if you only need an Object ID, please use the userId field to reduce the load on the database.
   */
  user: Maybe<User>;
  /** Created by User ID */
  userId: Scalars['ID']['output'];
};

/** DataImportCollection type */
export type DataImportCollection = {
  __typename?: 'DataImportCollection';
  /** A collection of paginated DataImportCollection */
  collection: Array<DataImport>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type DataImportCreateInput = {
  /** Create attributes */
  attributes: DataImportCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Data Import attributes */
export type DataImportCreateInputObject = {
  /** Attachment to import */
  attachmentAttached: AttachmentCuInputObject;
  /** Indicator to ignore rows with errors and import only valid rows */
  ignoreRowsWithErrors?: InputMaybe<Scalars['Boolean']['input']>;
  /** Kind of import */
  kind: DataImportKindEnum;
};

/** Description from base input object. Please set your description for child object. */
export type DataImportDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Data Import ID */
  id: Scalars['ID']['input'];
};

/** Data Import filters */
export type DataImportFilterInputObject = {
  /** Created at */
  createdAt?: InputMaybe<FilterInputObject>;
  /** Data Import ID */
  id?: InputMaybe<FilterIdInputObject>;
  /** Kind of import */
  kind?: InputMaybe<FilterInputObject>;
};

/** Available data import kinds */
export enum DataImportKindEnum {
  Asset = 'ASSET',
  Site = 'SITE',
  SiteArea = 'SITE_AREA'
}

/** Data Import sorts */
export type DataImportSortInputObject = {
  /** Attachment filename */
  attachmentFilename?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Kind of import */
  kind?: InputMaybe<SortDirectionEnum>;
  /** Created by user full name */
  userFullName?: InputMaybe<SortDirectionEnum>;
};

/** Available data import statuses */
export enum DataImportStatusEnum {
  /** Completed successfully */
  Complete = 'COMPLETE',
  /** Failed (after all retries) */
  Failed = 'FAILED',
  /** Interrupted (process ended before finishing) */
  Interrupted = 'INTERRUPTED',
  /** Queued (waiting to be processed) */
  Queued = 'QUEUED',
  /** Still in progress: an attempt failed and another is scheduled. Not an outcome — use display_status, which presents it as working */
  Retrying = 'RETRYING',
  /** Stopped (cancelled) */
  Stopped = 'STOPPED',
  /** Work in progress */
  Working = 'WORKING'
}

/** Description from base input object. Please set your description for child object. */
export type DataImportUpdateInput = {
  /** Update attributes */
  attributes: DataImportUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Data Import ID */
  id: Scalars['ID']['input'];
};

/** Data Import attributes */
export type DataImportUpdateInputObject = {
  /** Attachment to import */
  attachmentAttached?: InputMaybe<AttachmentCuInputObject>;
  /** Indicator to ignore rows with errors and import only valid rows */
  ignoreRowsWithErrors?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Date range attributes */
export type DateRangeInputObject = {
  /** End date */
  endDate: Scalars['ISO8601Date']['input'];
  /** Start date */
  startDate: Scalars['ISO8601Date']['input'];
};

/** Department entity */
export type Department = TimestampInterface & {
  __typename?: 'Department';
  canDestroy: AuthorizationResult;
  /** Direct sub-departments (nest to descend the tree; empty for a leaf) */
  children: Array<Department>;
  /** Direct sub-departments count (positive when the department can be unfolded) */
  childrenCount: Maybe<Scalars['Int']['output']>;
  /** Color */
  color: ColorEnum;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Department ID */
  id: Scalars['ID']['output'];
  /** Directly linked interventions count */
  interventionsOwnCount: Maybe<Scalars['Int']['output']>;
  /** Responsible manager */
  manager: Maybe<User>;
  /** Directly assigned members count */
  membersOwnCount: Maybe<Scalars['Int']['output']>;
  /** Members count including all sub-departments (distinct users) */
  membersTotalCount: Maybe<Scalars['Int']['output']>;
  /** Name */
  name: Scalars['String']['output'];
  /** Parent department (walk ancestors by nesting; empty for a top-level department) */
  parent: Maybe<Department>;
  /** Parent department ID (empty for a top-level department) */
  parentId: Maybe<Scalars['ID']['output']>;
  /** Full hierarchy path (ancestor names joined by " / ") */
  path: Maybe<Scalars['String']['output']>;
  /** Directly linked task groups count */
  tasksOwnCount: Maybe<Scalars['Int']['output']>;
  /** Linked task groups count including all sub-departments */
  tasksTotalCount: Maybe<Scalars['Int']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** DepartmentCollection type */
export type DepartmentCollection = {
  __typename?: 'DepartmentCollection';
  /** A collection of paginated DepartmentCollection */
  collection: Array<Department>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type DepartmentCreateInput = {
  /** Create attributes */
  attributes: DepartmentCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Department attributes */
export type DepartmentCreateInputObject = {
  /** Color */
  color: ColorEnum;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Intervention links attributes array */
  interventionLinks?: InputMaybe<Array<LinkingInputObject>>;
  /** Responsible manager ID */
  managerId?: InputMaybe<Scalars['ID']['input']>;
  /** Members attributes array */
  members?: InputMaybe<Array<LinkingInputObject>>;
  /** Name */
  name: Scalars['String']['input'];
  /** Parent department ID (leave empty for a top-level department) */
  parentId?: InputMaybe<Scalars['ID']['input']>;
  /** Task links attributes array (a link applies to the whole recurring task group) */
  taskLinks?: InputMaybe<Array<LinkingInputObject>>;
  /** Access group links attributes array */
  teamLinks?: InputMaybe<Array<LinkingInputObject>>;
};

/** Description from base input object. Please set your description for child object. */
export type DepartmentDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Department ID */
  id: Scalars['ID']['input'];
};

/** Department filters */
export type DepartmentFilterInputObject = {
  /** Filter to departments linked to this intervention */
  departmentInterventionsInterventionId?: InputMaybe<FilterIdInputObject>;
  /** Filter to departments linked to the task group with this group key */
  departmentTaskGroupsGroupKey?: InputMaybe<FilterIdInputObject>;
  /** Responsible manager full name */
  managerFullName?: InputMaybe<FilterInputObject>;
  /** Responsible manager ID */
  managerId?: InputMaybe<FilterIdInputObject>;
  /** Name */
  name?: InputMaybe<FilterInputObject>;
  /** Filter to departments linked to this access group */
  teamsId?: InputMaybe<FilterIdInputObject>;
  /** Members full name */
  usersFullName?: InputMaybe<FilterInputObject>;
  /** Filter to departments this user is a member of */
  usersId?: InputMaybe<FilterIdInputObject>;
};

/** Department sorts */
export type DepartmentSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type DepartmentUpdateInput = {
  /** Update attributes */
  attributes: DepartmentUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Department ID */
  id: Scalars['ID']['input'];
};

/** Department attributes */
export type DepartmentUpdateInputObject = {
  /** Color */
  color?: InputMaybe<ColorEnum>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Intervention links attributes array */
  interventionLinks?: InputMaybe<Array<LinkingInputObject>>;
  /** Responsible manager ID */
  managerId?: InputMaybe<Scalars['ID']['input']>;
  /** Members attributes array */
  members?: InputMaybe<Array<LinkingInputObject>>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Parent department ID (leave empty for a top-level department) */
  parentId?: InputMaybe<Scalars['ID']['input']>;
  /** Task links attributes array (a link applies to the whole recurring task group) */
  taskLinks?: InputMaybe<Array<LinkingInputObject>>;
  /** Access group links attributes array */
  teamLinks?: InputMaybe<Array<LinkingInputObject>>;
};

/** Company-wide default values for document renewal reminders (singleton per company) */
export type DocumentRenewalReminderTemplate = TimestampInterface & {
  __typename?: 'DocumentRenewalReminderTemplate';
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Document Renewal Reminder Template ID */
  id: Scalars['ID']['output'];
  /** Recurring renewal anchor in MM-DD format — two-digit month (01-12), dash, two-digit day (01-31). Examples: "10-15" for October 15, "02-29" for February 29. The year is intentionally not stored; FE picks the next concrete deadline at doc-create time. */
  renewalDeadlineMd: Maybe<Scalars['String']['output']>;
  /** Days before the deadline when an early reminder should be triggered */
  renewalEarlyReminderDays: Maybe<Scalars['Int']['output']>;
  /** Recurring renewal cadence (MONTHLY, QUARTERLY, HALF_YEARLY, YEARLY, CUSTOM) */
  renewalRepetition: Maybe<DocumentationRenewalRepetitionEnum>;
  /** Custom interval in days when renewal_repetition is CUSTOM */
  renewalRepetitionCustomDays: Maybe<Scalars['Int']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Description from base input object. Please set your description for child object. */
export type DocumentRenewalReminderTemplateUpdateInput = {
  /** Update attributes */
  attributes: DocumentRenewalReminderTemplateUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Document Renewal Reminder Template update attributes */
export type DocumentRenewalReminderTemplateUpdateInputObject = {
  /** Recurring renewal anchor in MM-DD format — two-digit month (01-12), dash, two-digit day (01-31). Examples: "10-15" for October 15, "02-29" for February 29. The year is intentionally not stored; FE picks the next concrete deadline at doc-create time. */
  renewalDeadlineMd?: InputMaybe<Scalars['String']['input']>;
  /** Days before the deadline when an early reminder should be triggered */
  renewalEarlyReminderDays?: InputMaybe<Scalars['Int']['input']>;
  /** Recurring renewal cadence (MONTHLY, QUARTERLY, HALF_YEARLY, YEARLY, CUSTOM) */
  renewalRepetition?: InputMaybe<DocumentationRenewalRepetitionEnum>;
  /** Custom interval in days when renewal_repetition is CUSTOM */
  renewalRepetitionCustomDays?: InputMaybe<Scalars['Int']['input']>;
};

/** Documentation entity */
export type Documentation = TimestampInterface & {
  __typename?: 'Documentation';
  /**
   * Whether the current version's file can be attached to an AI chat, or the reason it cannot
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiAttachability: Maybe<AiAttachabilityStatusEnum>;
  /**
   * Per-field AI-detection status (one entry per field AI is detecting)
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiDetectionStatus: Array<DocumentationFieldDetectionStatus>;
  /**
   * Machine-readable reason the current version's processing failed; null while nothing has failed.
   * ATTENTION: Access allowed for full admins.
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiIndexingError: Maybe<Scalars['String']['output']>;
  /**
   * Which automatic pass, if any, will come back to this document next; null when nothing needs indexing. Says whether a document that is not searchable will fix itself — which the status alone cannot, since FAILED only means processing has not completed yet.
   * ATTENTION: Access allowed for full admins.
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiIndexingRetryLane: Maybe<AiIndexingRetryLaneEnum>;
  /**
   * Where the current version stands in AI processing, including whether it yielded searchable content (SKIPPED). Only INDEXED documents are reachable by assistant search.
   * ATTENTION: Access allowed for full admins.
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiIndexingStatus: Maybe<AiIndexingStatusEnum>;
  /**
   * Approver user entity
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  approver: Maybe<User>;
  /**
   * Approver user ID
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  approverId: Maybe<Scalars['ID']['output']>;
  canDestroy: AuthorizationResult;
  canUpdate: AuthorizationResult;
  canUpdateValidationStatus: AuthorizationResult;
  /**
   * Category entity
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  category: Maybe<DocumentationCategory>;
  /**
   * Category ID
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  categoryId: Maybe<Scalars['ID']['output']>;
  /** Code */
  code: Maybe<Scalars['String']['output']>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /**
   * User entity
   * NOTE: if you only need an Object ID, please use the createdById field to reduce the load on the database.
   */
  createdBy: Maybe<User>;
  /** User ID */
  createdById: Maybe<Scalars['ID']['output']>;
  /** Current version */
  currentVersion: Maybe<DocumentationVersion>;
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /**
   * Whether the current user has favorited this documentation
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  favorited: Scalars['Boolean']['output'];
  /** Documentation ID */
  id: Scalars['ID']['output'];
  /** Name */
  name: Maybe<Scalars['String']['output']>;
  /**
   * Whether the current user has explicitly confirmed reading the required version of this documentation, via documentationVersionMarkAsRead. Opening a document does not set it (null when not computed)
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  read: Maybe<Scalars['Boolean']['output']>;
  /**
   * Renewal deadline date
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  renewalDeadlineDate: Maybe<Scalars['ISO8601Date']['output']>;
  /**
   * Days before deadline to send early reminder
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  renewalEarlyReminderDays: Maybe<Scalars['Int']['output']>;
  /**
   * Renewal repetition frequency
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  renewalRepetition: Maybe<DocumentationRenewalRepetitionEnum>;
  /**
   * Custom repetition interval in days
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  renewalRepetitionCustomDays: Maybe<Scalars['Int']['output']>;
  /**
   * AI-suggested alternative codes, for the user to choose from (populated on import when several codes are detected)
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  suggestedCodes: Array<Scalars['String']['output']>;
  /** Tags collection */
  tags: Array<Tag>;
  /**
   * Sum of reading_duration_seconds across all read documentation version reads for the documentation (null when not computed)
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  totalEngagementSeconds: Maybe<Scalars['Int']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Validation status
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  validationStatus: Maybe<DocumentationValidationStatusEnum>;
};

/** Per-category analytics row — view totals and share of total within the requested period */
export type DocumentationAnalyticsByCategory = {
  __typename?: 'DocumentationAnalyticsByCategory';
  /** Documentation category ID */
  categoryId: Scalars['ID']['output'];
  /** Share of total views (0–100) */
  percentage: Scalars['Float']['output'];
  /** Total views across all documents in this category */
  viewCount: Scalars['Int']['output'];
};

/** Documentation analytics sorts (per-category table) */
export type DocumentationAnalyticsByCategorySortInputObject = {
  /** Category name */
  categoryName?: InputMaybe<SortDirectionEnum>;
  /** Share of total views */
  percentage?: InputMaybe<SortDirectionEnum>;
  /** View count */
  viewCount?: InputMaybe<SortDirectionEnum>;
};

/** Per-document analytics row — view metrics for a single documentation within the requested period */
export type DocumentationAnalyticsByDocument = {
  __typename?: 'DocumentationAnalyticsByDocument';
  /** Average viewing time in seconds (null when no duration data) */
  avgTime: Maybe<Scalars['Float']['output']>;
  /** Documentation ID */
  documentationId: Scalars['ID']['output'];
  /** Longest viewing time in seconds (null when no duration data) */
  maxTime: Maybe<Scalars['Int']['output']>;
  /** Shortest viewing time in seconds (null when no duration data) */
  minTime: Maybe<Scalars['Int']['output']>;
  /** Total viewing time in seconds across all views (null when no duration data) */
  totalTime: Maybe<Scalars['Int']['output']>;
  /** Distinct users who opened the documentation */
  uniqueViews: Scalars['Int']['output'];
  /** Total views (each open creates a row) */
  viewCount: Scalars['Int']['output'];
};

/** DocumentationAnalyticsByDocumentCollection type */
export type DocumentationAnalyticsByDocumentCollection = {
  __typename?: 'DocumentationAnalyticsByDocumentCollection';
  /** A collection of paginated DocumentationAnalyticsByDocumentCollection */
  collection: Array<DocumentationAnalyticsByDocument>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Per-linked-entity analytics row — views of documents linked to one site/sector/form template/area/asset within the requested period. A document linked to several targets counts under each, so percentages can sum past 100. */
export type DocumentationAnalyticsByLinkable = {
  __typename?: 'DocumentationAnalyticsByLinkable';
  /** Linked entity ID */
  linkableId: Scalars['ID']['output'];
  /** Linked entity name */
  name: Scalars['String']['output'];
  /** Share of linkable-attributed views in the period */
  percentage: Scalars['Float']['output'];
  /** Distinct users who viewed documents linked to this entity */
  uniqueViews: Scalars['Int']['output'];
  /** Views of documents linked to this entity */
  viewCount: Scalars['Int']['output'];
};

/** Documentation analytics sorts (per-linked-entity table) */
export type DocumentationAnalyticsByLinkableSortInputObject = {
  /** Linked entity name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Share of linkable-attributed views */
  percentage?: InputMaybe<SortDirectionEnum>;
  /** Unique views */
  uniqueViews?: InputMaybe<SortDirectionEnum>;
  /** View count */
  viewCount?: InputMaybe<SortDirectionEnum>;
};

/** Per-user analytics row — one user's viewing activity within the requested period. Returned only for reads the requester is allowed to see. */
export type DocumentationAnalyticsByUser = {
  __typename?: 'DocumentationAnalyticsByUser';
  /** Average viewing time in seconds (null when no duration data) */
  avgTime: Maybe<Scalars['Float']['output']>;
  /** Total viewing time in seconds (null when no duration data) */
  totalTime: Maybe<Scalars['Int']['output']>;
  /** Distinct documents this user viewed */
  uniqueDocuments: Scalars['Int']['output'];
  /**
   * The user, resolved from %{id_field}
   * NOTE: if you only need an Object ID, please use the userId field to reduce the load on the database.
   */
  user: Maybe<User>;
  /** User ID */
  userId: Scalars['ID']['output'];
  /** Views by this user (each open creates a row) */
  viewCount: Scalars['Int']['output'];
};

/** Documentation analytics sorts (per-user table) */
export type DocumentationAnalyticsByUserSortInputObject = {
  /** Average viewing time */
  avgTime?: InputMaybe<SortDirectionEnum>;
  /** Total viewing time */
  totalTime?: InputMaybe<SortDirectionEnum>;
  /** Distinct documents viewed */
  uniqueDocuments?: InputMaybe<SortDirectionEnum>;
  /** User full name */
  userFullName?: InputMaybe<SortDirectionEnum>;
  /** View count */
  viewCount?: InputMaybe<SortDirectionEnum>;
};

/** The linked-entity dimension a documentation-views rollup groups by. */
export enum DocumentationAnalyticsLinkableDimensionEnum {
  /** Views grouped by linked site area. */
  Areas = 'AREAS',
  /** Views grouped by linked asset. */
  Assets = 'ASSETS',
  /** Views grouped by linked form template. */
  FormTemplates = 'FORM_TEMPLATES',
  /** Views grouped by linked sector. */
  Sectors = 'SECTORS',
  /** Views grouped by linked site. */
  Sites = 'SITES'
}

/** Documentation analytics sorts (per-document table) */
export type DocumentationAnalyticsSortInputObject = {
  /** Average viewing time */
  avgTime?: InputMaybe<SortDirectionEnum>;
  /** Category name */
  categoryName?: InputMaybe<SortDirectionEnum>;
  /** Maximum viewing time */
  maxTime?: InputMaybe<SortDirectionEnum>;
  /** Minimum viewing time */
  minTime?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Total viewing time */
  totalTime?: InputMaybe<SortDirectionEnum>;
  /** Unique views */
  uniqueViews?: InputMaybe<SortDirectionEnum>;
  /** View count */
  viewCount?: InputMaybe<SortDirectionEnum>;
};

/** Time-series data point for the documentation views trend */
export type DocumentationAnalyticsTrendPoint = {
  __typename?: 'DocumentationAnalyticsTrendPoint';
  /** Total views in this bucket */
  allViews: Scalars['Int']['output'];
  /** Bucket start date */
  period: Scalars['ISO8601Date']['output'];
  /** Distinct users who opened any documentation in this bucket */
  uniqueViews: Scalars['Int']['output'];
};

/** Description from base input object. Please set your description for child object. */
export type DocumentationBulkDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Documentation IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type DocumentationBulkEditInput = {
  /** Edit attributes */
  attributes: DocumentationBulkEditInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Documentation IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Documentation attributes */
export type DocumentationBulkEditInputObject = {
  /**
   * Approver ID
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  approverId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Site area links
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  areaLinks?: InputMaybe<Array<DocumentationLinkInputObject>>;
  /** Asset links */
  assetLinks?: InputMaybe<Array<DocumentationLinkInputObject>>;
  /**
   * Category ID
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Form template links
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  formTemplateLinks?: InputMaybe<Array<LinkingInputObject>>;
  /**
   * Renewal deadline date
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  renewalDeadlineDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /**
   * Days before deadline to send early reminder
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  renewalEarlyReminderDays?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Renewal repetition frequency
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  renewalRepetition?: InputMaybe<DocumentationRenewalRepetitionEnum>;
  /**
   * Custom repetition interval in days
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  renewalRepetitionCustomDays?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Sector links
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  sectorLinks?: InputMaybe<Array<LinkingInputObject>>;
  /**
   * Site links
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  siteLinks?: InputMaybe<Array<LinkingInputObject>>;
  /**
   * Task group links
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  taskGroupLinks?: InputMaybe<Array<LinkingInputObject>>;
};

/** Description from base input object. Please set your description for child object. */
export type DocumentationBulkFavoriteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Documentation IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type DocumentationBulkUnfavoriteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Documentation IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type DocumentationBulkUpdateValidationStatusInput = {
  /** Update attributes */
  attributes: DocumentationUpdateValidationStatusInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Documentation IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Documentation Category entity */
export type DocumentationCategory = TimestampInterface & {
  __typename?: 'DocumentationCategory';
  canDestroy: AuthorizationResult;
  canUpdate: AuthorizationResult;
  /** Color */
  color: ColorEnum;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Default category flag */
  default: Scalars['Boolean']['output'];
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Number of Documentations */
  documentationsCount: Scalars['Int']['output'];
  /** Documentation Category ID */
  id: Scalars['ID']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** DocumentationCategoryCollection type */
export type DocumentationCategoryCollection = {
  __typename?: 'DocumentationCategoryCollection';
  /** A collection of paginated DocumentationCategoryCollection */
  collection: Array<DocumentationCategory>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type DocumentationCategoryCreateInput = {
  /** Create attributes */
  attributes: DocumentationCategoryCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Documentation Category attributes */
export type DocumentationCategoryCreateInputObject = {
  /** Color */
  color: ColorEnum;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type DocumentationCategoryDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID */
  id: Scalars['ID']['input'];
};

/** Documentation Category filters */
export type DocumentationCategoryFilterInputObject = {
  /** Whether this is the company's default category */
  default?: InputMaybe<FilterBooleanInputObject>;
  /** Documentation Category ID */
  id?: InputMaybe<FilterIdInputObject>;
  /** Documentation Category name */
  name?: InputMaybe<FilterInputObject>;
};

/** Documentation Category sorts */
export type DocumentationCategorySortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Number of Documentations in this category */
  documentationsCount?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type DocumentationCategoryUpdateInput = {
  /** Update attributes */
  attributes: DocumentationCategoryUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID */
  id: Scalars['ID']['input'];
};

/** Documentation Category attributes */
export type DocumentationCategoryUpdateInputObject = {
  /** Color */
  color?: InputMaybe<ColorEnum>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** DocumentationCollection type */
export type DocumentationCollection = {
  __typename?: 'DocumentationCollection';
  /** A collection of paginated DocumentationCollection */
  collection: Array<Documentation>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type DocumentationCreateInput = {
  /** Create attributes */
  attributes: DocumentationCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Documentation attributes */
export type DocumentationCreateInputObject = {
  /**
   * Approver ID
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  approverId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Site area links
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  areaLinks?: InputMaybe<Array<DocumentationLinkInputObject>>;
  /** Asset links */
  assetLinks?: InputMaybe<Array<DocumentationLinkInputObject>>;
  /** File */
  attachmentAttached: AttachmentCuInputObject;
  /**
   * Category ID
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Tags */
  documentationTags?: InputMaybe<Array<LinkingInputObject>>;
  /**
   * Form template links
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  formTemplateLinks?: InputMaybe<Array<LinkingInputObject>>;
  /** Name */
  name: Scalars['String']['input'];
  /**
   * Renewal deadline date
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  renewalDeadlineDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /**
   * Days before deadline to send early reminder
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  renewalEarlyReminderDays?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Renewal repetition frequency
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  renewalRepetition?: InputMaybe<DocumentationRenewalRepetitionEnum>;
  /**
   * Custom repetition interval in days
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  renewalRepetitionCustomDays?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Sector links
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  sectorLinks?: InputMaybe<Array<LinkingInputObject>>;
  /**
   * Site links
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  siteLinks?: InputMaybe<Array<LinkingInputObject>>;
  /**
   * Task group links
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  taskGroupLinks?: InputMaybe<Array<LinkingInputObject>>;
};

/** The AI-detection status of one field on a document */
export type DocumentationFieldDetectionStatus = {
  __typename?: 'DocumentationFieldDetectionStatus';
  /** The document field being detected */
  field: AiDocumentationFieldEnum;
  /** The current detection status of that field */
  status: AiFieldDetectionStatusEnum;
};

/** Documentation filters */
export type DocumentationFilterInputObject = {
  /**
   * Which automatic pass will revisit the document next (RETRYING_SOON, RETRYING_DAILY, PARKED); null when nothing needs indexing, so not_null selects the whole backlog.
   * ATTENTION: Access allowed for full admins.
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiIndexingRetryLane?: InputMaybe<FilterIntInputObject>;
  /**
   * AI processing state of the current version (INDEXED, SKIPPED, STALE, PENDING, FAILED); null for a document with no version.
   * ATTENTION: Access allowed for full admins.
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiIndexingStatus?: InputMaybe<FilterIntInputObject>;
  /**
   * Approver full name
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  approverFullName?: InputMaybe<FilterInputObject>;
  /**
   * Approver ID
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  approverId?: InputMaybe<FilterIdInputObject>;
  /**
   * Documentation Category ID
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  categoryId?: InputMaybe<FilterIdInputObject>;
  /**
   * Category name
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  categoryName?: InputMaybe<FilterInputObject>;
  /** Code */
  code?: InputMaybe<FilterInputObject>;
  /** Created at */
  createdAt?: InputMaybe<FilterDateInputObject>;
  /** Created by user full name */
  createdByFullName?: InputMaybe<FilterInputObject>;
  /**
   * Task group key
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationTaskGroupsGroupKey?: InputMaybe<FilterIdInputObject>;
  /** Documentation ID */
  id?: InputMaybe<FilterIdInputObject>;
  /**
   * Imported at (filter to find imported documents)
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  importedAt?: InputMaybe<FilterDateInputObject>;
  /**
   * Site area ID
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  linkedAreasId?: InputMaybe<FilterIdInputObject>;
  /**
   * Linked site area name
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  linkedAreasName?: InputMaybe<FilterInputObject>;
  /** Asset ID */
  linkedAssetsId?: InputMaybe<FilterIdInputObject>;
  /** Linked asset name */
  linkedAssetsName?: InputMaybe<FilterInputObject>;
  /**
   * Form template ID
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  linkedFormTemplatesId?: InputMaybe<FilterIdInputObject>;
  /**
   * Linked form template name
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  linkedFormTemplatesName?: InputMaybe<FilterInputObject>;
  /** Current file media type (IMAGE, PDF, VIDEO) */
  mediaType?: InputMaybe<FilterIntInputObject>;
  /** Name */
  name?: InputMaybe<FilterInputObject>;
  /**
   * Renewal deadline date
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  renewalDeadlineDate?: InputMaybe<FilterDateInputObject>;
  /**
   * Renewal repetition
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  renewalRepetition?: InputMaybe<FilterIntInputObject>;
  /**
   * Sector ID
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  sectorsId?: InputMaybe<FilterIdInputObject>;
  /**
   * Sector name
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  sectorsName?: InputMaybe<FilterInputObject>;
  /**
   * Site ID
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  sitesId?: InputMaybe<FilterIdInputObject>;
  /**
   * Site name
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  sitesName?: InputMaybe<FilterInputObject>;
  /** Tag name */
  tagsName?: InputMaybe<FilterInputObject>;
  /**
   * Validation status
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  validationStatus?: InputMaybe<FilterIntInputObject>;
};

/** Documentation History data. Each record contains exactly one key indicating the change type. Format: [old_value, new_value] for changes, [value] for events. */
export type DocumentationHistoryData = {
  __typename?: 'DocumentationHistoryData';
  /** Approver changed. Format: [old_id | null, new_id | null]. null→id = 'approver assigned', id→null = 'approver removed', id→id = 'approver changed' */
  approverId: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Renewal deadline changed. Format: [old_date | null, new_date | null]. null→date = 'renewal reminder enabled', date→null = 'renewal reminder disabled', date→date = 'renewal date updated' */
  renewalDeadlineDate: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Renewal overdue (system event). Format: [deadline_date]. Label: 'update overdue'. Actor: Datizy system */
  renewalOverdue: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Renewal skipped by user. Format: [next_deadline_date]. Label: 'renewal skipped' */
  renewalSkipped: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Validation status changed. Format: [old_status, new_status]. Label: 'status changed' */
  validationStatus: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Version updated. Format: [old_number | null, new_number]. Label: 'version updated' */
  versionNumber: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** User confirmed reading a version. Format: [version_number]. Label: 'marked as read'. Returned by the 'reads' scope, not 'activity' */
  versionRead: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** User withdrew a read confirmation. Format: [version_number]. Label: 'marked as unread'. Returned by the 'reads' scope, not 'activity' */
  versionUnread: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

/** Documentation Import entity */
export type DocumentationImport = TimestampInterface & {
  __typename?: 'DocumentationImport';
  /** Uploaded ZIP archive (when kind is ARCHIVE) */
  archiveAttachmentAttached: Maybe<Attachment>;
  /** Background job tracking this import (status, progress, result) */
  backgroundJob: Maybe<BackgroundJob>;
  canDestroy: AuthorizationResult;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Per-file error details */
  failureDetails: Maybe<Scalars['CamelizedJson']['output']>;
  /** Uploaded files (when kind is FILES) */
  fileAttachmentsAttached: Maybe<Array<Attachment>>;
  /** Top-level error (e.g., zip extraction or FTP connection) */
  fileException: Maybe<Array<Scalars['String']['output']>>;
  /** FTP connection details (excluding password) */
  ftpConfig: Maybe<DocumentationImportFtpConfig>;
  /** Documentation Import ID */
  id: Scalars['ID']['output'];
  /** Timestamp shared by all documents created in this import */
  importedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Files successfully imported so far */
  importedFiles: Maybe<Scalars['Int']['output']>;
  /** Source kind (FILES, ARCHIVE, FTP) */
  kind: DocumentationImportKindEnum;
  /** Current status */
  status: DocumentationImportStatusEnum;
  /** Total files to import (after unsupported are filtered out) */
  totalFiles: Maybe<Scalars['Int']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Created by User
   * NOTE: if you only need an Object ID, please use the userId field to reduce the load on the database.
   */
  user: Maybe<User>;
  /** Created by User ID */
  userId: Scalars['ID']['output'];
};

/** DocumentationImportCollection type */
export type DocumentationImportCollection = {
  __typename?: 'DocumentationImportCollection';
  /** A collection of paginated DocumentationImportCollection */
  collection: Array<DocumentationImport>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type DocumentationImportCreateInput = {
  /** Create attributes */
  attributes: DocumentationImportCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Documentation Import attributes */
export type DocumentationImportCreateInputObject = {
  /** Approver ID applied to all imported documents */
  approverId?: InputMaybe<Scalars['ID']['input']>;
  /** Area links applied to all imported documents */
  areaLinks?: InputMaybe<Array<DocumentationLinkInputObject>>;
  /** Asset links applied to all imported documents */
  assetLinks?: InputMaybe<Array<DocumentationLinkInputObject>>;
  /** Category ID applied to all imported documents */
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Which fields AI should detect on each imported document, and the optional hint for the code field. Omit it to import without AI detection
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  detectFields?: InputMaybe<DocumentationImportDetectFieldsInputObject>;
  /** Form template links applied to all imported documents */
  formTemplateLinks?: InputMaybe<Array<LinkingInputObject>>;
  /** Source kind (FILES, ARCHIVE, FTP) */
  kind: DocumentationImportKindEnum;
  /** Renewal deadline date applied to all imported documents */
  renewalDeadlineDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Days before deadline to send early reminder */
  renewalEarlyReminderDays?: InputMaybe<Scalars['Int']['input']>;
  /** Renewal repetition frequency applied to all imported documents */
  renewalRepetition?: InputMaybe<DocumentationRenewalRepetitionEnum>;
  /** Custom repetition interval in days */
  renewalRepetitionCustomDays?: InputMaybe<Scalars['Int']['input']>;
  /** Sector links applied to all imported documents */
  sectorLinks?: InputMaybe<Array<LinkingInputObject>>;
  /** Site links applied to all imported documents */
  siteLinks?: InputMaybe<Array<LinkingInputObject>>;
  /** Source-specific input (one of file_attachments_attached, archive_attachment_attached, ftp_config) */
  source: DocumentationImportSourceInputObject;
  /** Task group links applied to all imported documents */
  taskGroupLinks?: InputMaybe<Array<LinkingInputObject>>;
};

/** Description from base input object. Please set your description for child object. */
export type DocumentationImportDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Documentation Import ID */
  id: Scalars['ID']['input'];
};

/** AI field-detection opt-in for a documentation import */
export type DocumentationImportDetectFieldsInputObject = {
  /** When true, AI detects the category of each imported document from its content, replacing only the default (Uncategorized) — a category the importer explicitly chose is kept */
  category?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true, AI detects the code(s) of each imported document — a single code fills the code field, several are stored as suggestions */
  code?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional user hint guiding how the AI should detect the code (applies only when code is true) */
  codePrompt?: InputMaybe<Scalars['String']['input']>;
  /** When true, AI detects and fills the description of each imported document */
  description?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true, AI detects and fills the name of each imported document from its content (a readable file with no clear name is left blank for the user to set) */
  name?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true, AI detects and links tags on each imported document */
  tags?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Documentation Import filters */
export type DocumentationImportFilterInputObject = {
  /** Created at */
  createdAt?: InputMaybe<FilterDateInputObject>;
  /** Documentation Import ID */
  id?: InputMaybe<FilterIdInputObject>;
  /** Source kind */
  kind?: InputMaybe<FilterIntInputObject>;
  /** Current status */
  status?: InputMaybe<FilterIntInputObject>;
};

/** FTP connection details exposed on a Documentation Import (password is never stored or returned) */
export type DocumentationImportFtpConfig = {
  __typename?: 'DocumentationImportFtpConfig';
  /** Full FTP/SFTP/FTPS URL including host, port and path */
  url: Scalars['String']['output'];
  /** Username used for authentication, if any */
  username: Maybe<Scalars['String']['output']>;
};

/** Documentation Import FTP/SFTP connection details */
export type DocumentationImportFtpConfigInputObject = {
  /** Optional password (never persisted) */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Server URL with scheme (ftp://, ftps://, sftp://) */
  url: Scalars['String']['input'];
  /** Optional username */
  username?: InputMaybe<Scalars['String']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type DocumentationImportFtpPreviewInput = {
  /** FTP connection attributes */
  attributes: DocumentationImportFtpConfigInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Result of an FTP preview call */
export type DocumentationImportFtpPreviewResult = {
  __typename?: 'DocumentationImportFtpPreviewResult';
  /** First few supported filenames as preview */
  sampleFilenames: Array<Scalars['String']['output']>;
  /** Files that can be imported (matching supported extensions) */
  supportedFilesCount: Scalars['Int']['output'];
  /** Total files visible in the directory */
  totalFilesCount: Scalars['Int']['output'];
  /** Files that will be skipped */
  unsupportedFilesCount: Scalars['Int']['output'];
};

/** Documentation Import source kinds */
export enum DocumentationImportKindEnum {
  /** Single ZIP archive containing multiple files */
  Archive = 'ARCHIVE',
  /** Multiple individual files uploaded directly */
  Files = 'FILES',
  /** Remote FTP/SFTP server */
  Ftp = 'FTP'
}

/** Documentation Import sorts */
export type DocumentationImportSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Source kind */
  kind?: InputMaybe<SortDirectionEnum>;
  /** Current status */
  status?: InputMaybe<SortDirectionEnum>;
};

/** Documentation Import source (exactly one must be present) */
export type DocumentationImportSourceInputObject = {
  /** Single ZIP archive (when kind is ARCHIVE) */
  archiveAttachmentAttached?: InputMaybe<AttachmentCuInputObject>;
  /** Individual files (when kind is FILES) */
  fileAttachmentsAttached?: InputMaybe<Array<AttachmentCuInputObject>>;
  /** Remote FTP/SFTP server connection (when kind is FTP) */
  ftpConfig?: InputMaybe<DocumentationImportFtpConfigInputObject>;
};

/** Documentation Import statuses */
export enum DocumentationImportStatusEnum {
  /** Import completed successfully */
  Complete = 'COMPLETE',
  /** Import failed with errors */
  Failed = 'FAILED',
  /** Import was interrupted (timeout or worker crash) */
  Interrupted = 'INTERRUPTED',
  /** Queued, waiting for worker to start */
  Queued = 'QUEUED',
  /** Still in progress: the worker is retrying after a transient failure */
  Retrying = 'RETRYING',
  /** Import was cancelled by the user */
  Stopped = 'STOPPED',
  /** Worker is processing the import */
  Working = 'WORKING'
}

/** Join row between a Documentation and one of its linkables (Asset, SiteArea, FormTemplate) */
export type DocumentationLink = TimestampInterface & {
  __typename?: 'DocumentationLink';
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Linked Documentation ID */
  documentationId: Scalars['ID']['output'];
  /** Documentation Link ID */
  id: Scalars['ID']['output'];
  /** Linkable ID */
  linkableId: Scalars['ID']['output'];
  /** Linkable type */
  linkableType: DocumentationLinkLinkableTypeEnum;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Whether the linked documentation is exposed when scanning the linkable's QR code */
  visibleViaQr: Scalars['Boolean']['output'];
};

/** DocumentationLinkCollection type */
export type DocumentationLinkCollection = {
  __typename?: 'DocumentationLinkCollection';
  /** A collection of paginated DocumentationLinkCollection */
  collection: Array<DocumentationLink>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Documentation link filters */
export type DocumentationLinkFilterInputObject = {
  /** Documentation ID */
  documentationId?: InputMaybe<FilterIdInputObject>;
  /** Linkable ID */
  linkableId?: InputMaybe<FilterIdInputObject>;
  /** Linkable type */
  linkableType?: InputMaybe<FilterInputObject>;
};

/** Anchor for the documentation links query — exactly one of documentation_id or linkable */
export type DocumentationLinkFindByInputObject = {
  /** Anchor by documentation; returns links of that documentation */
  documentationId?: InputMaybe<Scalars['ID']['input']>;
  /** Anchor by linkable; returns links to that asset, site area, or form template */
  linkable?: InputMaybe<DocumentationLinkLinkableInputObject>;
};

/** Documentation link attributes */
export type DocumentationLinkInputObject = {
  /** Linked entity ID (asset or area) */
  id: Scalars['ID']['input'];
  /** Unlink flag */
  unlink?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether the document is visible when scanning QR code
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  visibleViaQr?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Polymorphic linkable reference */
export type DocumentationLinkLinkableInputObject = {
  /** Linkable ID */
  id: Scalars['ID']['input'];
  /** Linkable type */
  type: DocumentationLinkLinkableTypeEnum;
};

/** Available types a documentation can be linked to */
export enum DocumentationLinkLinkableTypeEnum {
  /** Asset (equipment) */
  Asset = 'Asset',
  /** Form template */
  FormTemplate = 'FormTemplate',
  /** Site area */
  SiteArea = 'SiteArea'
}

/** Documentation link sorts */
export type DocumentationLinkSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Updated at */
  updatedAt?: InputMaybe<SortDirectionEnum>;
  /** Visible via QR */
  visibleViaQr?: InputMaybe<SortDirectionEnum>;
};

/** Available renewal repetition frequencies */
export enum DocumentationRenewalRepetitionEnum {
  /** Custom interval in days */
  Custom = 'CUSTOM',
  /** Half-yearly */
  HalfYearly = 'HALF_YEARLY',
  /** Monthly */
  Monthly = 'MONTHLY',
  /** Quarterly */
  Quarterly = 'QUARTERLY',
  /** Yearly */
  Yearly = 'YEARLY'
}

/** Documentation scope */
export type DocumentationScopeInputObject = {
  /** Scope name */
  name: DocumentationScopeNameEnum;
};

/** Available documentation scope names */
export enum DocumentationScopeNameEnum {
  /**
   * Favorited documentations
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  Favorited = 'FAVORITED',
  /**
   * Documentations linked to any task, form template, form question, or asset the current user can access
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  LinkedToAccessible = 'LINKED_TO_ACCESSIBLE',
  /**
   * Accessible documentations (see linked_to_accessible) that the current user has favorited
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  LinkedToAccessibleFavorited = 'LINKED_TO_ACCESSIBLE_FAVORITED',
  /**
   * Accessible documentations (see linked_to_accessible) that the current user has not read at the latest required version
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  LinkedToAccessibleUnread = 'LINKED_TO_ACCESSIBLE_UNREAD',
  /**
   * Documentations linked to site areas
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  LinkedToAreas = 'LINKED_TO_AREAS',
  /**
   * Documentations linked to assets (equipment)
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  LinkedToAssets = 'LINKED_TO_ASSETS',
  /**
   * Documentations linked to form templates
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  LinkedToForms = 'LINKED_TO_FORMS',
  /**
   * Documentations linked to tasks
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  LinkedToTasks = 'LINKED_TO_TASKS',
  /**
   * Unread documentations for the current user
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  Unread = 'UNREAD'
}

/** Description from base input object. Please set your description for child object. */
export type DocumentationSkipRenewalInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Documentation ID */
  id: Scalars['ID']['input'];
};

/** Documentation sorts */
export type DocumentationSortInputObject = {
  /**
   * Category name
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  categoryName?: InputMaybe<SortDirectionEnum>;
  /** Code */
  code?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Created by user full name */
  createdByFullName?: InputMaybe<SortDirectionEnum>;
  /**
   * Imported at
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  importedAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /**
   * Renewal deadline date
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  renewalDeadlineDate?: InputMaybe<SortDirectionEnum>;
  /** Updated at */
  updatedAt?: InputMaybe<SortDirectionEnum>;
  /**
   * Validation status
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  validationStatus?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type DocumentationUpdateInput = {
  /** Update attributes */
  attributes: DocumentationUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Documentation ID */
  id: Scalars['ID']['input'];
};

/** Documentation attributes */
export type DocumentationUpdateInputObject = {
  /**
   * Approver ID
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  approverId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Site area links
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  areaLinks?: InputMaybe<Array<DocumentationLinkInputObject>>;
  /** Asset links */
  assetLinks?: InputMaybe<Array<DocumentationLinkInputObject>>;
  /**
   * Category ID
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Tags */
  documentationTags?: InputMaybe<Array<LinkingInputObject>>;
  /**
   * Form template links
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  formTemplateLinks?: InputMaybe<Array<LinkingInputObject>>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Renewal deadline date
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  renewalDeadlineDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /**
   * Days before deadline to send early reminder
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  renewalEarlyReminderDays?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Renewal repetition frequency
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  renewalRepetition?: InputMaybe<DocumentationRenewalRepetitionEnum>;
  /**
   * Custom repetition interval in days
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  renewalRepetitionCustomDays?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Sector links
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  sectorLinks?: InputMaybe<Array<LinkingInputObject>>;
  /**
   * Site links
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  siteLinks?: InputMaybe<Array<LinkingInputObject>>;
  /**
   * Task group links
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  taskGroupLinks?: InputMaybe<Array<LinkingInputObject>>;
};

/** Documentation attributes */
export type DocumentationUpdateValidationStatusInputObject = {
  /** Validation status */
  validationStatus: DocumentationValidationStatusEnum;
};

/** Available documentation validation statuses */
export enum DocumentationValidationStatusEnum {
  OnValidation = 'ON_VALIDATION',
  Rejected = 'REJECTED',
  Validated = 'VALIDATED'
}

/** Documentation Version entity */
export type DocumentationVersion = TimestampInterface & {
  __typename?: 'DocumentationVersion';
  /**
   * Whether this version's file can be attached to an AI chat, or the reason it cannot
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiAttachability: Maybe<AiAttachabilityStatusEnum>;
  /**
   * Machine-readable reason this version's processing failed; null while nothing has failed.
   * ATTENTION: Access allowed for full admins.
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiIndexingError: Maybe<Scalars['String']['output']>;
  /**
   * Where this version stands in AI processing. Never SKIPPED — whether processing yielded searchable content is a document-level answer (Documentation.aiIndexingStatus).
   * ATTENTION: Access allowed for full admins.
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiIndexingStatus: AiIndexingStatusEnum;
  /** File */
  attachmentAttached: Maybe<Attachment>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** User entity */
  createdBy: Maybe<User>;
  /** Documentation Version ID */
  id: Scalars['ID']['output'];
  /** Version notes */
  notes: Maybe<Scalars['String']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Version number */
  versionNumber: Scalars['Int']['output'];
};

/** DocumentationVersionCollection type */
export type DocumentationVersionCollection = {
  __typename?: 'DocumentationVersionCollection';
  /** A collection of paginated DocumentationVersionCollection */
  collection: Array<DocumentationVersion>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type DocumentationVersionCreateInput = {
  /** Create attributes */
  attributes: DocumentationVersionCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Documentation ID */
  documentationId: Scalars['ID']['input'];
};

/** Documentation Version attributes */
export type DocumentationVersionCreateInputObject = {
  /** File */
  attachmentAttached: AttachmentCuInputObject;
  /** Version notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  /**
   * Whether users must reread this version
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  requiredToReread?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type DocumentationVersionMarkAsReadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Documentation Version ID */
  id: Scalars['ID']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type DocumentationVersionMarkAsUnreadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Documentation Version ID */
  id: Scalars['ID']['input'];
};

/** Documentation version sorts */
export type DocumentationVersionSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Version number */
  versionNumber?: InputMaybe<SortDirectionEnum>;
};

/** One viewing session of a documentation version — when it was opened and how long it was open. Engagement tracking only; it does not mean the user has read the document */
export type DocumentationVersionView = TimestampInterface & {
  __typename?: 'DocumentationVersionView';
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Documentation ID */
  documentationId: Scalars['ID']['output'];
  /** Documentation Version ID */
  documentationVersionId: Maybe<Scalars['ID']['output']>;
  /** Document View ID */
  id: Scalars['ID']['output'];
  /** Time spent reading in seconds */
  readingDurationSeconds: Maybe<Scalars['Int']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Viewer User entity. %{prefer_id}
   * NOTE: if you only need an Object ID, please use the userId field to reduce the load on the database.
   */
  user: Maybe<User>;
  /** Viewer User ID */
  userId: Maybe<Scalars['ID']['output']>;
  /** Date and time the document was opened */
  viewedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** DocumentationVersionViewCollection type */
export type DocumentationVersionViewCollection = {
  __typename?: 'DocumentationVersionViewCollection';
  /** A collection of paginated DocumentationVersionViewCollection */
  collection: Array<DocumentationVersionView>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type DocumentationVersionViewCreateInput = {
  /** View attributes */
  attributes: DocumentationVersionViewCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Documentation version view attributes */
export type DocumentationVersionViewCreateInputObject = {
  /** Documentation Version ID */
  documentationVersionId: Scalars['ID']['input'];
  /** Time spent reading in seconds */
  readingDurationSeconds: Scalars['Int']['input'];
  /** Date and time the document was opened */
  viewedAt: Scalars['ISO8601DateTime']['input'];
};

/** Documentation Version View filters */
export type DocumentationVersionViewFilterInputObject = {
  /** Documentation ID */
  documentationId?: InputMaybe<FilterIdInputObject>;
  /** Documentation Version ID */
  documentationVersionId?: InputMaybe<FilterIdInputObject>;
  /** Viewer User ID */
  userId?: InputMaybe<FilterIdInputObject>;
};

/** Description from base input object. Please set your description for child object. */
export type DocumentationVersionViewIncrementInput = {
  /** Increment attributes */
  attributes: DocumentationVersionViewIncrementInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Documentation Version View ID */
  id: Scalars['ID']['input'];
};

/** Documentation version view attributes */
export type DocumentationVersionViewIncrementInputObject = {
  /** Time spent reading in seconds */
  readingDurationSeconds: Scalars['Int']['input'];
};

/** Documentation Version View sorts */
export type DocumentationVersionViewSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** View timestamp */
  viewedAt?: InputMaybe<SortDirectionEnum>;
};

export type FailureReasons = {
  __typename?: 'FailureReasons';
  /** JSON-encoded map of reasons */
  details: Scalars['String']['output'];
  /** Human-readable errors */
  fullMessages: Array<Scalars['String']['output']>;
};

/** Fake DNS record entity (non-production only) */
export type FakeDnsRecord = TimestampInterface & {
  __typename?: 'FakeDnsRecord';
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Domain name */
  domain: Scalars['String']['output'];
  /** Fake DNS record ID */
  id: Scalars['ID']['output'];
  /** DNS record type */
  recordType: FakeDnsRecordTypeEnum;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Record value */
  value: Maybe<Scalars['String']['output']>;
};

/** FakeDnsRecordCollection type */
export type FakeDnsRecordCollection = {
  __typename?: 'FakeDnsRecordCollection';
  /** A collection of paginated FakeDnsRecordCollection */
  collection: Array<FakeDnsRecord>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type FakeDnsRecordCreateInput = {
  /** Create attributes */
  attributes: FakeDnsRecordCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Fake DNS record attributes (non-production only) */
export type FakeDnsRecordCreateInputObject = {
  /** Domain name */
  domain: Scalars['String']['input'];
  /** DNS record type (txt, a, cname, mx) */
  recordType?: InputMaybe<FakeDnsRecordTypeEnum>;
  /** Record value */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type FakeDnsRecordDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Fake DNS record ID */
  id: Scalars['ID']['input'];
};

/** Available fake DNS record types (non-production only) */
export enum FakeDnsRecordTypeEnum {
  /** A record */
  A = 'A',
  /** CNAME record */
  Cname = 'CNAME',
  /** MX record */
  Mx = 'MX',
  /** TXT record */
  Txt = 'TXT'
}

/** Description from base input object. Please set your description for child object. */
export type FakeDnsRecordUpdateInput = {
  /** Update attributes */
  attributes: FakeDnsRecordUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Fake DNS record ID */
  id: Scalars['ID']['input'];
};

/** Fake DNS record attributes (non-production only) */
export type FakeDnsRecordUpdateInputObject = {
  /** Domain name */
  domain?: InputMaybe<Scalars['String']['input']>;
  /** DNS record type (txt, a, cname, mx) */
  recordType?: InputMaybe<FakeDnsRecordTypeEnum>;
  /** Record value */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Frontend Filter Preset entity */
export type FeFilterPreset = TimestampInterface & {
  __typename?: 'FeFilterPreset';
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Untyped data in any format that frontend will understand. */
  data: Scalars['JSON']['output'];
  /** Entities attributes array. Used for storing entity IDs. Will be automatically deleted from preset when entity is deleted. */
  entities: FeFilterPresetEntities;
  /** Frontend Filter Preset ID */
  id: Scalars['ID']['output'];
  /** Kind */
  kind: Scalars['String']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** FeFilterPresetCollection type */
export type FeFilterPresetCollection = {
  __typename?: 'FeFilterPresetCollection';
  /** A collection of paginated FeFilterPresetCollection */
  collection: Array<FeFilterPreset>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type FeFilterPresetCreateInput = {
  /** Create attributes */
  attributes: FeFilterPresetCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Frontend Filter Preset attributes */
export type FeFilterPresetCreateInputObject = {
  /** Untyped data in any format that frontend will understand. */
  data?: InputMaybe<Scalars['JSON']['input']>;
  /** Entities attributes array. Used for storing entity IDs. Will be automatically deleted from preset when entity is deleted. */
  entities?: InputMaybe<FeFilterPresetEntitiesInputObject>;
  /** Kind */
  kind: Scalars['String']['input'];
  /** Name */
  name: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type FeFilterPresetDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Frontend Filter Preset ID */
  id: Scalars['ID']['input'];
};

/** Frontend Filter Preset Entities entity */
export type FeFilterPresetEntities = {
  __typename?: 'FeFilterPresetEntities';
  /** Form Categories collection */
  formCategories: Maybe<Array<FeFilterPresetEntity>>;
  /** Form Templates collection */
  formTemplates: Maybe<Array<FeFilterPresetEntity>>;
  /** Sectors collection */
  sectors: Maybe<Array<FeFilterPresetEntity>>;
  /** Sites collection */
  sites: Maybe<Array<FeFilterPresetEntity>>;
};

/** Entities attributes array. Used for storing entity IDs. Will be automatically deleted from preset when entity is deleted. */
export type FeFilterPresetEntitiesInputObject = {
  /** Form Categories attributes array */
  formCategories?: InputMaybe<Array<FeFilterPresetEntityInputObject>>;
  /** Form Templates attributes array */
  formTemplates?: InputMaybe<Array<FeFilterPresetEntityInputObject>>;
  /** Sectors attributes array */
  sectors?: InputMaybe<Array<FeFilterPresetEntityInputObject>>;
  /** Sites attributes array */
  sites?: InputMaybe<Array<FeFilterPresetEntityInputObject>>;
};

/** Frontend Filter Preset Entity entity */
export type FeFilterPresetEntity = {
  __typename?: 'FeFilterPresetEntity';
  /** Entity ID */
  id: Scalars['ID']['output'];
};

/** Entity attributes */
export type FeFilterPresetEntityInputObject = {
  /** Entity ID */
  id: Scalars['ID']['input'];
};

/** Frontend Filter Preset filters */
export type FeFilterPresetFilterInputObject = {
  /** Frontend Filter Preset ID */
  id?: InputMaybe<FilterIdInputObject>;
  /** Kind */
  kind?: InputMaybe<FilterInputObject>;
  /** Name */
  name?: InputMaybe<FilterInputObject>;
};

/** Frontend Filter Preset sorts */
export type FeFilterPresetSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type FeFilterPresetUpdateInput = {
  /** Update attributes */
  attributes: FeFilterPresetUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Frontend Filter Preset ID */
  id: Scalars['ID']['input'];
};

/** Frontend Filter Preset attributes */
export type FeFilterPresetUpdateInputObject = {
  /** Untyped data in any format that frontend will understand. */
  data?: InputMaybe<Scalars['JSON']['input']>;
  /** Entities attributes array. Used for storing entity IDs. Will be automatically deleted from preset when entity is deleted. */
  entities?: InputMaybe<FeFilterPresetEntitiesInputObject>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Filters
 * Examples:
 *   ```
 *   {
 *       "siteId": {
 *       "grouping": "or",
 *       "predicate": {
 *           "in": [
 *             "bab53e5d-be4b-4f5d-8429-ff5d3521d08e",
 *             "14fd0a18-6a3c-4523-aa68-a661641360f6"
 *           ]
 *       },
 *       "filterGroup": "filter1"
 *     }
 *   },
 *   {
 *       "siteAreaId": {
 *           "grouping": "or",
 *           "predicate": {
 *               "in": [
 *                   "57c6364d-0f55-43b0-8e7c-776011f8e2a9",
 *                   "e226b0e1-6ffd-4918-9aad-bbf217258ea7"
 *               ]
 *           },
 *           "filterGroup": "filter1"
 *       }
 *   },
 *   {
 *       "name": {
 *           "grouping": "or",
 *           "predicate": { "cont": "cleaning" },
 *           "filterGroup": "filter2"
 *       }
 *   },
 *   {
 *       "priority": {
 *           "grouping": "or",
 *           "predicate": { "in": ["HIGH", "MEDIUM", "LOW"] },
 *           "filterGroup": "filter2"
 *       }
 *   }
 *   ```
 *
 */
export type FilterBooleanInputObject = {
  /** Allows to group many filters by AND. For example, if you want to filter by (name or email) AND by (site or area), you can group them together. Specify the same group for the (name and email) and then specify an another group for (site and area). The filters in the same group will be combined by AND/OR (depends on grouping attribute) and the groups will be combined by AND. The filter_group is a string and it can be any string. It is used to group filters together. You can see the example in the description, where the filter_group is 'filter1' and 'filter2'. In the example, the result will be in the following format: (siteId OR siteAreaId) AND (name OR priority) */
  filterGroup?: InputMaybe<Scalars['String']['input']>;
  /** Determines if result must be matched with all filters ('AND') or any of them ('OR') */
  grouping?: InputMaybe<FilterGroupingEnum>;
  /** Predicate */
  predicate: FilterBooleanPredicateInputObject;
};

/** Filters */
export type FilterBooleanPredicateInputObject = {
  /** false */
  false?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is not null */
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is null */
  null?: InputMaybe<Scalars['Boolean']['input']>;
  /** true */
  true?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Filters
 * Examples:
 *   ```
 *   {
 *       "siteId": {
 *       "grouping": "or",
 *       "predicate": {
 *           "in": [
 *             "bab53e5d-be4b-4f5d-8429-ff5d3521d08e",
 *             "14fd0a18-6a3c-4523-aa68-a661641360f6"
 *           ]
 *       },
 *       "filterGroup": "filter1"
 *     }
 *   },
 *   {
 *       "siteAreaId": {
 *           "grouping": "or",
 *           "predicate": {
 *               "in": [
 *                   "57c6364d-0f55-43b0-8e7c-776011f8e2a9",
 *                   "e226b0e1-6ffd-4918-9aad-bbf217258ea7"
 *               ]
 *           },
 *           "filterGroup": "filter1"
 *       }
 *   },
 *   {
 *       "name": {
 *           "grouping": "or",
 *           "predicate": { "cont": "cleaning" },
 *           "filterGroup": "filter2"
 *       }
 *   },
 *   {
 *       "priority": {
 *           "grouping": "or",
 *           "predicate": { "in": ["HIGH", "MEDIUM", "LOW"] },
 *           "filterGroup": "filter2"
 *       }
 *   }
 *   ```
 *
 */
export type FilterDateInputObject = {
  /** Allows to group many filters by AND. For example, if you want to filter by (name or email) AND by (site or area), you can group them together. Specify the same group for the (name and email) and then specify an another group for (site and area). The filters in the same group will be combined by AND/OR (depends on grouping attribute) and the groups will be combined by AND. The filter_group is a string and it can be any string. It is used to group filters together. You can see the example in the description, where the filter_group is 'filter1' and 'filter2'. In the example, the result will be in the following format: (siteId OR siteAreaId) AND (name OR priority) */
  filterGroup?: InputMaybe<Scalars['String']['input']>;
  /** Determines if result must be matched with all filters ('AND') or any of them ('OR') */
  grouping?: InputMaybe<FilterGroupingEnum>;
  /** Predicate */
  predicate: FilterDatePredicateInputObject;
};

/** Filters */
export type FilterDatePredicateInputObject = {
  /** Equal to */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Greater than */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to */
  gteq?: InputMaybe<Scalars['String']['input']>;
  /** Less than */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to */
  lteq?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to */
  notEq?: InputMaybe<Scalars['String']['input']>;
  /** Is not null */
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is null */
  null?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Determines if result must be matched with all filters ('and') or any of them ('or') */
export enum FilterGroupingEnum {
  /** All */
  And = 'and',
  /** Any */
  Or = 'or'
}

/**
 * Filters
 * Examples:
 *   ```
 *   {
 *       "siteId": {
 *       "grouping": "or",
 *       "predicate": {
 *           "in": [
 *             "bab53e5d-be4b-4f5d-8429-ff5d3521d08e",
 *             "14fd0a18-6a3c-4523-aa68-a661641360f6"
 *           ]
 *       },
 *       "filterGroup": "filter1"
 *     }
 *   },
 *   {
 *       "siteAreaId": {
 *           "grouping": "or",
 *           "predicate": {
 *               "in": [
 *                   "57c6364d-0f55-43b0-8e7c-776011f8e2a9",
 *                   "e226b0e1-6ffd-4918-9aad-bbf217258ea7"
 *               ]
 *           },
 *           "filterGroup": "filter1"
 *       }
 *   },
 *   {
 *       "name": {
 *           "grouping": "or",
 *           "predicate": { "cont": "cleaning" },
 *           "filterGroup": "filter2"
 *       }
 *   },
 *   {
 *       "priority": {
 *           "grouping": "or",
 *           "predicate": { "in": ["HIGH", "MEDIUM", "LOW"] },
 *           "filterGroup": "filter2"
 *       }
 *   }
 *   ```
 *
 */
export type FilterIdInputObject = {
  /** Allows to group many filters by AND. For example, if you want to filter by (name or email) AND by (site or area), you can group them together. Specify the same group for the (name and email) and then specify an another group for (site and area). The filters in the same group will be combined by AND/OR (depends on grouping attribute) and the groups will be combined by AND. The filter_group is a string and it can be any string. It is used to group filters together. You can see the example in the description, where the filter_group is 'filter1' and 'filter2'. In the example, the result will be in the following format: (siteId OR siteAreaId) AND (name OR priority) */
  filterGroup?: InputMaybe<Scalars['String']['input']>;
  /** Determines if result must be matched with all filters ('AND') or any of them ('OR') */
  grouping?: InputMaybe<FilterGroupingEnum>;
  /** Predicate */
  predicate: FilterIdPredicateInputObject;
};

/** Filters */
export type FilterIdPredicateInputObject = {
  /** Is null or empty (SQL: col is null OR col = '') */
  blank?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** In */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Not equal to */
  notEq?: InputMaybe<Scalars['String']['input']>;
  /** Not in */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Is not null */
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is null */
  null?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not null and not empty (SQL: col is not null AND col != '') */
  present?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Filters
 * Examples:
 *   ```
 *   {
 *       "siteId": {
 *       "grouping": "or",
 *       "predicate": {
 *           "in": [
 *             "bab53e5d-be4b-4f5d-8429-ff5d3521d08e",
 *             "14fd0a18-6a3c-4523-aa68-a661641360f6"
 *           ]
 *       },
 *       "filterGroup": "filter1"
 *     }
 *   },
 *   {
 *       "siteAreaId": {
 *           "grouping": "or",
 *           "predicate": {
 *               "in": [
 *                   "57c6364d-0f55-43b0-8e7c-776011f8e2a9",
 *                   "e226b0e1-6ffd-4918-9aad-bbf217258ea7"
 *               ]
 *           },
 *           "filterGroup": "filter1"
 *       }
 *   },
 *   {
 *       "name": {
 *           "grouping": "or",
 *           "predicate": { "cont": "cleaning" },
 *           "filterGroup": "filter2"
 *       }
 *   },
 *   {
 *       "priority": {
 *           "grouping": "or",
 *           "predicate": { "in": ["HIGH", "MEDIUM", "LOW"] },
 *           "filterGroup": "filter2"
 *       }
 *   }
 *   ```
 *
 */
export type FilterInputObject = {
  /** Allows to group many filters by AND. For example, if you want to filter by (name or email) AND by (site or area), you can group them together. Specify the same group for the (name and email) and then specify an another group for (site and area). The filters in the same group will be combined by AND/OR (depends on grouping attribute) and the groups will be combined by AND. The filter_group is a string and it can be any string. It is used to group filters together. You can see the example in the description, where the filter_group is 'filter1' and 'filter2'. In the example, the result will be in the following format: (siteId OR siteAreaId) AND (name OR priority) */
  filterGroup?: InputMaybe<Scalars['String']['input']>;
  /** Determines if result must be matched with all filters ('AND') or any of them ('OR') */
  grouping?: InputMaybe<FilterGroupingEnum>;
  /** Predicate */
  predicate: FilterPredicateInputObject;
};

/**
 * Filters
 * Examples:
 *   ```
 *   {
 *       "siteId": {
 *       "grouping": "or",
 *       "predicate": {
 *           "in": [
 *             "bab53e5d-be4b-4f5d-8429-ff5d3521d08e",
 *             "14fd0a18-6a3c-4523-aa68-a661641360f6"
 *           ]
 *       },
 *       "filterGroup": "filter1"
 *     }
 *   },
 *   {
 *       "siteAreaId": {
 *           "grouping": "or",
 *           "predicate": {
 *               "in": [
 *                   "57c6364d-0f55-43b0-8e7c-776011f8e2a9",
 *                   "e226b0e1-6ffd-4918-9aad-bbf217258ea7"
 *               ]
 *           },
 *           "filterGroup": "filter1"
 *       }
 *   },
 *   {
 *       "name": {
 *           "grouping": "or",
 *           "predicate": { "cont": "cleaning" },
 *           "filterGroup": "filter2"
 *       }
 *   },
 *   {
 *       "priority": {
 *           "grouping": "or",
 *           "predicate": { "in": ["HIGH", "MEDIUM", "LOW"] },
 *           "filterGroup": "filter2"
 *       }
 *   }
 *   ```
 *
 */
export type FilterIntInputObject = {
  /** Allows to group many filters by AND. For example, if you want to filter by (name or email) AND by (site or area), you can group them together. Specify the same group for the (name and email) and then specify an another group for (site and area). The filters in the same group will be combined by AND/OR (depends on grouping attribute) and the groups will be combined by AND. The filter_group is a string and it can be any string. It is used to group filters together. You can see the example in the description, where the filter_group is 'filter1' and 'filter2'. In the example, the result will be in the following format: (siteId OR siteAreaId) AND (name OR priority) */
  filterGroup?: InputMaybe<Scalars['String']['input']>;
  /** Determines if result must be matched with all filters ('AND') or any of them ('OR') */
  grouping?: InputMaybe<FilterGroupingEnum>;
  /** Predicate */
  predicate: FilterIntPredicateInputObject;
};

/** Filters */
export type FilterIntPredicateInputObject = {
  /** Is null or empty (SQL: col is null OR col = '') */
  blank?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Equal to all */
  eqAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Greater than */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Greater than all */
  gtAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Greater than any */
  gtAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Greater than or equal to */
  gteq?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to all */
  gteqAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Greater than or equal to any */
  gteqAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** In */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Less than */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Less than all */
  ltAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Less than any */
  ltAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Less than or equal to */
  lteq?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to all */
  lteqAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Less than or equal to any */
  lteqAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Not equal to */
  notEq?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to all */
  notEqAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Not in */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Is not null */
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is null */
  null?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not null and not empty (SQL: col is not null AND col != '') */
  present?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Filters */
export type FilterPredicateInputObject = {
  /** Is null or empty (SQL: col is null OR col = '') */
  blank?: InputMaybe<Scalars['Boolean']['input']>;
  /** Contains (ILIKE %value%) */
  cont?: InputMaybe<Scalars['String']['input']>;
  /** Contains all (ILIKE %all values%) */
  contAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains any (ILIKE %any value%) */
  contAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not match (NOT ILIKE value) */
  doesNotMatch?: InputMaybe<Scalars['String']['input']>;
  /** Does not match all (NOT ILIKE all values) */
  doesNotMatchAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not match any (NOT ILIKE any value) */
  doesNotMatchAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Ends with (ILIKE %value) */
  end?: InputMaybe<Scalars['String']['input']>;
  /** Ends with all (ILIKE %all values) */
  endAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Ends with any (ILIKE %any value) */
  endAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Equal to */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Equal to all */
  eqAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** false */
  false?: InputMaybe<Scalars['Boolean']['input']>;
  /** Greater than */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Greater than all */
  gtAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Greater than any */
  gtAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Greater than or equal to */
  gteq?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to all */
  gteqAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Greater than or equal to any */
  gteqAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains value with case insensitive */
  iCont?: InputMaybe<Scalars['String']['input']>;
  /** Contains all values with case insensitive */
  iContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains any value with case insensitive */
  iContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** In */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Less than */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Less than all */
  ltAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Less than any */
  ltAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Less than or equal to */
  lteq?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to all */
  lteqAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Less than or equal to any */
  lteqAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches (ILIKE value) */
  matches?: InputMaybe<Scalars['String']['input']>;
  /** Matches all (ILIKE all values) */
  matchesAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches any (ILIKE any value) */
  matchesAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not contain (NOT ILIKE %value%) */
  notCont?: InputMaybe<Scalars['String']['input']>;
  /** Does not contain all (NOT ILIKE %all values%) */
  notContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not contain any (NOT ILIKE %any value%) */
  notContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not end with (NOT ILIKE %value) */
  notEnd?: InputMaybe<Scalars['String']['input']>;
  /** Does not end with all (NOT ILIKE %all values) */
  notEndAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not end with any (NOT ILIKE %any value) */
  notEndAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Not equal to */
  notEq?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to all */
  notEqAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not contain value with case insensitive */
  notICont?: InputMaybe<Scalars['String']['input']>;
  /** Does not contain all values with case insensitive */
  notIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not contain any value with case insensitive */
  notIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Not in */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Is not null */
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Does not start with (NOT ILIKE value%) */
  notStart?: InputMaybe<Scalars['String']['input']>;
  /** Does not start with all (NOT ILIKE all values%) */
  notStartAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not start with any (NOT ILIKE any value%) */
  notStartAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Is null */
  null?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not null and not empty (SQL: col is not null AND col != '') */
  present?: InputMaybe<Scalars['Boolean']['input']>;
  /** Starts with (ILIKE value%) */
  start?: InputMaybe<Scalars['String']['input']>;
  /** Starts with all (ILIKE all values%) */
  startAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Starts with any (ILIKE any value%) */
  startAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** true */
  true?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Form Answer entity */
export type FormAnswer = TimestampInterface & {
  __typename?: 'FormAnswer';
  /** Attachments */
  attachmentsAttached: Array<Attachment>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Documentation version viewing records */
  documentationVersionViews: Array<DocumentationVersionView>;
  /** Form Template Question Field */
  field: FormTemplateQuestionField;
  /** Form Template Question Field ID */
  fieldId: Scalars['ID']['output'];
  /** Form Answer ID */
  id: Scalars['ID']['output'];
  /** Form Template Question Field kind */
  kind: FormTemplateQuestionFieldsKindEnum;
  /**
   * Performer entity
   * NOTE: if you only need an Object ID, please use the performerId field to reduce the load on the database.
   */
  performer: Maybe<User>;
  /** Performer ID */
  performerId: Maybe<Scalars['ID']['output']>;
  /** Position */
  position: Scalars['Int']['output'];
  /** Form Template Question description */
  questionDescription: Maybe<Scalars['String']['output']>;
  /** Form Template Question ID */
  questionId: Scalars['ID']['output'];
  /** Form Template Question name */
  questionName: Maybe<Scalars['String']['output']>;
  /** Response object to a Form Answer */
  resp: Array<FormAnswerResp>;
  /** Task Completion ID */
  taskCompletionId: Scalars['ID']['output'];
  /** Form Template Version ID */
  templateVersionId: Scalars['ID']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Indicates if response is expected to be valid
   * ATTENTION: Access allowed for users: [TASKS_MANAGEMENT:READ].
   */
  validityHint: Maybe<FormTemplateQuestionFieldOptionsValidityHintEnum>;
};

/** Form Answer attributes */
export type FormAnswerCreateInputObject = {
  /** Attachments */
  attachmentsAttached?: InputMaybe<Array<AttachmentCuInputObject>>;
  /** Form Template Question Field ID */
  fieldId: Scalars['ID']['input'];
  /** Form Template Question ID */
  questionId: Scalars['ID']['input'];
  /** Response object */
  resp?: InputMaybe<Array<FormAnswerRespInputObject>>;
};

/** What the operator did with a document attached to a form question */
export enum FormAnswerDocumentStatusEnum {
  /** Document has been read during this task */
  Read = 'READ',
  /** Document was already read in a previous session and no re-read was required */
  ReadPreviously = 'READ_PREVIOUSLY',
  /** Document was not available */
  Unavailable = 'UNAVAILABLE',
  /** Document has not been read */
  Unread = 'UNREAD'
}

/** Reasons for the document status */
export enum FormAnswerDocumentStatusReasonEnum {
  /** Document was deleted */
  Deleted = 'DELETED',
  /** Document was unavailable due to free plan */
  FreePlan = 'FREE_PLAN',
  /** Document was not validated */
  NotValidated = 'NOT_VALIDATED',
  /** Operator's access level does not allow opening documents at all */
  NoAccess = 'NO_ACCESS',
  /** Document was unavailable because task was completed offline */
  Offline = 'OFFLINE'
}

/** Response type */
export type FormAnswerResp = {
  __typename?: 'FormAnswerResp';
  /** ID of the DocumentationVersionView row created for a READ status */
  documentationVersionViewId: Maybe<Scalars['ID']['output']>;
  /** Group */
  group: Maybe<FormAnswerRespGroupEnum>;
  /** Form Template Question Field Option ID (Row of the checkbox button grid) */
  optionId: Maybe<Scalars['ID']['output']>;
  /** Position */
  position: Maybe<Scalars['Int']['output']>;
  /** Indicates if option is selected */
  selected: Maybe<Scalars['Boolean']['output']>;
  /** Read status recorded for a Document-kind option at submission time */
  status: Maybe<FormAnswerDocumentStatusEnum>;
  /** Reason accompanying an UNAVAILABLE status */
  statusReason: Maybe<FormAnswerDocumentStatusReasonEnum>;
  /**
   * Indicates if option is expected to be valid
   * ATTENTION: Access allowed for users: [TASKS_MANAGEMENT:READ].
   */
  validityHint: Maybe<FormTemplateQuestionFieldOptionsValidityHintEnum>;
  /** Value */
  value: Maybe<Scalars['String']['output']>;
  /** Form Template Question Field Option ID (Column for the checkbox button grid and only for the checkbox button grid) */
  valueId: Maybe<Scalars['ID']['output']>;
};

/** All available form answer response groups */
export enum FormAnswerRespGroupEnum {
  EndDate = 'END_DATE',
  EndTime = 'END_TIME',
  Max = 'MAX',
  Min = 'MIN',
  No = 'NO',
  StartDate = 'START_DATE',
  StartTime = 'START_TIME',
  Yes = 'YES'
}

/** Response object */
export type FormAnswerRespInputObject = {
  /** Fresh DocumentationVersionView ID when status is read */
  documentationVersionViewId?: InputMaybe<Scalars['ID']['input']>;
  /** Group */
  group?: InputMaybe<FormAnswerRespGroupEnum>;
  /** Form Template Question Field Option ID (Row of the checkbox button grid) */
  optionId?: InputMaybe<Scalars['ID']['input']>;
  /** Indicates if option is selected */
  selected?: InputMaybe<Scalars['Boolean']['input']>;
  /** Document read status for document-kind fields (read, read_previously, unread, unavailable) */
  status?: InputMaybe<FormAnswerDocumentStatusEnum>;
  /** Reason when status is unavailable (not_validated, deleted, free_plan, offline) */
  statusReason?: InputMaybe<FormAnswerDocumentStatusReasonEnum>;
  /** Value */
  value?: InputMaybe<Scalars['String']['input']>;
  /** Form Template Question Field Option ID (Column for the checkbox button grid and only for the checkbox button grid) */
  valueId?: InputMaybe<Scalars['ID']['input']>;
};

/** Form Category entity */
export type FormCategory = TimestampInterface & {
  __typename?: 'FormCategory';
  canDestroy: AuthorizationResult;
  /** Color */
  color: ColorEnum;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Form Templates collection */
  formTemplates: FormTemplateCollection;
  /** Number of form templates */
  formTemplatesCount: Scalars['Int']['output'];
  /** Form Category ID */
  id: Scalars['ID']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


/** Form Category entity */
export type FormCategoryFormTemplatesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** FormCategoryCollection type */
export type FormCategoryCollection = {
  __typename?: 'FormCategoryCollection';
  /** A collection of paginated FormCategoryCollection */
  collection: Array<FormCategory>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type FormCategoryCreateInput = {
  /** Create attributes */
  attributes: FormCategoryCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Form Category attributes */
export type FormCategoryCreateInputObject = {
  /** Color */
  color: ColorEnum;
  /** Name */
  name: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type FormCategoryDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Form Category ID */
  id: Scalars['ID']['input'];
};

/** Form Category filters */
export type FormCategoryFilterInputObject = {
  /** Form Category ID */
  id?: InputMaybe<FilterIdInputObject>;
  /** Form Category name */
  name?: InputMaybe<FilterInputObject>;
};

/** Form Category sorts */
export type FormCategorySortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Number of form templates in this category */
  formTemplatesCount?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type FormCategoryUpdateInput = {
  /** Update attributes */
  attributes: FormCategoryUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Form Category ID */
  id: Scalars['ID']['input'];
};

/** Form Category attributes */
export type FormCategoryUpdateInputObject = {
  /** Color */
  color?: InputMaybe<ColorEnum>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Form Checklist Template entity */
export type FormChecklistTemplate = TimestampInterface & {
  __typename?: 'FormChecklistTemplate';
  canDestroy: AuthorizationResult;
  canUpdate: AuthorizationResult;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Form Checklist Template ID */
  id: Scalars['ID']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Form Checklist Template Options collection */
  options: Array<FormChecklistTemplateOption>;
  /** Number of options */
  optionsCount: Scalars['Int']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** FormChecklistTemplateCollection type */
export type FormChecklistTemplateCollection = {
  __typename?: 'FormChecklistTemplateCollection';
  /** A collection of paginated FormChecklistTemplateCollection */
  collection: Array<FormChecklistTemplate>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type FormChecklistTemplateCreateInput = {
  /** Create attributes */
  attributes: FormChecklistTemplateCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Form Checklist Template attributes */
export type FormChecklistTemplateCreateInputObject = {
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name: Scalars['String']['input'];
  /** Form Checklist Template Options attributes array */
  options: Array<FormChecklistTemplateOptionUpdateInputObject>;
};

/** Description from base input object. Please set your description for child object. */
export type FormChecklistTemplateDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Form Checklist Template ID */
  id: Scalars['ID']['input'];
};

/** Form Checklist Template filters */
export type FormChecklistTemplateFilterInputObject = {
  /** Form Checklist Template name */
  name?: InputMaybe<FilterInputObject>;
};

/** Form Checklist Template Option entity */
export type FormChecklistTemplateOption = TimestampInterface & {
  __typename?: 'FormChecklistTemplateOption';
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Form Checklist Template Option ID */
  id: Scalars['ID']['output'];
  /** Position */
  position: Scalars['Int']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Value */
  value: Scalars['String']['output'];
};

/** Form Checklist Template Option attributes */
export type FormChecklistTemplateOptionUpdateInputObject = {
  /** Form Checklist Template Option ID (to update existing option pass ID. To create new option do not pass ID) */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Position */
  position: Scalars['Int']['input'];
  /** Value */
  value: Scalars['String']['input'];
};

/** Form Checklist Template sorts */
export type FormChecklistTemplateSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Number of options */
  optionsCount?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type FormChecklistTemplateUpdateInput = {
  /** Update attributes */
  attributes: FormChecklistTemplateUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Form Checklist Template ID */
  id: Scalars['ID']['input'];
};

/** Form Checklist Template attributes */
export type FormChecklistTemplateUpdateInputObject = {
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Form Checklist Template Options attributes array */
  options: Array<FormChecklistTemplateOptionUpdateInputObject>;
};

/** Form Template entity */
export type FormTemplate = TimestampInterface & {
  __typename?: 'FormTemplate';
  /** Archived date */
  archivedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  canArchive: AuthorizationResult;
  canDestroy: AuthorizationResult;
  canRestore: AuthorizationResult;
  canUpdate: AuthorizationResult;
  /**
   * Form Category entity
   * NOTE: if you only need an Object ID, please use the categoryId field to reduce the load on the database.
   */
  category: Maybe<FormCategory>;
  /** Form Category ID */
  categoryId: Maybe<Scalars['ID']['output']>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Latest Form Template Version entity */
  currentVersion: Maybe<FormTemplateVersion>;
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Whether this Form Template has at least one documentation directly linked at the template level */
  hasLinkedDocumentations: Maybe<Scalars['Boolean']['output']>;
  /** Form Template ID */
  id: Scalars['ID']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Number of versions */
  versionsCount: Scalars['Int']['output'];
  /** Number of visible linked tasks for current user */
  visibleLinkedTasksCount: Scalars['Int']['output'];
};

/** Description from base input object. Please set your description for child object. */
export type FormTemplateBulkArchiveInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type FormTemplateBulkDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type FormTemplateBulkRestoreInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** FormTemplateCollection type */
export type FormTemplateCollection = {
  __typename?: 'FormTemplateCollection';
  /** A collection of paginated FormTemplateCollection */
  collection: Array<FormTemplate>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type FormTemplateCreateInput = {
  /** Create attributes */
  attributes: FormTemplateCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Form Template attributes */
export type FormTemplateCreateInputObject = {
  /** Form Category ID */
  categoryId: Scalars['ID']['input'];
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Documentation links
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationLinks?: InputMaybe<Array<DocumentationLinkInputObject>>;
  /** Name */
  name: Scalars['String']['input'];
  /** Version */
  version: FormTemplateVersionCuInputObject;
};

/** Form Template filters */
export type FormTemplateFilterInputObject = {
  /** Form Category ID */
  categoryId?: InputMaybe<FilterIdInputObject>;
  /** Form Category name */
  categoryName?: InputMaybe<FilterInputObject>;
  /**
   * Filter to form templates linked to one of these documentation IDs
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationsId?: InputMaybe<FilterIdInputObject>;
  /** Form Template name */
  name?: InputMaybe<FilterInputObject>;
};

/** Form Question entity */
export type FormTemplateQuestion = TimestampInterface & {
  __typename?: 'FormTemplateQuestion';
  /** Related Attachments */
  attachmentsAttached: Array<Attachment>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Related Form Question Fields */
  fields: Array<FormTemplateQuestionField>;
  /** Form Question ID */
  id: Scalars['ID']['output'];
  /** Name */
  name: Maybe<Scalars['String']['output']>;
  /** Position */
  position: Scalars['Int']['output'];
  /** Form Template ID */
  templateId: Scalars['ID']['output'];
  /** Form Template Version ID */
  templateVersionId: Scalars['ID']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Form Question Field entity */
export type FormTemplateQuestionField = TimestampInterface & {
  __typename?: 'FormTemplateQuestionField';
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Form Question Field ID */
  id: Scalars['ID']['output'];
  /** Kind */
  kind: FormTemplateQuestionFieldsKindEnum;
  /** Related Form Question Field Options */
  options: Array<FormTemplateQuestionFieldOption>;
  /** Position */
  position: Scalars['Int']['output'];
  /** Form Question ID */
  questionId: Scalars['ID']['output'];
  /** Indicates if field is required */
  required: Scalars['Boolean']['output'];
  /** Field settings */
  settings: FormTemplateQuestionFieldSettings;
  /** Form Template ID */
  templateId: Scalars['ID']['output'];
  /** Form Template Version ID */
  templateVersionId: Scalars['ID']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Validity hint config
   * ATTENTION: Access allowed for users: [TASKS_MANAGEMENT:READ].
   */
  validityHintConfig: Array<FormTemplateQuestionFieldValidityHintConfig>;
};

/** Form Question Field Option entity */
export type FormTemplateQuestionFieldOption = TimestampInterface & {
  __typename?: 'FormTemplateQuestionFieldOption';
  /**
   * Condition
   * ATTENTION: Access allowed for users: [TASKS_MANAGEMENT:READ].
   */
  condition: Maybe<FormTemplateQuestionFieldOptionConditionEnum>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Form Question Field ID */
  fieldId: Scalars['ID']['output'];
  /** Group */
  group: Maybe<FormTemplateQuestionFieldOptionGroupEnum>;
  /** Form Question Field Option ID */
  id: Scalars['ID']['output'];
  /**
   * Linked documentation (for document kind options)
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  optionDocumentation: Maybe<FormTemplateQuestionFieldOptionDocumentation>;
  /** Position */
  position: Scalars['Int']['output'];
  /** Form Question ID */
  questionId: Scalars['ID']['output'];
  /** Form Template ID */
  templateId: Scalars['ID']['output'];
  /** Form Template Version ID */
  templateVersionId: Scalars['ID']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Indicates if option will have expected result after user input in answers
   * ATTENTION: Access allowed for users: [TASKS_MANAGEMENT:READ].
   */
  validityHint: Maybe<FormTemplateQuestionFieldOptionsValidityHintEnum>;
  /** Array of values which will be used to validate user input or to display in the form (depends on the kind of the field) */
  values: Array<Scalars['String']['output']>;
};

/** All available form template question field option conditions */
export enum FormTemplateQuestionFieldOptionConditionEnum {
  Between = 'BETWEEN',
  Equal = 'EQUAL',
  GreaterThan = 'GREATER_THAN',
  LessThan = 'LESS_THAN',
  NotEqual = 'NOT_EQUAL'
}

/** Form Question Field Option Documentation link entity */
export type FormTemplateQuestionFieldOptionDocumentation = TimestampInterface & {
  __typename?: 'FormTemplateQuestionFieldOptionDocumentation';
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Documentation ID */
  documentationId: Scalars['ID']['output'];
  /** Option Documentation ID */
  id: Scalars['ID']['output'];
  /** Indicates if user must read this document */
  requiredToRead: Scalars['Boolean']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Option documentation link attributes */
export type FormTemplateQuestionFieldOptionDocumentationCuInputObject = {
  /** Documentation ID */
  documentationId: Scalars['ID']['input'];
  /** Indicates if user must read this document */
  requiredToRead: Scalars['Boolean']['input'];
};

/** All available form template question field option groups */
export enum FormTemplateQuestionFieldOptionGroupEnum {
  Columns = 'COLUMNS',
  Max = 'MAX',
  Min = 'MIN',
  No = 'NO',
  Rows = 'ROWS',
  Yes = 'YES'
}

/** Form Question Field Option attributes */
export type FormTemplateQuestionFieldOptionUpdateInputObject = {
  /** Condition */
  condition?: InputMaybe<FormTemplateQuestionFieldOptionConditionEnum>;
  /** Group */
  group?: InputMaybe<FormTemplateQuestionFieldOptionGroupEnum>;
  /** Form Question Field Option ID (to update existing question pass ID. To create new question do not pass ID) */
  id?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Document link (for document kind options)
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  optionDocumentation?: InputMaybe<FormTemplateQuestionFieldOptionDocumentationCuInputObject>;
  /** Position */
  position: Scalars['Int']['input'];
  /** Indicates if option will have expected result after user input in answers */
  validityHint?: InputMaybe<FormTemplateQuestionFieldOptionsValidityHintEnum>;
  /** Values */
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** All available form template question field option validity hints */
export enum FormTemplateQuestionFieldOptionsValidityHintEnum {
  Failure = 'FAILURE',
  Success = 'SUCCESS',
  Warning = 'WARNING'
}

/** Field settings */
export type FormTemplateQuestionFieldSettings = {
  __typename?: 'FormTemplateQuestionFieldSettings';
  /** Indicates if field should display last response for the same question */
  allowDisplayLastAnswer: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if field should limit responses to one (currently only for checklist field) */
  limitToOneResp: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if checkbox_button_grid field should limit responses to one per column */
  limitToOneRespPerColumn: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if checkbox_button_grid field should limit responses to one per row */
  limitToOneRespPerRow: Maybe<Scalars['Boolean']['output']>;
};

/** Field settings */
export type FormTemplateQuestionFieldSettingsInputObject = {
  /** Allow display last answer */
  allowDisplayLastAnswer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if field should limit responses to one (currently only for checklist field) */
  limitToOneResp?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if checkbox_button_grid field should limit responses to one per column */
  limitToOneRespPerColumn?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if checkbox_button_grid field should limit responses to one per row */
  limitToOneRespPerRow?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Form Question Field attributes */
export type FormTemplateQuestionFieldUpdateInputObject = {
  /** Form Question Field ID (to update existing field pass ID. To create new field do not pass ID) */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Kind */
  kind: FormTemplateQuestionFieldsKindEnum;
  /** Form Question Field Options attributes array */
  options?: InputMaybe<Array<FormTemplateQuestionFieldOptionUpdateInputObject>>;
  /** Position */
  position: Scalars['Int']['input'];
  /** Indicates if field is required */
  required: Scalars['Boolean']['input'];
  /** Field settings */
  settings?: InputMaybe<FormTemplateQuestionFieldSettingsInputObject>;
  /** Validity hint config */
  validityHintConfig?: InputMaybe<Array<FormTemplateQuestionFieldValidityHintConfigInputObject>>;
};

/** Validity hint config */
export type FormTemplateQuestionFieldValidityHintConfig = {
  __typename?: 'FormTemplateQuestionFieldValidityHintConfig';
  /** Option positions */
  optionPositions: Array<Scalars['Int']['output']>;
  /** Validity hint */
  validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum;
};

/** Validity hint config */
export type FormTemplateQuestionFieldValidityHintConfigInputObject = {
  /** Option positions */
  optionPositions: Array<Scalars['Int']['input']>;
  /** Validity hint */
  validityHint?: InputMaybe<FormTemplateQuestionFieldOptionsValidityHintEnum>;
};

/** Available form template question field kinds */
export enum FormTemplateQuestionFieldsKindEnum {
  /** Attachment */
  Attachment = 'ATTACHMENT',
  /** Multi select */
  Checkbox = 'CHECKBOX',
  /** Checkbox grid in table */
  CheckboxButtonGrid = 'CHECKBOX_BUTTON_GRID',
  /** Checklist */
  Checklist = 'CHECKLIST',
  /** Date */
  Date = 'DATE',
  /** Date and time */
  Datetime = 'DATETIME',
  /** Date range */
  DateRange = 'DATE_RANGE',
  /** Decision box */
  DecisionBox = 'DECISION_BOX',
  /** Document */
  Document = 'DOCUMENT',
  /** Important notice */
  ImportantNotice = 'IMPORTANT_NOTICE',
  /** Single line text */
  Input = 'INPUT',
  /** Numeric range */
  MinMax = 'MIN_MAX',
  /** Numeric */
  NumberInput = 'NUMBER_INPUT',
  /** Single select */
  RadioButton = 'RADIO_BUTTON',
  /** Rating */
  Rating = 'RATING',
  /** Section */
  Section = 'SECTION',
  /** Dropdown */
  SingleSelect = 'SINGLE_SELECT',
  /** Multi line text */
  TextArea = 'TEXT_AREA',
  /** Time */
  Time = 'TIME',
  /** Time range */
  TimeRange = 'TIME_RANGE',
  /** Yes/no */
  YesNo = 'YES_NO'
}

/** Form Question attributes */
export type FormTemplateQuestionUpdateInputObject = {
  /** Attachments */
  attachmentsAttached?: InputMaybe<Array<AttachmentCuInputObject>>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Form Question Fields attributes array */
  fields: Array<FormTemplateQuestionFieldUpdateInputObject>;
  /** Form Question ID (to update existing question pass ID. To create new question do not pass ID) */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Position */
  position: Scalars['Int']['input'];
};

/** Available form template scope names */
export enum FormTemplateScopeNameEnum {
  /** Active form templates */
  Active = 'ACTIVE',
  /** Archived form templates */
  Archived = 'ARCHIVED'
}

/** Form Template sorts */
export type FormTemplateSortInputObject = {
  /** Archived at */
  archivedAt?: InputMaybe<SortDirectionEnum>;
  /** Form Category name */
  categoryName?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Number of versions */
  versionsCount?: InputMaybe<SortDirectionEnum>;
  /** Number of visible linked tasks for current user */
  visibleLinkedTasksCount?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type FormTemplateUnlinkAllDocumentationsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Form Template ID */
  id: Scalars['ID']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type FormTemplateUpdateInput = {
  /** Update attributes */
  attributes: FormTemplateUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Form Template ID */
  id: Scalars['ID']['input'];
};

/** Form Template attributes */
export type FormTemplateUpdateInputObject = {
  /** Form Category ID */
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Documentation links
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationLinks?: InputMaybe<Array<DocumentationLinkInputObject>>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Form Template Version entity */
export type FormTemplateVersion = TimestampInterface & {
  __typename?: 'FormTemplateVersion';
  /** Archived date */
  archivedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  canArchive: AuthorizationResult;
  canDestroy: AuthorizationResult;
  canRestore: AuthorizationResult;
  canUpdate: AuthorizationResult;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Form Template ID */
  id: Scalars['ID']['output'];
  /** Related Form Questions */
  questions: Array<FormTemplateQuestion>;
  /** Status (Virtual field) */
  status: FormTemplateVersionStatusEnum;
  /** Form Template ID */
  templateId: Scalars['ID']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Version */
  version: Maybe<Scalars['String']['output']>;
  /** Number of visible linked tasks for current user */
  visibleLinkedTasksCount: Scalars['Int']['output'];
};

/** Description from base input object. Please set your description for child object. */
export type FormTemplateVersionArchiveInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Form Template ID */
  formTemplateId: Scalars['ID']['input'];
  /** Form Template Version ID */
  id: Scalars['ID']['input'];
};

/** FormTemplateVersionCollection type */
export type FormTemplateVersionCollection = {
  __typename?: 'FormTemplateVersionCollection';
  /** A collection of paginated FormTemplateVersionCollection */
  collection: Array<FormTemplateVersion>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type FormTemplateVersionCreateInput = {
  /** Create attributes */
  attributes: FormTemplateVersionCuInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Form Template ID */
  formTemplateId: Scalars['ID']['input'];
};

/** Form Template Version attributes */
export type FormTemplateVersionCuInputObject = {
  /** Form Template Questions attributes array */
  questions: Array<FormTemplateQuestionUpdateInputObject>;
  /** Task IDs to link */
  taskIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Description from base input object. Please set your description for child object. */
export type FormTemplateVersionDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Form Template ID */
  formTemplateId: Scalars['ID']['input'];
  /** Form Template Version ID */
  id: Scalars['ID']['input'];
};

/** Form Template Version filters */
export type FormTemplateVersionFilterInputObject = {
  /** Archived at */
  archivedAt?: InputMaybe<FilterDateInputObject>;
  /** Version */
  version?: InputMaybe<FilterIntInputObject>;
};

/** Description from base input object. Please set your description for child object. */
export type FormTemplateVersionRestoreInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Form Template ID */
  formTemplateId: Scalars['ID']['input'];
  /** Form Template Version ID */
  id: Scalars['ID']['input'];
};

/** Form Template Version sorts */
export type FormTemplateVersionSortInputObject = {
  /** Archived at */
  archivedAt?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Version */
  version?: InputMaybe<SortDirectionEnum>;
  /** Number of visible linked tasks for current user */
  visibleLinkedTasksCount?: InputMaybe<SortDirectionEnum>;
};

/** Available form template version statuses */
export enum FormTemplateVersionStatusEnum {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Unused = 'UNUSED'
}

/** Description from base input object. Please set your description for child object. */
export type FormTemplateVersionUpdateInput = {
  /** Update attributes */
  attributes: FormTemplateVersionCuInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Form Template ID */
  formTemplateId: Scalars['ID']['input'];
  /** Form Template Version ID */
  id: Scalars['ID']['input'];
};

/** Country */
export type GeoCountry = {
  __typename?: 'GeoCountry';
  /** Country code */
  code: Scalars['String']['output'];
  /** Country name */
  name: Scalars['String']['output'];
};

/** GeoJSON Feature entity */
export type GeojsonFeature = {
  __typename?: 'GeojsonFeature';
  /** Feature geometry */
  geometry: GeojsonGeometry;
  /** Feature properties */
  properties: Maybe<GeojsonProperties>;
  /** Feature type */
  type: GeojsonFeatureTypeEnum;
};

/** GeoJSON Feature Collection entity */
export type GeojsonFeatureCollection = {
  __typename?: 'GeojsonFeatureCollection';
  /** Features collection */
  features: Array<GeojsonFeature>;
  /** Feature Collection type */
  type: GeojsonFeatureCollectionTypeEnum;
};

/** GeoJSON Feature Collection input */
export type GeojsonFeatureCollectionInputObject = {
  /** Features collection */
  features: Array<GeojsonFeatureInputObject>;
  /** Feature Collection type */
  type: GeojsonFeatureCollectionTypeEnum;
};

/** Available GeoJSON feature collection types */
export enum GeojsonFeatureCollectionTypeEnum {
  /** Feature Collection */
  FeatureCollection = 'FeatureCollection'
}

/** GeoJSON Feature input */
export type GeojsonFeatureInputObject = {
  /** Feature geometry */
  geometry: GeojsonGeometryInputObject;
  /** Feature properties */
  properties?: InputMaybe<GeojsonPropertiesInputObject>;
  /** Feature type */
  type: GeojsonFeatureTypeEnum;
};

/** Available GeoJSON feature types */
export enum GeojsonFeatureTypeEnum {
  /** Feature */
  Feature = 'Feature'
}

/** GeoJSON Geometry entity */
export type GeojsonGeometry = {
  __typename?: 'GeojsonGeometry';
  /** Geometry coordinates (Point, Polygon); Point -> [longitude, latitude]; Polygon -> [[[longitude, latitude], ...], ...]; */
  coordinates: Scalars['JSON']['output'];
  /** Geometry type */
  type: GeojsonGeometryTypeEnum;
};

/** GeoJSON Geometry input */
export type GeojsonGeometryInputObject = {
  /** Geometry coordinates (Point, Polygon); Point -> [longitude, latitude]; Polygon -> [[[longitude, latitude], ...], ...]; */
  coordinates: Scalars['JSON']['input'];
  /** Geometry type */
  type: GeojsonGeometryTypeEnum;
};

/** Available GeoJSON geometry types */
export enum GeojsonGeometryTypeEnum {
  /** Point */
  Point = 'Point',
  /** Polygon */
  Polygon = 'Polygon'
}

/** GeoJSON Properties entity */
export type GeojsonProperties = {
  __typename?: 'GeojsonProperties';
  /** Address (exact address that syncs with the coordinates) */
  address: Maybe<Scalars['String']['output']>;
  /** Address details (any other details, for example, a building name, a floor number, etc.) */
  addressDetails: Maybe<Scalars['String']['output']>;
  /** Color */
  color: Maybe<ColorEnum>;
  /** Icon */
  icon: Maybe<Scalars['String']['output']>;
  /** ID (must be used by FE to recognize the same object on the map if it is returned multiple times during multiple requests) */
  id: Maybe<Scalars['String']['output']>;
  /** Point count (number of points in the cluster) */
  pointCount: Maybe<Scalars['Int']['output']>;
  /** Shape */
  shape: Maybe<Scalars['String']['output']>;
  /** Sourceables Collection. A set of unique object classes and identifiers associated with the cluster. This indicates that the cluster contains defined locations for each of these objects. */
  sourceables: Maybe<Array<GeojsonPropertiesPolymorphicIdentity>>;
  /** Type (cluster, polygon, point, line, etc.). Must be used by FE to identify the type of the feature and to render it correctly. */
  type: Maybe<GeojsonPropertiesTypeEnum>;
};

/** GeoJSON Properties input */
export type GeojsonPropertiesInputObject = {
  /** Address (exact address that syncs with the coordinates) */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Address details (any other details, for example, a building name, a floor number, etc.) */
  addressDetails?: InputMaybe<Scalars['String']['input']>;
  /** Color */
  color?: InputMaybe<ColorEnum>;
  /** Icon */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** Shape */
  shape?: InputMaybe<Scalars['String']['input']>;
};

/** Polymorphic identity entity */
export type GeojsonPropertiesPolymorphicIdentity = {
  __typename?: 'GeojsonPropertiesPolymorphicIdentity';
  /** ID */
  id: Scalars['ID']['output'];
  /** Type (Class name) */
  type: GeojsonPropertiesPolymorphicIdentityTypeEnum;
};

/** Available GeoJSON properties polymorphic identity types */
export enum GeojsonPropertiesPolymorphicIdentityTypeEnum {
  /** Sector */
  Sector = 'SECTOR',
  /** Site */
  Site = 'SITE'
}

/** Available GeoJSON properties types */
export enum GeojsonPropertiesTypeEnum {
  /** Cluster */
  Cluster = 'CLUSTER',
  /** Line */
  Line = 'LINE',
  /** Point */
  Point = 'POINT',
  /** Polygon */
  Polygon = 'POLYGON'
}

/** History entity */
export type History = {
  __typename?: 'History';
  /** Diff data */
  data: Maybe<HistoryDataUnion>;
  /** History ID */
  id: Scalars['ID']['output'];
  /** Kind of operation */
  kind: HistoryKindEnum;
  /** Metadata */
  metadata: Maybe<HistoryMetadataUnion>;
  /** Occurred at (actual time when a record was created/updated/etc.) */
  occurredAt: Scalars['ISO8601DateTime']['output'];
  /** Indicates if operation was done by the Datizy system */
  system: Maybe<Scalars['Boolean']['output']>;
  /**
   * User entity who made the operation
   * NOTE: if you only need an Object ID, please use the userId field to reduce the load on the database.
   */
  user: Maybe<User>;
  /** User ID who made the operation */
  userId: Maybe<Scalars['ID']['output']>;
};

/** HistoryCollection type */
export type HistoryCollection = {
  __typename?: 'HistoryCollection';
  /** A collection of paginated HistoryCollection */
  collection: Array<History>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** History data */
export type HistoryDataUnion = DocumentationHistoryData | InterventionActionHistoryData;

/** Available intervention action history metadata reasons */
export enum HistoryInterventionActionHistoryMetadataReasonEnum {
  /** When intervention was closed */
  InterventionClosed = 'INTERVENTION_CLOSED'
}

/** Available history kinds */
export enum HistoryKindEnum {
  /** Created action */
  Created = 'CREATED',
  /** Updated action */
  Updated = 'UPDATED'
}

/** History metadata */
export type HistoryMetadataUnion = InterventionActionHistoryMetadata;

/** History sorts */
export type HistorySortInputObject = {
  /** Occurred at (actual time when a record was created/updated/etc.) */
  occurredAt?: InputMaybe<SortDirectionEnum>;
};

/** Available source types */
export enum HistorySourceableTypeEnum {
  /** Documentation entity */
  Documentation = 'DOCUMENTATION',
  /** Intervention Action entity */
  InterventionAction = 'INTERVENTION_ACTION'
}

/** Home Page entity */
export type HomePage = TimestampInterface & {
  __typename?: 'HomePage';
  canDestroy: AuthorizationResult;
  canUpdate: AuthorizationResult;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Home Page ID */
  id: Scalars['ID']['output'];
  /** Indicates if Home Page is default */
  isDefault: Scalars['Boolean']['output'];
  /** Name */
  name: Maybe<Scalars['String']['output']>;
  /** Position */
  position: Scalars['Int']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** User ID */
  userId: Maybe<Scalars['ID']['output']>;
};

/** Description from base input object. Please set your description for child object. */
export type HomePageBulkUpdateInput = {
  /** Update attributes */
  attributes: Array<HomePageUpdateInputObject>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** HomePageCollection type */
export type HomePageCollection = {
  __typename?: 'HomePageCollection';
  /** A collection of paginated HomePageCollection */
  collection: Array<HomePage>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Home Page attributes */
export type HomePageUpdateInputObject = {
  /** Destroy home page (if true, home page will be destroyed) */
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Position */
  position?: InputMaybe<Scalars['Int']['input']>;
};

/** Industry entity */
export type Industry = TimestampInterface & {
  __typename?: 'Industry';
  /** Color */
  color: ColorEnum;
  /** Companies */
  companies: CompanyCollection;
  /** Number of companies in this industry */
  companiesCount: Scalars['Int']['output'];
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Industry ID */
  id: Scalars['ID']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


/** Industry entity */
export type IndustryCompaniesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** IndustryCollection type */
export type IndustryCollection = {
  __typename?: 'IndustryCollection';
  /** A collection of paginated IndustryCollection */
  collection: Array<Industry>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type IndustryCreateInput = {
  /** Create attributes */
  attributes: IndustryCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Industry attributes */
export type IndustryCreateInputObject = {
  /** Color */
  color: ColorEnum;
  /** Companies attributes array */
  companies?: InputMaybe<Array<LinkingInputObject>>;
  /** Name */
  name: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type IndustryDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Industry ID */
  id: Scalars['ID']['input'];
};

/** Industry filters */
export type IndustryFilterInputObject = {
  /** Industry name */
  name?: InputMaybe<FilterInputObject>;
};

/** Industry sorts */
export type IndustrySortInputObject = {
  /** Number of companies in this industry */
  companiesCount?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type IndustryUpdateInput = {
  /** Update attributes */
  attributes: IndustryUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Industry ID */
  id: Scalars['ID']['input'];
};

/** Industry attributes */
export type IndustryUpdateInputObject = {
  /** Color */
  color?: InputMaybe<ColorEnum>;
  /** Companies attributes array */
  companies?: InputMaybe<Array<LinkingInputObject>>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Intervention entity */
export type Intervention = TimestampInterface & {
  __typename?: 'Intervention';
  /**
   * Asset entity
   * NOTE: if you only need an Object ID, please use the assetId field to reduce the load on the database.
   */
  asset: Maybe<Asset>;
  /** Asset ID */
  assetId: Maybe<Scalars['ID']['output']>;
  /** Related Attachments */
  attachmentsAttached: Array<Attachment>;
  canClose: AuthorizationResult;
  canCreate: AuthorizationResult;
  canCreateAction: AuthorizationResult;
  canDestroy: AuthorizationResult;
  canUpdate: AuthorizationResult;
  /**
   * Intervention Category entity
   * NOTE: if you only need an Object ID, please use the categoryId field to reduce the load on the database.
   */
  category: Maybe<InterventionCategory>;
  /** Intervention Category ID */
  categoryId: Maybe<Scalars['ID']['output']>;
  /** Closed date */
  closedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Code */
  code: Maybe<Scalars['String']['output']>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /**
   * User entity
   * NOTE: if you only need an Object ID, please use the createdById field to reduce the load on the database.
   */
  createdBy: Maybe<User>;
  /** User ID */
  createdById: Maybe<Scalars['ID']['output']>;
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Duration time (in minutes) */
  durationTime: Maybe<Scalars['Int']['output']>;
  /** Estimated date */
  estimatedDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** Estimated time (in minutes) */
  estimatedTime: Maybe<Scalars['Int']['output']>;
  /** Intervention ID */
  id: Scalars['ID']['output'];
  /** Logistic time (in minutes) */
  logisticTime: Maybe<Scalars['Int']['output']>;
  /** Name */
  name: Scalars['String']['output'];
  /** Priority */
  priority: InterventionPriorityEnum;
  /**
   * Site entity
   * NOTE: if you only need an Object ID, please use the siteId field to reduce the load on the database.
   */
  site: Maybe<Site>;
  /**
   * Site Area entity
   * NOTE: if you only need an Object ID, please use the siteAreaId field to reduce the load on the database.
   */
  siteArea: Maybe<SiteArea>;
  /** Site Area ID */
  siteAreaId: Maybe<Scalars['ID']['output']>;
  /** Site ID */
  siteId: Maybe<Scalars['ID']['output']>;
  /** Status */
  status: InterventionStatusEnum;
  /**
   * User entity
   * NOTE: if you only need an Object ID, please use the supervisorId field to reduce the load on the database.
   */
  supervisor: Maybe<User>;
  /** User ID */
  supervisorId: Maybe<Scalars['ID']['output']>;
  /**
   * Task entity
   * NOTE: if you only need an Object ID, please use the taskId field to reduce the load on the database.
   */
  task: Maybe<Task>;
  /** Key to group the same tasks which are recurring or have been recurred (if recurring rule was deleted in some point) */
  taskGroupKey: Maybe<Scalars['ID']['output']>;
  /** Task ID */
  taskId: Maybe<Scalars['ID']['output']>;
  /** Total duration time (in minutes) (intervention.duration_time + SUM(intervention_actions.duration_time)) */
  totalDurationTime: Maybe<Scalars['Int']['output']>;
  /** Total estimated time (in minutes) (intervention.estimated_time + SUM(intervention_actions.estimated_time)) */
  totalEstimatedTime: Maybe<Scalars['Int']['output']>;
  /** Total logistic time (in minutes) (intervention.logistic_time + SUM(intervention_actions.logistic_time)) */
  totalLogisticTime: Maybe<Scalars['Int']['output']>;
  /** Total duration time + Total logistic time */
  totalTime: Maybe<Scalars['Int']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Intervention Action entity */
export type InterventionAction = TimestampInterface & {
  __typename?: 'InterventionAction';
  /** Related Attachments */
  attachmentsAttached: Array<Attachment>;
  canDestroy: AuthorizationResult;
  canUpdate: AuthorizationResult;
  /** Closed date */
  closedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /**
   * User entity
   * NOTE: if you only need an Object ID, please use the createdById field to reduce the load on the database.
   */
  createdBy: Maybe<User>;
  /** User ID */
  createdById: Maybe<Scalars['ID']['output']>;
  /** Duration time (in minutes) */
  durationTime: Maybe<Scalars['Int']['output']>;
  /** Estimated date */
  estimatedDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** Estimated time (in minutes) */
  estimatedTime: Maybe<Scalars['Int']['output']>;
  /** Intervention Action ID */
  id: Scalars['ID']['output'];
  /** Intervention ID */
  interventionId: Maybe<Scalars['ID']['output']>;
  /** Logistic time (in minutes) */
  logisticTime: Maybe<Scalars['Int']['output']>;
  /** Status */
  status: InterventionActionStatusEnum;
  /** Test */
  text: Maybe<Scalars['String']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** InterventionActionCollection type */
export type InterventionActionCollection = {
  __typename?: 'InterventionActionCollection';
  /** A collection of paginated InterventionActionCollection */
  collection: Array<InterventionAction>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type InterventionActionCreateInput = {
  /**  Link to open the intervention action from notification. Supported variables: `interventionId` and `interventionActionId`. Example: `https://admin.datizy.com/interventions/:interventionId/:interventionActionId`  */
  assigneeRedirectUrl: Scalars['String']['input'];
  /** Create attributes */
  attributes: InterventionActionCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Create attributes */
  interventionId: Scalars['ID']['input'];
  /**  Link to open the intervention action from notification where user was mentioned. Supported variables: `interventionId` and `interventionActionId`. Example: `https://admin.datizy.com/interventions/:interventionId/:interventionActionId`  */
  mentionRedirectUrl: Scalars['String']['input'];
};

/** Intervention action attributes */
export type InterventionActionCreateInputObject = {
  /** Assignees attributes array */
  assignees?: InputMaybe<Array<LinkingInputObject>>;
  /** Attachments */
  attachmentsAttached?: InputMaybe<Array<AttachmentCuInputObject>>;
  /** Duration time (in minutes) */
  durationTime?: InputMaybe<Scalars['Int']['input']>;
  /** Estimated date */
  estimatedDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Estimated time (in minutes) */
  estimatedTime?: InputMaybe<Scalars['Int']['input']>;
  /** Logistic time (in minutes) */
  logisticTime?: InputMaybe<Scalars['Int']['input']>;
  /** Status */
  status: InterventionActionStatusEnum;
  /** Text */
  text: Scalars['String']['input'];
  /** Mentions attributes array for text field */
  textMentions?: InputMaybe<Array<LinkingInputObject>>;
};

/** Description from base input object. Please set your description for child object. */
export type InterventionActionDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Intervention Action ID */
  id: Scalars['ID']['input'];
  /** Intervention ID */
  interventionId: Scalars['ID']['input'];
};

/** Intervention Action filters */
export type InterventionActionFilterInputObject = {
  /** Assignee users */
  assigneeUsersId?: InputMaybe<FilterIdInputObject>;
  /** Created at */
  createdAt?: InputMaybe<FilterDateInputObject>;
  /** Created by user */
  createdById?: InputMaybe<FilterIdInputObject>;
  /** Mentioned users in text field */
  textMentionsUsersId?: InputMaybe<FilterIdInputObject>;
};

/** Intervention Action entity */
export type InterventionActionHistoryData = {
  __typename?: 'InterventionActionHistoryData';
  /** Duration time (in minutes) */
  durationTime: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Estimated date */
  estimatedDate: Maybe<Array<Maybe<Scalars['ISO8601Date']['output']>>>;
  /** Estimated time (in minutes) */
  estimatedTime: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Logistic time (in minutes) */
  logisticTime: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Status */
  status: Maybe<Array<InterventionActionStatusEnum>>;
};

/** Intervention Action History Metadata entity */
export type InterventionActionHistoryMetadata = {
  __typename?: 'InterventionActionHistoryMetadata';
  /** Reason */
  reason: Maybe<HistoryInterventionActionHistoryMetadataReasonEnum>;
};

/** Intervention Action sorts */
export type InterventionActionSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
};

/** Available intervention action statuses */
export enum InterventionActionStatusEnum {
  ClassifiedSatsContinued = 'CLASSIFIED_SATS_CONTINUED',
  Closed = 'CLOSED',
  InCheck = 'IN_CHECK',
  InProgress = 'IN_PROGRESS',
  MaterialOrdered = 'MATERIAL_ORDERED',
  MaterialReceived = 'MATERIAL_RECEIVED',
  Planned = 'PLANNED'
}

/** Description from base input object. Please set your description for child object. */
export type InterventionActionUpdateInput = {
  /**  Link to open the intervention action from notification. Supported variables: `interventionId` and `interventionActionId`. Example: `https://admin.datizy.com/interventions/:interventionId/:interventionActionId`  */
  assigneeRedirectUrl: Scalars['String']['input'];
  /** Update attributes */
  attributes: InterventionActionUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Intervention Action ID */
  id: Scalars['ID']['input'];
  /** Intervention ID */
  interventionId: Scalars['ID']['input'];
  /**  Link to open the intervention action from notification where user was mentioned. Supported variables: `interventionId` and `interventionActionId`. Example: `https://admin.datizy.com/interventions/:interventionId/:interventionActionId`  */
  mentionRedirectUrl: Scalars['String']['input'];
};

/** Intervention action attributes */
export type InterventionActionUpdateInputObject = {
  /** Assignees attributes array */
  assignees?: InputMaybe<Array<LinkingInputObject>>;
  /** Attachments */
  attachmentsAttached?: InputMaybe<Array<AttachmentCuInputObject>>;
  /** Duration time (in minutes) */
  durationTime?: InputMaybe<Scalars['Int']['input']>;
  /** Estimated date */
  estimatedDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Estimated time (in minutes) */
  estimatedTime?: InputMaybe<Scalars['Int']['input']>;
  /** Logistic time (in minutes) */
  logisticTime?: InputMaybe<Scalars['Int']['input']>;
  /** Status */
  status?: InputMaybe<InterventionActionStatusEnum>;
  /** Text */
  text?: InputMaybe<Scalars['String']['input']>;
  /** Mentions attributes array for text field */
  textMentions?: InputMaybe<Array<LinkingInputObject>>;
};

/** Description from base input object. Please set your description for child object. */
export type InterventionBulkCloseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Intervention IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Intervention Category entity */
export type InterventionCategory = TimestampInterface & {
  __typename?: 'InterventionCategory';
  canDestroy: AuthorizationResult;
  /** Color */
  color: ColorEnum;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Intervention Category ID */
  id: Scalars['ID']['output'];
  /** Intervention collection */
  interventions: InterventionCollection;
  /** Name */
  name: Scalars['String']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Number of visible Interventions */
  visibleInterventionsCount: Scalars['Int']['output'];
};


/** Intervention Category entity */
export type InterventionCategoryInterventionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** InterventionCategoryCollection type */
export type InterventionCategoryCollection = {
  __typename?: 'InterventionCategoryCollection';
  /** A collection of paginated InterventionCategoryCollection */
  collection: Array<InterventionCategory>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type InterventionCategoryCreateInput = {
  /** Create attributes */
  attributes: InterventionCategoryCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Intervention Category attributes */
export type InterventionCategoryCreateInputObject = {
  /** Color */
  color: ColorEnum;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type InterventionCategoryDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Intervention Category ID */
  id: Scalars['ID']['input'];
};

/** Intervention Category filters */
export type InterventionCategoryFilterInputObject = {
  /** Intervention ID */
  id?: InputMaybe<FilterIdInputObject>;
  /** Intervention Category name */
  name?: InputMaybe<FilterInputObject>;
};

/** Intervention Category sorts */
export type InterventionCategorySortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Number of visible Interventions in this category */
  visibleInterventionsCount?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type InterventionCategoryUpdateInput = {
  /** Update attributes */
  attributes: InterventionCategoryUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Intervention Category ID */
  id: Scalars['ID']['input'];
};

/** Intervention Category attributes */
export type InterventionCategoryUpdateInputObject = {
  /** Color */
  color?: InputMaybe<ColorEnum>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** InterventionCollection type */
export type InterventionCollection = {
  __typename?: 'InterventionCollection';
  /** A collection of paginated InterventionCollection */
  collection: Array<Intervention>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type InterventionCreateInput = {
  /**  Link to open the intervention from notification. Supported variables: `interventionId`. Example: `https://admin.datizy.com/interventions/:interventionId`  */
  assigneeRedirectUrl: Scalars['String']['input'];
  /** Create attributes */
  attributes: InterventionCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Intervention attributes */
export type InterventionCreateInputObject = {
  /** Asset ID */
  assetId?: InputMaybe<Scalars['ID']['input']>;
  /** Assignees attributes array */
  assignees?: InputMaybe<Array<LinkingInputObject>>;
  /** Attachments */
  attachmentsAttached?: InputMaybe<Array<AttachmentCuInputObject>>;
  /** Intervention Category ID */
  categoryId: Scalars['ID']['input'];
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Department links */
  departmentLinks?: InputMaybe<Array<LinkingInputObject>>;
  /** Description */
  description: Scalars['String']['input'];
  /** Duration time (in minutes) */
  durationTime?: InputMaybe<Scalars['Int']['input']>;
  /** Estimated date */
  estimatedDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Estimated time (in minutes) */
  estimatedTime?: InputMaybe<Scalars['Int']['input']>;
  /** Logistic time (in minutes) */
  logisticTime?: InputMaybe<Scalars['Int']['input']>;
  /** Name */
  name: Scalars['String']['input'];
  /** Priority */
  priority: InterventionPriorityEnum;
  /** Site Area ID */
  siteAreaId?: InputMaybe<Scalars['ID']['input']>;
  /** Site ID */
  siteId: Scalars['ID']['input'];
  /** Status */
  status: InterventionStatusEnum;
  /** User ID */
  supervisorId?: InputMaybe<Scalars['ID']['input']>;
  /** Task ID */
  taskId?: InputMaybe<Scalars['ID']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type InterventionDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Intervention ID */
  id: Scalars['ID']['input'];
};

/** Intervention filters */
export type InterventionFilterInputObject = {
  /** Asset code */
  assetCode?: InputMaybe<FilterInputObject>;
  /** Asset ID */
  assetId?: InputMaybe<FilterIdInputObject>;
  /** Asset name */
  assetName?: InputMaybe<FilterInputObject>;
  /** Asset QR prefix */
  assetQrPrefix?: InputMaybe<FilterInputObject>;
  /** Assignee users */
  assigneeUsersId?: InputMaybe<FilterIdInputObject>;
  /** Intervention Category ID */
  categoryId?: InputMaybe<FilterIdInputObject>;
  /** Intervention Category name */
  categoryName?: InputMaybe<FilterInputObject>;
  /** Code */
  code?: InputMaybe<FilterInputObject>;
  /** Created at */
  createdAt?: InputMaybe<FilterDateInputObject>;
  /** Created by user */
  createdById?: InputMaybe<FilterIdInputObject>;
  /** Department ID */
  departmentsId?: InputMaybe<FilterIdInputObject>;
  /** Name */
  name?: InputMaybe<FilterInputObject>;
  /** Priority */
  priority?: InputMaybe<FilterIntInputObject>;
  /** Site Area code */
  siteAreaCode?: InputMaybe<FilterInputObject>;
  /** Site Area ID */
  siteAreaId?: InputMaybe<FilterIdInputObject>;
  /** Site Area name */
  siteAreaName?: InputMaybe<FilterInputObject>;
  /** Site code */
  siteCode?: InputMaybe<FilterInputObject>;
  /** Site ID */
  siteId?: InputMaybe<FilterIdInputObject>;
  /** Site name */
  siteName?: InputMaybe<FilterInputObject>;
  /** Status */
  status?: InputMaybe<FilterIntInputObject>;
  /** Task group key */
  taskGroupKey?: InputMaybe<FilterIdInputObject>;
};

/** Available intervention priorities */
export enum InterventionPriorityEnum {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

/** Available intervention scope names */
export enum InterventionScopeNameEnum {
  /** All */
  All = 'ALL',
  /** Closed interventions */
  Closed = 'CLOSED',
  /** Opened interventions */
  Opened = 'OPENED',
  /** Opened interventions where user is participant (creator, supervisor, assignee, action creator, action assignee or mentioned in comments) */
  OpenedMyParticipation = 'OPENED_MY_PARTICIPATION'
}

/** Intervention sorts */
export type InterventionSortInputObject = {
  /** Asset name */
  assetName?: InputMaybe<SortDirectionEnum>;
  /** Intervention Category name */
  categoryName?: InputMaybe<SortDirectionEnum>;
  /** Closed at */
  closedAt?: InputMaybe<SortDirectionEnum>;
  /** Code */
  code?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Priority */
  priority?: InputMaybe<SortDirectionEnum>;
  /** Site Area name */
  siteAreaName?: InputMaybe<SortDirectionEnum>;
  /** Site name */
  siteName?: InputMaybe<SortDirectionEnum>;
  /** Status */
  status?: InputMaybe<SortDirectionEnum>;
};

/** Available intervention statuses */
export enum InterventionStatusEnum {
  ClassifiedSatsContinued = 'CLASSIFIED_SATS_CONTINUED',
  Closed = 'CLOSED',
  InCheck = 'IN_CHECK',
  InProgress = 'IN_PROGRESS',
  MaterialOrdered = 'MATERIAL_ORDERED',
  MaterialReceived = 'MATERIAL_RECEIVED',
  Planned = 'PLANNED'
}

/** Description from base input object. Please set your description for child object. */
export type InterventionUpdateInput = {
  /**  Link to open the intervention from notification. Supported variables: `interventionId`. Example: `https://admin.datizy.com/interventions/:interventionId`  */
  assigneeRedirectUrl: Scalars['String']['input'];
  /** Update attributes */
  attributes: InterventionUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Intervention ID */
  id: Scalars['ID']['input'];
};

/** Intervention attributes */
export type InterventionUpdateInputObject = {
  /** Assignees attributes array */
  assignees?: InputMaybe<Array<LinkingInputObject>>;
  /** Attachments */
  attachmentsAttached?: InputMaybe<Array<AttachmentCuInputObject>>;
  /** Intervention Category ID */
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Department links */
  departmentLinks?: InputMaybe<Array<LinkingInputObject>>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Duration time (in minutes) */
  durationTime?: InputMaybe<Scalars['Int']['input']>;
  /** Estimated date */
  estimatedDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Estimated time (in minutes) */
  estimatedTime?: InputMaybe<Scalars['Int']['input']>;
  /** Logistic time (in minutes) */
  logisticTime?: InputMaybe<Scalars['Int']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Priority */
  priority?: InputMaybe<InterventionPriorityEnum>;
  /** Status */
  status?: InputMaybe<InterventionStatusEnum>;
  /** User ID */
  supervisorId?: InputMaybe<Scalars['ID']['input']>;
};

/** Available languages */
export enum LanguageEnum {
  /** English */
  En = 'en',
  /** Spanish */
  Es = 'es',
  /** French */
  Fr = 'fr',
  /** Polish */
  Pl = 'pl',
  /** Romanian */
  Ro = 'ro',
  /** Ukrainian */
  Uk = 'uk'
}

/** Linking attributes */
export type LinkingInputObject = {
  /** Entity ID */
  id: Scalars['ID']['input'];
  /** Unlink entity */
  unlink?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Location entity */
export type Location = TimestampInterface & {
  __typename?: 'Location';
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** GeoJSON */
  geojson: Maybe<GeojsonFeatureCollection>;
  /** Location ID */
  id: Scalars['ID']['output'];
  /** Kind */
  kind: Scalars['String']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Location attributes */
export type LocationCuInputObject = {
  /** GeoJSON */
  geojson?: InputMaybe<GeojsonFeatureCollectionInputObject>;
};

/** Location filters */
export type LocationFilterInputObject = {
  /** Location kind (site location => point; sector location => boundary) */
  kind?: InputMaybe<FilterInputObject>;
};

/** Location geographical center entity */
export type LocationGeographicalCenter = {
  __typename?: 'LocationGeographicalCenter';
  /** Latitude */
  lat: Maybe<Scalars['Float']['output']>;
  /** Longitude */
  lon: Maybe<Scalars['Float']['output']>;
};

/** Location Map Params input (current visible area on map) */
export type LocationMapParamsInputObject = {
  /** Maximum latitude */
  maxLat: Scalars['Float']['input'];
  /** Maximum longitude */
  maxLon: Scalars['Float']['input'];
  /** Minimum latitude */
  minLat: Scalars['Float']['input'];
  /** Minimum longitude */
  minLon: Scalars['Float']['input'];
  /** Zoom level */
  zoom: Scalars['Int']['input'];
};

/** List of mutations */
export type Mutation = {
  __typename?: 'Mutation';
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiConversationDestroy: Maybe<AiConversation>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiConversationUpdate: Maybe<AiConversation>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiDismissDocumentationDetection: Maybe<Documentation>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiGenerateDocumentationFields: AiFieldGenerationRequest;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiGenerateDocumentationVersionFields: AiFieldGenerationRequest;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiIndexingRetryParked: Maybe<AiIndexingCoverage>;
  /**
   *
   * ATTENTION: Access allowed for system admins.
   */
  aiIndexingRetryParkedForCompany: Maybe<AiIndexingCoverage>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiMessageFeedbackCreate: Maybe<AiMessage>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiMessageFeedbackDestroy: Maybe<AiMessage>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiSendMessage: Maybe<AiConversation>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiSendMessageStop: Maybe<AiConversation>;
  /** Create an ApiToken */
  apiTokenCreate: Maybe<ApiToken>;
  /** Destroy an ApiToken */
  apiTokenDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update an ApiToken */
  apiTokenUpdate: Maybe<ApiToken>;
  /** Bulk destroy Assets */
  assetBulkDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Create QR codes for Assets in bulk */
  assetBulkQrCodeCreate: Maybe<BackgroundJob>;
  /** Create an Asset Category */
  assetCategoryCreate: Maybe<AssetCategory>;
  /** Destroy an Asset Category */
  assetCategoryDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update an Asset Category */
  assetCategoryUpdate: Maybe<AssetCategory>;
  /** Create an Asset */
  assetCreate: Maybe<Asset>;
  /** Update an Asset */
  assetUpdate: Maybe<Asset>;
  /** Confirm email changing by token */
  authenticationConfirmationsEmailConfirmation: Whoami;
  /** Confirm registration by token */
  authenticationConfirmationsRegistrationConfirmation: Whoami;
  /** Resend email confirmation email */
  authenticationConfirmationsResendEmailConfirmation: ResponseMessage;
  /** Resend registration confirmation */
  authenticationConfirmationsResendRegistrationConfirmation: ResponseMessage;
  /** Complete password setup for newly created accounts */
  authenticationPasswordSetup: Scalars['Boolean']['output'];
  /** Send password reset instructions */
  authenticationPasswordsForgot: ResponseMessage;
  /** Reset password by token */
  authenticationPasswordsReset: Whoami;
  /** Change or set password. Requires session older than 24 hours and step-up 2FA verification (30-min window). Users with an existing password must provide password_challenge. SSO users without a password can set one without providing password_challenge. */
  authenticationPasswordsUpdate: Whoami;
  /** Resend account locked email */
  authenticationResendAccountLockedEmail: ResponseMessage;
  /** Resend account locked email to another system admin. Requires session older than 24 hours. */
  authenticationResendAccountLockedEmailForAdmin: Scalars['Boolean']['output'];
  /** Restore a locked account by token from email */
  authenticationRestoreAccount: Whoami;
  /** Create a session (aka Login) */
  authenticationSessionCreate: Whoami;
  /** End current session (aka Logout) */
  authenticationSessionEnd: Maybe<Scalars['Boolean']['output']>;
  /** End all sessions for the current user. Requires session older than 24 hours. */
  authenticationSessionEndAll: Scalars['Boolean']['output'];
  /** End a specific session by ID. Requires session older than 24 hours. */
  authenticationSessionEndSpecific: Scalars['Boolean']['output'];
  /** Report current session as suspicious and end all other sessions. Requires session older than 24 hours and step-up 2FA verification (30-min window). */
  authenticationSessionReportSuspicious: Scalars['Boolean']['output'];
  /** Report session as suspicious by token from email */
  authenticationSessionReportSuspiciousByToken: Scalars['Boolean']['output'];
  /** Disable email-based two-factor authentication method. Requires session older than 24 hours. */
  authenticationTwoFactorDisableEmailOtp: Scalars['Boolean']['output'];
  /** Disable TOTP (authenticator app) two-factor authentication method. Requires session older than 24 hours. */
  authenticationTwoFactorDisableTotp: Scalars['Boolean']['output'];
  /** Enable email-based two-factor authentication by verifying code from email. Requires session older than 24 hours. */
  authenticationTwoFactorEnableEmailOtp: TwoFactorSetupResult;
  /** Enable TOTP by verifying code from authenticator app. Requires session older than 24 hours. */
  authenticationTwoFactorEnableTotp: TwoFactorSetupResult;
  /** Generate new backup codes for two-factor authentication. Requires session older than 24 hours and fresh 2FA verification on every call. */
  authenticationTwoFactorGenerateBackupCodes: TwoFactorBackupCodes;
  /** Resend email OTP code */
  authenticationTwoFactorResendEmailOtp: Scalars['Boolean']['output'];
  /** Reset two-factor authentication for another admin. Requires session older than 24 hours and fresh 2FA verification on every call. */
  authenticationTwoFactorReset: Scalars['Boolean']['output'];
  /** Setup email OTP for two-factor authentication by sending verification code. Requires session older than 24 hours. Fresh 2FA verification required when adding second method. */
  authenticationTwoFactorSetupEmailOtp: Scalars['Boolean']['output'];
  /** Setup TOTP (authenticator app) for two-factor authentication. Requires session older than 24 hours. Fresh 2FA verification required when adding second method. */
  authenticationTwoFactorSetupTotp: TwoFactorTotpSetup;
  /** Verify two-factor authentication code during login */
  authenticationTwoFactorVerify: Whoami;
  /** Cancel a background job (removes a not-yet-running job, or asks a running one to stop) */
  backgroundJobCancel: Maybe<BackgroundJob>;
  /** Close a background job from your list (a view preference; does not affect execution) */
  backgroundJobDismiss: Maybe<BackgroundJob>;
  /** Ask to be emailed the job's result when it finishes (only while still running, and only once) */
  backgroundJobRequestDelivery: Maybe<BackgroundJob>;
  /** Re-run a failed job from its retry/dead set */
  backgroundJobRequeue: Maybe<BackgroundJob>;
  /** Create a Company */
  companyCreate: Maybe<Company>;
  /** Destroy a Company. Requires session older than 24 hours and fresh 2FA verification on every call. */
  companyDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Create a Company Domain */
  companyDomainCreate: Maybe<CompanyDomain>;
  /** Destroy a Company Domain */
  companyDomainDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Verify a Company Domain via DNS TXT record */
  companyDomainVerify: Maybe<CompanyDomain>;
  /** Plan change request */
  companyPlanChangeRequest: Maybe<Scalars['Boolean']['output']>;
  /** Update a Company */
  companyUpdate: Maybe<Company>;
  /** Bulk Destroy Counters */
  counterBulkDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Create QR codes for Counter in bulk */
  counterBulkQrCodeCreate: Maybe<BackgroundJob>;
  /** Create a Counter */
  counterCreate: Maybe<Counter>;
  /** Create a Counter Measure */
  counterMeasureCreate: Maybe<CounterMeasure>;
  /** Reset to zero a Counter */
  counterResetToZero: Maybe<Counter>;
  /** Update a Counter */
  counterUpdate: Maybe<Counter>;
  /** Create a Data Import */
  dataImportCreate: Maybe<DataImport>;
  /** Destroy a Data Import */
  dataImportDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update a Data Import */
  dataImportUpdate: Maybe<DataImport>;
  /** Department creation */
  departmentCreate: Maybe<Department>;
  /** Department destroy */
  departmentDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Department update */
  departmentUpdate: Maybe<Department>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentRenewalReminderTemplateUpdate: Maybe<DocumentRenewalReminderTemplate>;
  /** Bulk Destroy Documentations */
  documentationBulkDestroy: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationBulkEdit: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationBulkFavorite: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationBulkUnfavorite: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationBulkUpdateValidationStatus: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationCategoryCreate: Maybe<DocumentationCategory>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationCategoryDestroy: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationCategoryUpdate: Maybe<DocumentationCategory>;
  /** Create a Documentation */
  documentationCreate: Maybe<Documentation>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationImportCreate: Maybe<DocumentationImport>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationImportDestroy: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationImportFtpPreview: Maybe<DocumentationImportFtpPreviewResult>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationSkipRenewal: Maybe<Documentation>;
  /** Update a Documentation */
  documentationUpdate: Maybe<Documentation>;
  /** Create a new Documentation Version */
  documentationVersionCreate: Maybe<DocumentationVersion>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationVersionMarkAsRead: Maybe<Documentation>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationVersionMarkAsUnread: Maybe<Documentation>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationVersionViewCreate: Maybe<DocumentationVersionView>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationVersionViewIncrement: Maybe<DocumentationVersionView>;
  /** Create a fake DNS record (non-production only) */
  fakeDnsRecordCreate: Maybe<FakeDnsRecord>;
  /** Destroy a fake DNS record (non-production only) */
  fakeDnsRecordDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update a fake DNS record (non-production only) */
  fakeDnsRecordUpdate: Maybe<FakeDnsRecord>;
  /** Create a Frontend Filter Preset */
  feFilterPresetCreate: Maybe<FeFilterPreset>;
  /** Destroy a Frontend Filter Preset */
  feFilterPresetDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update a Frontend Filter Preset */
  feFilterPresetUpdate: Maybe<FeFilterPreset>;
  /** Create a Form Category */
  formCategoryCreate: Maybe<FormCategory>;
  /** Destroy a Form Category */
  formCategoryDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update a Form Category */
  formCategoryUpdate: Maybe<FormCategory>;
  /** Create a Form Checklist Template */
  formChecklistTemplateCreate: Maybe<FormChecklistTemplate>;
  /** Destroy a Form Checklist Template */
  formChecklistTemplateDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update a Form Checklist Template */
  formChecklistTemplateUpdate: Maybe<FormChecklistTemplate>;
  /** Bulk archive Form Templates */
  formTemplateBulkArchive: Maybe<Scalars['Boolean']['output']>;
  /** Bulk destroy Form Templates */
  formTemplateBulkDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Bulk restore Form Templates */
  formTemplateBulkRestore: Maybe<Scalars['Boolean']['output']>;
  /** Create a Form Template */
  formTemplateCreate: Maybe<FormTemplate>;
  /** Unlink every documentation associated with a Form Template (template-level links only; per-question option documents are not touched) */
  formTemplateUnlinkAllDocumentations: Maybe<Scalars['Boolean']['output']>;
  /** Update a Form Template */
  formTemplateUpdate: Maybe<FormTemplate>;
  /** Archive a Form Template Version */
  formTemplateVersionArchive: Maybe<FormTemplateVersion>;
  /** Create a Form Template Version */
  formTemplateVersionCreate: Maybe<FormTemplateVersion>;
  /** Destroy a Form Template Version */
  formTemplateVersionDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Restore a Form Template Version */
  formTemplateVersionRestore: Maybe<FormTemplateVersion>;
  /** Update a Form Template Version */
  formTemplateVersionUpdate: Maybe<FormTemplateVersion>;
  /** Bulk update Home Pages */
  homePageBulkUpdate: Maybe<Scalars['Boolean']['output']>;
  /** Create an Industry */
  industryCreate: Maybe<Industry>;
  /** Destroy an Industry */
  industryDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update an Industry */
  industryUpdate: Maybe<Industry>;
  /** Create an Intervention Action */
  interventionActionCreate: Maybe<InterventionAction>;
  /** Destroy an Intervention Action */
  interventionActionDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update an Intervention Action */
  interventionActionUpdate: Maybe<InterventionAction>;
  /** Bulk close Interventions */
  interventionBulkClose: Maybe<Scalars['Boolean']['output']>;
  /** Create an Intervention Category */
  interventionCategoryCreate: Maybe<InterventionCategory>;
  /** Destroy an Intervention Category */
  interventionCategoryDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update an Intervention Category */
  interventionCategoryUpdate: Maybe<InterventionCategory>;
  /** Create an Intervention */
  interventionCreate: Maybe<Intervention>;
  /** Destroy an Intervention */
  interventionDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update an Intervention */
  interventionUpdate: Maybe<Intervention>;
  /** Bulk Destroy Nomenclatures */
  nomenclatureBulkDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Create QR codes for component assets of Nomenclatures in bulk */
  nomenclatureBulkQrCodeCreate: Maybe<BackgroundJob>;
  /** Create a Nomenclature */
  nomenclatureCreate: Maybe<Nomenclature>;
  /** Update a Nomenclature */
  nomenclatureUpdate: Maybe<Nomenclature>;
  /** Create a Sector */
  sectorCreate: Maybe<Sector>;
  /** Destroy a Sector */
  sectorDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update a Sector */
  sectorUpdate: Maybe<Sector>;
  /** Destroy Site Areas in bulk. Site Areas that cannot be deleted are skipped and returned in the result instead of failing the whole call */
  siteAreaBulkDestroy: Maybe<SiteAreaBulkDestroyResult>;
  /** Create QR codes for Site Areas in bulk */
  siteAreaBulkQrCodeCreate: Maybe<BackgroundJob>;
  /** Update a Site Area */
  siteAreaUpdate: Maybe<SiteArea>;
  /** Create a Site */
  siteCreate: Maybe<Site>;
  /** Destroy a Site */
  siteDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update a Site */
  siteUpdate: Maybe<Site>;
  /** Activate an SSO integration */
  ssoIntegrationActivate: Maybe<SsoIntegration>;
  /** Create an SSO integration */
  ssoIntegrationCreate: Maybe<SsoIntegration>;
  /** Deactivate an SSO integration */
  ssoIntegrationDeactivate: Maybe<SsoIntegration>;
  /** Destroy an SSO integration */
  ssoIntegrationDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update an SSO integration */
  ssoIntegrationUpdate: Maybe<SsoIntegration>;
  /** Create a System Admin */
  systemAdminCreate: Maybe<SystemAdmin>;
  /** Destroy a System Admin. Requires session older than 24 hours. */
  systemAdminDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update self System Admin. When changing email, requires session older than 24 hours and step-up 2FA verification (30-min window). */
  systemAdminSelfUpdate: Maybe<SystemAdmin>;
  /** Update a System Admin by other System Admin */
  systemAdminUpdate: Maybe<SystemAdmin>;
  /** Create a User by System Admin */
  systemAdminUserCreate: Maybe<User>;
  /** Create a Tag */
  tagCreate: Maybe<Tag>;
  /** Destroy a Tag */
  tagDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Create same Tasks in bulk */
  taskBulkCreateSame: Maybe<Array<Scalars['ID']['output']>>;
  /** Bulk update a Task's Deadline Missed Reason */
  taskBulkDeadlineMissedReasonUpdate: Maybe<Scalars['Boolean']['output']>;
  /** Bulk schedule Tasks */
  taskBulkScheduling: Maybe<Scalars['Boolean']['output']>;
  /** Bulk update a Task's Template Version */
  taskBulkTemplateVersionUpdate: Maybe<Scalars['Boolean']['output']>;
  /** Update Tasks status */
  taskBulkUpdateStatus: Maybe<Scalars['Boolean']['output']>;
  /** Create a Task Completion */
  taskCompletionCreate: Maybe<TaskCompletion>;
  /** Update a Task's Completion status */
  taskCompletionStatusUpdate: Maybe<TaskCompletion>;
  /** Destroy a Task */
  taskDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Generate a Tasks Timeline Report */
  taskTimelineReportCreate: Maybe<BackgroundJob>;
  /** Unlink every documentation associated with the tasks of a given recurring group_key */
  taskUnlinkAllDocumentations: Maybe<Scalars['Boolean']['output']>;
  /** Update a Task */
  taskUpdate: Maybe<Task>;
  /** Team creation */
  teamCreate: Maybe<Team>;
  /** Team destroy */
  teamDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Team update */
  teamUpdate: Maybe<Team>;
  /** Create a Technical Pause. Requires fresh 2FA verification on every call. */
  technicalPauseCreate: Maybe<TechnicalPause>;
  /** Destroy a Technical Pause. Requires fresh 2FA verification on every call. */
  technicalPauseDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update a Technical Pause. Requires fresh 2FA verification on every call. */
  technicalPauseUpdate: Maybe<TechnicalPause>;
  /** Activate Users in bulk */
  userBulkActivate: Maybe<Scalars['Boolean']['output']>;
  /** Deactivate Users in bulk */
  userBulkDeactivate: Maybe<Scalars['Boolean']['output']>;
  /** Accept the Code of Conduct */
  userCodeOfConductAccept: Maybe<User>;
  /** Create a User */
  userCreate: Maybe<User>;
  /** Destroy a User */
  userDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update self User */
  userSelfUpdate: Maybe<User>;
  /** Update a User by other Full Admin/Admin */
  userUpdate: Maybe<User>;
  /** Bulk update Widgets for a Home Page */
  widgetBulkUpdate: Maybe<Scalars['Boolean']['output']>;
  /** Create a new Widget Template (only announcement and external_link kinds) */
  widgetTemplateCreate: Maybe<WidgetTemplate>;
  /** Delete a Widget Template (deletes all associated widgets for external_link kind) */
  widgetTemplateDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update an existing Widget Template */
  widgetTemplateUpdate: Maybe<WidgetTemplate>;
};


/** List of mutations */
export type MutationAiConversationDestroyArgs = {
  input: AiConversationDestroyInput;
};


/** List of mutations */
export type MutationAiConversationUpdateArgs = {
  input: AiConversationUpdateInput;
};


/** List of mutations */
export type MutationAiDismissDocumentationDetectionArgs = {
  input: AiDismissDocumentationDetectionInput;
};


/** List of mutations */
export type MutationAiGenerateDocumentationFieldsArgs = {
  input: AiGenerateDocumentationFieldsInput;
};


/** List of mutations */
export type MutationAiGenerateDocumentationVersionFieldsArgs = {
  input: AiGenerateDocumentationVersionFieldsInput;
};


/** List of mutations */
export type MutationAiIndexingRetryParkedArgs = {
  input: AiIndexingRetryParkedInput;
};


/** List of mutations */
export type MutationAiIndexingRetryParkedForCompanyArgs = {
  input: AiIndexingRetryParkedForCompanyInput;
};


/** List of mutations */
export type MutationAiMessageFeedbackCreateArgs = {
  input: AiMessageFeedbackCreateInput;
};


/** List of mutations */
export type MutationAiMessageFeedbackDestroyArgs = {
  input: AiMessageFeedbackDestroyInput;
};


/** List of mutations */
export type MutationAiSendMessageArgs = {
  input: AiSendMessageInput;
};


/** List of mutations */
export type MutationAiSendMessageStopArgs = {
  input: AiSendMessageStopInput;
};


/** List of mutations */
export type MutationApiTokenCreateArgs = {
  input: ApiTokenCreateInput;
};


/** List of mutations */
export type MutationApiTokenDestroyArgs = {
  input: ApiTokenDestroyInput;
};


/** List of mutations */
export type MutationApiTokenUpdateArgs = {
  input: ApiTokenUpdateInput;
};


/** List of mutations */
export type MutationAssetBulkDestroyArgs = {
  input: AssetBulkDestroyInput;
};


/** List of mutations */
export type MutationAssetBulkQrCodeCreateArgs = {
  input: AssetBulkQrCodeCreateInput;
};


/** List of mutations */
export type MutationAssetCategoryCreateArgs = {
  input: AssetCategoryCreateInput;
};


/** List of mutations */
export type MutationAssetCategoryDestroyArgs = {
  input: AssetCategoryDestroyInput;
};


/** List of mutations */
export type MutationAssetCategoryUpdateArgs = {
  input: AssetCategoryUpdateInput;
};


/** List of mutations */
export type MutationAssetCreateArgs = {
  input: AssetCreateInput;
};


/** List of mutations */
export type MutationAssetUpdateArgs = {
  input: AssetUpdateInput;
};


/** List of mutations */
export type MutationAuthenticationConfirmationsEmailConfirmationArgs = {
  input: AuthenticationConfirmationsEmailConfirmationInput;
};


/** List of mutations */
export type MutationAuthenticationConfirmationsRegistrationConfirmationArgs = {
  input: AuthenticationConfirmationsRegistrationConfirmationInput;
};


/** List of mutations */
export type MutationAuthenticationConfirmationsResendEmailConfirmationArgs = {
  input: AuthenticationConfirmationsResendEmailConfirmationInput;
};


/** List of mutations */
export type MutationAuthenticationConfirmationsResendRegistrationConfirmationArgs = {
  input: AuthenticationConfirmationsResendRegistrationConfirmationInput;
};


/** List of mutations */
export type MutationAuthenticationPasswordSetupArgs = {
  input: AuthenticationPasswordSetupInput;
};


/** List of mutations */
export type MutationAuthenticationPasswordsForgotArgs = {
  input: AuthenticationPasswordsForgotInput;
};


/** List of mutations */
export type MutationAuthenticationPasswordsResetArgs = {
  input: AuthenticationPasswordsResetInput;
};


/** List of mutations */
export type MutationAuthenticationPasswordsUpdateArgs = {
  input: AuthenticationPasswordsUpdateInput;
};


/** List of mutations */
export type MutationAuthenticationResendAccountLockedEmailArgs = {
  input: AuthenticationResendAccountLockedEmailInput;
};


/** List of mutations */
export type MutationAuthenticationResendAccountLockedEmailForAdminArgs = {
  input: AuthenticationResendAccountLockedEmailForAdminInput;
};


/** List of mutations */
export type MutationAuthenticationRestoreAccountArgs = {
  input: AuthenticationRestoreAccountInput;
};


/** List of mutations */
export type MutationAuthenticationSessionCreateArgs = {
  input: AuthenticationSessionCreateInput;
};


/** List of mutations */
export type MutationAuthenticationSessionEndArgs = {
  input: AuthenticationSessionEndInput;
};


/** List of mutations */
export type MutationAuthenticationSessionEndAllArgs = {
  input: AuthenticationSessionEndAllInput;
};


/** List of mutations */
export type MutationAuthenticationSessionEndSpecificArgs = {
  input: AuthenticationSessionEndSpecificInput;
};


/** List of mutations */
export type MutationAuthenticationSessionReportSuspiciousArgs = {
  input: AuthenticationSessionReportSuspiciousInput;
};


/** List of mutations */
export type MutationAuthenticationSessionReportSuspiciousByTokenArgs = {
  input: AuthenticationSessionReportSuspiciousByTokenInput;
};


/** List of mutations */
export type MutationAuthenticationTwoFactorDisableEmailOtpArgs = {
  input: AuthenticationTwoFactorDisableEmailOtpInput;
};


/** List of mutations */
export type MutationAuthenticationTwoFactorDisableTotpArgs = {
  input: AuthenticationTwoFactorDisableTotpInput;
};


/** List of mutations */
export type MutationAuthenticationTwoFactorEnableEmailOtpArgs = {
  input: AuthenticationTwoFactorEnableEmailOtpInput;
};


/** List of mutations */
export type MutationAuthenticationTwoFactorEnableTotpArgs = {
  input: AuthenticationTwoFactorEnableTotpInput;
};


/** List of mutations */
export type MutationAuthenticationTwoFactorGenerateBackupCodesArgs = {
  input: AuthenticationTwoFactorGenerateBackupCodesInput;
};


/** List of mutations */
export type MutationAuthenticationTwoFactorResendEmailOtpArgs = {
  input: AuthenticationTwoFactorResendEmailOtpInput;
};


/** List of mutations */
export type MutationAuthenticationTwoFactorResetArgs = {
  input: AuthenticationTwoFactorResetInput;
};


/** List of mutations */
export type MutationAuthenticationTwoFactorSetupEmailOtpArgs = {
  input: AuthenticationTwoFactorSetupEmailOtpInput;
};


/** List of mutations */
export type MutationAuthenticationTwoFactorSetupTotpArgs = {
  input: AuthenticationTwoFactorSetupTotpInput;
};


/** List of mutations */
export type MutationAuthenticationTwoFactorVerifyArgs = {
  input: AuthenticationTwoFactorVerifyInput;
};


/** List of mutations */
export type MutationBackgroundJobCancelArgs = {
  input: BackgroundJobCancelInput;
};


/** List of mutations */
export type MutationBackgroundJobDismissArgs = {
  input: BackgroundJobDismissInput;
};


/** List of mutations */
export type MutationBackgroundJobRequestDeliveryArgs = {
  input: BackgroundJobRequestDeliveryInput;
};


/** List of mutations */
export type MutationBackgroundJobRequeueArgs = {
  input: BackgroundJobRequeueInput;
};


/** List of mutations */
export type MutationCompanyCreateArgs = {
  input: CompanyCreateInput;
};


/** List of mutations */
export type MutationCompanyDestroyArgs = {
  input: CompanyDestroyInput;
};


/** List of mutations */
export type MutationCompanyDomainCreateArgs = {
  input: CompanyDomainCreateInput;
};


/** List of mutations */
export type MutationCompanyDomainDestroyArgs = {
  input: CompanyDomainDestroyInput;
};


/** List of mutations */
export type MutationCompanyDomainVerifyArgs = {
  input: CompanyDomainVerifyInput;
};


/** List of mutations */
export type MutationCompanyPlanChangeRequestArgs = {
  input: CompanyPlanChangeRequestInput;
};


/** List of mutations */
export type MutationCompanyUpdateArgs = {
  input: CompanyUpdateInput;
};


/** List of mutations */
export type MutationCounterBulkDestroyArgs = {
  input: CounterBulkDestroyInput;
};


/** List of mutations */
export type MutationCounterBulkQrCodeCreateArgs = {
  input: CounterBulkQrCodeCreateInput;
};


/** List of mutations */
export type MutationCounterCreateArgs = {
  input: CounterCreateInput;
};


/** List of mutations */
export type MutationCounterMeasureCreateArgs = {
  input: CounterMeasureCreateInput;
};


/** List of mutations */
export type MutationCounterResetToZeroArgs = {
  input: CounterResetToZeroInput;
};


/** List of mutations */
export type MutationCounterUpdateArgs = {
  input: CounterUpdateInput;
};


/** List of mutations */
export type MutationDataImportCreateArgs = {
  input: DataImportCreateInput;
};


/** List of mutations */
export type MutationDataImportDestroyArgs = {
  input: DataImportDestroyInput;
};


/** List of mutations */
export type MutationDataImportUpdateArgs = {
  input: DataImportUpdateInput;
};


/** List of mutations */
export type MutationDepartmentCreateArgs = {
  input: DepartmentCreateInput;
};


/** List of mutations */
export type MutationDepartmentDestroyArgs = {
  input: DepartmentDestroyInput;
};


/** List of mutations */
export type MutationDepartmentUpdateArgs = {
  input: DepartmentUpdateInput;
};


/** List of mutations */
export type MutationDocumentRenewalReminderTemplateUpdateArgs = {
  input: DocumentRenewalReminderTemplateUpdateInput;
};


/** List of mutations */
export type MutationDocumentationBulkDestroyArgs = {
  input: DocumentationBulkDestroyInput;
};


/** List of mutations */
export type MutationDocumentationBulkEditArgs = {
  input: DocumentationBulkEditInput;
};


/** List of mutations */
export type MutationDocumentationBulkFavoriteArgs = {
  input: DocumentationBulkFavoriteInput;
};


/** List of mutations */
export type MutationDocumentationBulkUnfavoriteArgs = {
  input: DocumentationBulkUnfavoriteInput;
};


/** List of mutations */
export type MutationDocumentationBulkUpdateValidationStatusArgs = {
  input: DocumentationBulkUpdateValidationStatusInput;
};


/** List of mutations */
export type MutationDocumentationCategoryCreateArgs = {
  input: DocumentationCategoryCreateInput;
};


/** List of mutations */
export type MutationDocumentationCategoryDestroyArgs = {
  input: DocumentationCategoryDestroyInput;
};


/** List of mutations */
export type MutationDocumentationCategoryUpdateArgs = {
  input: DocumentationCategoryUpdateInput;
};


/** List of mutations */
export type MutationDocumentationCreateArgs = {
  input: DocumentationCreateInput;
};


/** List of mutations */
export type MutationDocumentationImportCreateArgs = {
  input: DocumentationImportCreateInput;
};


/** List of mutations */
export type MutationDocumentationImportDestroyArgs = {
  input: DocumentationImportDestroyInput;
};


/** List of mutations */
export type MutationDocumentationImportFtpPreviewArgs = {
  input: DocumentationImportFtpPreviewInput;
};


/** List of mutations */
export type MutationDocumentationSkipRenewalArgs = {
  input: DocumentationSkipRenewalInput;
};


/** List of mutations */
export type MutationDocumentationUpdateArgs = {
  input: DocumentationUpdateInput;
};


/** List of mutations */
export type MutationDocumentationVersionCreateArgs = {
  input: DocumentationVersionCreateInput;
};


/** List of mutations */
export type MutationDocumentationVersionMarkAsReadArgs = {
  input: DocumentationVersionMarkAsReadInput;
};


/** List of mutations */
export type MutationDocumentationVersionMarkAsUnreadArgs = {
  input: DocumentationVersionMarkAsUnreadInput;
};


/** List of mutations */
export type MutationDocumentationVersionViewCreateArgs = {
  input: DocumentationVersionViewCreateInput;
};


/** List of mutations */
export type MutationDocumentationVersionViewIncrementArgs = {
  input: DocumentationVersionViewIncrementInput;
};


/** List of mutations */
export type MutationFakeDnsRecordCreateArgs = {
  input: FakeDnsRecordCreateInput;
};


/** List of mutations */
export type MutationFakeDnsRecordDestroyArgs = {
  input: FakeDnsRecordDestroyInput;
};


/** List of mutations */
export type MutationFakeDnsRecordUpdateArgs = {
  input: FakeDnsRecordUpdateInput;
};


/** List of mutations */
export type MutationFeFilterPresetCreateArgs = {
  input: FeFilterPresetCreateInput;
};


/** List of mutations */
export type MutationFeFilterPresetDestroyArgs = {
  input: FeFilterPresetDestroyInput;
};


/** List of mutations */
export type MutationFeFilterPresetUpdateArgs = {
  input: FeFilterPresetUpdateInput;
};


/** List of mutations */
export type MutationFormCategoryCreateArgs = {
  input: FormCategoryCreateInput;
};


/** List of mutations */
export type MutationFormCategoryDestroyArgs = {
  input: FormCategoryDestroyInput;
};


/** List of mutations */
export type MutationFormCategoryUpdateArgs = {
  input: FormCategoryUpdateInput;
};


/** List of mutations */
export type MutationFormChecklistTemplateCreateArgs = {
  input: FormChecklistTemplateCreateInput;
};


/** List of mutations */
export type MutationFormChecklistTemplateDestroyArgs = {
  input: FormChecklistTemplateDestroyInput;
};


/** List of mutations */
export type MutationFormChecklistTemplateUpdateArgs = {
  input: FormChecklistTemplateUpdateInput;
};


/** List of mutations */
export type MutationFormTemplateBulkArchiveArgs = {
  input: FormTemplateBulkArchiveInput;
};


/** List of mutations */
export type MutationFormTemplateBulkDestroyArgs = {
  input: FormTemplateBulkDestroyInput;
};


/** List of mutations */
export type MutationFormTemplateBulkRestoreArgs = {
  input: FormTemplateBulkRestoreInput;
};


/** List of mutations */
export type MutationFormTemplateCreateArgs = {
  input: FormTemplateCreateInput;
};


/** List of mutations */
export type MutationFormTemplateUnlinkAllDocumentationsArgs = {
  input: FormTemplateUnlinkAllDocumentationsInput;
};


/** List of mutations */
export type MutationFormTemplateUpdateArgs = {
  input: FormTemplateUpdateInput;
};


/** List of mutations */
export type MutationFormTemplateVersionArchiveArgs = {
  input: FormTemplateVersionArchiveInput;
};


/** List of mutations */
export type MutationFormTemplateVersionCreateArgs = {
  input: FormTemplateVersionCreateInput;
};


/** List of mutations */
export type MutationFormTemplateVersionDestroyArgs = {
  input: FormTemplateVersionDestroyInput;
};


/** List of mutations */
export type MutationFormTemplateVersionRestoreArgs = {
  input: FormTemplateVersionRestoreInput;
};


/** List of mutations */
export type MutationFormTemplateVersionUpdateArgs = {
  input: FormTemplateVersionUpdateInput;
};


/** List of mutations */
export type MutationHomePageBulkUpdateArgs = {
  input: HomePageBulkUpdateInput;
};


/** List of mutations */
export type MutationIndustryCreateArgs = {
  input: IndustryCreateInput;
};


/** List of mutations */
export type MutationIndustryDestroyArgs = {
  input: IndustryDestroyInput;
};


/** List of mutations */
export type MutationIndustryUpdateArgs = {
  input: IndustryUpdateInput;
};


/** List of mutations */
export type MutationInterventionActionCreateArgs = {
  input: InterventionActionCreateInput;
};


/** List of mutations */
export type MutationInterventionActionDestroyArgs = {
  input: InterventionActionDestroyInput;
};


/** List of mutations */
export type MutationInterventionActionUpdateArgs = {
  input: InterventionActionUpdateInput;
};


/** List of mutations */
export type MutationInterventionBulkCloseArgs = {
  input: InterventionBulkCloseInput;
};


/** List of mutations */
export type MutationInterventionCategoryCreateArgs = {
  input: InterventionCategoryCreateInput;
};


/** List of mutations */
export type MutationInterventionCategoryDestroyArgs = {
  input: InterventionCategoryDestroyInput;
};


/** List of mutations */
export type MutationInterventionCategoryUpdateArgs = {
  input: InterventionCategoryUpdateInput;
};


/** List of mutations */
export type MutationInterventionCreateArgs = {
  input: InterventionCreateInput;
};


/** List of mutations */
export type MutationInterventionDestroyArgs = {
  input: InterventionDestroyInput;
};


/** List of mutations */
export type MutationInterventionUpdateArgs = {
  input: InterventionUpdateInput;
};


/** List of mutations */
export type MutationNomenclatureBulkDestroyArgs = {
  input: NomenclatureBulkDestroyInput;
};


/** List of mutations */
export type MutationNomenclatureBulkQrCodeCreateArgs = {
  input: NomenclatureBulkQrCodeCreateInput;
};


/** List of mutations */
export type MutationNomenclatureCreateArgs = {
  input: NomenclatureCreateInput;
};


/** List of mutations */
export type MutationNomenclatureUpdateArgs = {
  input: NomenclatureUpdateInput;
};


/** List of mutations */
export type MutationSectorCreateArgs = {
  input: SectorCreateInput;
};


/** List of mutations */
export type MutationSectorDestroyArgs = {
  input: SectorDestroyInput;
};


/** List of mutations */
export type MutationSectorUpdateArgs = {
  input: SectorUpdateInput;
};


/** List of mutations */
export type MutationSiteAreaBulkDestroyArgs = {
  input: SiteAreaBulkDestroyInput;
};


/** List of mutations */
export type MutationSiteAreaBulkQrCodeCreateArgs = {
  input: SiteAreaBulkQrCodeCreateInput;
};


/** List of mutations */
export type MutationSiteAreaUpdateArgs = {
  input: SiteAreaUpdateInput;
};


/** List of mutations */
export type MutationSiteCreateArgs = {
  input: SiteCreateInput;
};


/** List of mutations */
export type MutationSiteDestroyArgs = {
  input: SiteDestroyInput;
};


/** List of mutations */
export type MutationSiteUpdateArgs = {
  input: SiteUpdateInput;
};


/** List of mutations */
export type MutationSsoIntegrationActivateArgs = {
  input: SsoIntegrationActivateInput;
};


/** List of mutations */
export type MutationSsoIntegrationCreateArgs = {
  input: SsoIntegrationCreateInput;
};


/** List of mutations */
export type MutationSsoIntegrationDeactivateArgs = {
  input: SsoIntegrationDeactivateInput;
};


/** List of mutations */
export type MutationSsoIntegrationDestroyArgs = {
  input: SsoIntegrationDestroyInput;
};


/** List of mutations */
export type MutationSsoIntegrationUpdateArgs = {
  input: SsoIntegrationUpdateInput;
};


/** List of mutations */
export type MutationSystemAdminCreateArgs = {
  input: SystemAdminCreateInput;
};


/** List of mutations */
export type MutationSystemAdminDestroyArgs = {
  input: SystemAdminDestroyInput;
};


/** List of mutations */
export type MutationSystemAdminSelfUpdateArgs = {
  input: SystemAdminSelfUpdateInput;
};


/** List of mutations */
export type MutationSystemAdminUpdateArgs = {
  input: SystemAdminUpdateInput;
};


/** List of mutations */
export type MutationSystemAdminUserCreateArgs = {
  input: SystemAdminUserCreateInput;
};


/** List of mutations */
export type MutationTagCreateArgs = {
  input: TagCreateInput;
};


/** List of mutations */
export type MutationTagDestroyArgs = {
  input: TagDestroyInput;
};


/** List of mutations */
export type MutationTaskBulkCreateSameArgs = {
  input: TaskBulkCreateSameInput;
};


/** List of mutations */
export type MutationTaskBulkDeadlineMissedReasonUpdateArgs = {
  input: TaskBulkDeadlineMissedReasonUpdateInput;
};


/** List of mutations */
export type MutationTaskBulkSchedulingArgs = {
  input: TaskBulkSchedulingInput;
};


/** List of mutations */
export type MutationTaskBulkTemplateVersionUpdateArgs = {
  input: TaskBulkTemplateVersionUpdateInput;
};


/** List of mutations */
export type MutationTaskBulkUpdateStatusArgs = {
  input: TaskBulkUpdateStatusInput;
};


/** List of mutations */
export type MutationTaskCompletionCreateArgs = {
  input: TaskCompletionCreateInput;
};


/** List of mutations */
export type MutationTaskCompletionStatusUpdateArgs = {
  input: TaskCompletionStatusUpdateInput;
};


/** List of mutations */
export type MutationTaskDestroyArgs = {
  input: TaskDestroyInput;
};


/** List of mutations */
export type MutationTaskTimelineReportCreateArgs = {
  input: TasksTimelineReportCreateInput;
};


/** List of mutations */
export type MutationTaskUnlinkAllDocumentationsArgs = {
  input: TaskUnlinkAllDocumentationsInput;
};


/** List of mutations */
export type MutationTaskUpdateArgs = {
  input: TaskUpdateInput;
};


/** List of mutations */
export type MutationTeamCreateArgs = {
  input: TeamCreateInput;
};


/** List of mutations */
export type MutationTeamDestroyArgs = {
  input: TeamDestroyInput;
};


/** List of mutations */
export type MutationTeamUpdateArgs = {
  input: TeamUpdateInput;
};


/** List of mutations */
export type MutationTechnicalPauseCreateArgs = {
  input: TechnicalPauseCreateInput;
};


/** List of mutations */
export type MutationTechnicalPauseDestroyArgs = {
  input: TechnicalPauseDestroyInput;
};


/** List of mutations */
export type MutationTechnicalPauseUpdateArgs = {
  input: TechnicalPauseUpdateInput;
};


/** List of mutations */
export type MutationUserBulkActivateArgs = {
  input: UserBulkActivateInput;
};


/** List of mutations */
export type MutationUserBulkDeactivateArgs = {
  input: UserBulkDeactivateInput;
};


/** List of mutations */
export type MutationUserCodeOfConductAcceptArgs = {
  input: UserCodeOfConductAcceptInput;
};


/** List of mutations */
export type MutationUserCreateArgs = {
  input: UserCreateInput;
};


/** List of mutations */
export type MutationUserDestroyArgs = {
  input: UserDestroyInput;
};


/** List of mutations */
export type MutationUserSelfUpdateArgs = {
  input: UserSelfUpdateInput;
};


/** List of mutations */
export type MutationUserUpdateArgs = {
  input: UserUpdateInput;
};


/** List of mutations */
export type MutationWidgetBulkUpdateArgs = {
  input: WidgetBulkUpdateInput;
};


/** List of mutations */
export type MutationWidgetTemplateCreateArgs = {
  input: WidgetTemplateCreateInput;
};


/** List of mutations */
export type MutationWidgetTemplateDestroyArgs = {
  input: WidgetTemplateDestroyInput;
};


/** List of mutations */
export type MutationWidgetTemplateUpdateArgs = {
  input: WidgetTemplateUpdateInput;
};

/** Nomenclature entity */
export type Nomenclature = TimestampInterface & {
  __typename?: 'Nomenclature';
  /**
   * Component Asset entity
   * NOTE: if you only need an Object ID, please use the componentAssetId field to reduce the load on the database.
   */
  componentAsset: Maybe<Asset>;
  /** Component Asset ID */
  componentAssetId: Maybe<Scalars['ID']['output']>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Nomenclature ID */
  id: Scalars['ID']['output'];
  /**
   * Main Asset entity
   * NOTE: if you only need an Object ID, please use the mainAssetId field to reduce the load on the database.
   */
  mainAsset: Maybe<Asset>;
  /** Main Asset ID */
  mainAssetId: Maybe<Scalars['ID']['output']>;
  /** Quantity */
  quantity: Scalars['Int']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Description from base input object. Please set your description for child object. */
export type NomenclatureBulkDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Nomenclature IDs */
  ids: Array<Scalars['ID']['input']>;
  /** Main Asset ID */
  mainAssetId: Scalars['ID']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type NomenclatureBulkQrCodeCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Create params */
  params: QrCodesCreateInputObject;
};

/** NomenclatureCollection type */
export type NomenclatureCollection = {
  __typename?: 'NomenclatureCollection';
  /** A collection of paginated NomenclatureCollection */
  collection: Array<Nomenclature>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type NomenclatureCreateInput = {
  /** Create attributes */
  attributes: NomenclatureCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Nomenclature attributes */
export type NomenclatureCreateInputObject = {
  /** Component asset ID */
  componentAssetId: Scalars['ID']['input'];
  /** Main asset ID (Asset nomenclature for) */
  mainAssetId: Scalars['ID']['input'];
  /** Quantity */
  quantity: Scalars['Int']['input'];
};

/** Nomenclature filters */
export type NomenclatureFilterInputObject = {
  /** Component Asset code */
  componentAssetCode?: InputMaybe<FilterInputObject>;
  /** Component Asset name */
  componentAssetName?: InputMaybe<FilterInputObject>;
};

/** Nomenclature sorts */
export type NomenclatureSortInputObject = {
  /** Component Asset code */
  componentAssetCode?: InputMaybe<SortDirectionEnum>;
  /** Component Asset name */
  componentAssetName?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Quantity */
  quantity?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type NomenclatureUpdateInput = {
  /** Update attributes */
  attributes: NomenclatureUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Nomenclature ID */
  id: Scalars['ID']['input'];
  /** Main Asset ID */
  mainAssetId: Scalars['ID']['input'];
};

/** Nomenclature attributes */
export type NomenclatureUpdateInputObject = {
  /** Quantity */
  quantity: Scalars['Int']['input'];
};

/** Available period group by options */
export enum PeriodGroupByEnum {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

/** Available QR code file formats */
export enum QrCodeFileFormatEnum {
  /** EPS */
  Eps = 'EPS',
  /** PDF */
  Pdf = 'PDF',
  /** PNG */
  Png = 'PNG',
  /** SVG */
  Svg = 'SVG'
}

/** Available QR code file layouts */
export enum QrCodeFileLayoutEnum {
  /** Single file */
  SingleFile = 'SINGLE_FILE',
  /** Single page */
  SinglePage = 'SINGLE_PAGE'
}

/** Available QR code page sizes */
export enum QrCodePageSizeEnum {
  /** 29x39 mm */
  W29H39 = 'W29H39',
  /** 60x80 mm */
  W60H80 = 'W60H80',
  /** 67x76 mm */
  W67H76 = 'W67H76',
  /** A5 (148x210 mm) */
  W148H210 = 'W148H210'
}

/** QR codes attributes */
export type QrCodesCreateInputObject = {
  /** File format */
  fileFormat: QrCodeFileFormatEnum;
  /** File layout */
  fileLayout: QrCodeFileLayoutEnum;
  /** IDs */
  ids: Array<Scalars['ID']['input']>;
  /** Message to recipient */
  message?: InputMaybe<Scalars['String']['input']>;
  /** Page size */
  pageSize: QrCodePageSizeEnum;
  /** Recipient user ID */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** List of queries */
export type Query = {
  __typename?: 'Query';
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiBudgetStatus: AiBudgetStatus;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiCompanyIndexingCoverage: AiIndexingCoverage;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiConversation: AiConversation;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiConversations: AiConversationCollection;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiMediaConstraints: Array<AiMediaConstraint>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiMessages: AiMessageCollection;
  /** The AI model offer per hosting region — selectable chat models plus the region-derived embedding and extraction models, each with pricing (system admins only). */
  aiModelCatalog: Array<AiModelCatalogRegion>;
  /** What a customer's AI workload costs us and what it could be sold for — the form to render, per-unit rate cards for every region and assistant model, the costed workload, and the caveats that apply to it (system admins only). */
  aiPriceCalculator: AiPriceCalculator;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiThinkingCapability: AiThinkingCapability;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiUsageByUser: AiUsageByUserCollection;
  /** Show an ApiToken */
  apiToken: Maybe<ApiToken>;
  /** List of ApiTokens */
  apiTokens: ApiTokenCollection;
  /** Asset */
  asset: Maybe<Asset>;
  /** List of Asset Categories */
  assetCategories: AssetCategoryCollection;
  /** Show an Asset Category */
  assetCategory: Maybe<AssetCategory>;
  /** List of Assets */
  assets: AssetCollection;
  /** Check if an email domain has SSO integrations configured. Used on login page to show SSO options. */
  authenticationSsoCheck: SsoCheck;
  /** Show one background job (its tree) by ID */
  backgroundJob: Maybe<BackgroundJob>;
  /** List background jobs you own (roots only, each with its children tree) */
  backgroundJobs: BackgroundJobCollection;
  /** List of Companies */
  companies: CompanyCollection;
  /** Show a Company */
  company: Maybe<Company>;
  /** Show a Company Domain */
  companyDomain: Maybe<CompanyDomain>;
  /** List of Company Domains */
  companyDomains: CompanyDomainCollection;
  /** Raw text report of aggregate statistics for a company (system admins only). */
  companyStatistics: Scalars['String']['output'];
  /** Show a Counter */
  counter: Maybe<Counter>;
  /** Show a Counter Measure */
  counterMeasure: Maybe<CounterMeasure>;
  /** List of Counter Measures */
  counterMeasures: CounterMeasureCollection;
  /** Counter Measures Graph Data */
  counterMeasuresGraphData: Array<CounterMeasureGraphData>;
  /** List of Counters */
  counters: CounterCollection;
  /** List of countries */
  countries: Array<GeoCountry>;
  /** Show a Data Import */
  dataImport: Maybe<DataImport>;
  /** Data Import Config */
  dataImportConfig: Maybe<Scalars['CamelizedJson']['output']>;
  /** List of Data Imports */
  dataImports: DataImportCollection;
  /** Show a Department */
  department: Maybe<Department>;
  /** List of Departments — root departments by default; with a filter, a flat search across every depth (descend the tree via the Department.children field) */
  departments: DepartmentCollection;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentRenewalReminderTemplate: Maybe<DocumentRenewalReminderTemplate>;
  /** Show a documentation */
  documentation: Maybe<Documentation>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationCategories: DocumentationCategoryCollection;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationCategory: Maybe<DocumentationCategory>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationImport: Maybe<DocumentationImport>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationImports: DocumentationImportCollection;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationLinks: DocumentationLinkCollection;
  /** Show a documentation version */
  documentationVersion: Maybe<DocumentationVersion>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationVersionViews: DocumentationVersionViewCollection;
  /** List of documentation versions */
  documentationVersions: DocumentationVersionCollection;
  /** List of documentations */
  documentations: DocumentationCollection;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationsAnalyticsByCategory: Array<DocumentationAnalyticsByCategory>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationsAnalyticsByDocument: DocumentationAnalyticsByDocumentCollection;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationsAnalyticsByLinkable: Array<DocumentationAnalyticsByLinkable>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationsAnalyticsByUser: Array<DocumentationAnalyticsByUser>;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationsAnalyticsTrend: Array<DocumentationAnalyticsTrendPoint>;
  /** Show a fake DNS record (non-production only) */
  fakeDnsRecord: Maybe<FakeDnsRecord>;
  /** List of fake DNS records (non-production only) */
  fakeDnsRecords: FakeDnsRecordCollection;
  /** Show a Frontend Filter Preset */
  feFilterPreset: Maybe<FeFilterPreset>;
  /** List of Frontend Filter Presets */
  feFilterPresets: FeFilterPresetCollection;
  /** List of Form Categories */
  formCategories: FormCategoryCollection;
  /** Show a Form Category */
  formCategory: Maybe<FormCategory>;
  /** Show a Form Checklist Template */
  formChecklistTemplate: Maybe<FormChecklistTemplate>;
  /** List of Form Checklist Templates */
  formChecklistTemplates: FormChecklistTemplateCollection;
  /** Show a Form Template */
  formTemplate: Maybe<FormTemplate>;
  /** Show a Form Template Version */
  formTemplateVersion: Maybe<FormTemplateVersion>;
  /** List of Form Template Versions */
  formTemplateVersions: FormTemplateVersionCollection;
  /** List of Form Templates */
  formTemplates: FormTemplateCollection;
  /** List of Histories */
  histories: HistoryCollection;
  /** Show a Home Page */
  homePage: Maybe<HomePage>;
  /** List of Home Pages */
  homePages: HomePageCollection;
  /** List of Industries */
  industries: IndustryCollection;
  /** Show an Industry */
  industry: Maybe<Industry>;
  /** Show an Intervention */
  intervention: Maybe<Intervention>;
  /** Show an Intervention Action */
  interventionAction: Maybe<InterventionAction>;
  /** List of Intervention Actions */
  interventionActions: InterventionActionCollection;
  /** List of Intervention Categories */
  interventionCategories: InterventionCategoryCollection;
  /** Show an Intervention Category */
  interventionCategory: Maybe<InterventionCategory>;
  /** List of Interventions */
  interventions: InterventionCollection;
  /** Show a Nomenclature */
  nomenclature: Maybe<Nomenclature>;
  /** List of Nomenclatures */
  nomenclatures: NomenclatureCollection;
  /** Show a Sector */
  sector: Maybe<Sector>;
  /** Sector Location Center */
  sectorLocationCenter: Maybe<LocationGeographicalCenter>;
  /** List of Sector Locations */
  sectorLocations: Maybe<GeojsonFeatureCollection>;
  /** List of Sectors */
  sectors: SectorCollection;
  /** Sectors performance metrics by task deadlines missed */
  sectorsPerformanceMetricsByTaskDeadlinesMissed: Maybe<Array<SectorPerformanceMetricByTaskDeadlinesMissed>>;
  /** Sectors performance metrics by task deadlines missed by date */
  sectorsPerformanceMetricsByTaskDeadlinesMissedByDate: Maybe<Array<SectorPerformanceMetricByTaskDeadlinesMissedByDate>>;
  /** Sectors performance metrics by task results */
  sectorsPerformanceMetricsByTaskResults: Maybe<Array<SectorPerformanceMetricByTaskResults>>;
  /** Sectors performance metrics by task results by date */
  sectorsPerformanceMetricsByTaskResultsByDate: Maybe<Array<SectorPerformanceMetricByTaskResultsByDate>>;
  /** List of user sessions */
  sessions: SessionCollection;
  /** Show a Site */
  site: Maybe<Site>;
  /** Show a Site Area */
  siteArea: Maybe<SiteArea>;
  /** List of Site Areas */
  siteAreas: SiteAreaCollection;
  /** Site Location Center */
  siteLocationCenter: Maybe<LocationGeographicalCenter>;
  /** List of Site Locations */
  siteLocations: Maybe<GeojsonFeatureCollection>;
  /** List of Sites */
  sites: SiteCollection;
  /** Sites performance metrics by task deadlines missed */
  sitesPerformanceMetricsByTaskDeadlinesMissed: Maybe<Array<SitePerformanceMetricByTaskDeadlinesMissed>>;
  /** Sites performance metrics by task deadlines missed by date */
  sitesPerformanceMetricsByTaskDeadlinesMissedByDate: Maybe<Array<SitePerformanceMetricByTaskDeadlinesMissedByDate>>;
  /** Sites performance metrics by task results */
  sitesPerformanceMetricsByTaskResults: Maybe<Array<SitePerformanceMetricByTaskResults>>;
  /** Sites performance metrics by task results by date */
  sitesPerformanceMetricsByTaskResultsByDate: Maybe<Array<SitePerformanceMetricByTaskResultsByDate>>;
  /** Show an SSO integration */
  ssoIntegration: Maybe<SsoIntegration>;
  /** Generate a new SSO code with SP URLs for IdP configuration */
  ssoIntegrationGenerateCode: SsoGeneratedCode;
  /** Get default attribute mapping and settings for a provider preset */
  ssoIntegrationPresetDefaults: Scalars['JSON']['output'];
  /** List of supported user fields for SSO attribute mapping */
  ssoIntegrationSupportedMappingFields: Array<SsoMappingField>;
  /** List of SSO integrations */
  ssoIntegrations: SsoIntegrationCollection;
  /** Show a System Admin */
  systemAdmin: Maybe<SystemAdmin>;
  /** List of System Admins */
  systemAdmins: SystemAdminCollection;
  /** Show a tag */
  tag: Maybe<Tag>;
  /** List of tags */
  tags: TagCollection;
  /** Task */
  task: Maybe<Task>;
  /** Get unique task kinds for given task IDs available for scheduling */
  taskAvailableForSchedulingKindsByIds: Array<TaskKindEnum>;
  /** Show a Task Completion */
  taskCompletion: Maybe<TaskCompletion>;
  /** List of Task Completions */
  taskCompletions: TaskCompletionCollection;
  /** List of Tasks */
  tasks: TaskCollection;
  /** Tasks data which can be completed from today until a provided date and assigned to the current user */
  tasksMyTodoCompletableByDateData: Array<TasksTodoCompletableByDateData>;
  /** Tasks Timeline */
  tasksTimeline: Array<TaskTimeline>;
  /** Show a Team */
  team: Maybe<Team>;
  /** List of Teams */
  teams: TeamCollection;
  /** Show a Technical Pause */
  technicalPause: Maybe<TechnicalPause>;
  /** List of Technical Pauses */
  technicalPauses: TechnicalPauseCollection;
  /** Show a User */
  user: Maybe<User>;
  /** List of Users */
  users: UserCollection;
  /** Show current user */
  whoami: Whoami;
  /** Show a Widget */
  widget: Maybe<Widget>;
  /** Show a Widget Template */
  widgetTemplate: Maybe<WidgetTemplate>;
  /** List of Widget Templates */
  widgetTemplates: WidgetTemplateCollection;
  /** List of Widgets */
  widgets: Array<Widget>;
};


/** List of queries */
export type QueryAiConversationArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryAiConversationsArgs = {
  filters?: InputMaybe<Array<AiConversationFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<AiConversationSortInputObject>;
};


/** List of queries */
export type QueryAiMessagesArgs = {
  conversationId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<AiMessageSortInputObject>;
};


/** List of queries */
export type QueryAiPriceCalculatorArgs = {
  input?: InputMaybe<AiPriceCalculatorInput>;
};


/** List of queries */
export type QueryAiUsageByUserArgs = {
  filters?: InputMaybe<Array<AiUsageByUserFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<AiUsageByUserSortInputObject>;
};


/** List of queries */
export type QueryApiTokenArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryApiTokensArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** List of queries */
export type QueryAssetArgs = {
  findBy: AssetFindByInputObject;
  siteFindBy?: InputMaybe<SiteFindByInputObject>;
};


/** List of queries */
export type QueryAssetCategoriesArgs = {
  filters?: InputMaybe<Array<AssetCategoryFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<AssetCategorySortInputObject>;
};


/** List of queries */
export type QueryAssetCategoryArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryAssetsArgs = {
  filters?: InputMaybe<Array<AssetFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<AssetSortInputObject>;
};


/** List of queries */
export type QueryAuthenticationSsoCheckArgs = {
  email: Scalars['String']['input'];
};


/** List of queries */
export type QueryBackgroundJobArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryBackgroundJobsArgs = {
  filters?: InputMaybe<Array<BackgroundJobFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<BackgroundJobScopeEnum>;
  sorts?: InputMaybe<BackgroundJobSortInputObject>;
};


/** List of queries */
export type QueryCompaniesArgs = {
  filters?: InputMaybe<Array<CompanyFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<CompanySortInputObject>;
};


/** List of queries */
export type QueryCompanyArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryCompanyDomainArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryCompanyDomainsArgs = {
  filters?: InputMaybe<Array<CompanyDomainFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<CompanyDomainSortInputObject>;
};


/** List of queries */
export type QueryCompanyStatisticsArgs = {
  id: Scalars['ID']['input'];
  period?: InputMaybe<TimePeriodEnum>;
};


/** List of queries */
export type QueryCounterArgs = {
  assetFindBy: AssetFindByInputObject;
  findBy: CounterFindByInputObject;
};


/** List of queries */
export type QueryCounterMeasureArgs = {
  assetId: Scalars['ID']['input'];
  counterId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryCounterMeasuresArgs = {
  assetId: Scalars['ID']['input'];
  counterId: Scalars['ID']['input'];
  filters?: InputMaybe<Array<CounterMeasureFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<CounterMeasureSortInputObject>;
};


/** List of queries */
export type QueryCounterMeasuresGraphDataArgs = {
  assetId: Scalars['ID']['input'];
  counterId: Scalars['ID']['input'];
  dateRange: DateRangeInputObject;
};


/** List of queries */
export type QueryCountersArgs = {
  assetId: Scalars['ID']['input'];
  filters?: InputMaybe<Array<CounterFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<CounterSortInputObject>;
};


/** List of queries */
export type QueryDataImportArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryDataImportsArgs = {
  filters?: InputMaybe<Array<DataImportFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<DataImportSortInputObject>;
};


/** List of queries */
export type QueryDepartmentArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryDepartmentsArgs = {
  filters?: InputMaybe<Array<DepartmentFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<DepartmentSortInputObject>;
};


/** List of queries */
export type QueryDocumentationArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryDocumentationCategoriesArgs = {
  filters?: InputMaybe<Array<DocumentationCategoryFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<DocumentationCategorySortInputObject>;
};


/** List of queries */
export type QueryDocumentationCategoryArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryDocumentationImportArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryDocumentationImportsArgs = {
  filters?: InputMaybe<Array<DocumentationImportFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<DocumentationImportSortInputObject>;
};


/** List of queries */
export type QueryDocumentationLinksArgs = {
  filters?: InputMaybe<Array<DocumentationLinkFilterInputObject>>;
  findBy: DocumentationLinkFindByInputObject;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<DocumentationLinkSortInputObject>;
};


/** List of queries */
export type QueryDocumentationVersionArgs = {
  documentationId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryDocumentationVersionViewsArgs = {
  filters?: InputMaybe<Array<DocumentationVersionViewFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<DocumentationVersionViewSortInputObject>;
};


/** List of queries */
export type QueryDocumentationVersionsArgs = {
  documentationId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<DocumentationVersionSortInputObject>;
};


/** List of queries */
export type QueryDocumentationsArgs = {
  filters?: InputMaybe<Array<DocumentationFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<DocumentationScopeInputObject>;
  sorts?: InputMaybe<DocumentationSortInputObject>;
};


/** List of queries */
export type QueryDocumentationsAnalyticsByCategoryArgs = {
  filters?: InputMaybe<Array<DocumentationFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  period: DateRangeInputObject;
  sorts?: InputMaybe<DocumentationAnalyticsByCategorySortInputObject>;
};


/** List of queries */
export type QueryDocumentationsAnalyticsByDocumentArgs = {
  filters?: InputMaybe<Array<DocumentationFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  period: DateRangeInputObject;
  sorts?: InputMaybe<DocumentationAnalyticsSortInputObject>;
};


/** List of queries */
export type QueryDocumentationsAnalyticsByLinkableArgs = {
  dimension: DocumentationAnalyticsLinkableDimensionEnum;
  filters?: InputMaybe<Array<DocumentationFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  period: DateRangeInputObject;
  sorts?: InputMaybe<DocumentationAnalyticsByLinkableSortInputObject>;
};


/** List of queries */
export type QueryDocumentationsAnalyticsByUserArgs = {
  filters?: InputMaybe<Array<DocumentationFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  period: DateRangeInputObject;
  sorts?: InputMaybe<DocumentationAnalyticsByUserSortInputObject>;
};


/** List of queries */
export type QueryDocumentationsAnalyticsTrendArgs = {
  filters?: InputMaybe<Array<DocumentationFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  period: DateRangeInputObject;
  periodGroupBy: PeriodGroupByEnum;
};


/** List of queries */
export type QueryFakeDnsRecordArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryFakeDnsRecordsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** List of queries */
export type QueryFeFilterPresetArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryFeFilterPresetsArgs = {
  filters?: InputMaybe<Array<FeFilterPresetFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<FeFilterPresetSortInputObject>;
};


/** List of queries */
export type QueryFormCategoriesArgs = {
  filters?: InputMaybe<Array<FormCategoryFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<FormCategorySortInputObject>;
};


/** List of queries */
export type QueryFormCategoryArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryFormChecklistTemplateArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryFormChecklistTemplatesArgs = {
  filters?: InputMaybe<Array<FormChecklistTemplateFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<FormChecklistTemplateSortInputObject>;
};


/** List of queries */
export type QueryFormTemplateArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryFormTemplateVersionArgs = {
  formTemplateId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryFormTemplateVersionsArgs = {
  filters?: InputMaybe<Array<FormTemplateVersionFilterInputObject>>;
  formTemplateId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<FormTemplateVersionSortInputObject>;
};


/** List of queries */
export type QueryFormTemplatesArgs = {
  filters?: InputMaybe<Array<FormTemplateFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  scopeName: FormTemplateScopeNameEnum;
  sorts?: InputMaybe<FormTemplateSortInputObject>;
};


/** List of queries */
export type QueryHistoriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  sorts?: InputMaybe<HistorySortInputObject>;
  sourceableId: Scalars['ID']['input'];
  sourceableType: HistorySourceableTypeEnum;
};


/** List of queries */
export type QueryHomePageArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryHomePagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** List of queries */
export type QueryIndustriesArgs = {
  filters?: InputMaybe<Array<IndustryFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<IndustrySortInputObject>;
};


/** List of queries */
export type QueryIndustryArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryInterventionArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryInterventionActionArgs = {
  id: Scalars['ID']['input'];
  interventionId: Scalars['ID']['input'];
};


/** List of queries */
export type QueryInterventionActionsArgs = {
  filters?: InputMaybe<Array<InterventionActionFilterInputObject>>;
  interventionId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<InterventionActionSortInputObject>;
};


/** List of queries */
export type QueryInterventionCategoriesArgs = {
  filters?: InputMaybe<Array<InterventionCategoryFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<InterventionCategorySortInputObject>;
};


/** List of queries */
export type QueryInterventionCategoryArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryInterventionsArgs = {
  filters?: InputMaybe<Array<InterventionFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  scopeName: InterventionScopeNameEnum;
  sorts?: InputMaybe<InterventionSortInputObject>;
};


/** List of queries */
export type QueryNomenclatureArgs = {
  id: Scalars['ID']['input'];
  mainAssetId: Scalars['ID']['input'];
};


/** List of queries */
export type QueryNomenclaturesArgs = {
  filters?: InputMaybe<Array<NomenclatureFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mainAssetId: Scalars['ID']['input'];
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<NomenclatureSortInputObject>;
};


/** List of queries */
export type QuerySectorArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


/** List of queries */
export type QuerySectorLocationCenterArgs = {
  filters?: InputMaybe<Array<LocationFilterInputObject>>;
  sectorFilters?: InputMaybe<Array<SectorFilterInputObject>>;
};


/** List of queries */
export type QuerySectorLocationsArgs = {
  filters?: InputMaybe<Array<LocationFilterInputObject>>;
  mapParams: LocationMapParamsInputObject;
  sectorFilters?: InputMaybe<Array<SectorFilterInputObject>>;
};


/** List of queries */
export type QuerySectorsArgs = {
  filters?: InputMaybe<Array<SectorFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<SectorSortInputObject>;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject>>;
};


/** List of queries */
export type QuerySectorsPerformanceMetricsByTaskDeadlinesMissedArgs = {
  ids: Array<Scalars['ID']['input']>;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject>>;
};


/** List of queries */
export type QuerySectorsPerformanceMetricsByTaskDeadlinesMissedByDateArgs = {
  ids: Array<Scalars['ID']['input']>;
  periodGroupBy: PeriodGroupByEnum;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject>>;
};


/** List of queries */
export type QuerySectorsPerformanceMetricsByTaskResultsArgs = {
  ids: Array<Scalars['ID']['input']>;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject>>;
};


/** List of queries */
export type QuerySectorsPerformanceMetricsByTaskResultsByDateArgs = {
  ids: Array<Scalars['ID']['input']>;
  periodGroupBy: PeriodGroupByEnum;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject>>;
};


/** List of queries */
export type QuerySessionsArgs = {
  currentFirst?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  scope: SessionScopeEnum;
  sorts?: InputMaybe<SessionSortInputObject>;
};


/** List of queries */
export type QuerySiteArgs = {
  findBy: SiteFindByInputObject;
};


/** List of queries */
export type QuerySiteAreaArgs = {
  findBy: SiteAreaFindByInputObject;
  siteFindBy?: InputMaybe<SiteFindByInputObject>;
};


/** List of queries */
export type QuerySiteAreasArgs = {
  filters?: InputMaybe<Array<SiteAreaFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<SiteAreaSortInputObject>;
};


/** List of queries */
export type QuerySiteLocationCenterArgs = {
  filters?: InputMaybe<Array<LocationFilterInputObject>>;
  siteFilters?: InputMaybe<Array<SiteFilterInputObject>>;
};


/** List of queries */
export type QuerySiteLocationsArgs = {
  filters?: InputMaybe<Array<LocationFilterInputObject>>;
  mapParams: LocationMapParamsInputObject;
  siteFilters?: InputMaybe<Array<SiteFilterInputObject>>;
};


/** List of queries */
export type QuerySitesArgs = {
  filters?: InputMaybe<Array<SiteFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<SiteSortInputObject>;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject>>;
};


/** List of queries */
export type QuerySitesPerformanceMetricsByTaskDeadlinesMissedArgs = {
  ids: Array<Scalars['ID']['input']>;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject>>;
};


/** List of queries */
export type QuerySitesPerformanceMetricsByTaskDeadlinesMissedByDateArgs = {
  ids: Array<Scalars['ID']['input']>;
  periodGroupBy: PeriodGroupByEnum;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject>>;
};


/** List of queries */
export type QuerySitesPerformanceMetricsByTaskResultsArgs = {
  ids: Array<Scalars['ID']['input']>;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject>>;
};


/** List of queries */
export type QuerySitesPerformanceMetricsByTaskResultsByDateArgs = {
  ids: Array<Scalars['ID']['input']>;
  periodGroupBy: PeriodGroupByEnum;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject>>;
};


/** List of queries */
export type QuerySsoIntegrationArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QuerySsoIntegrationPresetDefaultsArgs = {
  preset: SsoIntegrationProviderPresetEnum;
};


/** List of queries */
export type QuerySsoIntegrationsArgs = {
  filters?: InputMaybe<Array<SsoIntegrationFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<SsoIntegrationSortInputObject>;
};


/** List of queries */
export type QuerySystemAdminArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QuerySystemAdminsArgs = {
  filters?: InputMaybe<Array<SystemAdminFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<SystemAdminSortInputObject>;
};


/** List of queries */
export type QueryTagArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryTagsArgs = {
  filters?: InputMaybe<Array<TagFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<TagSortInputObject>;
};


/** List of queries */
export type QueryTaskArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryTaskAvailableForSchedulingKindsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** List of queries */
export type QueryTaskCompletionArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryTaskCompletionsArgs = {
  filters?: InputMaybe<Array<TaskCompletionFilterInputObject>>;
  groupKey: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<TaskCompletionSortInputObject>;
};


/** List of queries */
export type QueryTasksArgs = {
  filters?: InputMaybe<Array<TaskFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  scope: TaskScopeInputObject;
  sorts?: InputMaybe<TaskSortInputObject>;
};


/** List of queries */
export type QueryTasksMyTodoCompletableByDateDataArgs = {
  date: Scalars['ISO8601DateTime']['input'];
};


/** List of queries */
export type QueryTasksTimelineArgs = {
  queryData: TaskTimelineQueryDataInputObject;
  taskIds: Array<Scalars['ID']['input']>;
};


/** List of queries */
export type QueryTeamArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryTeamsArgs = {
  filters?: InputMaybe<Array<TeamFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<TeamSortInputObject>;
};


/** List of queries */
export type QueryTechnicalPauseArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryTechnicalPausesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<TechnicalPauseSortInputObject>;
};


/** List of queries */
export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryUsersArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  filters?: InputMaybe<Array<UserFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<UserScopeInputObject>;
  sorts?: InputMaybe<UserSortInputObject>;
};


/** List of queries */
export type QueryWidgetArgs = {
  homePageId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryWidgetTemplateArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryWidgetTemplatesArgs = {
  filters?: InputMaybe<Array<WidgetTemplateFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<WidgetTemplateSortInputObject>;
};


/** List of queries */
export type QueryWidgetsArgs = {
  homePageId: Scalars['ID']['input'];
};

/** Recurring rule entity */
export type RecurringRule = TimestampInterface & {
  __typename?: 'RecurringRule';
  /** Countdown type */
  countdownType: Maybe<RecurringRuleCountdownTypeEnum>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** End time */
  endTime: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Number of occurrences after which recurring rule will be stopped */
  endsAfterOccurrences: Maybe<Scalars['Int']['output']>;
  /** Days that should be moved to the nearest available day */
  excludedWdays: Maybe<Array<Scalars['Int']['output']>>;
  /** Recurring rule ID */
  id: Scalars['ID']['output'];
  /** Recurring rule schema */
  schema: RecurringRuleSchema;
  /** Start time */
  startTime: Scalars['ISO8601DateTime']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Available countdown types */
export enum RecurringRuleCountdownTypeEnum {
  Completion = 'COMPLETION',
  Deadline = 'DEADLINE'
}

/** Recurring rule attributes */
export type RecurringRuleInputObject = {
  /** Countdown type */
  countdownType: RecurringRuleCountdownTypeEnum;
  /** End time */
  endTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Number of occurrences after which recurring rule will be stopped */
  endsAfterOccurrences?: InputMaybe<Scalars['Int']['input']>;
  /** Days that should be moved to the nearest available day */
  excludedWdays: Array<Scalars['Int']['input']>;
  /** Schema attributes */
  schema: RecurringRuleSchemaInputObject;
  /** Start time */
  startTime: Scalars['ISO8601DateTime']['input'];
};

/** Available recurring rule types */
export enum RecurringRuleRuleTypeEnum {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

/** Recurring rule schema type */
export type RecurringRuleSchema = {
  __typename?: 'RecurringRuleSchema';
  /** Recurring rule schema metadata */
  metadata: Maybe<RecurringRuleSchemaMetadata>;
  /** Recurring schema rule */
  rrules: Array<RecurringRuleSchemaRule>;
};

/**
 * Recurring rule schema attributes
 * Examples:
 *
 *   - Daily:
 *     ```
 *     [
 *       {
 *         "ruleType": "DAILY",
 *         "interval": 1
 *       }
 *     ]
 *     ```
 *
 *   - Weekly on Sundays, Mondays, Wednesdays, and Fridays:
 *     ```
 *     [
 *       {
 *         "ruleType": "WEEKLY",
 *         "interval": 1,
 *         "validations": {
 *           "day": [0,1,3,5]
 *         }
 *       }
 *     ]
 *     ```
 *
 *   - Monthly on the 1st, 15th, and 31st days of the month:
 *     ```
 *     [
 *       {
 *         "ruleType": "MONTHLY",
 *         "interval": 1,
 *         "validations": {
 *           "dayOfMonth": [1,15,31]
 *         }
 *       }
 *     ]
 *     ```
 *
 *   - Monthly on the 1st Monday and on the last day of the month
 *     ```
 *     [
 *       {
 *         "ruleType": "MONTHLY",
 *         "interval": 1,
 *         "validations": {
 *           "dayOfWeek": {
 *             "1": [1]
 *           }
 *         }
 *       },
 *       {
 *         "ruleType": "MONTHLY",
 *         "interval": 1,
 *         "validations": {
 *           "dayOfMonth": [-1]
 *         }
 *       }
 *     ]
 *     ```
 *
 *   - Yearly:
 *     ```
 *     [
 *       {
 *         "ruleType": "YEARLY",
 *         "interval": 1
 *       }
 *     ]
 *     ```
 *
 *   - Every 2 years on the 1st and last days of the month in January, February, and December:
 *     ```
 *     [
 *       {
 *         "ruleType": "YEARLY",
 *         "interval": 2,
 *         "validations": {
 *           "dayOfMonth": [1,-1],
 *           "monthOfYear": [1,2,12]
 *         }
 *       }
 *     ]
 *     ```
 *   - Every 2 years on the 1st Monday and last Friday (1) and on the last day of the month (2) in January and February
 *     ```
 *     [
 *       {
 *         "ruleType": "YEARLY",
 *         "interval": 2,
 *         "validations": {
 *           "dayOfWeek": {
 *             "1": [1],
 *             "5": [-1]
 *           },
 *           "monthOfYear": [1,2]
 *         }
 *       },
 *       {
 *         "ruleType": "YEARLY",
 *         "interval": 2,
 *         "validations": {
 *           "dayOfMonth": [-1],
 *           "monthOfYear": [1,2]
 *         }
 *       }
 *     ]
 *     ```
 *
 */
export type RecurringRuleSchemaInputObject = {
  /** Metadata */
  metadata?: InputMaybe<RecurringRuleSchemaMetadataInputObject>;
  /** Recurring schema rule */
  rrules: Array<RecurringRuleSchemaRuleInputObject>;
};

/** Recurring rule schema metadata */
export type RecurringRuleSchemaMetadata = {
  __typename?: 'RecurringRuleSchemaMetadata';
  /** Recurring rule schema option */
  schemaOption: RecurringRuleSchemaOptionEnum;
};

/** Recurring rule schema metadata attributes */
export type RecurringRuleSchemaMetadataInputObject = {
  /** Schema option */
  schemaOption?: InputMaybe<RecurringRuleSchemaOptionEnum>;
};

/** Available recurring rule schema options */
export enum RecurringRuleSchemaOptionEnum {
  Each = 'EACH',
  OnThe = 'ON_THE'
}

/**
 * Recurring schema rule
 * Examples:
 *
 * - Daily:
 *   ```
 *   [
 *     {
 *       "ruleType": "DAILY",
 *       "interval": 1
 *     }
 *   ]
 *   ```
 *
 * - Weekly on Sundays, Mondays, Wednesdays, and Fridays:
 *   ```
 *   [
 *     {
 *       "ruleType": "WEEKLY",
 *       "interval": 1,
 *       "validations": {
 *         "day": [0,1,3,5]
 *       }
 *     }
 *   ]
 *   ```
 *
 * - Monthly on the 1st, 15th, and 31st days of the month:
 *   ```
 *   [
 *     {
 *       "ruleType": "MONTHLY",
 *       "interval": 1,
 *       "validations": {
 *         "dayOfMonth": [1,15,31]
 *       }
 *     }
 *   ]
 *   ```
 *
 * - Monthly on the 1st Monday and on the last day of the month
 *   ```
 *   [
 *     {
 *       "ruleType": "MONTHLY",
 *       "interval": 1,
 *       "validations": {
 *         "dayOfWeek": {
 *           "1": [1]
 *         }
 *       }
 *     },
 *     {
 *       "ruleType": "MONTHLY",
 *       "interval": 1,
 *       "validations": {
 *         "dayOfMonth": [-1]
 *       }
 *     }
 *   ]
 *   ```
 *
 * - Yearly:
 *   ```
 *   [
 *     {
 *       "ruleType": "YEARLY",
 *       "interval": 1
 *     }
 *   ]
 *   ```
 *
 * - Every 2 years on the 1st and last days of the month in January, February, and December:
 *   ```
 *   [
 *     {
 *       "ruleType": "YEARLY",
 *       "interval": 2,
 *       "validations": {
 *         "dayOfMonth": [1,-1],
 *         "monthOfYear": [1,2,12]
 *       }
 *     }
 *   ]
 *   ```
 * - Every 2 years on the 1st Monday and last Friday (1) and on the last day of the month (2) in January and February
 *   ```
 *   [
 *     {
 *       "ruleType": "YEARLY",
 *       "interval": 2,
 *       "validations": {
 *         "dayOfWeek": {
 *           "1": [1],
 *           "5": [-1]
 *         },
 *         "monthOfYear": [1,2]
 *       }
 *     },
 *     {
 *       "ruleType": "YEARLY",
 *       "interval": 2,
 *       "validations": {
 *         "dayOfMonth": [-1],
 *         "monthOfYear": [1,2]
 *       }
 *     }
 *   ]
 *   ```
 *
 */
export type RecurringRuleSchemaRule = {
  __typename?: 'RecurringRuleSchemaRule';
  /** Interval */
  interval: Scalars['Int']['output'];
  /** Rule type */
  ruleType: RecurringRuleRuleTypeEnum;
  /** Recurring schema rule validations */
  validations: Maybe<RecurringRuleValidations>;
};

/** Recurring rule schema rule attributes */
export type RecurringRuleSchemaRuleInputObject = {
  /** Interval */
  interval: Scalars['Int']['input'];
  /** Rule type */
  ruleType: RecurringRuleRuleTypeEnum;
  /** Validations attributes */
  validations?: InputMaybe<RecurringRuleValidationsInputObject>;
};

/** Recurring schema rule validations */
export type RecurringRuleValidations = {
  __typename?: 'RecurringRuleValidations';
  /** Day (1..31) */
  day: Maybe<Array<Scalars['Int']['output']>>;
  /** Days of month (-1, 1..31) where -1 is the last day of the month, 1 is the first day of the month, etc. */
  dayOfMonth: Maybe<Array<Scalars['Int']['output']>>;
  /**
   * Days of week.
   * Example: `{"1": [-1,1,3,5]}` where key `1` is the day of the week (Monday) and value `[-1,1,3,5]` are the number of the day in the month (last, 1st, 3rd, 5th)
   *
   */
  dayOfWeek: Maybe<Scalars['JSON']['output']>;
  /** Month of year (1..12) */
  monthOfYear: Maybe<Array<Scalars['Int']['output']>>;
};

/** Recurring rule validations */
export type RecurringRuleValidationsInputObject = {
  /** Day (1..31) */
  day?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Day of month (-1, 1..31) where -1 is the last day of the month, 1 is the first day of the month, etc. */
  dayOfMonth?: InputMaybe<Array<Scalars['Int']['input']>>;
  /**
   * Days of week.
   * Example: `{"1": [-1,1,3,5]}` where key `1` is the day of the week (Monday) and value `[-1,1,3,5]` are the number of the day in the month (last, 1st, 3rd, 5th)
   *
   */
  dayOfWeek?: InputMaybe<Scalars['JSON']['input']>;
  /** Month of year (1..12) */
  monthOfYear?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Response message */
export type ResponseMessage = {
  __typename?: 'ResponseMessage';
  /** Message */
  message: Scalars['String']['output'];
};

/** Sector entity */
export type Sector = TimestampInterface & {
  __typename?: 'Sector';
  canDestroy: AuthorizationResult;
  /** Code */
  code: Maybe<Scalars['String']['output']>;
  /** Color */
  color: Maybe<ColorEnum>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Sector ID */
  id: Scalars['ID']['output'];
  /** Location boundary */
  locationBoundary: Maybe<Location>;
  /** Name */
  name: Maybe<Scalars['String']['output']>;
  /** Indicates if sector is read only (default system sector) */
  readOnly: Scalars['Boolean']['output'];
  /** Sites collection */
  sites: SiteCollection;
  /** Sites count */
  sitesCount: Scalars['Int']['output'];
  /** [Performance metrics] Success percentage (deadlines missed) according to the task filters */
  successPercentageByTaskDeadlinesMissed: Maybe<Scalars['Float']['output']>;
  /** [Performance metrics] Success percentage according to the task filters */
  successPercentageByTaskResults: Maybe<Scalars['Float']['output']>;
  /** [Performance metrics] Total anomalies (deadlines missed) according to the task filters */
  totalAnomaliesByTaskDeadlinesMissed: Maybe<Scalars['Int']['output']>;
  /** [Performance metrics] Total anomalies (warning and failure completions) according to the task filters */
  totalAnomaliesByTaskResults: Maybe<Scalars['Int']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Responsible User entity
   * NOTE: if you only need an Object ID, please use the userId field to reduce the load on the database.
   */
  user: Maybe<User>;
  /** Responsible User ID */
  userId: Maybe<Scalars['ID']['output']>;
  /** Users count (memberships + full admins) */
  usersCount: Scalars['Int']['output'];
};


/** Sector entity */
export type SectorSitesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** SectorCollection type */
export type SectorCollection = {
  __typename?: 'SectorCollection';
  /** A collection of paginated SectorCollection */
  collection: Array<Sector>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type SectorCreateInput = {
  /** Create attributes */
  attributes: SectorCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Sector attributes */
export type SectorCreateInputObject = {
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Color */
  color: ColorEnum;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Location boundary */
  locationBoundary?: InputMaybe<LocationCuInputObject>;
  /** Name */
  name: Scalars['String']['input'];
  /** Sites linking attributes array */
  sites?: InputMaybe<Array<LinkingInputObject>>;
  /** Responsible User ID */
  userId?: InputMaybe<Scalars['ID']['input']>;
  /** Users linking attributes array (not full admins) */
  userMemberships?: InputMaybe<Array<LinkingInputObject>>;
};

/** Description from base input object. Please set your description for child object. */
export type SectorDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Sector ID */
  id: Scalars['ID']['input'];
};

/** Sector filters */
export type SectorFilterInputObject = {
  /** Sector code */
  code?: InputMaybe<FilterInputObject>;
  /**
   * Documentation ID
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationsId?: InputMaybe<FilterIdInputObject>;
  /** Sector ID */
  id?: InputMaybe<FilterIdInputObject>;
  /** Sector name */
  name?: InputMaybe<FilterInputObject>;
  /** Sites ID */
  sitesId?: InputMaybe<FilterIdInputObject>;
};

/** Sector performance metric by task deadlines missed entity */
export type SectorPerformanceMetricByTaskDeadlinesMissed = {
  __typename?: 'SectorPerformanceMetricByTaskDeadlinesMissed';
  /** Sector ID */
  id: Scalars['ID']['output'];
  /** [Performance metrics] Success percentage (deadlines missed) according to the task filters */
  successPercentageByTaskDeadlinesMissed: Maybe<Scalars['Float']['output']>;
  /** [Performance metrics] Total anomalies (deadlines missed) according to the task filters */
  totalAnomaliesByTaskDeadlinesMissed: Maybe<Scalars['Int']['output']>;
};

/** Sector performance metric by task deadlines missed by date entity */
export type SectorPerformanceMetricByTaskDeadlinesMissedByDate = {
  __typename?: 'SectorPerformanceMetricByTaskDeadlinesMissedByDate';
  /** Sector ID */
  id: Scalars['ID']['output'];
  /** Period */
  period: Scalars['ISO8601Date']['output'];
  /** [Performance metrics] Total anomalies (deadlines missed) according to the task filters */
  totalAnomaliesByTaskDeadlinesMissed: Scalars['Int']['output'];
};

/** Sector performance metric by task results entity */
export type SectorPerformanceMetricByTaskResults = {
  __typename?: 'SectorPerformanceMetricByTaskResults';
  /** Sector ID */
  id: Scalars['ID']['output'];
  /** [Performance metrics] Success percentage according to the task filters */
  successPercentageByTaskResults: Maybe<Scalars['Float']['output']>;
  /** [Performance metrics] Total anomalies (warning and failure completions) according to the task filters */
  totalAnomaliesByTaskResults: Maybe<Scalars['Int']['output']>;
};

/** Sector performance metric by task results by date entity */
export type SectorPerformanceMetricByTaskResultsByDate = {
  __typename?: 'SectorPerformanceMetricByTaskResultsByDate';
  /** Sector ID */
  id: Scalars['ID']['output'];
  /** Period */
  period: Scalars['ISO8601Date']['output'];
  /** [Performance metrics] Total anomalies (warning and failure completions) according to the task filters */
  totalAnomaliesByTaskResults: Scalars['Int']['output'];
};

/** Sector sorts */
export type SectorSortInputObject = {
  /** Code */
  code?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Sites count */
  sitesCount?: InputMaybe<SortDirectionEnum>;
  /** [Performance metrics] Success percentage (deadlines missed) according to the task filters */
  successPercentageByTaskDeadlinesMissed?: InputMaybe<SortDirectionEnum>;
  /** [Performance metrics] Success percentage according to the task filters */
  successPercentageByTaskResults?: InputMaybe<SortDirectionEnum>;
  /** [Performance metrics] Total anomalies (deadlines missed) according to the task filters */
  totalAnomaliesByTaskDeadlinesMissed?: InputMaybe<SortDirectionEnum>;
  /** [Performance metrics] Total anomalies (warning and failure completions) according to the task filters */
  totalAnomaliesByTaskResults?: InputMaybe<SortDirectionEnum>;
  /** Users count (memberships + full admins) */
  usersCount?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type SectorUpdateInput = {
  /** Update attributes */
  attributes: SectorUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Sector ID */
  id: Scalars['ID']['input'];
};

/** Sector attributes */
export type SectorUpdateInputObject = {
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Color */
  color?: InputMaybe<ColorEnum>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Location boundary */
  locationBoundary?: InputMaybe<LocationCuInputObject>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Sites linking attributes array */
  sites?: InputMaybe<Array<LinkingInputObject>>;
  /** Responsible User ID */
  userId?: InputMaybe<Scalars['ID']['input']>;
  /** Users linking attributes array (not full admins) */
  userMemberships?: InputMaybe<Array<LinkingInputObject>>;
};

/** Session */
export type Session = {
  __typename?: 'Session';
  /** Minimum session age in hours required for sensitive operations */
  ageMinimumHours: Scalars['Int']['output'];
  /** Browser name */
  browserName: Scalars['String']['output'];
  /** Browser version */
  browserVersion: Scalars['String']['output'];
  /** City from IP geolocation */
  city: Scalars['String']['output'];
  /** Country from IP geolocation */
  country: Scalars['String']['output'];
  /** ISO 3166-1 alpha-2 country code */
  countryCode: Maybe<Scalars['String']['output']>;
  /** Creation time */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Combined device info (e.g., "Desktop, Chrome 120.0") */
  device: Scalars['String']['output'];
  /** Device type (Desktop, Smartphone, Tablet, etc.) */
  deviceType: Scalars['String']['output'];
  /** Expiration time */
  expiresAt: Scalars['ISO8601DateTime']['output'];
  /** Session ID */
  id: Scalars['ID']['output'];
  /** IP address */
  ip: Maybe<Scalars['String']['output']>;
  /** Last activity time */
  lastActivityAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Combined location info (e.g., "Kyiv, Kyiv Oblast, Ukraine") */
  location: Scalars['String']['output'];
  /** Operating system name */
  osName: Scalars['String']['output'];
  /** Region/state from IP geolocation */
  region: Scalars['String']['output'];
  /** Whether this session belongs to the current device */
  thisDevice: Scalars['Boolean']['output'];
  /** Whether session is too young for sensitive operations */
  tooYoung: Scalars['Boolean']['output'];
  /** Indicates if session is pending two-factor authentication verification */
  twoFactorPending: Scalars['Boolean']['output'];
  /** Indicates if two-factor authentication has been verified for this session */
  twoFactorVerified: Scalars['Boolean']['output'];
  /** User agent */
  userAgent: Maybe<Scalars['String']['output']>;
};

/** SessionCollection type */
export type SessionCollection = {
  __typename?: 'SessionCollection';
  /** A collection of paginated SessionCollection */
  collection: Array<Session>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Available session scopes */
export enum SessionScopeEnum {
  /** Active sessions (not expired) */
  Active = 'ACTIVE',
  /** Ended sessions (expired) */
  Ended = 'ENDED'
}

/** Session sorts */
export type SessionSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Expires at */
  expiresAt?: InputMaybe<SortDirectionEnum>;
  /** Last activity at */
  lastActivityAt?: InputMaybe<SortDirectionEnum>;
};

/** Site entity */
export type Site = TimestampInterface & {
  __typename?: 'Site';
  /** Site cellphone */
  cellphone: Maybe<Scalars['String']['output']>;
  /** Code */
  code: Scalars['String']['output'];
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Site contact email */
  email: Scalars['String']['output'];
  /** Site ID */
  id: Scalars['ID']['output'];
  /** Site location photo */
  locationPhotoAttached: Maybe<Attachment>;
  /** Location point */
  locationPoint: Maybe<Location>;
  /** Name */
  name: Scalars['String']['output'];
  /** Site contact phone number */
  phoneNumber: Maybe<Scalars['String']['output']>;
  /**
   * Sector
   * NOTE: if you only need an Object ID, please use the sectorId field to reduce the load on the database.
   */
  sector: Maybe<Sector>;
  /** Sector ID */
  sectorId: Maybe<Scalars['ID']['output']>;
  /** Number of Site Areas */
  siteAreasCount: Scalars['Int']['output'];
  /** Site Code of Conduct sections */
  siteConductCodeSections: Array<SiteConductCodeSection>;
  /** [Performance metrics] Success percentage (deadlines missed) according to the task filters */
  successPercentageByTaskDeadlinesMissed: Maybe<Scalars['Float']['output']>;
  /** [Performance metrics] Success percentage according to the task filters */
  successPercentageByTaskResults: Maybe<Scalars['Float']['output']>;
  /** [Performance metrics] Total anomalies (deadlines missed) according to the task filters */
  totalAnomaliesByTaskDeadlinesMissed: Maybe<Scalars['Int']['output']>;
  /** [Performance metrics] Total anomalies (warning and failure completions) according to the task filters */
  totalAnomaliesByTaskResults: Maybe<Scalars['Int']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Responsible user
   * NOTE: if you only need an Object ID, please use the userId field to reduce the load on the database.
   */
  user: Maybe<User>;
  /** Responsible user ID */
  userId: Maybe<Scalars['ID']['output']>;
  /** Number of Users (memberships + full admins) */
  usersCount: Scalars['Int']['output'];
};

/** Site Area entity */
export type SiteArea = TimestampInterface & {
  __typename?: 'SiteArea';
  /** Site Area address */
  address: Maybe<Scalars['String']['output']>;
  canDestroy: AuthorizationResult;
  /** Code */
  code: Scalars['String']['output'];
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Full code (As on the QR code) */
  fullCode: Scalars['String']['output'];
  /** Site Area ID */
  id: Scalars['ID']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Indicates if site area location has poor wifi or does not have wifi */
  poorWifi: Scalars['Boolean']['output'];
  /**
   * Site entity
   * NOTE: if you only need an Object ID, please use the siteId field to reduce the load on the database.
   */
  site: Maybe<Site>;
  /** Site ID */
  siteId: Maybe<Scalars['ID']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Description from base input object. Please set your description for child object. */
export type SiteAreaBulkDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Outcome of a Site Area bulk destroy */
export type SiteAreaBulkDestroyResult = {
  __typename?: 'SiteAreaBulkDestroyResult';
  /** Site Areas that were not deleted; read each one's canDestroy for the reason */
  blocked: Array<SiteArea>;
  /** Number of records actually deleted */
  destroyedCount: Scalars['Int']['output'];
};

/** Description from base input object. Please set your description for child object. */
export type SiteAreaBulkQrCodeCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Create params */
  params: QrCodesCreateInputObject;
};

/** SiteAreaCollection type */
export type SiteAreaCollection = {
  __typename?: 'SiteAreaCollection';
  /** A collection of paginated SiteAreaCollection */
  collection: Array<SiteArea>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Site area attributes */
export type SiteAreaCreateInputObject = {
  /** Address */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Documentation links
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationLinks?: InputMaybe<Array<DocumentationLinkInputObject>>;
  /** Name */
  name: Scalars['String']['input'];
  /** Indicates if site area location has poor wifi or does not have wifi */
  poorWifi?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Site Area filters */
export type SiteAreaFilterInputObject = {
  /** Site Area code */
  code?: InputMaybe<FilterInputObject>;
  /**
   * Documentation ID
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationsId?: InputMaybe<FilterIdInputObject>;
  /** Site Area ID */
  id?: InputMaybe<FilterIdInputObject>;
  /** Site Area name */
  name?: InputMaybe<FilterInputObject>;
  /** Sector ID */
  sectorId?: InputMaybe<FilterIdInputObject>;
  /** Sector name */
  sectorName?: InputMaybe<FilterInputObject>;
  /** Site code */
  siteCode?: InputMaybe<FilterInputObject>;
  /** Site ID */
  siteId?: InputMaybe<FilterIdInputObject>;
  /** Site name */
  siteName?: InputMaybe<FilterInputObject>;
};

/** Site area attributes */
export type SiteAreaFindByInputObject = {
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** ID */
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Site Area sorts */
export type SiteAreaSortInputObject = {
  /** Code */
  code?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Sector name */
  sectorName?: InputMaybe<SortDirectionEnum>;
  /** Site code */
  siteCode?: InputMaybe<SortDirectionEnum>;
  /** Site name */
  siteName?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type SiteAreaUpdateInput = {
  /** Update attributes */
  attributes: SiteAreaUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Site Area ID */
  id: Scalars['ID']['input'];
};

/** Site area attributes */
export type SiteAreaUpdateInputObject = {
  /** Address */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Documentation links
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationLinks?: InputMaybe<Array<DocumentationLinkInputObject>>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if site area location has poor wifi or does not have wifi */
  poorWifi?: InputMaybe<Scalars['Boolean']['input']>;
};

/** SiteCollection type */
export type SiteCollection = {
  __typename?: 'SiteCollection';
  /** A collection of paginated SiteCollection */
  collection: Array<Site>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Site Code of Conduct section entity */
export type SiteConductCodeSection = TimestampInterface & {
  __typename?: 'SiteConductCodeSection';
  /** Body text */
  body: Scalars['String']['output'];
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Site Code of Conduct section ID */
  id: Scalars['ID']['output'];
  /** Position */
  position: Scalars['Int']['output'];
  /** Title */
  title: Scalars['String']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Site conduct code section attributes */
export type SiteConductCodeSectionCreateInputObject = {
  /** Body */
  body: Scalars['String']['input'];
  /** Position */
  position: Scalars['Int']['input'];
  /** Title */
  title: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type SiteCreateInput = {
  /** Create attributes */
  attributes: SiteCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Site attributes */
export type SiteCreateInputObject = {
  /** Create Site Areas attributes array */
  areas?: InputMaybe<Array<SiteAreaCreateInputObject>>;
  /** Site cellphone */
  cellphone?: InputMaybe<Scalars['String']['input']>;
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Create Conduct Code sections attributes array */
  conductCodeSections?: InputMaybe<Array<SiteConductCodeSectionCreateInputObject>>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Site contact email */
  email: Scalars['String']['input'];
  /** Location photo */
  locationPhotoAttached?: InputMaybe<AttachmentCuInputObject>;
  /** Location point */
  locationPoint: LocationCuInputObject;
  /** Name */
  name: Scalars['String']['input'];
  /** Site contact phone number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Sector ID */
  sectorId?: InputMaybe<Scalars['ID']['input']>;
  /** Responsible user ID */
  userId: Scalars['ID']['input'];
  /** User memberships attributes array (not full admins) */
  userMemberships?: InputMaybe<Array<LinkingInputObject>>;
};

/** Description from base input object. Please set your description for child object. */
export type SiteDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Site ID */
  id: Scalars['ID']['input'];
};

/** Site filters */
export type SiteFilterInputObject = {
  /** Site area code */
  areasCode?: InputMaybe<FilterInputObject>;
  /** Site area name */
  areasName?: InputMaybe<FilterInputObject>;
  /** Site code */
  code?: InputMaybe<FilterInputObject>;
  /**
   * Documentation ID
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationsId?: InputMaybe<FilterIdInputObject>;
  /** Site ID */
  id?: InputMaybe<FilterIdInputObject>;
  /** Site name */
  name?: InputMaybe<FilterInputObject>;
  /** Sector ID */
  sectorId?: InputMaybe<FilterInputObject>;
  /** Sector name */
  sectorName?: InputMaybe<FilterInputObject>;
  /** Responsible user full name */
  userFullName?: InputMaybe<FilterInputObject>;
};

/** Site attributes */
export type SiteFindByInputObject = {
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** ID */
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Site performance metric by task deadlines missed entity */
export type SitePerformanceMetricByTaskDeadlinesMissed = {
  __typename?: 'SitePerformanceMetricByTaskDeadlinesMissed';
  /** Site ID */
  id: Scalars['ID']['output'];
  /** [Performance metrics] Success percentage (deadlines missed) according to the task filters */
  successPercentageByTaskDeadlinesMissed: Maybe<Scalars['Float']['output']>;
  /** [Performance metrics] Total anomalies (deadlines missed) according to the task filters */
  totalAnomaliesByTaskDeadlinesMissed: Maybe<Scalars['Int']['output']>;
};

/** Sector performance metric by task deadlines missed by date entity */
export type SitePerformanceMetricByTaskDeadlinesMissedByDate = {
  __typename?: 'SitePerformanceMetricByTaskDeadlinesMissedByDate';
  /** Sector ID */
  id: Scalars['ID']['output'];
  /** Period */
  period: Scalars['ISO8601Date']['output'];
  /** [Performance metrics] Total anomalies (deadlines missed) according to the task filters */
  totalAnomaliesByTaskDeadlinesMissed: Scalars['Int']['output'];
};

/** Site performance metric by task results entity */
export type SitePerformanceMetricByTaskResults = {
  __typename?: 'SitePerformanceMetricByTaskResults';
  /** Site ID */
  id: Scalars['ID']['output'];
  /** [Performance metrics] Success percentage according to the task filters */
  successPercentageByTaskResults: Maybe<Scalars['Float']['output']>;
  /** [Performance metrics] Total anomalies (warning and failure completions) according to the task filters */
  totalAnomaliesByTaskResults: Maybe<Scalars['Int']['output']>;
};

/** Site performance metric by task results by date entity */
export type SitePerformanceMetricByTaskResultsByDate = {
  __typename?: 'SitePerformanceMetricByTaskResultsByDate';
  /** Site ID */
  id: Scalars['ID']['output'];
  /** Period */
  period: Scalars['ISO8601Date']['output'];
  /** [Performance metrics] Total anomalies (warning and failure completions) according to the task filters */
  totalAnomaliesByTaskResults: Scalars['Int']['output'];
};

/** Site sorts */
export type SiteSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Sector name */
  sectorName?: InputMaybe<SortDirectionEnum>;
  /** Number of site areas */
  siteAreasCount?: InputMaybe<SortDirectionEnum>;
  /** [Performance metrics] Success percentage (deadlines missed) according to the task filters */
  successPercentageByTaskDeadlinesMissed?: InputMaybe<SortDirectionEnum>;
  /** [Performance metrics] Success percentage according to the task filters */
  successPercentageByTaskResults?: InputMaybe<SortDirectionEnum>;
  /** [Performance metrics] Total anomalies (deadlines missed) according to the task filters */
  totalAnomaliesByTaskDeadlinesMissed?: InputMaybe<SortDirectionEnum>;
  /** [Performance metrics] Total anomalies (warning and failure completions) according to the task filters */
  totalAnomaliesByTaskResults?: InputMaybe<SortDirectionEnum>;
  /** Number of users (memberships + full admins) */
  usersCount?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type SiteUpdateInput = {
  /** Update attributes */
  attributes: SiteUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Site ID */
  id: Scalars['ID']['input'];
};

/** Site attributes */
export type SiteUpdateInputObject = {
  /** Create Site Areas attributes array */
  areas?: InputMaybe<Array<SiteAreaCreateInputObject>>;
  /** Site cellphone */
  cellphone?: InputMaybe<Scalars['String']['input']>;
  /** Create Conduct Code sections attributes array */
  conductCodeSections?: InputMaybe<Array<SiteConductCodeSectionCreateInputObject>>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Site contact email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Location photo */
  locationPhotoAttached?: InputMaybe<AttachmentCuInputObject>;
  /** Location point */
  locationPoint?: InputMaybe<LocationCuInputObject>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Site contact phone number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Sector ID */
  sectorId?: InputMaybe<Scalars['ID']['input']>;
  /** Responsible user ID */
  userId?: InputMaybe<Scalars['ID']['input']>;
  /** User memberships attributes array (not full admins) */
  userMemberships?: InputMaybe<Array<LinkingInputObject>>;
};

/** Sort directions */
export enum SortDirectionEnum {
  /** Ascending */
  Asc = 'asc',
  /** Descending */
  Desc = 'desc'
}

/** SSO availability check result */
export type SsoCheck = {
  __typename?: 'SsoCheck';
  /** Indicates if password login is allowed (always true) */
  passwordAllowed: Scalars['Boolean']['output'];
  /** Indicates if SSO is available for this email domain */
  ssoEnabled: Scalars['Boolean']['output'];
  /** List of available SSO integrations for this domain */
  ssoIntegrations: Array<SsoIntegrationPreview>;
};

/** Generated SSO code */
export type SsoGeneratedCode = {
  __typename?: 'SsoGeneratedCode';
  /** Assertion Consumer Service URL */
  acsUrl: Scalars['String']['output'];
  /** Unique code for the SSO integration */
  code: Scalars['String']['output'];
  /** Service Provider entity ID */
  entityId: Scalars['String']['output'];
  /** Service Provider metadata URL */
  metadataUrl: Scalars['String']['output'];
};

/** SSO integration entity */
export type SsoIntegration = TimestampInterface & {
  __typename?: 'SsoIntegration';
  /** Whether IdP-initiated SSO login is allowed */
  allowIdpInitiated: Scalars['Boolean']['output'];
  /** Attribute mapping configuration */
  attributeMapping: Maybe<Scalars['JSON']['output']>;
  /** Unique code for the SSO integration */
  code: Scalars['String']['output'];
  /** Associated company domains */
  companyDomains: Array<CompanyDomain>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Display status (computed based on status and domain verification) */
  displayStatus: SsoIntegrationDisplayStatusEnum;
  /** SSO integration icon */
  icon: Maybe<Attachment>;
  /** SSO integration ID */
  id: Scalars['ID']['output'];
  /** IdP metadata XML */
  idpMetadata: Maybe<Scalars['String']['output']>;
  /** Indicates if Just-In-Time provisioning is enabled */
  jitProvisioningEnabled: Scalars['Boolean']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Indicates if the SSO integration is pinned */
  pinned: Scalars['Boolean']['output'];
  /** Provider preset */
  providerPreset: SsoIntegrationProviderPresetEnum;
  /** Provider type */
  providerType: SsoIntegrationProviderTypeEnum;
  /** Status (admin-controlled) */
  status: SsoIntegrationStatusEnum;
  /** Sync user attributes from IdP on each login */
  syncUserAttributes: Scalars['Boolean']['output'];
  /** Time tolerance for SAML assertions in seconds */
  timeToleranceSeconds: Maybe<Scalars['Int']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Warning key for configuration issues */
  warningKey: Maybe<SsoIntegrationWarningKeyEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type SsoIntegrationActivateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** SSO integration ID */
  id: Scalars['ID']['input'];
};

/** SsoIntegrationCollection type */
export type SsoIntegrationCollection = {
  __typename?: 'SsoIntegrationCollection';
  /** A collection of paginated SsoIntegrationCollection */
  collection: Array<SsoIntegration>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type SsoIntegrationCreateInput = {
  /** Create attributes */
  attributes: SsoIntegrationCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** SSO integration attributes */
export type SsoIntegrationCreateInputObject = {
  /** Allow Identity Provider initiated SSO login */
  allowIdpInitiated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Attribute mapping configuration */
  attributeMapping: Scalars['JSON']['input'];
  /** Unique code for the SSO integration. Becomes a URL path segment, so letters, digits, hyphens and underscores only. Generated when omitted. */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Company domain IDs to associate */
  companyDomainIds: Array<LinkingInputObject>;
  /** SSO integration icon */
  iconAttached?: InputMaybe<AttachmentCuInputObject>;
  /** IdP metadata (raw XML or base64-encoded XML) */
  idpMetadata: Scalars['String']['input'];
  /** Indicates if Just-In-Time provisioning is enabled */
  jitProvisioningEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if the SSO integration is pinned */
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  /** Provider preset */
  providerPreset: SsoIntegrationProviderPresetEnum;
  /** Provider type */
  providerType: SsoIntegrationProviderTypeEnum;
  /** Sync user attributes from IdP on each login */
  syncUserAttributes?: InputMaybe<Scalars['Boolean']['input']>;
  /** Time tolerance for SAML assertions in seconds */
  timeToleranceSeconds?: InputMaybe<Scalars['Int']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type SsoIntegrationDeactivateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** SSO integration ID */
  id: Scalars['ID']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type SsoIntegrationDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** SSO integration ID */
  id: Scalars['ID']['input'];
};

/** Available SSO integration display statuses */
export enum SsoIntegrationDisplayStatusEnum {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED',
  Misconfigured = 'MISCONFIGURED'
}

/** SSO integration filters */
export type SsoIntegrationFilterInputObject = {
  /** Company domain ID */
  companyDomainsId?: InputMaybe<FilterIdInputObject>;
  /** SSO integration name */
  name?: InputMaybe<FilterInputObject>;
  /** Provider type */
  providerType?: InputMaybe<FilterInputObject>;
};

/** SSO integration preview for login page */
export type SsoIntegrationPreview = {
  __typename?: 'SsoIntegrationPreview';
  /** SSO integration code for constructing init URL */
  code: Scalars['String']['output'];
  /** Custom icon (for custom preset) */
  icon: Maybe<Attachment>;
  /** Display name */
  name: Scalars['String']['output'];
  /** Provider preset (for displaying provider icon) */
  providerPreset: SsoIntegrationProviderPresetEnum;
};

/** Available SSO provider presets */
export enum SsoIntegrationProviderPresetEnum {
  Auth0 = 'AUTH0',
  Custom = 'CUSTOM',
  Google = 'GOOGLE',
  Microsoft = 'MICROSOFT',
  Okta = 'OKTA',
  Onelogin = 'ONELOGIN'
}

/** Available SSO provider types */
export enum SsoIntegrationProviderTypeEnum {
  Saml = 'SAML'
}

/** SSO integration sorts */
export type SsoIntegrationSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Updated at */
  updatedAt?: InputMaybe<SortDirectionEnum>;
};

/** Available SSO integration statuses */
export enum SsoIntegrationStatusEnum {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED'
}

/** Description from base input object. Please set your description for child object. */
export type SsoIntegrationUpdateInput = {
  /** Update attributes */
  attributes: SsoIntegrationUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** SSO integration ID */
  id: Scalars['ID']['input'];
};

/** SSO integration attributes */
export type SsoIntegrationUpdateInputObject = {
  /** Allow Identity Provider initiated SSO login */
  allowIdpInitiated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Attribute mapping configuration */
  attributeMapping?: InputMaybe<Scalars['JSON']['input']>;
  /** Company domain IDs to associate */
  companyDomainIds?: InputMaybe<Array<LinkingInputObject>>;
  /** SSO integration icon */
  iconAttached?: InputMaybe<AttachmentCuInputObject>;
  /** IdP metadata (raw XML or base64-encoded XML) */
  idpMetadata?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if Just-In-Time provisioning is enabled */
  jitProvisioningEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if the SSO integration is pinned */
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sync user attributes from IdP on each login */
  syncUserAttributes?: InputMaybe<Scalars['Boolean']['input']>;
  /** Time tolerance for SAML assertions in seconds */
  timeToleranceSeconds?: InputMaybe<Scalars['Int']['input']>;
};

/** SSO integration warning keys */
export enum SsoIntegrationWarningKeyEnum {
  NoVerifiedDomains = 'NO_VERIFIED_DOMAINS',
  SomeDomainsNotVerified = 'SOME_DOMAINS_NOT_VERIFIED'
}

/** SSO attribute mapping field */
export type SsoMappingField = {
  __typename?: 'SsoMappingField';
  /** Help text explaining the field purpose and constraints */
  description: Maybe<Scalars['String']['output']>;
  /** Field key */
  key: Scalars['String']['output'];
  /** Field label */
  label: Scalars['String']['output'];
  /** Indicates if the field is required */
  required: Scalars['Boolean']['output'];
  /** Display order index for the field */
  sortIndex: Scalars['Int']['output'];
};

/** List of subscriptions */
export type Subscription = {
  __typename?: 'Subscription';
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiBudgetStatus: AiBudgetStatus;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiCompanyIndexingCoverageChanged: AiIndexingCoverage;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiConversationStream: AiConversationStreamEvent;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiDocumentationFieldsGenerated: AiFieldsGeneration;
  /**
   *
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT, AI_ASSISTANCE.
   */
  aiDocumentationVersionFieldsGenerated: AiFieldsGeneration;
  /** Streams the document-indexing coverage of the company identified by companyId as it changes — the counterpart of aiCompanyIndexingCoverageChanged (which streams the requesting company's own) for a specified company. Same frames and rollup. Restricted to system administrators. */
  aiIndexingCoverageChanged: AiIndexingCoverage;
  /** Streams progress and status frames for background jobs. Pass rootId to follow a single tree, or omit it to receive every one of your jobs on one stream. Each frame carries the changed node (status, counters, estimatedFinishAt); the client holds the tree(s) and applies the node delta by id. Scoped to the requesting owner. */
  backgroundJobProgress: BackgroundJobProgressEvent;
};


/** List of subscriptions */
export type SubscriptionAiConversationStreamArgs = {
  conversationId: Scalars['ID']['input'];
};


/** List of subscriptions */
export type SubscriptionAiDocumentationFieldsGeneratedArgs = {
  generationId: Scalars['ID']['input'];
};


/** List of subscriptions */
export type SubscriptionAiDocumentationVersionFieldsGeneratedArgs = {
  generationId: Scalars['ID']['input'];
};


/** List of subscriptions */
export type SubscriptionAiIndexingCoverageChangedArgs = {
  companyId: Scalars['ID']['input'];
};


/** List of subscriptions */
export type SubscriptionBackgroundJobProgressArgs = {
  rootId?: InputMaybe<Scalars['ID']['input']>;
};

/** SystemAdmin entity */
export type SystemAdmin = TimestampInterface & TwoFactorAuthenticatableInterface & UserInterface & {
  __typename?: 'SystemAdmin';
  /** Avatar */
  avatarAttached: Maybe<Attachment>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Deactivation time */
  deactivatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Time until debug mode is active */
  debugModeUntil: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Email */
  email: Maybe<Scalars['String']['output']>;
  /** First name */
  firstName: Scalars['String']['output'];
  /** Indicates if user has a password set */
  hasPassword: Scalars['Boolean']['output'];
  /** SystemAdmin ID */
  id: Scalars['ID']['output'];
  /** Job title */
  jobTitle: Maybe<Scalars['String']['output']>;
  /** Preferred language */
  lang: LanguageEnum;
  /** Last name */
  lastName: Scalars['String']['output'];
  /** Lock time */
  lockedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Lock reason */
  lockedReason: Maybe<SystemAdminLockedReasonEnum>;
  /** Indicates if password change is required */
  passwordChangeRequired: Scalars['Boolean']['output'];
  /** Password change required reason */
  passwordChangeRequiredReason: Maybe<SystemAdminPasswordChangeRequiredReasonEnum>;
  /** Indicates if user needs to set up password */
  passwordSetupRequired: Scalars['Boolean']['output'];
  /**
   * Last password update time
   * ATTENTION: Access allowed for current resource only.
   */
  passwordUpdatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Number of available backup codes */
  twoFactorBackupCodesCount: Scalars['Int']['output'];
  /** Indicates if email OTP method is enabled */
  twoFactorEmailOtpEnabled: Scalars['Boolean']['output'];
  /** Indicates if two-factor authentication is enabled */
  twoFactorEnabled: Scalars['Boolean']['output'];
  /** List of enabled two-factor authentication methods */
  twoFactorEnabledMethods: Array<AuthenticationTwoFactorOtpMethodEnum>;
  /** Timestamp of last successful two-factor verification */
  twoFactorLastVerifiedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Indicates if two-factor authentication is required for this account */
  twoFactorRequired: Scalars['Boolean']['output'];
  /** Indicates if two-factor authentication reset is required */
  twoFactorResetRequired: Scalars['Boolean']['output'];
  /** Two-factor authentication reset required reason */
  twoFactorResetRequiredReason: Maybe<SystemAdminTwoFactorResetRequiredReasonEnum>;
  /** Indicates if two-factor authentication setup is required */
  twoFactorSetupRequired: Scalars['Boolean']['output'];
  /** Indicates if TOTP (authenticator app) method is enabled */
  twoFactorTotpEnabled: Scalars['Boolean']['output'];
  /** Email awaiting confirmation */
  unconfirmedEmail: Maybe<Scalars['String']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Indicates if user has verified email */
  verified: Maybe<Scalars['Boolean']['output']>;
};

/** SystemAdminCollection type */
export type SystemAdminCollection = {
  __typename?: 'SystemAdminCollection';
  /** A collection of paginated SystemAdminCollection */
  collection: Array<SystemAdmin>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type SystemAdminCreateInput = {
  /** Create attributes */
  attributes: SystemAdminCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Url to confirm registration */
  redirectUrl: Scalars['String']['input'];
};

/** System Admin attributes */
export type SystemAdminCreateInputObject = {
  /** Email */
  email: Scalars['String']['input'];
  /** First name */
  firstName: Scalars['String']['input'];
  /** Job title */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Interface preferred language */
  lang: LanguageEnum;
  /** Last name */
  lastName: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type SystemAdminDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** System Admin ID */
  id: Scalars['ID']['input'];
};

/** System Admin filters */
export type SystemAdminFilterInputObject = {
  /** Full name */
  fullName?: InputMaybe<FilterInputObject>;
  /** Job title */
  jobTitle?: InputMaybe<FilterInputObject>;
};

/** Available locked reasons */
export enum SystemAdminLockedReasonEnum {
  SecurityNotYou = 'SECURITY__NOT_YOU'
}

/** Available password change required reasons */
export enum SystemAdminPasswordChangeRequiredReasonEnum {
  SecurityNotYou = 'SECURITY__NOT_YOU'
}

/** Description from base input object. Please set your description for child object. */
export type SystemAdminSelfUpdateInput = {
  /** Update attributes */
  attributes: SystemAdminSelfUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Url to confirm new email */
  redirectUrl: Scalars['String']['input'];
};

/** System Admin attributes */
export type SystemAdminSelfUpdateInputObject = {
  /** Avatar */
  avatarAttached?: InputMaybe<AttachmentCuInputObject>;
  /** Cancel email changing */
  cancelConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Job title */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Interface preferred language */
  lang?: InputMaybe<LanguageEnum>;
  /** Last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
};

/** System Admin sorts */
export type SystemAdminSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Full name */
  fullName?: InputMaybe<SortDirectionEnum>;
  /** Job title */
  jobTitle?: InputMaybe<SortDirectionEnum>;
};

/** Available two-factor reset required reasons */
export enum SystemAdminTwoFactorResetRequiredReasonEnum {
  SecurityNotYou = 'SECURITY__NOT_YOU'
}

/** Description from base input object. Please set your description for child object. */
export type SystemAdminUpdateInput = {
  /** Update attributes */
  attributes: SystemAdminUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Url to confirm new email */
  confirmEmailRedirectUrl: Scalars['String']['input'];
  /** Url to finish registration */
  finishRegistrationRedirectUrl: Scalars['String']['input'];
  /** System Admin ID */
  id: Scalars['ID']['input'];
};

/** System Admin attributes */
export type SystemAdminUpdateInputObject = {
  /** Email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Job title */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type SystemAdminUserCreateInput = {
  /** Create attributes */
  attributes: SystemAdminUserCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Company ID */
  companyId: Scalars['ID']['input'];
  /** Url to confirm registration */
  redirectUrl: Scalars['String']['input'];
};

/** User attributes */
export type SystemAdminUserCreateInputObject = {
  /** Email */
  email: Scalars['String']['input'];
  /** First name */
  firstName: Scalars['String']['input'];
  /** Interface preferred language */
  lang?: InputMaybe<LanguageEnum>;
  /** Last name */
  lastName: Scalars['String']['input'];
  /** Role */
  role: UserRoleEnum;
};

/** Tag entity */
export type Tag = TimestampInterface & {
  __typename?: 'Tag';
  canDestroy: AuthorizationResult;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Tag ID */
  id: Scalars['ID']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** TagCollection type */
export type TagCollection = {
  __typename?: 'TagCollection';
  /** A collection of paginated TagCollection */
  collection: Array<Tag>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type TagCreateInput = {
  /** Create attributes */
  attributes: TagCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Tag attributes */
export type TagCreateInputObject = {
  /** Name */
  name: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type TagDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID */
  id: Scalars['ID']['input'];
};

/** Tag filters */
export type TagFilterInputObject = {
  /** Name */
  name?: InputMaybe<FilterInputObject>;
};

/** Tag sorts */
export type TagSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
};

/** Task entity */
export type Task = TimestampInterface & {
  __typename?: 'Task';
  /**
   * User entity
   * NOTE: if you only need an Object ID, please use the approverId field to reduce the load on the database.
   */
  approver: Maybe<User>;
  /** Approver ID */
  approverId: Maybe<Scalars['ID']['output']>;
  /** Archived date */
  archivedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * Asset entity
   * NOTE: if you only need an Object ID, please use the assetId field to reduce the load on the database.
   */
  asset: Maybe<Asset>;
  /** Asset ID */
  assetId: Maybe<Scalars['ID']['output']>;
  canArchive: AuthorizationResult;
  canCompletionCreate: AuthorizationResult;
  canDestroy: AuthorizationResult;
  canFormTemplateVersionUpdate: AuthorizationResult;
  canInterventionCreate: AuthorizationResult;
  canQrCodeRelatedInfoUpdate: AuthorizationResult;
  canReschedule: AuthorizationResult;
  canUpdate: AuthorizationResult;
  /** Completed date */
  completedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Task completion entity */
  completion: Maybe<TaskCompletion>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Deadline date (On date or Next check - for non completed tasks) */
  deadlineAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Shows the reason why the deadline was missed. */
  deadlineMissedReason: Maybe<TaskDeadlineMissedReasonEnum>;
  /** Indicates if the deadline was missed before. */
  deadlineWasMissed: Scalars['Boolean']['output'];
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Early completion */
  earlyCompletion: Maybe<Scalars['Int']['output']>;
  /** Early completion unit */
  earlyCompletionUnit: Maybe<TaskEarlyCompletionUnitEnum>;
  /** Form Template entity */
  formTemplate: FormTemplate;
  /** Form Template Version entity */
  formTemplateVersion: FormTemplateVersion;
  /** Key to group the same tasks which are recurring or have been recurred (if recurring rule was deleted in some point) */
  groupKey: Scalars['ID']['output'];
  /** Whether this task's recurring chain (shared group_key) has at least one documentation linked */
  hasLinkedDocumentations: Maybe<Scalars['Boolean']['output']>;
  /** Task ID */
  id: Scalars['ID']['output'];
  /** Intervention entity */
  intervention: Maybe<Intervention>;
  /** Task kind (standard or on-demand) */
  kind: TaskKindEnum;
  /** Form Answers from previous completion that allowed to be shown in the form */
  lastAllowedAnswers: Array<FormAnswer>;
  /** Last check date (Completion date for previous task completion) */
  lastCheckAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Last deadline date */
  lastDeadlineAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Shows how many days the missed deadline. If the task is not missed, the value is null. */
  lateFor: Maybe<Scalars['Int']['output']>;
  /** Name */
  name: Scalars['String']['output'];
  /** Next deadline date (Next check date - for recurring tasks which have the next created task) */
  nextDeadlineAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Important data digest for todo tasks (changes when the data is changed) [NULL means that not implemented for the query] */
  offlineImportantDataDigest: Maybe<Scalars['String']['output']>;
  /** Original creation date (for recurring tasks) */
  originalCreatedAt: Scalars['ISO8601DateTime']['output'];
  /** Priority */
  priority: TaskPriorityEnum;
  /**
   * Recurring rule entity
   * NOTE: if you only need an Object ID, please use the recurringRuleId field to reduce the load on the database.
   */
  recurringRule: Maybe<RecurringRule>;
  /** Recurring rule ID */
  recurringRuleId: Maybe<Scalars['ID']['output']>;
  /**
   * Site entity
   * NOTE: if you only need an Object ID, please use the siteId field to reduce the load on the database.
   */
  site: Maybe<Site>;
  /**
   * Site Area entity
   * NOTE: if you only need an Object ID, please use the siteAreaId field to reduce the load on the database.
   */
  siteArea: Maybe<SiteArea>;
  /** Site Area ID */
  siteAreaId: Maybe<Scalars['ID']['output']>;
  /** Site ID */
  siteId: Maybe<Scalars['ID']['output']>;
  /** Status */
  status: TaskStatusEnum;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Task attributes */
export type TaskAssignationsInputObject = {
  /** Asset ID */
  assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Site Area ID */
  siteAreaIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Description from base input object. Please set your description for child object. */
export type TaskBulkCreateSameInput = {
  /** Create attributes */
  attributes: TaskBulkCreateSameInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Task attributes */
export type TaskBulkCreateSameInputObject = {
  /** Approver ID */
  approverId: Scalars['ID']['input'];
  /** Assignations attributes array */
  assignations: TaskAssignationsInputObject;
  /** Deadline at (On date) */
  deadlineAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Department links (a link applies to the whole recurring task group) */
  departmentLinks?: InputMaybe<Array<LinkingInputObject>>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Documentation links
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationLinks?: InputMaybe<Array<DocumentationLinkInputObject>>;
  /** Early completion */
  earlyCompletion?: InputMaybe<Scalars['Int']['input']>;
  /** Early completion unit */
  earlyCompletionUnit?: InputMaybe<TaskEarlyCompletionUnitEnum>;
  /** Task kind (standard or on-demand) */
  kind: TaskKindEnum;
  /** Name */
  name: Scalars['String']['input'];
  /** Priority */
  priority: TaskPriorityEnum;
  /** Recurring rule attributes */
  recurringRule?: InputMaybe<RecurringRuleInputObject>;
  /** Form Template ID */
  templateId: Scalars['ID']['input'];
  /** Form Template Version ID */
  templateVersionId: Scalars['ID']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type TaskBulkDeadlineMissedReasonUpdateInput = {
  /** Update attributes */
  attributes: TaskUpdateDeadlineMissedReasonInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Task IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type TaskBulkSchedulingInput = {
  /** Scheduling params */
  attributes: TaskBulkSchedulingInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Task IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Task attributes */
export type TaskBulkSchedulingInputObject = {
  /** Deadline at (On date) */
  deadlineAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Early completion */
  earlyCompletion?: InputMaybe<Scalars['Int']['input']>;
  /** Early completion unit */
  earlyCompletionUnit?: InputMaybe<TaskEarlyCompletionUnitEnum>;
  /** Task kind (standard or on-demand) */
  kind: TaskKindEnum;
  /** Recurring rule attributes */
  recurringRule?: InputMaybe<RecurringRuleInputObject>;
};

/** Description from base input object. Please set your description for child object. */
export type TaskBulkTemplateVersionUpdateInput = {
  /** Update attributes */
  attributes: TaskUpdateTemplateVersionInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Task IDs */
  ids: Array<Scalars['ID']['input']>;
  /** Form Template ID */
  templateId: Scalars['ID']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type TaskBulkUpdateStatusInput = {
  /** Update attributes */
  attributes: TaskUpdateStatusInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Task IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** TaskCollection type */
export type TaskCollection = {
  __typename?: 'TaskCollection';
  /** A collection of paginated TaskCollection */
  collection: Array<Task>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Task completion entity */
export type TaskCompletion = TimestampInterface & {
  __typename?: 'TaskCompletion';
  /** Form Answers collection */
  answers: Maybe<Array<FormAnswer>>;
  canStatusUpdate: AuthorizationResult;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Task Completion ID */
  id: Scalars['ID']['output'];
  /**
   * Performer entity
   * NOTE: if you only need an Object ID, please use the performerId field to reduce the load on the database.
   */
  performer: Maybe<User>;
  /** Performer ID */
  performerId: Maybe<Scalars['ID']['output']>;
  /**
   * Solved date
   * ATTENTION: Access allowed for users: [TASKS_MANAGEMENT:READ].
   */
  solvedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * Result status
   * ATTENTION: Access allowed for users: [TASKS_MANAGEMENT:READ].
   */
  status: Maybe<TaskCompletionStatusEnum>;
  /**
   * Task entity
   * NOTE: if you only need an Object ID, please use the taskId field to reduce the load on the database.
   */
  task: Maybe<Task>;
  /** Task ID */
  taskId: Maybe<Scalars['ID']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Indicates if task completion is expected to be valid
   * ATTENTION: Access allowed for users: [TASKS_MANAGEMENT:READ].
   */
  validityHint: Maybe<FormTemplateQuestionFieldOptionsValidityHintEnum>;
};

/** TaskCompletionCollection type */
export type TaskCompletionCollection = {
  __typename?: 'TaskCompletionCollection';
  /** A collection of paginated TaskCompletionCollection */
  collection: Array<TaskCompletion>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type TaskCompletionCreateInput = {
  /** Create attributes */
  attributes: TaskCompletionCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Task completion attributes */
export type TaskCompletionCreateInputObject = {
  /** Answers attributes array */
  answers: Array<FormAnswerCreateInputObject>;
  /** Task ID */
  taskId: Scalars['ID']['input'];
};

/** Task completion filters */
export type TaskCompletionFilterInputObject = {
  /** Created at */
  createdAt?: InputMaybe<FilterDateInputObject>;
  /**
   * Performer ID
   * ATTENTION: Access allowed for users: [TASKS_MANAGEMENT:READ].
   */
  performerId?: InputMaybe<FilterIdInputObject>;
  /**
   * Validity hint
   * ATTENTION: Access allowed for users: [TASKS_MANAGEMENT:READ].
   */
  validityHint?: InputMaybe<FilterInputObject>;
};

/** Task completion sorts */
export type TaskCompletionSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Performer full name */
  performerFullName?: InputMaybe<SortDirectionEnum>;
  /** Solved at */
  solvedAt?: InputMaybe<SortDirectionEnum>;
  /** Status */
  status?: InputMaybe<SortDirectionEnum>;
};

/** Available task completion statuses */
export enum TaskCompletionStatusEnum {
  InProgress = 'IN_PROGRESS',
  Solved = 'SOLVED',
  Unsolved = 'UNSOLVED'
}

/** Description from base input object. Please set your description for child object. */
export type TaskCompletionStatusUpdateInput = {
  /** Update attributes */
  attributes: TaskCompletionUpdateStatusInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Task ID */
  taskId: Scalars['ID']['input'];
};

/** Task completion attributes */
export type TaskCompletionUpdateStatusInputObject = {
  /** Status */
  status: TaskCompletionStatusEnum;
};

/** Available deadline missed reasons */
export enum TaskDeadlineMissedReasonEnum {
  Inaccessible = 'INACCESSIBLE',
  Other = 'OTHER',
  SiteClosed = 'SITE_CLOSED',
  StaffProblem = 'STAFF_PROBLEM',
  UnderConstruction = 'UNDER_CONSTRUCTION'
}

/** Description from base input object. Please set your description for child object. */
export type TaskDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Task ID */
  id: Scalars['ID']['input'];
};

/** Available early completion units */
export enum TaskEarlyCompletionUnitEnum {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK'
}

/** Task filters */
export type TaskFilterInputObject = {
  /** Asset code */
  assetCode?: InputMaybe<FilterInputObject>;
  /** Asset ID */
  assetId?: InputMaybe<FilterIdInputObject>;
  /** Asset name */
  assetName?: InputMaybe<FilterInputObject>;
  /** Asset QR prefix */
  assetQrPrefix?: InputMaybe<FilterInputObject>;
  /** Completed at */
  completedAt?: InputMaybe<FilterDateInputObject>;
  /**
   * Completion validity hint
   * ATTENTION: Access allowed for users: [TASKS_MANAGEMENT:READ].
   */
  completionValidityHint?: InputMaybe<FilterInputObject>;
  /** Deadline at */
  deadlineAt?: InputMaybe<FilterDateInputObject>;
  /** Filter to tasks linked to one of these department IDs (matched via shared group_key) */
  departmentsId?: InputMaybe<FilterIdInputObject>;
  /**
   * Filter to tasks linked to one of these documentation IDs (matched via shared group_key)
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationsId?: InputMaybe<FilterIdInputObject>;
  /** Form Category ID */
  formCategoryId?: InputMaybe<FilterIdInputObject>;
  /** Form Category name */
  formCategoryName?: InputMaybe<FilterInputObject>;
  /** Recurring group key shared by all occurrences of the same recurring task */
  groupKey?: InputMaybe<FilterIdInputObject>;
  /** Task kind */
  kind?: InputMaybe<FilterIntInputObject>;
  /** Task name */
  name?: InputMaybe<FilterInputObject>;
  /** Task priority */
  priority?: InputMaybe<FilterIntInputObject>;
  /** Site Area code */
  siteAreaCode?: InputMaybe<FilterInputObject>;
  /** Site Area ID */
  siteAreaId?: InputMaybe<FilterIdInputObject>;
  /** Site Area name */
  siteAreaName?: InputMaybe<FilterInputObject>;
  /** Site code */
  siteCode?: InputMaybe<FilterInputObject>;
  /** Site ID */
  siteId?: InputMaybe<FilterIdInputObject>;
  /** Site name */
  siteName?: InputMaybe<FilterInputObject>;
  /** Form Template ID */
  templateId?: InputMaybe<FilterIdInputObject>;
  /** Form Template Version ID */
  templateVersionId?: InputMaybe<FilterIdInputObject>;
};

/** Available task kinds */
export enum TaskKindEnum {
  OnDemand = 'ON_DEMAND',
  Standard = 'STANDARD'
}

/** Available task priorities */
export enum TaskPriorityEnum {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

/** Tasks which are linked to form template and grouped by recurring rule */
export type TaskScopeArgsLinkedToFormTemplateGroupedInputObject = {
  /** Form Template ID */
  templateId: Scalars['ID']['input'];
};

/** Custom scope attributes */
export type TaskScopeCustomInputObject = {
  /** Tasks which are linked to form template and grouped by recurring rule */
  linkedToFormTemplateGrouped?: InputMaybe<TaskScopeArgsLinkedToFormTemplateGroupedInputObject>;
};

/** Task scope attributes */
export type TaskScopeInputObject = {
  /** Custom scope attributes */
  custom?: InputMaybe<TaskScopeCustomInputObject>;
  /** Scope name */
  name?: InputMaybe<TaskScopeNameEnum>;
};

/** Available task scope names */
export enum TaskScopeNameEnum {
  /** Current active tasks (not completed yet but validated) */
  Active = 'ACTIVE',
  /** Archived tasks */
  Archived = 'ARCHIVED',
  /** Archived tasks grouped by recurrence */
  ArchivedGrouped = 'ARCHIVED_GROUPED',
  /** Completed tasks */
  Completed = 'COMPLETED',
  /** Completed tasks grouped by recurrence */
  CompletedGrouped = 'COMPLETED_GROUPED',
  /** Tasks that are the latest occurrence in their recurring chain (not yet superseded by a regenerated task) */
  Current = 'CURRENT',
  /** All tasks for dashboard */
  DashboardAll = 'DASHBOARD_ALL',
  /** All tasks for dashboard and grouped by recurring rule */
  DashboardAllGrouped = 'DASHBOARD_ALL_GROUPED',
  /** Tasks with missed deadline */
  DeadlineMissed = 'DEADLINE_MISSED',
  /** Tasks with missed deadline without selected deadline missed reason */
  DeadlineMissedWithoutReason = 'DEADLINE_MISSED_WITHOUT_REASON',
  /** Completed tasks with failure result */
  Failure = 'FAILURE',
  /** Solved completed tasks with failure result */
  FailureSolved = 'FAILURE_SOLVED',
  /** Unsolved completed tasks with failure result */
  FailureUnsolved = 'FAILURE_UNSOLVED',
  /** Current tasks need to be validated */
  MyApprovals = 'MY_APPROVALS',
  /** Completed tasks assigned to me */
  MyCompleted = 'MY_COMPLETED',
  /** Tasks assigned to me and available to complete */
  MyTodoAvailableToComplete = 'MY_TODO_AVAILABLE_TO_COMPLETE',
  /** Tasks assigned to me and not available to complete yet because of deadline date */
  MyTodoUpcoming = 'MY_TODO_UPCOMING',
  /** Completed tasks with non success result and without intervention */
  NonSuccessWithoutIntervention = 'NON_SUCCESS_WITHOUT_INTERVENTION',
  /** Tasks which have not processed yet and grouped by recurring rule */
  NotProcessedGrouped = 'NOT_PROCESSED_GROUPED',
  /** Current tasks that are on validation or validated */
  OnValidationOrValidated = 'ON_VALIDATION_OR_VALIDATED',
  /** Current pending tasks (not completed nor validated yet) */
  Pending = 'PENDING',
  /** Solved completed tasks (with warning or failure result) */
  Solved = 'SOLVED',
  /** Completed tasks with success result */
  Success = 'SUCCESS',
  /** Completed tasks with warning result */
  Warning = 'WARNING',
  /** Solved completed tasks with warning result */
  WarningSolved = 'WARNING_SOLVED',
  /** Unsolved completed tasks with warning result */
  WarningUnsolved = 'WARNING_UNSOLVED'
}

/** Task sorts */
export type TaskSortInputObject = {
  /** Archived at */
  archivedAt?: InputMaybe<SortDirectionEnum>;
  /** Asset name */
  assetName?: InputMaybe<SortDirectionEnum>;
  /** Completed at */
  completedAt?: InputMaybe<SortDirectionEnum>;
  /** Completion solved at */
  completionSolvedAt?: InputMaybe<SortDirectionEnum>;
  /** Completion status */
  completionStatus?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Deadline date (On date or Next check - for non completed tasks) */
  deadlineAt?: InputMaybe<SortDirectionEnum>;
  /** Deadline missed reason */
  deadlineMissedReason?: InputMaybe<SortDirectionEnum>;
  /** Form Category name */
  formCategoryName?: InputMaybe<SortDirectionEnum>;
  /** Task kind */
  kind?: InputMaybe<SortDirectionEnum>;
  /** Last check at */
  lastCheckAt?: InputMaybe<SortDirectionEnum>;
  /** Last deadline date */
  lastDeadlineAt?: InputMaybe<SortDirectionEnum>;
  /** Shows how many days the missed deadline. If the task is not missed, the value is null. */
  lateFor?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Next deadline date (Next check date - for recurring tasks which have the next created task) */
  nextDeadlineAt?: InputMaybe<SortDirectionEnum>;
  /** Priority */
  priority?: InputMaybe<SortDirectionEnum>;
  /** Site Area name */
  siteAreaName?: InputMaybe<SortDirectionEnum>;
  /** Site name */
  siteName?: InputMaybe<SortDirectionEnum>;
  /** Status */
  status?: InputMaybe<SortDirectionEnum>;
  /** Form Template name */
  templateName?: InputMaybe<SortDirectionEnum>;
  /** Form Template Version version */
  templateVersionVersion?: InputMaybe<SortDirectionEnum>;
};

/** Available task statuses */
export enum TaskStatusEnum {
  Archived = 'ARCHIVED',
  Completed = 'COMPLETED',
  OnValidation = 'ON_VALIDATION',
  Rejected = 'REJECTED',
  Validated = 'VALIDATED'
}

/** Task timeline */
export type TaskTimeline = {
  __typename?: 'TaskTimeline';
  /** Task ID */
  id: Scalars['ID']['output'];
  /** Timeline rows */
  rows: Array<TaskTimelineRow>;
};

/** Available timeline completion group by options */
export enum TaskTimelineCompletionGroupByEnum {
  FormCategory = 'FORM_CATEGORY',
  FormTemplate = 'FORM_TEMPLATE',
  SiteArea = 'SITE_AREA'
}

/** Available timeline frames */
export enum TaskTimelineFrameEnum {
  Month = 'MONTH',
  Quarter = 'QUARTER',
  Week = 'WEEK',
  Year = 'YEAR'
}

/** Available timeline group by options */
export enum TaskTimelineGroupByEnum {
  Day = 'DAY',
  Month = 'MONTH'
}

/** Timeline query data attributes */
export type TaskTimelineQueryDataInputObject = {
  /** Date range */
  dateRange: DateRangeInputObject;
  /** Group by */
  groupBy: TaskTimelineGroupByEnum;
  /** Validity hints */
  validityHints?: InputMaybe<Array<FormTemplateQuestionFieldOptionsValidityHintEnum>>;
};

/** Timeline report attributes */
export type TaskTimelineReportCreateInputObject = {
  /** Completion group by */
  completionGroupBy: TaskTimelineCompletionGroupByEnum;
  /** Message to recipient */
  message?: InputMaybe<Scalars['String']['input']>;
  /** Query data */
  queryData: TaskTimelineQueryDataInputObject;
  /** Task IDs */
  taskIds: Array<Scalars['ID']['input']>;
  /** Time frame */
  timeFrame: TaskTimelineFrameEnum;
  /** Recipient user ID */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Timeline row */
export type TaskTimelineRow = {
  __typename?: 'TaskTimelineRow';
  /** Date */
  date: Scalars['String']['output'];
  /** Validity hint counters */
  validityHintCounters: TaskTimelineValidityHintCounter;
};

/** Validity hint counter */
export type TaskTimelineValidityHintCounter = {
  __typename?: 'TaskTimelineValidityHintCounter';
  /** Failure */
  failure: Maybe<Scalars['Int']['output']>;
  /** Hint is absent (no answers where hint was set) */
  none: Maybe<Scalars['Int']['output']>;
  /** Success */
  success: Maybe<Scalars['Int']['output']>;
  /** Warning */
  warning: Maybe<Scalars['Int']['output']>;
};

/** Description from base input object. Please set your description for child object. */
export type TaskUnlinkAllDocumentationsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Recurring group key shared by all occurrences of the same recurring task */
  groupKey: Scalars['ID']['input'];
};

/** Task attributes */
export type TaskUpdateDeadlineMissedReasonInputObject = {
  /** Deadline missed reason */
  deadlineMissedReason: TaskDeadlineMissedReasonEnum;
};

/** Description from base input object. Please set your description for child object. */
export type TaskUpdateInput = {
  /** Update attributes */
  attributes: TaskUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Task ID */
  id: Scalars['ID']['input'];
};

/** Task attributes */
export type TaskUpdateInputObject = {
  /** Approver ID */
  approverId?: InputMaybe<Scalars['ID']['input']>;
  /** Asset ID */
  assetId?: InputMaybe<Scalars['ID']['input']>;
  /** Department links (a link applies to the whole recurring task group) */
  departmentLinks?: InputMaybe<Array<LinkingInputObject>>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Documentation links
   * ATTENTION: Requires plan upgrade for feature: DOCUMENTATION_MANAGEMENT.
   */
  documentationLinks?: InputMaybe<Array<DocumentationLinkInputObject>>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Priority */
  priority?: InputMaybe<TaskPriorityEnum>;
  /** Site Area ID */
  siteAreaId?: InputMaybe<Scalars['ID']['input']>;
  /** Form Template ID */
  templateId?: InputMaybe<Scalars['ID']['input']>;
  /** Form Template Version ID */
  templateVersionId?: InputMaybe<Scalars['ID']['input']>;
};

/** Task attributes */
export type TaskUpdateStatusInputObject = {
  /** Status */
  status: TaskStatusEnum;
};

/** Task attributes */
export type TaskUpdateTemplateVersionInputObject = {
  /** Form Template Version ID */
  templateVersionId: Scalars['ID']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type TasksTimelineReportCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Params */
  params: TaskTimelineReportCreateInputObject;
};

/** Task entity */
export type TasksTodoCompletableByDateData = {
  __typename?: 'TasksTodoCompletableByDateData';
  /** Task ID */
  id: Scalars['ID']['output'];
  /** Important data digest for todo tasks (changes when the data is changed) [NULL means that not implemented for the query] */
  offlineImportantDataDigest: Scalars['String']['output'];
};

/** Team entity */
export type Team = TimestampInterface & {
  __typename?: 'Team';
  /** Related accesses */
  accesses: Array<Access>;
  canDestroy: AuthorizationResult;
  /** Color */
  color: ColorEnum;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Team ID */
  id: Scalars['ID']['output'];
  /** Name */
  name: Maybe<Scalars['String']['output']>;
  /** Indicates if team is read only (default system team) */
  readOnly: Scalars['Boolean']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Assigned users count (only visible by site memberships) */
  visibleUsersCount: Maybe<Scalars['Int']['output']>;
};

/** TeamCollection type */
export type TeamCollection = {
  __typename?: 'TeamCollection';
  /** A collection of paginated TeamCollection */
  collection: Array<Team>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type TeamCreateInput = {
  /** Create attributes */
  attributes: TeamCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Team attributes */
export type TeamCreateInputObject = {
  /** Accesses attributes array */
  accesses: Array<AccessCuInputObject>;
  /** Color */
  color: ColorEnum;
  /** Department links */
  departmentLinks?: InputMaybe<Array<LinkingInputObject>>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name: Scalars['String']['input'];
  /** Users attributes array */
  users?: InputMaybe<Array<LinkingInputObject>>;
};

/** Description from base input object. Please set your description for child object. */
export type TeamDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Team ID */
  id: Scalars['ID']['input'];
};

/** Team filters */
export type TeamFilterInputObject = {
  /** Department ID */
  departmentsId?: InputMaybe<FilterIdInputObject>;
  /** Name */
  name?: InputMaybe<FilterInputObject>;
  /** Users full name */
  usersFullName?: InputMaybe<FilterInputObject>;
};

/** Team sorts */
export type TeamSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Assigned users count (only visible by site memberships) */
  visibleUsersCount?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type TeamUpdateInput = {
  /** Update attributes */
  attributes: TeamUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Team ID */
  id: Scalars['ID']['input'];
};

/** Team attributes */
export type TeamUpdateInputObject = {
  /** Accesses attributes array */
  accesses?: InputMaybe<Array<AccessCuInputObject>>;
  /** Color */
  color?: InputMaybe<ColorEnum>;
  /** Department links */
  departmentLinks?: InputMaybe<Array<LinkingInputObject>>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Users attributes array */
  users?: InputMaybe<Array<LinkingInputObject>>;
};

/** Technical pause entity */
export type TechnicalPause = TimestampInterface & {
  __typename?: 'TechnicalPause';
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Created by */
  createdBy: SystemAdmin;
  /** Early terminated at */
  earlyTerminatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** End time of the technical pause */
  endAt: Scalars['ISO8601DateTime']['output'];
  /** Technical pause ID */
  id: Scalars['ID']['output'];
  /** Start time of the technical pause */
  startAt: Scalars['ISO8601DateTime']['output'];
  /** Status */
  status: TechnicalPauseStatusEnum;
  /** Time left to start/end of the technical pause */
  time: Maybe<Scalars['Int']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** TechnicalPauseCollection type */
export type TechnicalPauseCollection = {
  __typename?: 'TechnicalPauseCollection';
  /** A collection of paginated TechnicalPauseCollection */
  collection: Array<TechnicalPause>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type TechnicalPauseCreateInput = {
  /** Create attributes */
  attributes: TechnicalPauseCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 2FA code for verification */
  code: Scalars['String']['input'];
  /** Type of code (totp, email, backup) */
  codeType: AuthenticationTwoFactorCodeTypeEnum;
};

/** Technical Pause attributes */
export type TechnicalPauseCreateInputObject = {
  /** End at */
  endAt: Scalars['ISO8601DateTime']['input'];
  /** Start at */
  startAt: Scalars['ISO8601DateTime']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type TechnicalPauseDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 2FA code for verification */
  code: Scalars['String']['input'];
  /** Type of code (totp, email, backup) */
  codeType: AuthenticationTwoFactorCodeTypeEnum;
  /** Technical Pause ID */
  id: Scalars['ID']['input'];
};

/** Technical Pause sorts */
export type TechnicalPauseSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Created by full name */
  createdByFullName?: InputMaybe<SortDirectionEnum>;
  /** End at */
  endAt?: InputMaybe<SortDirectionEnum>;
  /** Start at */
  startAt?: InputMaybe<SortDirectionEnum>;
};

/** Available statuses */
export enum TechnicalPauseStatusEnum {
  Completed = 'COMPLETED',
  Ongoing = 'ONGOING',
  Scheduled = 'SCHEDULED'
}

/** Description from base input object. Please set your description for child object. */
export type TechnicalPauseUpdateInput = {
  /** Update attributes */
  attributes: TechnicalPauseUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 2FA code for verification */
  code: Scalars['String']['input'];
  /** Type of code (totp, email, backup) */
  codeType: AuthenticationTwoFactorCodeTypeEnum;
  /** Technical Pause ID */
  id: Scalars['ID']['input'];
};

/** Technical Pause attributes */
export type TechnicalPauseUpdateInputObject = {
  /** Early terminated */
  earlyTerminated?: InputMaybe<Scalars['Boolean']['input']>;
  /** End at */
  endAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Start at */
  startAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** Available time periods for scoping activity metrics */
export enum TimePeriodEnum {
  /** All time */
  AllTime = 'ALL_TIME',
  /** Last 30 days */
  Last_30Days = 'LAST_30_DAYS',
  /** Last 90 days */
  Last_90Days = 'LAST_90_DAYS',
  /** Last 365 days */
  Last_365Days = 'LAST_365_DAYS',
  /** Year to date */
  YearToDate = 'YEAR_TO_DATE'
}

/** Shows timestamp */
export type TimestampInterface = {
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Two-factor authentication fields */
export type TwoFactorAuthenticatableInterface = {
  /** Number of available backup codes */
  twoFactorBackupCodesCount: Scalars['Int']['output'];
  /** Indicates if email OTP method is enabled */
  twoFactorEmailOtpEnabled: Scalars['Boolean']['output'];
  /** Indicates if two-factor authentication is enabled */
  twoFactorEnabled: Scalars['Boolean']['output'];
  /** List of enabled two-factor authentication methods */
  twoFactorEnabledMethods: Array<AuthenticationTwoFactorOtpMethodEnum>;
  /** Timestamp of last successful two-factor verification */
  twoFactorLastVerifiedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Indicates if two-factor authentication is required for this account */
  twoFactorRequired: Scalars['Boolean']['output'];
  /** Indicates if two-factor authentication reset is required */
  twoFactorResetRequired: Scalars['Boolean']['output'];
  /** Indicates if two-factor authentication setup is required */
  twoFactorSetupRequired: Scalars['Boolean']['output'];
  /** Indicates if TOTP (authenticator app) method is enabled */
  twoFactorTotpEnabled: Scalars['Boolean']['output'];
};

/** Backup codes information */
export type TwoFactorBackupCodes = {
  __typename?: 'TwoFactorBackupCodes';
  /** List of backup codes */
  codes: Array<Scalars['String']['output']>;
  /** Number of backup codes */
  count: Scalars['Int']['output'];
};

/** Two-factor authentication setup result */
export type TwoFactorSetupResult = {
  __typename?: 'TwoFactorSetupResult';
  /** Generated backup codes (if requested) */
  backupCodes: Array<Scalars['String']['output']>;
  /** Number of generated backup codes */
  backupCodesCount: Scalars['Int']['output'];
};

/** TOTP setup information */
export type TwoFactorTotpSetup = {
  __typename?: 'TwoFactorTotpSetup';
  /** TOTP secret key */
  secret: Scalars['String']['output'];
  /** TOTP URI for QR code generation */
  uri: Scalars['String']['output'];
};

/** User entity */
export type User = TimestampInterface & UserInterface & {
  __typename?: 'User';
  /** Avatar */
  avatarAttached: Maybe<Attachment>;
  /** Indicates if user accepted the Code of Conduct */
  codeOfConductAccepted: Scalars['Boolean']['output'];
  /**
   * Company
   * NOTE: if you only need an Object ID, please use the companyId field to reduce the load on the database.
   */
  company: Company;
  /** Company ID */
  companyId: Scalars['ID']['output'];
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Deactivation time */
  deactivatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Time until debug mode is active */
  debugModeUntil: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Email */
  email: Maybe<Scalars['String']['output']>;
  /** Final Access setup */
  finalAccesses: Maybe<Array<Access>>;
  /** First name */
  firstName: Scalars['String']['output'];
  /** Indicates if user has a password set */
  hasPassword: Scalars['Boolean']['output'];
  /** User ID */
  id: Scalars['ID']['output'];
  /** Preferred language */
  lang: LanguageEnum;
  /** Last name */
  lastName: Scalars['String']['output'];
  /** Owned company */
  ownedCompany: Maybe<Company>;
  /** Indicates if user needs to set up password */
  passwordSetupRequired: Scalars['Boolean']['output'];
  /**
   * Last password update time
   * ATTENTION: Access allowed for current resource only.
   */
  passwordUpdatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Related personal accesses */
  personalAccesses: Array<Access>;
  /** Personal ID */
  personalId: Maybe<Scalars['String']['output']>;
  /** Phone number in E.164 format */
  phoneNumber: Maybe<Scalars['String']['output']>;
  /** Role */
  role: UserRoleEnum;
  /** Sectors collection */
  sectors: SectorCollection;
  /** Sites collection */
  sites: SiteCollection;
  /**
   * Team entity
   * NOTE: if you only need an Object ID, please use the teamId field to reduce the load on the database.
   */
  team: Team;
  /** Team ID */
  teamId: Maybe<Scalars['ID']['output']>;
  /** Email awaiting confirmation */
  unconfirmedEmail: Maybe<Scalars['String']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Username */
  username: Maybe<Scalars['String']['output']>;
  /** Indicates if user has verified email */
  verified: Maybe<Scalars['Boolean']['output']>;
};


/** User entity */
export type UserSectorsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** User entity */
export type UserSitesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type UserBulkActivateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type UserBulkDeactivateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type UserCodeOfConductAcceptInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if user accepted the Code of Conduct */
  codeOfConductAccepted: Scalars['Boolean']['input'];
};

/** UserCollection type */
export type UserCollection = {
  __typename?: 'UserCollection';
  /** A collection of paginated UserCollection */
  collection: Array<User>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type UserCreateInput = {
  /** Create attributes */
  attributes: UserCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Url to confirm registration */
  redirectUrl: Scalars['String']['input'];
};

/** User attributes */
export type UserCreateInputObject = {
  /** Department memberships attributes array */
  departmentMemberships?: InputMaybe<Array<LinkingInputObject>>;
  /** Email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name */
  firstName: Scalars['String']['input'];
  /** Last name */
  lastName: Scalars['String']['input'];
  /** Password */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Personal ID */
  personalId?: InputMaybe<Scalars['String']['input']>;
  /** Phone number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Role */
  role: UserRoleEnum;
  /** Sector memberships attributes array */
  sectorMemberships?: InputMaybe<Array<LinkingInputObject>>;
  /** Site memberships attributes array */
  siteMemberships?: InputMaybe<Array<LinkingInputObject>>;
  /** Team ID */
  teamId?: InputMaybe<Scalars['String']['input']>;
  /** Username */
  username?: InputMaybe<Scalars['String']['input']>;
};

/** User attributes */
export type UserCreateOwnerInputObject = {
  /** Email */
  email: Scalars['String']['input'];
  /** First name */
  firstName: Scalars['String']['input'];
  /** Interface preferred language */
  lang?: InputMaybe<LanguageEnum>;
  /** Last name */
  lastName: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type UserDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** User ID */
  id: Scalars['ID']['input'];
};

/** User filters */
export type UserFilterInputObject = {
  /** Department memberships ID */
  departmentMembershipsId?: InputMaybe<FilterIdInputObject>;
  /** User email */
  email?: InputMaybe<FilterInputObject>;
  /** User full name */
  fullName?: InputMaybe<FilterInputObject>;
  /** Intervention Action assignees */
  interventionActionAssigneesActionId?: InputMaybe<FilterIdInputObject>;
  /** Intervention Action mentioned users */
  interventionActionsTextMentionsId?: InputMaybe<FilterIdInputObject>;
  /** Intervention assignees */
  interventionAssigneesInterventionId?: InputMaybe<FilterIdInputObject>;
  /** Assigned Department ID */
  memberAssignedDepartmentsId?: InputMaybe<FilterIdInputObject>;
  /** Assigned Sector ID */
  memberAssignedSectorsId?: InputMaybe<FilterIdInputObject>;
  /** Assigned Sector name */
  memberAssignedSectorsName?: InputMaybe<FilterInputObject>;
  /** Assigned Site ID */
  memberAssignedSitesId?: InputMaybe<FilterIdInputObject>;
  /** Assigned Site name */
  memberAssignedSitesName?: InputMaybe<FilterInputObject>;
  /** User personal ID */
  personalId?: InputMaybe<FilterInputObject>;
  /** User role */
  role?: InputMaybe<FilterIntInputObject>;
  /** Sector memberships ID */
  sectorMembershipsId?: InputMaybe<FilterIdInputObject>;
  /** Site memberships ID */
  siteMembershipsId?: InputMaybe<FilterIdInputObject>;
  /** Team ID */
  teamId?: InputMaybe<FilterIdInputObject>;
  /** Team name */
  teamName?: InputMaybe<FilterInputObject>;
  /** User username */
  username?: InputMaybe<FilterInputObject>;
};

/** Common user fields */
export type UserInterface = {
  /** Avatar */
  avatarAttached: Maybe<Attachment>;
  /** Deactivation time */
  deactivatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Time until debug mode is active */
  debugModeUntil: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Email */
  email: Maybe<Scalars['String']['output']>;
  /** First name */
  firstName: Scalars['String']['output'];
  /** Indicates if user has a password set */
  hasPassword: Scalars['Boolean']['output'];
  /** Preferred language */
  lang: LanguageEnum;
  /** Last name */
  lastName: Scalars['String']['output'];
  /** Indicates if user needs to set up password */
  passwordSetupRequired: Scalars['Boolean']['output'];
  /**
   * Last password update time
   * ATTENTION: Access allowed for current resource only.
   */
  passwordUpdatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Email awaiting confirmation */
  unconfirmedEmail: Maybe<Scalars['String']['output']>;
  /** Indicates if user has verified email */
  verified: Maybe<Scalars['Boolean']['output']>;
};

/** Available roles */
export enum UserRoleEnum {
  FullAdmin = 'FULL_ADMIN',
  User = 'USER'
}

/** User access */
export type UserScopeArgsAccessInputObject = {
  /** Component name */
  component: AccessComponentEnum;
  /** Min level of access (Means provided value or higher) */
  level: AccessLevelEnum;
  /** Sourceable ID */
  sourceableId?: InputMaybe<Scalars['ID']['input']>;
};

/** Users core filter */
export type UserScopeArgsByCoreInputObject = {
  /** User access */
  access?: InputMaybe<UserScopeArgsAccessInputObject>;
  /** When set to `true`, this filter ensures that only users who have access to **every site** listed in the `siteId` array are returned. If a user lacks access to any one of the specified sites, they will be excluded from the results. */
  allSitesAccessible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only active users */
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Site ID or array of site IDs */
  siteId?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Custom scope attributes */
export type UserScopeCustomInputObject = {
  /** Users core filter */
  byCore?: InputMaybe<UserScopeArgsByCoreInputObject>;
};

/** User scope attributes */
export type UserScopeInputObject = {
  /** Custom scope attributes */
  custom?: InputMaybe<UserScopeCustomInputObject>;
  /** Scope name */
  name?: InputMaybe<UserScopeNameEnum>;
};

/** Available user scope names */
export enum UserScopeNameEnum {
  /** Active users */
  Active = 'ACTIVE'
}

/** Description from base input object. Please set your description for child object. */
export type UserSelfUpdateInput = {
  /** Update attributes */
  attributes: UserSelfUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Url to confirm new email */
  redirectUrl: Scalars['String']['input'];
};

/** User attributes */
export type UserSelfUpdateInputObject = {
  /** Avatar */
  avatarAttached?: InputMaybe<AttachmentCuInputObject>;
  /** Cancel email changing */
  cancelConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Interface preferred language */
  lang?: InputMaybe<LanguageEnum>;
  /** Last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Personal ID */
  personalId?: InputMaybe<Scalars['String']['input']>;
  /** Phone number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

/** User sorts */
export type UserSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** User email */
  email?: InputMaybe<SortDirectionEnum>;
  /** Full name */
  fullName?: InputMaybe<SortDirectionEnum>;
  /** Personal ID */
  personalId?: InputMaybe<SortDirectionEnum>;
  /** Role */
  role?: InputMaybe<SortDirectionEnum>;
  /** Team name */
  teamName?: InputMaybe<SortDirectionEnum>;
  /** User username */
  username?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type UserUpdateInput = {
  /** Update attributes */
  attributes: UserUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Url to confirm new email */
  confirmEmailRedirectUrl: Scalars['String']['input'];
  /** Url to finish registration */
  finishRegistrationRedirectUrl: Scalars['String']['input'];
  /** User ID */
  id: Scalars['ID']['input'];
};

/** User attributes */
export type UserUpdateInputObject = {
  /** Accesses attributes array */
  accesses?: InputMaybe<Array<AccessCuInputObject>>;
  /** Department memberships attributes array */
  departmentMemberships?: InputMaybe<Array<LinkingInputObject>>;
  /** Email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Password */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Personal ID */
  personalId?: InputMaybe<Scalars['String']['input']>;
  /** Phone number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Role */
  role?: InputMaybe<UserRoleEnum>;
  /** Sector memberships attributes array */
  sectorMemberships?: InputMaybe<Array<LinkingInputObject>>;
  /** Site memberships attributes array */
  siteMemberships?: InputMaybe<Array<LinkingInputObject>>;
  /** Team ID */
  teamId?: InputMaybe<Scalars['String']['input']>;
  /** Username */
  username?: InputMaybe<Scalars['String']['input']>;
};

/** Current resource */
export type Whoami = {
  __typename?: 'Whoami';
  /** Entrypoint entity */
  entrypoint: AuthenticationEntrypointUnion;
  /** Resource entity */
  resource: AuthenticationWhoamiUnion;
};

/** Widget entity */
export type Widget = TimestampInterface & {
  __typename?: 'Widget';
  /** Attachments */
  attachmentsAttached: Array<Attachment>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Widget fields configuration */
  fields: WidgetsField;
  /** Widget grid configuration */
  grid: Scalars['JSON']['output'];
  /** Home Page ID */
  homePageId: Scalars['ID']['output'];
  /** Widget ID */
  id: Scalars['ID']['output'];
  /** Widget kind */
  kind: WidgetsKindEnum;
  /** Position */
  position: Scalars['Int']['output'];
  /** Title */
  title: Maybe<Scalars['String']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Widget Template ID */
  widgetTemplateId: Maybe<Scalars['ID']['output']>;
};

/** Description from base input object. Please set your description for child object. */
export type WidgetBulkUpdateInput = {
  /** Update attributes */
  attributes: Array<WidgetUpdateInputObject>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Home Page ID */
  homePageId: Scalars['ID']['input'];
};

/** Widget button item configuration */
export type WidgetFieldsButtonItemInputObject = {
  /** Indicates if button is enabled */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Last update timestamp for the button */
  updatedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** Widget buttons configuration */
export type WidgetFieldsButtonsInputObject = {
  /** Asset button configuration */
  asset?: InputMaybe<WidgetFieldsButtonItemInputObject>;
  /** Form template button configuration */
  formTemplate?: InputMaybe<WidgetFieldsButtonItemInputObject>;
  /** Intervention button configuration */
  intervention?: InputMaybe<WidgetFieldsButtonItemInputObject>;
  /** Site button configuration */
  site?: InputMaybe<WidgetFieldsButtonItemInputObject>;
  /** Task button configuration */
  task?: InputMaybe<WidgetFieldsButtonItemInputObject>;
  /** Team member button configuration */
  teamMember?: InputMaybe<WidgetFieldsButtonItemInputObject>;
};

/** Widget fields configuration */
export type WidgetFieldsInputObject = {
  /** Background color */
  backgroundColor?: InputMaybe<ColorEnum>;
  /** Widget buttons configuration */
  buttons?: InputMaybe<WidgetFieldsButtonsInputObject>;
  /** End at */
  endAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Link */
  link?: InputMaybe<Scalars['String']['input']>;
  /** Location */
  location?: InputMaybe<Scalars['String']['input']>;
  /** Only my */
  onlyMy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Start at */
  startAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Timezone */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

/** Widget Template entity */
export type WidgetTemplate = TimestampInterface & {
  __typename?: 'WidgetTemplate';
  /** Attachments */
  attachmentsAttached: Array<Attachment>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Subtitle */
  description: Maybe<Scalars['String']['output']>;
  /** Widget Template fields configuration */
  fields: WidgetTemplatesField;
  /** Widget Template ID */
  id: Scalars['ID']['output'];
  /** Is default template */
  isDefault: Scalars['Boolean']['output'];
  /** Widget Template kind */
  kind: WidgetTemplatesKindEnum;
  /** Title */
  title: Maybe<Scalars['String']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** User ID (creator) */
  userId: Maybe<Scalars['ID']['output']>;
  /** Visibility */
  visibility: WidgetTemplatesVisibilityEnum;
};

/** WidgetTemplateCollection type */
export type WidgetTemplateCollection = {
  __typename?: 'WidgetTemplateCollection';
  /** A collection of paginated WidgetTemplateCollection */
  collection: Array<WidgetTemplate>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type WidgetTemplateCreateInput = {
  /** Widget Template creation attributes */
  attributes: WidgetTemplateCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Widget Template attributes */
export type WidgetTemplateCreateInputObject = {
  /** Attachments (icon and/or image) */
  attachmentsAttached?: InputMaybe<Array<AttachmentCuInputObject>>;
  /** Subtitle */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Widget Template fields configuration */
  fields?: InputMaybe<WidgetTemplateFieldsInputObject>;
  /** Widget Template kind */
  kind: WidgetTemplatesKindEnum;
  /** Title */
  title: Scalars['String']['input'];
  /** Visibility (prv for private, pub for public) */
  visibility?: InputMaybe<WidgetTemplatesVisibilityEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type WidgetTemplateDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Widget Template ID */
  id: Scalars['ID']['input'];
};

/** Widget Template fields configuration */
export type WidgetTemplateFieldsInputObject = {
  /** Background color (for announcement only) */
  backgroundColor?: InputMaybe<ColorEnum>;
  /** Rich text content (for announcement only) */
  content?: InputMaybe<Scalars['String']['input']>;
  /** Link URL (for external_link only) */
  link?: InputMaybe<Scalars['String']['input']>;
};

/** Widget Template filters */
export type WidgetTemplateFilterInputObject = {
  /** Is default filter */
  isDefault?: InputMaybe<FilterInputObject>;
  /** Kind filter */
  kind?: InputMaybe<FilterInputObject>;
  /** Title filter */
  title?: InputMaybe<FilterInputObject>;
  /** Visibility filter */
  visibility?: InputMaybe<FilterInputObject>;
};

/** Widget Template sorting */
export type WidgetTemplateSortInputObject = {
  /** Sort by title */
  title?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type WidgetTemplateUpdateInput = {
  /** Widget Template update attributes */
  attributes: WidgetTemplateUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Widget Template ID */
  id: Scalars['ID']['input'];
};

/** Widget Template attributes */
export type WidgetTemplateUpdateInputObject = {
  /** Attachments (icon and/or image) */
  attachmentsAttached?: InputMaybe<Array<AttachmentCuInputObject>>;
  /** Subtitle */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Widget Template fields configuration */
  fields?: InputMaybe<WidgetTemplateFieldsInputObject>;
  /** Title */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Visibility (prv for private, pub for public) */
  visibility?: InputMaybe<WidgetTemplatesVisibilityEnum>;
};

/** Widget Template fields configuration */
export type WidgetTemplatesField = {
  __typename?: 'WidgetTemplatesField';
  /** Background color */
  backgroundColor: Maybe<ColorEnum>;
  /** Rich text content */
  content: Maybe<Scalars['String']['output']>;
  /** Link URL */
  link: Maybe<Scalars['String']['output']>;
};

/** Available widget template kinds */
export enum WidgetTemplatesKindEnum {
  ActiveInterventions = 'ACTIVE_INTERVENTIONS',
  Announcement = 'ANNOUNCEMENT',
  Clock = 'CLOCK',
  ExternalLink = 'EXTERNAL_LINK',
  QuickCreation = 'QUICK_CREATION',
  SectorsPerformanceMetricsByDeadlinesMissed = 'SECTORS_PERFORMANCE_METRICS_BY_DEADLINES_MISSED',
  SitesMap = 'SITES_MAP',
  SitesPerformanceMetricsByDeadlinesMissed = 'SITES_PERFORMANCE_METRICS_BY_DEADLINES_MISSED',
  WeatherToday = 'WEATHER_TODAY',
  WeatherWeek = 'WEATHER_WEEK'
}

/** Widget template visibility options (prv for private, pub for public) */
export enum WidgetTemplatesVisibilityEnum {
  Prv = 'PRV',
  Pub = 'PUB'
}

/** Widget attributes */
export type WidgetUpdateInputObject = {
  /** Destroy widget (if true, widget will be destroyed) */
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Attachments */
  attachmentsAttached?: InputMaybe<Array<AttachmentCuInputObject>>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Widget fields configuration */
  fields?: InputMaybe<WidgetFieldsInputObject>;
  /** Widget grid configuration */
  grid?: InputMaybe<Scalars['JSON']['input']>;
  /** ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Kind */
  kind?: InputMaybe<WidgetsKindEnum>;
  /** Position */
  position?: InputMaybe<Scalars['Int']['input']>;
  /** Title */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Widget Template ID */
  widgetTemplateId?: InputMaybe<Scalars['ID']['input']>;
};

/** Widget fields configuration */
export type WidgetsField = {
  __typename?: 'WidgetsField';
  /** Background color */
  backgroundColor: Maybe<ColorEnum>;
  /** Widget fields buttons configuration */
  buttons: Maybe<WidgetsFieldsButtons>;
  /** End at */
  endAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Link */
  link: Maybe<Scalars['String']['output']>;
  /** Location */
  location: Maybe<Scalars['String']['output']>;
  /** Only my */
  onlyMy: Maybe<Scalars['Boolean']['output']>;
  /** Start at */
  startAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Timezone */
  timezone: Maybe<Scalars['String']['output']>;
};

/** Widget button item configuration */
export type WidgetsFieldsButtonItem = {
  __typename?: 'WidgetsFieldsButtonItem';
  /** Indicates if button is enabled */
  enabled: Maybe<Scalars['Boolean']['output']>;
  /** Last update timestamp for the button */
  updatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Widget fields buttons configuration */
export type WidgetsFieldsButtons = {
  __typename?: 'WidgetsFieldsButtons';
  /** Asset button configuration */
  asset: Maybe<WidgetsFieldsButtonItem>;
  /** Form template button configuration */
  formTemplate: Maybe<WidgetsFieldsButtonItem>;
  /** Intervention button configuration */
  intervention: Maybe<WidgetsFieldsButtonItem>;
  /** Site button configuration */
  site: Maybe<WidgetsFieldsButtonItem>;
  /** Task button configuration */
  task: Maybe<WidgetsFieldsButtonItem>;
  /** Team member button configuration */
  teamMember: Maybe<WidgetsFieldsButtonItem>;
};

/** Available widget kinds */
export enum WidgetsKindEnum {
  ActiveInterventions = 'ACTIVE_INTERVENTIONS',
  Announcement = 'ANNOUNCEMENT',
  Clock = 'CLOCK',
  ExternalLink = 'EXTERNAL_LINK',
  QuickCreation = 'QUICK_CREATION',
  SectorsPerformanceMetricsByDeadlinesMissed = 'SECTORS_PERFORMANCE_METRICS_BY_DEADLINES_MISSED',
  SitesMap = 'SITES_MAP',
  SitesPerformanceMetricsByDeadlinesMissed = 'SITES_PERFORMANCE_METRICS_BY_DEADLINES_MISSED',
  WeatherToday = 'WEATHER_TODAY',
  WeatherWeek = 'WEATHER_WEEK'
}

export type AssetCategoriesSearchListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<Array<AssetCategoryFilterInputObject> | AssetCategoryFilterInputObject>;
  sorts?: InputMaybe<AssetCategorySortInputObject>;
}>;


export type AssetCategoriesSearchListQuery = { __typename?: 'Query', data: { __typename?: 'AssetCategoryCollection', collection: Array<{ __typename?: 'AssetCategory', color: ColorEnum, name: string, id: string, prefix: string | null }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type AuthenticationConfirmationsEmailConfirmationMutationVariables = Exact<{
  input: AuthenticationConfirmationsEmailConfirmationInput;
}>;


export type AuthenticationConfirmationsEmailConfirmationMutation = { __typename?: 'Mutation', data: { __typename?: 'Whoami', resource: { __typename?: 'SystemAdmin', id: string } | { __typename?: 'User' } } };

export type AuthenticationConfirmationsRegistrationConfirmationMutationVariables = Exact<{
  input: AuthenticationConfirmationsRegistrationConfirmationInput;
}>;


export type AuthenticationConfirmationsRegistrationConfirmationMutation = { __typename?: 'Mutation', data: { __typename?: 'Whoami', resource: { __typename?: 'SystemAdmin', id: string } | { __typename?: 'User' } } };

export type AuthenticationConfirmationsResendEmailConfirmationMutationVariables = Exact<{
  input: AuthenticationConfirmationsResendEmailConfirmationInput;
}>;


export type AuthenticationConfirmationsResendEmailConfirmationMutation = { __typename?: 'Mutation', data: { __typename?: 'ResponseMessage', message: string } };

export type AuthenticationConfirmationsResendRegistrationConfirmationMutationVariables = Exact<{
  input: AuthenticationConfirmationsResendRegistrationConfirmationInput;
}>;


export type AuthenticationConfirmationsResendRegistrationConfirmationMutation = { __typename?: 'Mutation', data: { __typename?: 'ResponseMessage', message: string } };

export type AuthenticationPasswordsForgotMutationVariables = Exact<{
  input: AuthenticationPasswordsForgotInput;
}>;


export type AuthenticationPasswordsForgotMutation = { __typename?: 'Mutation', data: { __typename?: 'ResponseMessage', message: string } };

export type AuthenticationPasswordsResetMutationVariables = Exact<{
  input: AuthenticationPasswordsResetInput;
}>;


export type AuthenticationPasswordsResetMutation = { __typename?: 'Mutation', data: { __typename?: 'Whoami', resource: { __typename?: 'SystemAdmin', id: string } | { __typename?: 'User' } } };

export type AuthenticationPasswordsUpdateMutationVariables = Exact<{
  input: AuthenticationPasswordsUpdateInput;
}>;


export type AuthenticationPasswordsUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'Whoami', resource: { __typename?: 'SystemAdmin', id: string } | { __typename?: 'User' } } };

export type AuthenticationPasswordSetupMutationVariables = Exact<{
  input: AuthenticationPasswordSetupInput;
}>;


export type AuthenticationPasswordSetupMutation = { __typename?: 'Mutation', data: boolean };

export type AuthenticationSessionCreateMutationVariables = Exact<{
  input: AuthenticationSessionCreateInput;
}>;


export type AuthenticationSessionCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'Whoami', resource: { __typename?: 'SystemAdmin', id: string, twoFactorSetupRequired: boolean, twoFactorRequired: boolean, passwordSetupRequired: boolean, lockedAt: any | null, twoFactorEnabled: boolean, twoFactorTotpEnabled: boolean, twoFactorEmailOtpEnabled: boolean } | { __typename?: 'User' } } };

export type AuthenticationSessionEndMutationVariables = Exact<{
  input: AuthenticationSessionEndInput;
}>;


export type AuthenticationSessionEndMutation = { __typename?: 'Mutation', data: boolean | null };

export type AuthenticationSessionEndAllMutationVariables = Exact<{
  input: AuthenticationSessionEndAllInput;
}>;


export type AuthenticationSessionEndAllMutation = { __typename?: 'Mutation', data: boolean };

export type AuthenticationSessionEndSpecificMutationVariables = Exact<{
  input: AuthenticationSessionEndSpecificInput;
}>;


export type AuthenticationSessionEndSpecificMutation = { __typename?: 'Mutation', data: boolean };

export type AuthenticationSessionReportSuspiciousMutationVariables = Exact<{
  input: AuthenticationSessionReportSuspiciousInput;
}>;


export type AuthenticationSessionReportSuspiciousMutation = { __typename?: 'Mutation', data: boolean };

export type AuthenticationSessionReportSuspiciousByTokenMutationVariables = Exact<{
  input: AuthenticationSessionReportSuspiciousByTokenInput;
}>;


export type AuthenticationSessionReportSuspiciousByTokenMutation = { __typename?: 'Mutation', data: boolean };

export type AuthenticationTwoFactorSetupTotpMutationVariables = Exact<{
  input: AuthenticationTwoFactorSetupTotpInput;
}>;


export type AuthenticationTwoFactorSetupTotpMutation = { __typename?: 'Mutation', data: { __typename?: 'TwoFactorTotpSetup', secret: string, uri: string } };

export type AuthenticationTwoFactorSetupEmailOtpMutationVariables = Exact<{
  input: AuthenticationTwoFactorSetupEmailOtpInput;
}>;


export type AuthenticationTwoFactorSetupEmailOtpMutation = { __typename?: 'Mutation', data: boolean };

export type AuthenticationTwoFactorEnableTotpMutationVariables = Exact<{
  input: AuthenticationTwoFactorEnableTotpInput;
}>;


export type AuthenticationTwoFactorEnableTotpMutation = { __typename?: 'Mutation', data: { __typename?: 'TwoFactorSetupResult', backupCodes: Array<string>, backupCodesCount: number } };

export type AuthenticationTwoFactorEnableEmailOtpMutationVariables = Exact<{
  input: AuthenticationTwoFactorEnableEmailOtpInput;
}>;


export type AuthenticationTwoFactorEnableEmailOtpMutation = { __typename?: 'Mutation', data: { __typename?: 'TwoFactorSetupResult', backupCodes: Array<string>, backupCodesCount: number } };

export type AuthenticationTwoFactorDisableTotpMutationVariables = Exact<{
  input: AuthenticationTwoFactorDisableTotpInput;
}>;


export type AuthenticationTwoFactorDisableTotpMutation = { __typename?: 'Mutation', data: boolean };

export type AuthenticationTwoFactorDisableEmailOtpMutationVariables = Exact<{
  input: AuthenticationTwoFactorDisableEmailOtpInput;
}>;


export type AuthenticationTwoFactorDisableEmailOtpMutation = { __typename?: 'Mutation', data: boolean };

export type AuthenticationTwoFactorGenerateBackupCodesMutationVariables = Exact<{
  input: AuthenticationTwoFactorGenerateBackupCodesInput;
}>;


export type AuthenticationTwoFactorGenerateBackupCodesMutation = { __typename?: 'Mutation', data: { __typename?: 'TwoFactorBackupCodes', codes: Array<string>, count: number } };

export type AuthenticationTwoFactorResendEmailOtpMutationVariables = Exact<{
  input: AuthenticationTwoFactorResendEmailOtpInput;
}>;


export type AuthenticationTwoFactorResendEmailOtpMutation = { __typename?: 'Mutation', data: boolean };

export type AuthenticationTwoFactorVerifyMutationVariables = Exact<{
  input: AuthenticationTwoFactorVerifyInput;
}>;


export type AuthenticationTwoFactorVerifyMutation = { __typename?: 'Mutation', data: { __typename?: 'Whoami', resource: { __typename?: 'SystemAdmin', id: string } | { __typename?: 'User' } } };

export type AuthenticationTwoFactorResetMutationVariables = Exact<{
  input: AuthenticationTwoFactorResetInput;
}>;


export type AuthenticationTwoFactorResetMutation = { __typename?: 'Mutation', data: boolean };

export type AuthenticationResendAccountLockedEmailMutationVariables = Exact<{
  input: AuthenticationResendAccountLockedEmailInput;
}>;


export type AuthenticationResendAccountLockedEmailMutation = { __typename?: 'Mutation', data: { __typename?: 'ResponseMessage', message: string } };

export type AuthenticationRestoreAccountMutationVariables = Exact<{
  input: AuthenticationRestoreAccountInput;
}>;


export type AuthenticationRestoreAccountMutation = { __typename?: 'Mutation', data: { __typename?: 'Whoami', resource: { __typename?: 'SystemAdmin', id: string } | { __typename?: 'User' } } };

export type WhoamiQueryVariables = Exact<{ [key: string]: never; }>;


export type WhoamiQuery = { __typename?: 'Query', whoami: { __typename?: 'Whoami', resource: { __typename: 'SystemAdmin', verified: boolean | null, deactivatedAt: any | null, createdAt: any, email: string | null, firstName: string, id: string, jobTitle: string | null, lang: LanguageEnum, lastName: string, unconfirmedEmail: string | null, updatedAt: any, passwordSetupRequired: boolean, passwordChangeRequired: boolean, passwordChangeRequiredReason: SystemAdminPasswordChangeRequiredReasonEnum | null, passwordUpdatedAt: any | null, twoFactorRequired: boolean, twoFactorSetupRequired: boolean, twoFactorResetRequired: boolean, twoFactorResetRequiredReason: SystemAdminTwoFactorResetRequiredReasonEnum | null, twoFactorEnabled: boolean, twoFactorEnabledMethods: Array<AuthenticationTwoFactorOtpMethodEnum>, twoFactorTotpEnabled: boolean, twoFactorEmailOtpEnabled: boolean, twoFactorBackupCodesCount: number, twoFactorLastVerifiedAt: any | null, lockedAt: any | null, lockedReason: SystemAdminLockedReasonEnum | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | { __typename: 'User' } } };

export type CompanyDomainsSearchListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<CompanyDomainSortInputObject>;
  filters?: InputMaybe<Array<CompanyDomainFilterInputObject> | CompanyDomainFilterInputObject>;
}>;


export type CompanyDomainsSearchListQuery = { __typename?: 'Query', data: { __typename?: 'CompanyDomainCollection', collection: Array<{ __typename?: 'CompanyDomain', id: string, domain: string, verified: boolean }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type EdmDocumentationCategoryFragmentFragment = { __typename?: 'DocumentationCategory', id: string, name: string, color: ColorEnum };

export type EdmDocumentationBaseFragmentFragment = { __typename?: 'Documentation', id: string, name: string | null, code: string | null, createdAt: any, updatedAt: any, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, currentVersion: { __typename?: 'DocumentationVersion', id: string, versionNumber: number, notes: string | null, attachmentAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, canUpdateValidationStatus: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } };

export type EdmDocumentationPremiumFragmentFragment = { __typename?: 'Documentation', validationStatus: DocumentationValidationStatusEnum | null, approverId: string | null, read: boolean | null, renewalDeadlineDate: any | null, approver: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null };

export type EdmDocumentationFragmentFragment = { __typename?: 'Documentation', id: string, name: string | null, code: string | null, createdAt: any, updatedAt: any, validationStatus: DocumentationValidationStatusEnum | null, approverId: string | null, read: boolean | null, renewalDeadlineDate: any | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, currentVersion: { __typename?: 'DocumentationVersion', id: string, versionNumber: number, notes: string | null, attachmentAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, canUpdateValidationStatus: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, approver: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null };

export type EdmDocumentationAiDetectionFragmentFragment = { __typename?: 'Documentation', suggestedCodes: Array<string>, aiDetectionStatus: Array<{ __typename?: 'DocumentationFieldDetectionStatus', field: AiDocumentationFieldEnum, status: AiFieldDetectionStatusEnum }> };

export type EdmDocumentationLightBaseFragmentFragment = { __typename?: 'Documentation', id: string, name: string | null, currentVersion: { __typename?: 'DocumentationVersion', id: string, versionNumber: number, notes: string | null, attachmentAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null };

export type EdmDocumentationLightPremiumFragmentFragment = { __typename?: 'Documentation', validationStatus: DocumentationValidationStatusEnum | null, read: boolean | null, favorited: boolean, category: { __typename?: 'DocumentationCategory', id: string, name: string, color: ColorEnum } | null };

export type EdmDocumentationLightFragmentFragment = { __typename?: 'Documentation', id: string, name: string | null, validationStatus: DocumentationValidationStatusEnum | null, read: boolean | null, favorited: boolean, currentVersion: { __typename?: 'DocumentationVersion', id: string, versionNumber: number, notes: string | null, attachmentAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, category: { __typename?: 'DocumentationCategory', id: string, name: string, color: ColorEnum } | null };

export type EdmDocumentationsLightQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<DocumentationSortInputObject>;
  filters?: InputMaybe<Array<DocumentationFilterInputObject> | DocumentationFilterInputObject>;
  scope?: InputMaybe<DocumentationScopeInputObject>;
  isViewLocked?: Scalars['Boolean']['input'];
}>;


export type EdmDocumentationsLightQuery = { __typename?: 'Query', data: { __typename?: 'DocumentationCollection', collection: Array<{ __typename?: 'Documentation', id: string, name: string | null, validationStatus: DocumentationValidationStatusEnum | null, read: boolean | null, favorited: boolean, currentVersion: { __typename?: 'DocumentationVersion', id: string, versionNumber: number, notes: string | null, attachmentAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, category: { __typename?: 'DocumentationCategory', id: string, name: string, color: ColorEnum } | null }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type EdmDocumentationsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<DocumentationSortInputObject>;
  filters?: InputMaybe<Array<DocumentationFilterInputObject> | DocumentationFilterInputObject>;
  scope?: InputMaybe<DocumentationScopeInputObject>;
  isViewLocked?: Scalars['Boolean']['input'];
  skipCategory?: Scalars['Boolean']['input'];
  isAiDetectionEnabled?: Scalars['Boolean']['input'];
}>;


export type EdmDocumentationsQuery = { __typename?: 'Query', data: { __typename?: 'DocumentationCollection', collection: Array<{ __typename?: 'Documentation', favorited?: boolean, id: string, name: string | null, code: string | null, createdAt: any, updatedAt: any, validationStatus: DocumentationValidationStatusEnum | null, approverId: string | null, read: boolean | null, renewalDeadlineDate: any | null, suggestedCodes: Array<string>, category?: { __typename?: 'DocumentationCategory', id: string, name: string, color: ColorEnum } | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, currentVersion: { __typename?: 'DocumentationVersion', id: string, versionNumber: number, notes: string | null, attachmentAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, canUpdateValidationStatus: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, approver: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, aiDetectionStatus: Array<{ __typename?: 'DocumentationFieldDetectionStatus', field: AiDocumentationFieldEnum, status: AiFieldDetectionStatusEnum }> }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type EdmDocumentationCategoriesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<DocumentationCategorySortInputObject>;
  filters?: InputMaybe<Array<DocumentationCategoryFilterInputObject> | DocumentationCategoryFilterInputObject>;
}>;


export type EdmDocumentationCategoriesQuery = { __typename?: 'Query', data: { __typename?: 'DocumentationCategoryCollection', collection: Array<{ __typename?: 'DocumentationCategory', id: string, name: string, color: ColorEnum }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type EdmDocumentationCategoriesSearchListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<DocumentationCategorySortInputObject>;
  filters?: InputMaybe<Array<DocumentationCategoryFilterInputObject> | DocumentationCategoryFilterInputObject>;
}>;


export type EdmDocumentationCategoriesSearchListQuery = { __typename?: 'Query', data: { __typename?: 'DocumentationCategoryCollection', collection: Array<{ __typename?: 'DocumentationCategory', id: string, name: string, color: ColorEnum }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type EdmDocumentationBulkFavoriteMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type EdmDocumentationBulkFavoriteMutation = { __typename?: 'Mutation', documentationBulkFavorite: boolean | null };

export type EdmDocumentationBulkUnfavoriteMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type EdmDocumentationBulkUnfavoriteMutation = { __typename?: 'Mutation', documentationBulkUnfavorite: boolean | null };

export type EdmDocumentationVersionViewCreateMutationVariables = Exact<{
  documentationVersionId: Scalars['ID']['input'];
  viewedAt: Scalars['ISO8601DateTime']['input'];
  readingDurationSeconds: Scalars['Int']['input'];
}>;


export type EdmDocumentationVersionViewCreateMutation = { __typename?: 'Mutation', documentationVersionViewCreate: { __typename?: 'DocumentationVersionView', id: string, readingDurationSeconds: number | null } | null };

export type EdmDocumentationVersionViewIncrementMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  readingDurationSeconds: Scalars['Int']['input'];
}>;


export type EdmDocumentationVersionViewIncrementMutation = { __typename?: 'Mutation', documentationVersionViewIncrement: { __typename?: 'DocumentationVersionView', id: string, readingDurationSeconds: number | null } | null };

export type EdmDocumentationVersionMarkAsReadMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EdmDocumentationVersionMarkAsReadMutation = { __typename?: 'Mutation', documentationVersionMarkAsRead: { __typename?: 'Documentation', id: string, read: boolean | null } | null };

export type AttachmentFragmentFragment = { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null };

export type MetadataFragmentFragment = { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number };

export type AuthorizationResultFragmentFragment = { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null };

export type InterventionCategoriesSearchListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<Array<InterventionCategoryFilterInputObject> | InterventionCategoryFilterInputObject>;
  sorts?: InputMaybe<InterventionCategorySortInputObject>;
}>;


export type InterventionCategoriesSearchListQuery = { __typename?: 'Query', data: { __typename?: 'InterventionCategoryCollection', collection: Array<{ __typename?: 'InterventionCategory', id: string, name: string, color: ColorEnum }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type CompanyPlanChangeRequestMutationVariables = Exact<{
  input: CompanyPlanChangeRequestInput;
}>;


export type CompanyPlanChangeRequestMutation = { __typename?: 'Mutation', companyPlanChangeRequest: boolean | null };

export type SitesSearchListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<Array<SiteFilterInputObject> | SiteFilterInputObject>;
  sorts?: InputMaybe<SiteSortInputObject>;
}>;


export type SitesSearchListQuery = { __typename?: 'Query', data: { __typename?: 'SiteCollection', collection: Array<{ __typename?: 'Site', id: string, name: string, code: string }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type TeamsSearchListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<TeamSortInputObject>;
  filters?: InputMaybe<Array<TeamFilterInputObject> | TeamFilterInputObject>;
}>;


export type TeamsSearchListQuery = { __typename?: 'Query', data: { __typename?: 'TeamCollection', collection: Array<{ __typename?: 'Team', id: string, name: string | null, color: ColorEnum }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type UsersSearchListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<UserSortInputObject>;
  filters?: InputMaybe<Array<UserFilterInputObject> | UserFilterInputObject>;
  scope?: InputMaybe<UserScopeInputObject>;
}>;


export type UsersSearchListQuery = { __typename?: 'Query', data: { __typename?: 'UserCollection', collection: Array<{ __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null, video480p: string | null, video720p: string | null, video1080p: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type UsersSearchListIdsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<UserSortInputObject>;
  filters?: InputMaybe<Array<UserFilterInputObject> | UserFilterInputObject>;
  scope?: InputMaybe<UserScopeInputObject>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UsersSearchListIdsQuery = { __typename?: 'Query', data: { __typename?: 'UserCollection', collection: Array<{ __typename?: 'User', id: string }> } };

export const AttachmentFragmentFragmentDoc = gql`
    fragment attachmentFragment on Attachment {
  id
  processed
  fileTag
  fileData
  filename
  urls {
    large
    medium
    original
    small
    imagePreview
    originalDirectDownload
    video480p
    video720p
    video1080p
  }
  metadata {
    intendedUse
  }
}
    `;
export const AuthorizationResultFragmentFragmentDoc = gql`
    fragment authorizationResultFragment on AuthorizationResult {
  value
  message
  reasons {
    details
    fullMessages
  }
}
    `;
export const EdmDocumentationBaseFragmentFragmentDoc = gql`
    fragment edmDocumentationBaseFragment on Documentation {
  id
  name
  code
  createdAt
  updatedAt
  createdBy {
    id
    firstName
    lastName
    email
    avatarAttached {
      ...attachmentFragment
    }
  }
  currentVersion {
    id
    versionNumber
    notes
    attachmentAttached {
      ...attachmentFragment
    }
  }
  tags {
    id
    name
  }
  canUpdateValidationStatus {
    ...authorizationResultFragment
  }
  canDestroy {
    ...authorizationResultFragment
  }
  canUpdate {
    ...authorizationResultFragment
  }
}
    `;
export const EdmDocumentationPremiumFragmentFragmentDoc = gql`
    fragment edmDocumentationPremiumFragment on Documentation {
  validationStatus
  approver {
    id
    firstName
    lastName
    email
    avatarAttached {
      ...attachmentFragment
    }
  }
  approverId
  read
  renewalDeadlineDate
}
    `;
export const EdmDocumentationFragmentFragmentDoc = gql`
    fragment edmDocumentationFragment on Documentation {
  ...edmDocumentationBaseFragment
  ...edmDocumentationPremiumFragment
}
    `;
export const EdmDocumentationAiDetectionFragmentFragmentDoc = gql`
    fragment edmDocumentationAiDetectionFragment on Documentation {
  suggestedCodes
  aiDetectionStatus {
    field
    status
  }
}
    `;
export const EdmDocumentationLightBaseFragmentFragmentDoc = gql`
    fragment edmDocumentationLightBaseFragment on Documentation {
  id
  name
  currentVersion {
    id
    versionNumber
    notes
    attachmentAttached {
      ...attachmentFragment
    }
  }
}
    `;
export const EdmDocumentationCategoryFragmentFragmentDoc = gql`
    fragment edmDocumentationCategoryFragment on DocumentationCategory {
  id
  name
  color
}
    `;
export const EdmDocumentationLightPremiumFragmentFragmentDoc = gql`
    fragment edmDocumentationLightPremiumFragment on Documentation {
  validationStatus
  read
  favorited
  category {
    ...edmDocumentationCategoryFragment
  }
}
    `;
export const EdmDocumentationLightFragmentFragmentDoc = gql`
    fragment edmDocumentationLightFragment on Documentation {
  ...edmDocumentationLightBaseFragment
  ...edmDocumentationLightPremiumFragment
}
    `;
export const MetadataFragmentFragmentDoc = gql`
    fragment metadataFragment on CollectionMetadata {
  currentPage
  limitValue
  totalCount
  totalPages
}
    `;
export const AssetCategoriesSearchListDocument = gql`
    query assetCategoriesSearchList($page: Int, $limit: Int, $filters: [AssetCategoryFilterInputObject!], $sorts: AssetCategorySortInputObject) {
  data: assetCategories(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
  ) {
    collection {
      color
      name
      id
      prefix
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${MetadataFragmentFragmentDoc}`;

/**
 * __useAssetCategoriesSearchListQuery__
 *
 * To run a query within a React component, call `useAssetCategoriesSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetCategoriesSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetCategoriesSearchListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useAssetCategoriesSearchListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AssetCategoriesSearchListQuery, AssetCategoriesSearchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AssetCategoriesSearchListQuery, AssetCategoriesSearchListQueryVariables>(AssetCategoriesSearchListDocument, options);
      }
export function useAssetCategoriesSearchListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AssetCategoriesSearchListQuery, AssetCategoriesSearchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AssetCategoriesSearchListQuery, AssetCategoriesSearchListQueryVariables>(AssetCategoriesSearchListDocument, options);
        }
// @ts-ignore
export function useAssetCategoriesSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AssetCategoriesSearchListQuery, AssetCategoriesSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AssetCategoriesSearchListQuery, AssetCategoriesSearchListQueryVariables>;
// @ts-ignore
export function useAssetCategoriesSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AssetCategoriesSearchListQuery, AssetCategoriesSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AssetCategoriesSearchListQuery | undefined, AssetCategoriesSearchListQueryVariables>;
export function useAssetCategoriesSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AssetCategoriesSearchListQuery, AssetCategoriesSearchListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<AssetCategoriesSearchListQuery, AssetCategoriesSearchListQueryVariables>(AssetCategoriesSearchListDocument, options);
        }
export type AssetCategoriesSearchListQueryHookResult = ReturnType<typeof useAssetCategoriesSearchListQuery>;
export type AssetCategoriesSearchListLazyQueryHookResult = ReturnType<typeof useAssetCategoriesSearchListLazyQuery>;
export type AssetCategoriesSearchListSuspenseQueryHookResult = ReturnType<typeof useAssetCategoriesSearchListSuspenseQuery>;
export type AssetCategoriesSearchListQueryResult = ApolloReactCommon.QueryResult<AssetCategoriesSearchListQuery, AssetCategoriesSearchListQueryVariables>;
export function refetchAssetCategoriesSearchListQuery(variables?: AssetCategoriesSearchListQueryVariables) {
      return { query: AssetCategoriesSearchListDocument, variables: variables }
    }
export const AuthenticationConfirmationsEmailConfirmationDocument = gql`
    mutation authenticationConfirmationsEmailConfirmation($input: AuthenticationConfirmationsEmailConfirmationInput!) {
  data: authenticationConfirmationsEmailConfirmation(input: $input) {
    resource {
      ... on SystemAdmin {
        id
      }
    }
  }
}
    `;

/**
 * __useAuthenticationConfirmationsEmailConfirmationMutation__
 *
 * To run a mutation, you first call `useAuthenticationConfirmationsEmailConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationConfirmationsEmailConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationConfirmationsEmailConfirmationMutation, { data, loading, error }] = useAuthenticationConfirmationsEmailConfirmationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationConfirmationsEmailConfirmationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AuthenticationConfirmationsEmailConfirmationMutation, AuthenticationConfirmationsEmailConfirmationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AuthenticationConfirmationsEmailConfirmationMutation, AuthenticationConfirmationsEmailConfirmationMutationVariables>(AuthenticationConfirmationsEmailConfirmationDocument, options);
      }
export type AuthenticationConfirmationsEmailConfirmationMutationHookResult = ReturnType<typeof useAuthenticationConfirmationsEmailConfirmationMutation>;
export type AuthenticationConfirmationsEmailConfirmationMutationResult = ApolloReactCommon.MutationResult<AuthenticationConfirmationsEmailConfirmationMutation>;
export const AuthenticationConfirmationsRegistrationConfirmationDocument = gql`
    mutation authenticationConfirmationsRegistrationConfirmation($input: AuthenticationConfirmationsRegistrationConfirmationInput!) {
  data: authenticationConfirmationsRegistrationConfirmation(input: $input) {
    resource {
      ... on SystemAdmin {
        id
      }
    }
  }
}
    `;

/**
 * __useAuthenticationConfirmationsRegistrationConfirmationMutation__
 *
 * To run a mutation, you first call `useAuthenticationConfirmationsRegistrationConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationConfirmationsRegistrationConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationConfirmationsRegistrationConfirmationMutation, { data, loading, error }] = useAuthenticationConfirmationsRegistrationConfirmationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationConfirmationsRegistrationConfirmationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AuthenticationConfirmationsRegistrationConfirmationMutation, AuthenticationConfirmationsRegistrationConfirmationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AuthenticationConfirmationsRegistrationConfirmationMutation, AuthenticationConfirmationsRegistrationConfirmationMutationVariables>(AuthenticationConfirmationsRegistrationConfirmationDocument, options);
      }
export type AuthenticationConfirmationsRegistrationConfirmationMutationHookResult = ReturnType<typeof useAuthenticationConfirmationsRegistrationConfirmationMutation>;
export type AuthenticationConfirmationsRegistrationConfirmationMutationResult = ApolloReactCommon.MutationResult<AuthenticationConfirmationsRegistrationConfirmationMutation>;
export const AuthenticationConfirmationsResendEmailConfirmationDocument = gql`
    mutation authenticationConfirmationsResendEmailConfirmation($input: AuthenticationConfirmationsResendEmailConfirmationInput!) {
  data: authenticationConfirmationsResendEmailConfirmation(input: $input) {
    message
  }
}
    `;

/**
 * __useAuthenticationConfirmationsResendEmailConfirmationMutation__
 *
 * To run a mutation, you first call `useAuthenticationConfirmationsResendEmailConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationConfirmationsResendEmailConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationConfirmationsResendEmailConfirmationMutation, { data, loading, error }] = useAuthenticationConfirmationsResendEmailConfirmationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationConfirmationsResendEmailConfirmationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AuthenticationConfirmationsResendEmailConfirmationMutation, AuthenticationConfirmationsResendEmailConfirmationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AuthenticationConfirmationsResendEmailConfirmationMutation, AuthenticationConfirmationsResendEmailConfirmationMutationVariables>(AuthenticationConfirmationsResendEmailConfirmationDocument, options);
      }
export type AuthenticationConfirmationsResendEmailConfirmationMutationHookResult = ReturnType<typeof useAuthenticationConfirmationsResendEmailConfirmationMutation>;
export type AuthenticationConfirmationsResendEmailConfirmationMutationResult = ApolloReactCommon.MutationResult<AuthenticationConfirmationsResendEmailConfirmationMutation>;
export const AuthenticationConfirmationsResendRegistrationConfirmationDocument = gql`
    mutation authenticationConfirmationsResendRegistrationConfirmation($input: AuthenticationConfirmationsResendRegistrationConfirmationInput!) {
  data: authenticationConfirmationsResendRegistrationConfirmation(input: $input) {
    message
  }
}
    `;

/**
 * __useAuthenticationConfirmationsResendRegistrationConfirmationMutation__
 *
 * To run a mutation, you first call `useAuthenticationConfirmationsResendRegistrationConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationConfirmationsResendRegistrationConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationConfirmationsResendRegistrationConfirmationMutation, { data, loading, error }] = useAuthenticationConfirmationsResendRegistrationConfirmationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationConfirmationsResendRegistrationConfirmationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AuthenticationConfirmationsResendRegistrationConfirmationMutation, AuthenticationConfirmationsResendRegistrationConfirmationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AuthenticationConfirmationsResendRegistrationConfirmationMutation, AuthenticationConfirmationsResendRegistrationConfirmationMutationVariables>(AuthenticationConfirmationsResendRegistrationConfirmationDocument, options);
      }
export type AuthenticationConfirmationsResendRegistrationConfirmationMutationHookResult = ReturnType<typeof useAuthenticationConfirmationsResendRegistrationConfirmationMutation>;
export type AuthenticationConfirmationsResendRegistrationConfirmationMutationResult = ApolloReactCommon.MutationResult<AuthenticationConfirmationsResendRegistrationConfirmationMutation>;
export const AuthenticationPasswordsForgotDocument = gql`
    mutation authenticationPasswordsForgot($input: AuthenticationPasswordsForgotInput!) {
  data: authenticationPasswordsForgot(input: $input) {
    message
  }
}
    `;

/**
 * __useAuthenticationPasswordsForgotMutation__
 *
 * To run a mutation, you first call `useAuthenticationPasswordsForgotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationPasswordsForgotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationPasswordsForgotMutation, { data, loading, error }] = useAuthenticationPasswordsForgotMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationPasswordsForgotMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AuthenticationPasswordsForgotMutation, AuthenticationPasswordsForgotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AuthenticationPasswordsForgotMutation, AuthenticationPasswordsForgotMutationVariables>(AuthenticationPasswordsForgotDocument, options);
      }
export type AuthenticationPasswordsForgotMutationHookResult = ReturnType<typeof useAuthenticationPasswordsForgotMutation>;
export type AuthenticationPasswordsForgotMutationResult = ApolloReactCommon.MutationResult<AuthenticationPasswordsForgotMutation>;
export const AuthenticationPasswordsResetDocument = gql`
    mutation authenticationPasswordsReset($input: AuthenticationPasswordsResetInput!) {
  data: authenticationPasswordsReset(input: $input) {
    resource {
      ... on SystemAdmin {
        id
      }
    }
  }
}
    `;

/**
 * __useAuthenticationPasswordsResetMutation__
 *
 * To run a mutation, you first call `useAuthenticationPasswordsResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationPasswordsResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationPasswordsResetMutation, { data, loading, error }] = useAuthenticationPasswordsResetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationPasswordsResetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AuthenticationPasswordsResetMutation, AuthenticationPasswordsResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AuthenticationPasswordsResetMutation, AuthenticationPasswordsResetMutationVariables>(AuthenticationPasswordsResetDocument, options);
      }
export type AuthenticationPasswordsResetMutationHookResult = ReturnType<typeof useAuthenticationPasswordsResetMutation>;
export type AuthenticationPasswordsResetMutationResult = ApolloReactCommon.MutationResult<AuthenticationPasswordsResetMutation>;
export const AuthenticationPasswordsUpdateDocument = gql`
    mutation authenticationPasswordsUpdate($input: AuthenticationPasswordsUpdateInput!) {
  data: authenticationPasswordsUpdate(input: $input) {
    resource {
      ... on SystemAdmin {
        id
      }
    }
  }
}
    `;

/**
 * __useAuthenticationPasswordsUpdateMutation__
 *
 * To run a mutation, you first call `useAuthenticationPasswordsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationPasswordsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationPasswordsUpdateMutation, { data, loading, error }] = useAuthenticationPasswordsUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationPasswordsUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AuthenticationPasswordsUpdateMutation, AuthenticationPasswordsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AuthenticationPasswordsUpdateMutation, AuthenticationPasswordsUpdateMutationVariables>(AuthenticationPasswordsUpdateDocument, options);
      }
export type AuthenticationPasswordsUpdateMutationHookResult = ReturnType<typeof useAuthenticationPasswordsUpdateMutation>;
export type AuthenticationPasswordsUpdateMutationResult = ApolloReactCommon.MutationResult<AuthenticationPasswordsUpdateMutation>;
export const AuthenticationPasswordSetupDocument = gql`
    mutation authenticationPasswordSetup($input: AuthenticationPasswordSetupInput!) {
  data: authenticationPasswordSetup(input: $input)
}
    `;

/**
 * __useAuthenticationPasswordSetupMutation__
 *
 * To run a mutation, you first call `useAuthenticationPasswordSetupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationPasswordSetupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationPasswordSetupMutation, { data, loading, error }] = useAuthenticationPasswordSetupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationPasswordSetupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AuthenticationPasswordSetupMutation, AuthenticationPasswordSetupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AuthenticationPasswordSetupMutation, AuthenticationPasswordSetupMutationVariables>(AuthenticationPasswordSetupDocument, options);
      }
export type AuthenticationPasswordSetupMutationHookResult = ReturnType<typeof useAuthenticationPasswordSetupMutation>;
export type AuthenticationPasswordSetupMutationResult = ApolloReactCommon.MutationResult<AuthenticationPasswordSetupMutation>;
export const AuthenticationSessionCreateDocument = gql`
    mutation authenticationSessionCreate($input: AuthenticationSessionCreateInput!) {
  data: authenticationSessionCreate(input: $input) {
    resource {
      ... on SystemAdmin {
        id
        twoFactorSetupRequired
        twoFactorRequired
        passwordSetupRequired
        lockedAt
        twoFactorEnabled
        twoFactorTotpEnabled
        twoFactorEmailOtpEnabled
      }
    }
  }
}
    `;

/**
 * __useAuthenticationSessionCreateMutation__
 *
 * To run a mutation, you first call `useAuthenticationSessionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationSessionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationSessionCreateMutation, { data, loading, error }] = useAuthenticationSessionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationSessionCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AuthenticationSessionCreateMutation, AuthenticationSessionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AuthenticationSessionCreateMutation, AuthenticationSessionCreateMutationVariables>(AuthenticationSessionCreateDocument, options);
      }
export type AuthenticationSessionCreateMutationHookResult = ReturnType<typeof useAuthenticationSessionCreateMutation>;
export type AuthenticationSessionCreateMutationResult = ApolloReactCommon.MutationResult<AuthenticationSessionCreateMutation>;
export const AuthenticationSessionEndDocument = gql`
    mutation authenticationSessionEnd($input: AuthenticationSessionEndInput!) {
  data: authenticationSessionEnd(input: $input)
}
    `;

/**
 * __useAuthenticationSessionEndMutation__
 *
 * To run a mutation, you first call `useAuthenticationSessionEndMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationSessionEndMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationSessionEndMutation, { data, loading, error }] = useAuthenticationSessionEndMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationSessionEndMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AuthenticationSessionEndMutation, AuthenticationSessionEndMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AuthenticationSessionEndMutation, AuthenticationSessionEndMutationVariables>(AuthenticationSessionEndDocument, options);
      }
export type AuthenticationSessionEndMutationHookResult = ReturnType<typeof useAuthenticationSessionEndMutation>;
export type AuthenticationSessionEndMutationResult = ApolloReactCommon.MutationResult<AuthenticationSessionEndMutation>;
export const AuthenticationSessionEndAllDocument = gql`
    mutation authenticationSessionEndAll($input: AuthenticationSessionEndAllInput!) {
  data: authenticationSessionEndAll(input: $input)
}
    `;

/**
 * __useAuthenticationSessionEndAllMutation__
 *
 * To run a mutation, you first call `useAuthenticationSessionEndAllMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationSessionEndAllMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationSessionEndAllMutation, { data, loading, error }] = useAuthenticationSessionEndAllMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationSessionEndAllMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AuthenticationSessionEndAllMutation, AuthenticationSessionEndAllMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AuthenticationSessionEndAllMutation, AuthenticationSessionEndAllMutationVariables>(AuthenticationSessionEndAllDocument, options);
      }
export type AuthenticationSessionEndAllMutationHookResult = ReturnType<typeof useAuthenticationSessionEndAllMutation>;
export type AuthenticationSessionEndAllMutationResult = ApolloReactCommon.MutationResult<AuthenticationSessionEndAllMutation>;
export const AuthenticationSessionEndSpecificDocument = gql`
    mutation authenticationSessionEndSpecific($input: AuthenticationSessionEndSpecificInput!) {
  data: authenticationSessionEndSpecific(input: $input)
}
    `;

/**
 * __useAuthenticationSessionEndSpecificMutation__
 *
 * To run a mutation, you first call `useAuthenticationSessionEndSpecificMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationSessionEndSpecificMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationSessionEndSpecificMutation, { data, loading, error }] = useAuthenticationSessionEndSpecificMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationSessionEndSpecificMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AuthenticationSessionEndSpecificMutation, AuthenticationSessionEndSpecificMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AuthenticationSessionEndSpecificMutation, AuthenticationSessionEndSpecificMutationVariables>(AuthenticationSessionEndSpecificDocument, options);
      }
export type AuthenticationSessionEndSpecificMutationHookResult = ReturnType<typeof useAuthenticationSessionEndSpecificMutation>;
export type AuthenticationSessionEndSpecificMutationResult = ApolloReactCommon.MutationResult<AuthenticationSessionEndSpecificMutation>;
export const AuthenticationSessionReportSuspiciousDocument = gql`
    mutation authenticationSessionReportSuspicious($input: AuthenticationSessionReportSuspiciousInput!) {
  data: authenticationSessionReportSuspicious(input: $input)
}
    `;

/**
 * __useAuthenticationSessionReportSuspiciousMutation__
 *
 * To run a mutation, you first call `useAuthenticationSessionReportSuspiciousMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationSessionReportSuspiciousMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationSessionReportSuspiciousMutation, { data, loading, error }] = useAuthenticationSessionReportSuspiciousMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationSessionReportSuspiciousMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AuthenticationSessionReportSuspiciousMutation, AuthenticationSessionReportSuspiciousMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AuthenticationSessionReportSuspiciousMutation, AuthenticationSessionReportSuspiciousMutationVariables>(AuthenticationSessionReportSuspiciousDocument, options);
      }
export type AuthenticationSessionReportSuspiciousMutationHookResult = ReturnType<typeof useAuthenticationSessionReportSuspiciousMutation>;
export type AuthenticationSessionReportSuspiciousMutationResult = ApolloReactCommon.MutationResult<AuthenticationSessionReportSuspiciousMutation>;
export const AuthenticationSessionReportSuspiciousByTokenDocument = gql`
    mutation authenticationSessionReportSuspiciousByToken($input: AuthenticationSessionReportSuspiciousByTokenInput!) {
  data: authenticationSessionReportSuspiciousByToken(input: $input)
}
    `;

/**
 * __useAuthenticationSessionReportSuspiciousByTokenMutation__
 *
 * To run a mutation, you first call `useAuthenticationSessionReportSuspiciousByTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationSessionReportSuspiciousByTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationSessionReportSuspiciousByTokenMutation, { data, loading, error }] = useAuthenticationSessionReportSuspiciousByTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationSessionReportSuspiciousByTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AuthenticationSessionReportSuspiciousByTokenMutation, AuthenticationSessionReportSuspiciousByTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AuthenticationSessionReportSuspiciousByTokenMutation, AuthenticationSessionReportSuspiciousByTokenMutationVariables>(AuthenticationSessionReportSuspiciousByTokenDocument, options);
      }
export type AuthenticationSessionReportSuspiciousByTokenMutationHookResult = ReturnType<typeof useAuthenticationSessionReportSuspiciousByTokenMutation>;
export type AuthenticationSessionReportSuspiciousByTokenMutationResult = ApolloReactCommon.MutationResult<AuthenticationSessionReportSuspiciousByTokenMutation>;
export const AuthenticationTwoFactorSetupTotpDocument = gql`
    mutation authenticationTwoFactorSetupTotp($input: AuthenticationTwoFactorSetupTotpInput!) {
  data: authenticationTwoFactorSetupTotp(input: $input) {
    secret
    uri
  }
}
    `;

/**
 * __useAuthenticationTwoFactorSetupTotpMutation__
 *
 * To run a mutation, you first call `useAuthenticationTwoFactorSetupTotpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationTwoFactorSetupTotpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationTwoFactorSetupTotpMutation, { data, loading, error }] = useAuthenticationTwoFactorSetupTotpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationTwoFactorSetupTotpMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AuthenticationTwoFactorSetupTotpMutation, AuthenticationTwoFactorSetupTotpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AuthenticationTwoFactorSetupTotpMutation, AuthenticationTwoFactorSetupTotpMutationVariables>(AuthenticationTwoFactorSetupTotpDocument, options);
      }
export type AuthenticationTwoFactorSetupTotpMutationHookResult = ReturnType<typeof useAuthenticationTwoFactorSetupTotpMutation>;
export type AuthenticationTwoFactorSetupTotpMutationResult = ApolloReactCommon.MutationResult<AuthenticationTwoFactorSetupTotpMutation>;
export const AuthenticationTwoFactorSetupEmailOtpDocument = gql`
    mutation authenticationTwoFactorSetupEmailOtp($input: AuthenticationTwoFactorSetupEmailOtpInput!) {
  data: authenticationTwoFactorSetupEmailOtp(input: $input)
}
    `;

/**
 * __useAuthenticationTwoFactorSetupEmailOtpMutation__
 *
 * To run a mutation, you first call `useAuthenticationTwoFactorSetupEmailOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationTwoFactorSetupEmailOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationTwoFactorSetupEmailOtpMutation, { data, loading, error }] = useAuthenticationTwoFactorSetupEmailOtpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationTwoFactorSetupEmailOtpMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AuthenticationTwoFactorSetupEmailOtpMutation, AuthenticationTwoFactorSetupEmailOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AuthenticationTwoFactorSetupEmailOtpMutation, AuthenticationTwoFactorSetupEmailOtpMutationVariables>(AuthenticationTwoFactorSetupEmailOtpDocument, options);
      }
export type AuthenticationTwoFactorSetupEmailOtpMutationHookResult = ReturnType<typeof useAuthenticationTwoFactorSetupEmailOtpMutation>;
export type AuthenticationTwoFactorSetupEmailOtpMutationResult = ApolloReactCommon.MutationResult<AuthenticationTwoFactorSetupEmailOtpMutation>;
export const AuthenticationTwoFactorEnableTotpDocument = gql`
    mutation authenticationTwoFactorEnableTotp($input: AuthenticationTwoFactorEnableTotpInput!) {
  data: authenticationTwoFactorEnableTotp(input: $input) {
    backupCodes
    backupCodesCount
  }
}
    `;

/**
 * __useAuthenticationTwoFactorEnableTotpMutation__
 *
 * To run a mutation, you first call `useAuthenticationTwoFactorEnableTotpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationTwoFactorEnableTotpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationTwoFactorEnableTotpMutation, { data, loading, error }] = useAuthenticationTwoFactorEnableTotpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationTwoFactorEnableTotpMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AuthenticationTwoFactorEnableTotpMutation, AuthenticationTwoFactorEnableTotpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AuthenticationTwoFactorEnableTotpMutation, AuthenticationTwoFactorEnableTotpMutationVariables>(AuthenticationTwoFactorEnableTotpDocument, options);
      }
export type AuthenticationTwoFactorEnableTotpMutationHookResult = ReturnType<typeof useAuthenticationTwoFactorEnableTotpMutation>;
export type AuthenticationTwoFactorEnableTotpMutationResult = ApolloReactCommon.MutationResult<AuthenticationTwoFactorEnableTotpMutation>;
export const AuthenticationTwoFactorEnableEmailOtpDocument = gql`
    mutation authenticationTwoFactorEnableEmailOtp($input: AuthenticationTwoFactorEnableEmailOtpInput!) {
  data: authenticationTwoFactorEnableEmailOtp(input: $input) {
    backupCodes
    backupCodesCount
  }
}
    `;

/**
 * __useAuthenticationTwoFactorEnableEmailOtpMutation__
 *
 * To run a mutation, you first call `useAuthenticationTwoFactorEnableEmailOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationTwoFactorEnableEmailOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationTwoFactorEnableEmailOtpMutation, { data, loading, error }] = useAuthenticationTwoFactorEnableEmailOtpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationTwoFactorEnableEmailOtpMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AuthenticationTwoFactorEnableEmailOtpMutation, AuthenticationTwoFactorEnableEmailOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AuthenticationTwoFactorEnableEmailOtpMutation, AuthenticationTwoFactorEnableEmailOtpMutationVariables>(AuthenticationTwoFactorEnableEmailOtpDocument, options);
      }
export type AuthenticationTwoFactorEnableEmailOtpMutationHookResult = ReturnType<typeof useAuthenticationTwoFactorEnableEmailOtpMutation>;
export type AuthenticationTwoFactorEnableEmailOtpMutationResult = ApolloReactCommon.MutationResult<AuthenticationTwoFactorEnableEmailOtpMutation>;
export const AuthenticationTwoFactorDisableTotpDocument = gql`
    mutation authenticationTwoFactorDisableTotp($input: AuthenticationTwoFactorDisableTotpInput!) {
  data: authenticationTwoFactorDisableTotp(input: $input)
}
    `;

/**
 * __useAuthenticationTwoFactorDisableTotpMutation__
 *
 * To run a mutation, you first call `useAuthenticationTwoFactorDisableTotpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationTwoFactorDisableTotpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationTwoFactorDisableTotpMutation, { data, loading, error }] = useAuthenticationTwoFactorDisableTotpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationTwoFactorDisableTotpMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AuthenticationTwoFactorDisableTotpMutation, AuthenticationTwoFactorDisableTotpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AuthenticationTwoFactorDisableTotpMutation, AuthenticationTwoFactorDisableTotpMutationVariables>(AuthenticationTwoFactorDisableTotpDocument, options);
      }
export type AuthenticationTwoFactorDisableTotpMutationHookResult = ReturnType<typeof useAuthenticationTwoFactorDisableTotpMutation>;
export type AuthenticationTwoFactorDisableTotpMutationResult = ApolloReactCommon.MutationResult<AuthenticationTwoFactorDisableTotpMutation>;
export const AuthenticationTwoFactorDisableEmailOtpDocument = gql`
    mutation authenticationTwoFactorDisableEmailOtp($input: AuthenticationTwoFactorDisableEmailOtpInput!) {
  data: authenticationTwoFactorDisableEmailOtp(input: $input)
}
    `;

/**
 * __useAuthenticationTwoFactorDisableEmailOtpMutation__
 *
 * To run a mutation, you first call `useAuthenticationTwoFactorDisableEmailOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationTwoFactorDisableEmailOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationTwoFactorDisableEmailOtpMutation, { data, loading, error }] = useAuthenticationTwoFactorDisableEmailOtpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationTwoFactorDisableEmailOtpMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AuthenticationTwoFactorDisableEmailOtpMutation, AuthenticationTwoFactorDisableEmailOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AuthenticationTwoFactorDisableEmailOtpMutation, AuthenticationTwoFactorDisableEmailOtpMutationVariables>(AuthenticationTwoFactorDisableEmailOtpDocument, options);
      }
export type AuthenticationTwoFactorDisableEmailOtpMutationHookResult = ReturnType<typeof useAuthenticationTwoFactorDisableEmailOtpMutation>;
export type AuthenticationTwoFactorDisableEmailOtpMutationResult = ApolloReactCommon.MutationResult<AuthenticationTwoFactorDisableEmailOtpMutation>;
export const AuthenticationTwoFactorGenerateBackupCodesDocument = gql`
    mutation authenticationTwoFactorGenerateBackupCodes($input: AuthenticationTwoFactorGenerateBackupCodesInput!) {
  data: authenticationTwoFactorGenerateBackupCodes(input: $input) {
    codes
    count
  }
}
    `;

/**
 * __useAuthenticationTwoFactorGenerateBackupCodesMutation__
 *
 * To run a mutation, you first call `useAuthenticationTwoFactorGenerateBackupCodesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationTwoFactorGenerateBackupCodesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationTwoFactorGenerateBackupCodesMutation, { data, loading, error }] = useAuthenticationTwoFactorGenerateBackupCodesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationTwoFactorGenerateBackupCodesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AuthenticationTwoFactorGenerateBackupCodesMutation, AuthenticationTwoFactorGenerateBackupCodesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AuthenticationTwoFactorGenerateBackupCodesMutation, AuthenticationTwoFactorGenerateBackupCodesMutationVariables>(AuthenticationTwoFactorGenerateBackupCodesDocument, options);
      }
export type AuthenticationTwoFactorGenerateBackupCodesMutationHookResult = ReturnType<typeof useAuthenticationTwoFactorGenerateBackupCodesMutation>;
export type AuthenticationTwoFactorGenerateBackupCodesMutationResult = ApolloReactCommon.MutationResult<AuthenticationTwoFactorGenerateBackupCodesMutation>;
export const AuthenticationTwoFactorResendEmailOtpDocument = gql`
    mutation authenticationTwoFactorResendEmailOtp($input: AuthenticationTwoFactorResendEmailOtpInput!) {
  data: authenticationTwoFactorResendEmailOtp(input: $input)
}
    `;

/**
 * __useAuthenticationTwoFactorResendEmailOtpMutation__
 *
 * To run a mutation, you first call `useAuthenticationTwoFactorResendEmailOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationTwoFactorResendEmailOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationTwoFactorResendEmailOtpMutation, { data, loading, error }] = useAuthenticationTwoFactorResendEmailOtpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationTwoFactorResendEmailOtpMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AuthenticationTwoFactorResendEmailOtpMutation, AuthenticationTwoFactorResendEmailOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AuthenticationTwoFactorResendEmailOtpMutation, AuthenticationTwoFactorResendEmailOtpMutationVariables>(AuthenticationTwoFactorResendEmailOtpDocument, options);
      }
export type AuthenticationTwoFactorResendEmailOtpMutationHookResult = ReturnType<typeof useAuthenticationTwoFactorResendEmailOtpMutation>;
export type AuthenticationTwoFactorResendEmailOtpMutationResult = ApolloReactCommon.MutationResult<AuthenticationTwoFactorResendEmailOtpMutation>;
export const AuthenticationTwoFactorVerifyDocument = gql`
    mutation authenticationTwoFactorVerify($input: AuthenticationTwoFactorVerifyInput!) {
  data: authenticationTwoFactorVerify(input: $input) {
    resource {
      ... on SystemAdmin {
        id
      }
    }
  }
}
    `;

/**
 * __useAuthenticationTwoFactorVerifyMutation__
 *
 * To run a mutation, you first call `useAuthenticationTwoFactorVerifyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationTwoFactorVerifyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationTwoFactorVerifyMutation, { data, loading, error }] = useAuthenticationTwoFactorVerifyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationTwoFactorVerifyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AuthenticationTwoFactorVerifyMutation, AuthenticationTwoFactorVerifyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AuthenticationTwoFactorVerifyMutation, AuthenticationTwoFactorVerifyMutationVariables>(AuthenticationTwoFactorVerifyDocument, options);
      }
export type AuthenticationTwoFactorVerifyMutationHookResult = ReturnType<typeof useAuthenticationTwoFactorVerifyMutation>;
export type AuthenticationTwoFactorVerifyMutationResult = ApolloReactCommon.MutationResult<AuthenticationTwoFactorVerifyMutation>;
export const AuthenticationTwoFactorResetDocument = gql`
    mutation authenticationTwoFactorReset($input: AuthenticationTwoFactorResetInput!) {
  data: authenticationTwoFactorReset(input: $input)
}
    `;

/**
 * __useAuthenticationTwoFactorResetMutation__
 *
 * To run a mutation, you first call `useAuthenticationTwoFactorResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationTwoFactorResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationTwoFactorResetMutation, { data, loading, error }] = useAuthenticationTwoFactorResetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationTwoFactorResetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AuthenticationTwoFactorResetMutation, AuthenticationTwoFactorResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AuthenticationTwoFactorResetMutation, AuthenticationTwoFactorResetMutationVariables>(AuthenticationTwoFactorResetDocument, options);
      }
export type AuthenticationTwoFactorResetMutationHookResult = ReturnType<typeof useAuthenticationTwoFactorResetMutation>;
export type AuthenticationTwoFactorResetMutationResult = ApolloReactCommon.MutationResult<AuthenticationTwoFactorResetMutation>;
export const AuthenticationResendAccountLockedEmailDocument = gql`
    mutation authenticationResendAccountLockedEmail($input: AuthenticationResendAccountLockedEmailInput!) {
  data: authenticationResendAccountLockedEmail(input: $input) {
    message
  }
}
    `;

/**
 * __useAuthenticationResendAccountLockedEmailMutation__
 *
 * To run a mutation, you first call `useAuthenticationResendAccountLockedEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationResendAccountLockedEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationResendAccountLockedEmailMutation, { data, loading, error }] = useAuthenticationResendAccountLockedEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationResendAccountLockedEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AuthenticationResendAccountLockedEmailMutation, AuthenticationResendAccountLockedEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AuthenticationResendAccountLockedEmailMutation, AuthenticationResendAccountLockedEmailMutationVariables>(AuthenticationResendAccountLockedEmailDocument, options);
      }
export type AuthenticationResendAccountLockedEmailMutationHookResult = ReturnType<typeof useAuthenticationResendAccountLockedEmailMutation>;
export type AuthenticationResendAccountLockedEmailMutationResult = ApolloReactCommon.MutationResult<AuthenticationResendAccountLockedEmailMutation>;
export const AuthenticationRestoreAccountDocument = gql`
    mutation authenticationRestoreAccount($input: AuthenticationRestoreAccountInput!) {
  data: authenticationRestoreAccount(input: $input) {
    resource {
      ... on SystemAdmin {
        id
      }
    }
  }
}
    `;

/**
 * __useAuthenticationRestoreAccountMutation__
 *
 * To run a mutation, you first call `useAuthenticationRestoreAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationRestoreAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationRestoreAccountMutation, { data, loading, error }] = useAuthenticationRestoreAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationRestoreAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AuthenticationRestoreAccountMutation, AuthenticationRestoreAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AuthenticationRestoreAccountMutation, AuthenticationRestoreAccountMutationVariables>(AuthenticationRestoreAccountDocument, options);
      }
export type AuthenticationRestoreAccountMutationHookResult = ReturnType<typeof useAuthenticationRestoreAccountMutation>;
export type AuthenticationRestoreAccountMutationResult = ApolloReactCommon.MutationResult<AuthenticationRestoreAccountMutation>;
export const WhoamiDocument = gql`
    query Whoami {
  whoami {
    resource {
      __typename
      ... on SystemAdmin {
        avatarAttached {
          ...attachmentFragment
        }
        verified
        deactivatedAt
        createdAt
        email
        firstName
        id
        jobTitle
        lang
        lastName
        unconfirmedEmail
        updatedAt
        passwordSetupRequired
        passwordChangeRequired
        passwordChangeRequiredReason
        passwordUpdatedAt
        twoFactorRequired
        twoFactorSetupRequired
        twoFactorResetRequired
        twoFactorResetRequiredReason
        twoFactorEnabled
        twoFactorEnabledMethods
        twoFactorTotpEnabled
        twoFactorEmailOtpEnabled
        twoFactorBackupCodesCount
        twoFactorLastVerifiedAt
        lockedAt
        lockedReason
      }
    }
  }
}
    ${AttachmentFragmentFragmentDoc}`;

/**
 * __useWhoamiQuery__
 *
 * To run a query within a React component, call `useWhoamiQuery` and pass it any options that fit your needs.
 * When your component renders, `useWhoamiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWhoamiQuery({
 *   variables: {
 *   },
 * });
 */
export function useWhoamiQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WhoamiQuery, WhoamiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WhoamiQuery, WhoamiQueryVariables>(WhoamiDocument, options);
      }
export function useWhoamiLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WhoamiQuery, WhoamiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WhoamiQuery, WhoamiQueryVariables>(WhoamiDocument, options);
        }
// @ts-ignore
export function useWhoamiSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WhoamiQuery, WhoamiQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WhoamiQuery, WhoamiQueryVariables>;
// @ts-ignore
export function useWhoamiSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WhoamiQuery, WhoamiQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WhoamiQuery | undefined, WhoamiQueryVariables>;
export function useWhoamiSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WhoamiQuery, WhoamiQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<WhoamiQuery, WhoamiQueryVariables>(WhoamiDocument, options);
        }
export type WhoamiQueryHookResult = ReturnType<typeof useWhoamiQuery>;
export type WhoamiLazyQueryHookResult = ReturnType<typeof useWhoamiLazyQuery>;
export type WhoamiSuspenseQueryHookResult = ReturnType<typeof useWhoamiSuspenseQuery>;
export type WhoamiQueryResult = ApolloReactCommon.QueryResult<WhoamiQuery, WhoamiQueryVariables>;
export function refetchWhoamiQuery(variables?: WhoamiQueryVariables) {
      return { query: WhoamiDocument, variables: variables }
    }
export const CompanyDomainsSearchListDocument = gql`
    query companyDomainsSearchList($page: Int, $limit: Int, $sorts: CompanyDomainSortInputObject, $filters: [CompanyDomainFilterInputObject!]) {
  data: companyDomains(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
  ) {
    collection {
      id
      domain
      verified
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${MetadataFragmentFragmentDoc}`;

/**
 * __useCompanyDomainsSearchListQuery__
 *
 * To run a query within a React component, call `useCompanyDomainsSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyDomainsSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyDomainsSearchListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCompanyDomainsSearchListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CompanyDomainsSearchListQuery, CompanyDomainsSearchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CompanyDomainsSearchListQuery, CompanyDomainsSearchListQueryVariables>(CompanyDomainsSearchListDocument, options);
      }
export function useCompanyDomainsSearchListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CompanyDomainsSearchListQuery, CompanyDomainsSearchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CompanyDomainsSearchListQuery, CompanyDomainsSearchListQueryVariables>(CompanyDomainsSearchListDocument, options);
        }
// @ts-ignore
export function useCompanyDomainsSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CompanyDomainsSearchListQuery, CompanyDomainsSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CompanyDomainsSearchListQuery, CompanyDomainsSearchListQueryVariables>;
// @ts-ignore
export function useCompanyDomainsSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CompanyDomainsSearchListQuery, CompanyDomainsSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CompanyDomainsSearchListQuery | undefined, CompanyDomainsSearchListQueryVariables>;
export function useCompanyDomainsSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CompanyDomainsSearchListQuery, CompanyDomainsSearchListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<CompanyDomainsSearchListQuery, CompanyDomainsSearchListQueryVariables>(CompanyDomainsSearchListDocument, options);
        }
export type CompanyDomainsSearchListQueryHookResult = ReturnType<typeof useCompanyDomainsSearchListQuery>;
export type CompanyDomainsSearchListLazyQueryHookResult = ReturnType<typeof useCompanyDomainsSearchListLazyQuery>;
export type CompanyDomainsSearchListSuspenseQueryHookResult = ReturnType<typeof useCompanyDomainsSearchListSuspenseQuery>;
export type CompanyDomainsSearchListQueryResult = ApolloReactCommon.QueryResult<CompanyDomainsSearchListQuery, CompanyDomainsSearchListQueryVariables>;
export function refetchCompanyDomainsSearchListQuery(variables?: CompanyDomainsSearchListQueryVariables) {
      return { query: CompanyDomainsSearchListDocument, variables: variables }
    }
export const EdmDocumentationsLightDocument = gql`
    query edmDocumentationsLight($page: Int, $limit: Int, $sorts: DocumentationSortInputObject, $filters: [DocumentationFilterInputObject!], $scope: DocumentationScopeInputObject, $isViewLocked: Boolean! = false) {
  data: documentations(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
    scope: $scope
  ) {
    collection {
      ...edmDocumentationLightBaseFragment
      ...edmDocumentationLightPremiumFragment @skip(if: $isViewLocked)
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${EdmDocumentationLightBaseFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}
${EdmDocumentationLightPremiumFragmentFragmentDoc}
${EdmDocumentationCategoryFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useEdmDocumentationsLightQuery__
 *
 * To run a query within a React component, call `useEdmDocumentationsLightQuery` and pass it any options that fit your needs.
 * When your component renders, `useEdmDocumentationsLightQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEdmDocumentationsLightQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      scope: // value for 'scope'
 *      isViewLocked: // value for 'isViewLocked'
 *   },
 * });
 */
export function useEdmDocumentationsLightQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EdmDocumentationsLightQuery, EdmDocumentationsLightQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EdmDocumentationsLightQuery, EdmDocumentationsLightQueryVariables>(EdmDocumentationsLightDocument, options);
      }
export function useEdmDocumentationsLightLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EdmDocumentationsLightQuery, EdmDocumentationsLightQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EdmDocumentationsLightQuery, EdmDocumentationsLightQueryVariables>(EdmDocumentationsLightDocument, options);
        }
// @ts-ignore
export function useEdmDocumentationsLightSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationsLightQuery, EdmDocumentationsLightQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentationsLightQuery, EdmDocumentationsLightQueryVariables>;
// @ts-ignore
export function useEdmDocumentationsLightSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationsLightQuery, EdmDocumentationsLightQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentationsLightQuery | undefined, EdmDocumentationsLightQueryVariables>;
export function useEdmDocumentationsLightSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationsLightQuery, EdmDocumentationsLightQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<EdmDocumentationsLightQuery, EdmDocumentationsLightQueryVariables>(EdmDocumentationsLightDocument, options);
        }
export type EdmDocumentationsLightQueryHookResult = ReturnType<typeof useEdmDocumentationsLightQuery>;
export type EdmDocumentationsLightLazyQueryHookResult = ReturnType<typeof useEdmDocumentationsLightLazyQuery>;
export type EdmDocumentationsLightSuspenseQueryHookResult = ReturnType<typeof useEdmDocumentationsLightSuspenseQuery>;
export type EdmDocumentationsLightQueryResult = ApolloReactCommon.QueryResult<EdmDocumentationsLightQuery, EdmDocumentationsLightQueryVariables>;
export function refetchEdmDocumentationsLightQuery(variables?: EdmDocumentationsLightQueryVariables) {
      return { query: EdmDocumentationsLightDocument, variables: variables }
    }
export const EdmDocumentationsDocument = gql`
    query edmDocumentations($page: Int, $limit: Int, $sorts: DocumentationSortInputObject, $filters: [DocumentationFilterInputObject!], $scope: DocumentationScopeInputObject, $isViewLocked: Boolean! = false, $skipCategory: Boolean! = false, $isAiDetectionEnabled: Boolean! = false) {
  data: documentations(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
    scope: $scope
  ) {
    collection {
      ...edmDocumentationBaseFragment
      ...edmDocumentationPremiumFragment @skip(if: $isViewLocked)
      ...edmDocumentationAiDetectionFragment @include(if: $isAiDetectionEnabled)
      favorited @skip(if: $isViewLocked)
      category @skip(if: $skipCategory) {
        ...edmDocumentationCategoryFragment
      }
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${EdmDocumentationBaseFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}
${EdmDocumentationPremiumFragmentFragmentDoc}
${EdmDocumentationAiDetectionFragmentFragmentDoc}
${EdmDocumentationCategoryFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useEdmDocumentationsQuery__
 *
 * To run a query within a React component, call `useEdmDocumentationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEdmDocumentationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEdmDocumentationsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      scope: // value for 'scope'
 *      isViewLocked: // value for 'isViewLocked'
 *      skipCategory: // value for 'skipCategory'
 *      isAiDetectionEnabled: // value for 'isAiDetectionEnabled'
 *   },
 * });
 */
export function useEdmDocumentationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EdmDocumentationsQuery, EdmDocumentationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EdmDocumentationsQuery, EdmDocumentationsQueryVariables>(EdmDocumentationsDocument, options);
      }
export function useEdmDocumentationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EdmDocumentationsQuery, EdmDocumentationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EdmDocumentationsQuery, EdmDocumentationsQueryVariables>(EdmDocumentationsDocument, options);
        }
// @ts-ignore
export function useEdmDocumentationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationsQuery, EdmDocumentationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentationsQuery, EdmDocumentationsQueryVariables>;
// @ts-ignore
export function useEdmDocumentationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationsQuery, EdmDocumentationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentationsQuery | undefined, EdmDocumentationsQueryVariables>;
export function useEdmDocumentationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationsQuery, EdmDocumentationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<EdmDocumentationsQuery, EdmDocumentationsQueryVariables>(EdmDocumentationsDocument, options);
        }
export type EdmDocumentationsQueryHookResult = ReturnType<typeof useEdmDocumentationsQuery>;
export type EdmDocumentationsLazyQueryHookResult = ReturnType<typeof useEdmDocumentationsLazyQuery>;
export type EdmDocumentationsSuspenseQueryHookResult = ReturnType<typeof useEdmDocumentationsSuspenseQuery>;
export type EdmDocumentationsQueryResult = ApolloReactCommon.QueryResult<EdmDocumentationsQuery, EdmDocumentationsQueryVariables>;
export function refetchEdmDocumentationsQuery(variables?: EdmDocumentationsQueryVariables) {
      return { query: EdmDocumentationsDocument, variables: variables }
    }
export const EdmDocumentationCategoriesDocument = gql`
    query edmDocumentationCategories($page: Int, $limit: Int, $sorts: DocumentationCategorySortInputObject, $filters: [DocumentationCategoryFilterInputObject!]) {
  data: documentationCategories(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
  ) {
    collection {
      ...edmDocumentationCategoryFragment
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${EdmDocumentationCategoryFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useEdmDocumentationCategoriesQuery__
 *
 * To run a query within a React component, call `useEdmDocumentationCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEdmDocumentationCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEdmDocumentationCategoriesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useEdmDocumentationCategoriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EdmDocumentationCategoriesQuery, EdmDocumentationCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EdmDocumentationCategoriesQuery, EdmDocumentationCategoriesQueryVariables>(EdmDocumentationCategoriesDocument, options);
      }
export function useEdmDocumentationCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EdmDocumentationCategoriesQuery, EdmDocumentationCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EdmDocumentationCategoriesQuery, EdmDocumentationCategoriesQueryVariables>(EdmDocumentationCategoriesDocument, options);
        }
// @ts-ignore
export function useEdmDocumentationCategoriesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationCategoriesQuery, EdmDocumentationCategoriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentationCategoriesQuery, EdmDocumentationCategoriesQueryVariables>;
// @ts-ignore
export function useEdmDocumentationCategoriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationCategoriesQuery, EdmDocumentationCategoriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentationCategoriesQuery | undefined, EdmDocumentationCategoriesQueryVariables>;
export function useEdmDocumentationCategoriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationCategoriesQuery, EdmDocumentationCategoriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<EdmDocumentationCategoriesQuery, EdmDocumentationCategoriesQueryVariables>(EdmDocumentationCategoriesDocument, options);
        }
export type EdmDocumentationCategoriesQueryHookResult = ReturnType<typeof useEdmDocumentationCategoriesQuery>;
export type EdmDocumentationCategoriesLazyQueryHookResult = ReturnType<typeof useEdmDocumentationCategoriesLazyQuery>;
export type EdmDocumentationCategoriesSuspenseQueryHookResult = ReturnType<typeof useEdmDocumentationCategoriesSuspenseQuery>;
export type EdmDocumentationCategoriesQueryResult = ApolloReactCommon.QueryResult<EdmDocumentationCategoriesQuery, EdmDocumentationCategoriesQueryVariables>;
export function refetchEdmDocumentationCategoriesQuery(variables?: EdmDocumentationCategoriesQueryVariables) {
      return { query: EdmDocumentationCategoriesDocument, variables: variables }
    }
export const EdmDocumentationCategoriesSearchListDocument = gql`
    query edmDocumentationCategoriesSearchList($page: Int, $limit: Int, $sorts: DocumentationCategorySortInputObject, $filters: [DocumentationCategoryFilterInputObject!]) {
  data: documentationCategories(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
  ) {
    collection {
      ...edmDocumentationCategoryFragment
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${EdmDocumentationCategoryFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useEdmDocumentationCategoriesSearchListQuery__
 *
 * To run a query within a React component, call `useEdmDocumentationCategoriesSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useEdmDocumentationCategoriesSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEdmDocumentationCategoriesSearchListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useEdmDocumentationCategoriesSearchListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EdmDocumentationCategoriesSearchListQuery, EdmDocumentationCategoriesSearchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EdmDocumentationCategoriesSearchListQuery, EdmDocumentationCategoriesSearchListQueryVariables>(EdmDocumentationCategoriesSearchListDocument, options);
      }
export function useEdmDocumentationCategoriesSearchListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EdmDocumentationCategoriesSearchListQuery, EdmDocumentationCategoriesSearchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EdmDocumentationCategoriesSearchListQuery, EdmDocumentationCategoriesSearchListQueryVariables>(EdmDocumentationCategoriesSearchListDocument, options);
        }
// @ts-ignore
export function useEdmDocumentationCategoriesSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationCategoriesSearchListQuery, EdmDocumentationCategoriesSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentationCategoriesSearchListQuery, EdmDocumentationCategoriesSearchListQueryVariables>;
// @ts-ignore
export function useEdmDocumentationCategoriesSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationCategoriesSearchListQuery, EdmDocumentationCategoriesSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EdmDocumentationCategoriesSearchListQuery | undefined, EdmDocumentationCategoriesSearchListQueryVariables>;
export function useEdmDocumentationCategoriesSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EdmDocumentationCategoriesSearchListQuery, EdmDocumentationCategoriesSearchListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<EdmDocumentationCategoriesSearchListQuery, EdmDocumentationCategoriesSearchListQueryVariables>(EdmDocumentationCategoriesSearchListDocument, options);
        }
export type EdmDocumentationCategoriesSearchListQueryHookResult = ReturnType<typeof useEdmDocumentationCategoriesSearchListQuery>;
export type EdmDocumentationCategoriesSearchListLazyQueryHookResult = ReturnType<typeof useEdmDocumentationCategoriesSearchListLazyQuery>;
export type EdmDocumentationCategoriesSearchListSuspenseQueryHookResult = ReturnType<typeof useEdmDocumentationCategoriesSearchListSuspenseQuery>;
export type EdmDocumentationCategoriesSearchListQueryResult = ApolloReactCommon.QueryResult<EdmDocumentationCategoriesSearchListQuery, EdmDocumentationCategoriesSearchListQueryVariables>;
export function refetchEdmDocumentationCategoriesSearchListQuery(variables?: EdmDocumentationCategoriesSearchListQueryVariables) {
      return { query: EdmDocumentationCategoriesSearchListDocument, variables: variables }
    }
export const EdmDocumentationBulkFavoriteDocument = gql`
    mutation edmDocumentationBulkFavorite($ids: [ID!]!) {
  documentationBulkFavorite(input: {ids: $ids})
}
    `;

/**
 * __useEdmDocumentationBulkFavoriteMutation__
 *
 * To run a mutation, you first call `useEdmDocumentationBulkFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEdmDocumentationBulkFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [edmDocumentationBulkFavoriteMutation, { data, loading, error }] = useEdmDocumentationBulkFavoriteMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useEdmDocumentationBulkFavoriteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EdmDocumentationBulkFavoriteMutation, EdmDocumentationBulkFavoriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EdmDocumentationBulkFavoriteMutation, EdmDocumentationBulkFavoriteMutationVariables>(EdmDocumentationBulkFavoriteDocument, options);
      }
export type EdmDocumentationBulkFavoriteMutationHookResult = ReturnType<typeof useEdmDocumentationBulkFavoriteMutation>;
export type EdmDocumentationBulkFavoriteMutationResult = ApolloReactCommon.MutationResult<EdmDocumentationBulkFavoriteMutation>;
export const EdmDocumentationBulkUnfavoriteDocument = gql`
    mutation edmDocumentationBulkUnfavorite($ids: [ID!]!) {
  documentationBulkUnfavorite(input: {ids: $ids})
}
    `;

/**
 * __useEdmDocumentationBulkUnfavoriteMutation__
 *
 * To run a mutation, you first call `useEdmDocumentationBulkUnfavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEdmDocumentationBulkUnfavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [edmDocumentationBulkUnfavoriteMutation, { data, loading, error }] = useEdmDocumentationBulkUnfavoriteMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useEdmDocumentationBulkUnfavoriteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EdmDocumentationBulkUnfavoriteMutation, EdmDocumentationBulkUnfavoriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EdmDocumentationBulkUnfavoriteMutation, EdmDocumentationBulkUnfavoriteMutationVariables>(EdmDocumentationBulkUnfavoriteDocument, options);
      }
export type EdmDocumentationBulkUnfavoriteMutationHookResult = ReturnType<typeof useEdmDocumentationBulkUnfavoriteMutation>;
export type EdmDocumentationBulkUnfavoriteMutationResult = ApolloReactCommon.MutationResult<EdmDocumentationBulkUnfavoriteMutation>;
export const EdmDocumentationVersionViewCreateDocument = gql`
    mutation edmDocumentationVersionViewCreate($documentationVersionId: ID!, $viewedAt: ISO8601DateTime!, $readingDurationSeconds: Int!) {
  documentationVersionViewCreate(
    input: {attributes: {documentationVersionId: $documentationVersionId, viewedAt: $viewedAt, readingDurationSeconds: $readingDurationSeconds}}
  ) {
    id
    readingDurationSeconds
  }
}
    `;

/**
 * __useEdmDocumentationVersionViewCreateMutation__
 *
 * To run a mutation, you first call `useEdmDocumentationVersionViewCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEdmDocumentationVersionViewCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [edmDocumentationVersionViewCreateMutation, { data, loading, error }] = useEdmDocumentationVersionViewCreateMutation({
 *   variables: {
 *      documentationVersionId: // value for 'documentationVersionId'
 *      viewedAt: // value for 'viewedAt'
 *      readingDurationSeconds: // value for 'readingDurationSeconds'
 *   },
 * });
 */
export function useEdmDocumentationVersionViewCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EdmDocumentationVersionViewCreateMutation, EdmDocumentationVersionViewCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EdmDocumentationVersionViewCreateMutation, EdmDocumentationVersionViewCreateMutationVariables>(EdmDocumentationVersionViewCreateDocument, options);
      }
export type EdmDocumentationVersionViewCreateMutationHookResult = ReturnType<typeof useEdmDocumentationVersionViewCreateMutation>;
export type EdmDocumentationVersionViewCreateMutationResult = ApolloReactCommon.MutationResult<EdmDocumentationVersionViewCreateMutation>;
export const EdmDocumentationVersionViewIncrementDocument = gql`
    mutation edmDocumentationVersionViewIncrement($id: ID!, $readingDurationSeconds: Int!) {
  documentationVersionViewIncrement(
    input: {id: $id, attributes: {readingDurationSeconds: $readingDurationSeconds}}
  ) {
    id
    readingDurationSeconds
  }
}
    `;

/**
 * __useEdmDocumentationVersionViewIncrementMutation__
 *
 * To run a mutation, you first call `useEdmDocumentationVersionViewIncrementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEdmDocumentationVersionViewIncrementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [edmDocumentationVersionViewIncrementMutation, { data, loading, error }] = useEdmDocumentationVersionViewIncrementMutation({
 *   variables: {
 *      id: // value for 'id'
 *      readingDurationSeconds: // value for 'readingDurationSeconds'
 *   },
 * });
 */
export function useEdmDocumentationVersionViewIncrementMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EdmDocumentationVersionViewIncrementMutation, EdmDocumentationVersionViewIncrementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EdmDocumentationVersionViewIncrementMutation, EdmDocumentationVersionViewIncrementMutationVariables>(EdmDocumentationVersionViewIncrementDocument, options);
      }
export type EdmDocumentationVersionViewIncrementMutationHookResult = ReturnType<typeof useEdmDocumentationVersionViewIncrementMutation>;
export type EdmDocumentationVersionViewIncrementMutationResult = ApolloReactCommon.MutationResult<EdmDocumentationVersionViewIncrementMutation>;
export const EdmDocumentationVersionMarkAsReadDocument = gql`
    mutation edmDocumentationVersionMarkAsRead($id: ID!) {
  documentationVersionMarkAsRead(input: {id: $id}) {
    id
    read
  }
}
    `;

/**
 * __useEdmDocumentationVersionMarkAsReadMutation__
 *
 * To run a mutation, you first call `useEdmDocumentationVersionMarkAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEdmDocumentationVersionMarkAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [edmDocumentationVersionMarkAsReadMutation, { data, loading, error }] = useEdmDocumentationVersionMarkAsReadMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEdmDocumentationVersionMarkAsReadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EdmDocumentationVersionMarkAsReadMutation, EdmDocumentationVersionMarkAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EdmDocumentationVersionMarkAsReadMutation, EdmDocumentationVersionMarkAsReadMutationVariables>(EdmDocumentationVersionMarkAsReadDocument, options);
      }
export type EdmDocumentationVersionMarkAsReadMutationHookResult = ReturnType<typeof useEdmDocumentationVersionMarkAsReadMutation>;
export type EdmDocumentationVersionMarkAsReadMutationResult = ApolloReactCommon.MutationResult<EdmDocumentationVersionMarkAsReadMutation>;
export const InterventionCategoriesSearchListDocument = gql`
    query interventionCategoriesSearchList($page: Int, $limit: Int, $filters: [InterventionCategoryFilterInputObject!], $sorts: InterventionCategorySortInputObject) {
  data: interventionCategories(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
  ) {
    collection {
      id
      name
      color
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${MetadataFragmentFragmentDoc}`;

/**
 * __useInterventionCategoriesSearchListQuery__
 *
 * To run a query within a React component, call `useInterventionCategoriesSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterventionCategoriesSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterventionCategoriesSearchListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useInterventionCategoriesSearchListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<InterventionCategoriesSearchListQuery, InterventionCategoriesSearchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InterventionCategoriesSearchListQuery, InterventionCategoriesSearchListQueryVariables>(InterventionCategoriesSearchListDocument, options);
      }
export function useInterventionCategoriesSearchListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InterventionCategoriesSearchListQuery, InterventionCategoriesSearchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InterventionCategoriesSearchListQuery, InterventionCategoriesSearchListQueryVariables>(InterventionCategoriesSearchListDocument, options);
        }
// @ts-ignore
export function useInterventionCategoriesSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<InterventionCategoriesSearchListQuery, InterventionCategoriesSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InterventionCategoriesSearchListQuery, InterventionCategoriesSearchListQueryVariables>;
// @ts-ignore
export function useInterventionCategoriesSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InterventionCategoriesSearchListQuery, InterventionCategoriesSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InterventionCategoriesSearchListQuery | undefined, InterventionCategoriesSearchListQueryVariables>;
export function useInterventionCategoriesSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InterventionCategoriesSearchListQuery, InterventionCategoriesSearchListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<InterventionCategoriesSearchListQuery, InterventionCategoriesSearchListQueryVariables>(InterventionCategoriesSearchListDocument, options);
        }
export type InterventionCategoriesSearchListQueryHookResult = ReturnType<typeof useInterventionCategoriesSearchListQuery>;
export type InterventionCategoriesSearchListLazyQueryHookResult = ReturnType<typeof useInterventionCategoriesSearchListLazyQuery>;
export type InterventionCategoriesSearchListSuspenseQueryHookResult = ReturnType<typeof useInterventionCategoriesSearchListSuspenseQuery>;
export type InterventionCategoriesSearchListQueryResult = ApolloReactCommon.QueryResult<InterventionCategoriesSearchListQuery, InterventionCategoriesSearchListQueryVariables>;
export function refetchInterventionCategoriesSearchListQuery(variables?: InterventionCategoriesSearchListQueryVariables) {
      return { query: InterventionCategoriesSearchListDocument, variables: variables }
    }
export const CompanyPlanChangeRequestDocument = gql`
    mutation companyPlanChangeRequest($input: CompanyPlanChangeRequestInput!) {
  companyPlanChangeRequest(input: $input)
}
    `;

/**
 * __useCompanyPlanChangeRequestMutation__
 *
 * To run a mutation, you first call `useCompanyPlanChangeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyPlanChangeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyPlanChangeRequestMutation, { data, loading, error }] = useCompanyPlanChangeRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompanyPlanChangeRequestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CompanyPlanChangeRequestMutation, CompanyPlanChangeRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CompanyPlanChangeRequestMutation, CompanyPlanChangeRequestMutationVariables>(CompanyPlanChangeRequestDocument, options);
      }
export type CompanyPlanChangeRequestMutationHookResult = ReturnType<typeof useCompanyPlanChangeRequestMutation>;
export type CompanyPlanChangeRequestMutationResult = ApolloReactCommon.MutationResult<CompanyPlanChangeRequestMutation>;
export const SitesSearchListDocument = gql`
    query sitesSearchList($page: Int, $limit: Int, $filters: [SiteFilterInputObject!], $sorts: SiteSortInputObject) {
  data: sites(page: $page, limit: $limit, filters: $filters, sorts: $sorts) {
    collection {
      id
      name
      code
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${MetadataFragmentFragmentDoc}`;

/**
 * __useSitesSearchListQuery__
 *
 * To run a query within a React component, call `useSitesSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitesSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitesSearchListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useSitesSearchListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SitesSearchListQuery, SitesSearchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SitesSearchListQuery, SitesSearchListQueryVariables>(SitesSearchListDocument, options);
      }
export function useSitesSearchListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SitesSearchListQuery, SitesSearchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SitesSearchListQuery, SitesSearchListQueryVariables>(SitesSearchListDocument, options);
        }
// @ts-ignore
export function useSitesSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SitesSearchListQuery, SitesSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SitesSearchListQuery, SitesSearchListQueryVariables>;
// @ts-ignore
export function useSitesSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SitesSearchListQuery, SitesSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SitesSearchListQuery | undefined, SitesSearchListQueryVariables>;
export function useSitesSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SitesSearchListQuery, SitesSearchListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<SitesSearchListQuery, SitesSearchListQueryVariables>(SitesSearchListDocument, options);
        }
export type SitesSearchListQueryHookResult = ReturnType<typeof useSitesSearchListQuery>;
export type SitesSearchListLazyQueryHookResult = ReturnType<typeof useSitesSearchListLazyQuery>;
export type SitesSearchListSuspenseQueryHookResult = ReturnType<typeof useSitesSearchListSuspenseQuery>;
export type SitesSearchListQueryResult = ApolloReactCommon.QueryResult<SitesSearchListQuery, SitesSearchListQueryVariables>;
export function refetchSitesSearchListQuery(variables?: SitesSearchListQueryVariables) {
      return { query: SitesSearchListDocument, variables: variables }
    }
export const TeamsSearchListDocument = gql`
    query teamsSearchList($page: Int, $limit: Int, $sorts: TeamSortInputObject, $filters: [TeamFilterInputObject!]) {
  data: teams(page: $page, limit: $limit, sorts: $sorts, filters: $filters) {
    collection {
      id
      name
      color
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${MetadataFragmentFragmentDoc}`;

/**
 * __useTeamsSearchListQuery__
 *
 * To run a query within a React component, call `useTeamsSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamsSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamsSearchListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useTeamsSearchListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TeamsSearchListQuery, TeamsSearchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TeamsSearchListQuery, TeamsSearchListQueryVariables>(TeamsSearchListDocument, options);
      }
export function useTeamsSearchListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamsSearchListQuery, TeamsSearchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TeamsSearchListQuery, TeamsSearchListQueryVariables>(TeamsSearchListDocument, options);
        }
// @ts-ignore
export function useTeamsSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TeamsSearchListQuery, TeamsSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamsSearchListQuery, TeamsSearchListQueryVariables>;
// @ts-ignore
export function useTeamsSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamsSearchListQuery, TeamsSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamsSearchListQuery | undefined, TeamsSearchListQueryVariables>;
export function useTeamsSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamsSearchListQuery, TeamsSearchListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<TeamsSearchListQuery, TeamsSearchListQueryVariables>(TeamsSearchListDocument, options);
        }
export type TeamsSearchListQueryHookResult = ReturnType<typeof useTeamsSearchListQuery>;
export type TeamsSearchListLazyQueryHookResult = ReturnType<typeof useTeamsSearchListLazyQuery>;
export type TeamsSearchListSuspenseQueryHookResult = ReturnType<typeof useTeamsSearchListSuspenseQuery>;
export type TeamsSearchListQueryResult = ApolloReactCommon.QueryResult<TeamsSearchListQuery, TeamsSearchListQueryVariables>;
export function refetchTeamsSearchListQuery(variables?: TeamsSearchListQueryVariables) {
      return { query: TeamsSearchListDocument, variables: variables }
    }
export const UsersSearchListDocument = gql`
    query usersSearchList($page: Int, $limit: Int, $sorts: UserSortInputObject, $filters: [UserFilterInputObject!], $scope: UserScopeInputObject) {
  data: users(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
    scope: $scope
  ) {
    collection {
      id
      firstName
      lastName
      avatarAttached {
        ...attachmentFragment
      }
      email
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${AttachmentFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useUsersSearchListQuery__
 *
 * To run a query within a React component, call `useUsersSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersSearchListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function useUsersSearchListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UsersSearchListQuery, UsersSearchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UsersSearchListQuery, UsersSearchListQueryVariables>(UsersSearchListDocument, options);
      }
export function useUsersSearchListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UsersSearchListQuery, UsersSearchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UsersSearchListQuery, UsersSearchListQueryVariables>(UsersSearchListDocument, options);
        }
// @ts-ignore
export function useUsersSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UsersSearchListQuery, UsersSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UsersSearchListQuery, UsersSearchListQueryVariables>;
// @ts-ignore
export function useUsersSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UsersSearchListQuery, UsersSearchListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UsersSearchListQuery | undefined, UsersSearchListQueryVariables>;
export function useUsersSearchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UsersSearchListQuery, UsersSearchListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<UsersSearchListQuery, UsersSearchListQueryVariables>(UsersSearchListDocument, options);
        }
export type UsersSearchListQueryHookResult = ReturnType<typeof useUsersSearchListQuery>;
export type UsersSearchListLazyQueryHookResult = ReturnType<typeof useUsersSearchListLazyQuery>;
export type UsersSearchListSuspenseQueryHookResult = ReturnType<typeof useUsersSearchListSuspenseQuery>;
export type UsersSearchListQueryResult = ApolloReactCommon.QueryResult<UsersSearchListQuery, UsersSearchListQueryVariables>;
export function refetchUsersSearchListQuery(variables?: UsersSearchListQueryVariables) {
      return { query: UsersSearchListDocument, variables: variables }
    }
export const UsersSearchListIdsDocument = gql`
    query usersSearchListIds($page: Int, $limit: Int, $sorts: UserSortInputObject, $filters: [UserFilterInputObject!], $scope: UserScopeInputObject, $onlyIds: Boolean) {
  data: users(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
    scope: $scope
    onlyIds: $onlyIds
  ) {
    collection {
      id
    }
  }
}
    `;

/**
 * __useUsersSearchListIdsQuery__
 *
 * To run a query within a React component, call `useUsersSearchListIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersSearchListIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersSearchListIdsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      scope: // value for 'scope'
 *      onlyIds: // value for 'onlyIds'
 *   },
 * });
 */
export function useUsersSearchListIdsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UsersSearchListIdsQuery, UsersSearchListIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UsersSearchListIdsQuery, UsersSearchListIdsQueryVariables>(UsersSearchListIdsDocument, options);
      }
export function useUsersSearchListIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UsersSearchListIdsQuery, UsersSearchListIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UsersSearchListIdsQuery, UsersSearchListIdsQueryVariables>(UsersSearchListIdsDocument, options);
        }
// @ts-ignore
export function useUsersSearchListIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UsersSearchListIdsQuery, UsersSearchListIdsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UsersSearchListIdsQuery, UsersSearchListIdsQueryVariables>;
// @ts-ignore
export function useUsersSearchListIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UsersSearchListIdsQuery, UsersSearchListIdsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UsersSearchListIdsQuery | undefined, UsersSearchListIdsQueryVariables>;
export function useUsersSearchListIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UsersSearchListIdsQuery, UsersSearchListIdsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          // @ts-ignore
          return ApolloReactHooks.useSuspenseQuery<UsersSearchListIdsQuery, UsersSearchListIdsQueryVariables>(UsersSearchListIdsDocument, options);
        }
export type UsersSearchListIdsQueryHookResult = ReturnType<typeof useUsersSearchListIdsQuery>;
export type UsersSearchListIdsLazyQueryHookResult = ReturnType<typeof useUsersSearchListIdsLazyQuery>;
export type UsersSearchListIdsSuspenseQueryHookResult = ReturnType<typeof useUsersSearchListIdsSuspenseQuery>;
export type UsersSearchListIdsQueryResult = ApolloReactCommon.QueryResult<UsersSearchListIdsQuery, UsersSearchListIdsQueryVariables>;
export function refetchUsersSearchListIdsQuery(variables?: UsersSearchListIdsQueryVariables) {
      return { query: UsersSearchListIdsDocument, variables: variables }
    }